var b6 = Object.defineProperty;
var w6 = (e, t, n) => t in e ? b6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ar = (e, t, n) => w6(e, typeof t != "symbol" ? t + "" : t, n);
import * as g from "react";
import o, { useState as Ae, useCallback as he, createContext as jt, useContext as gt, useLayoutEffect as _n, useRef as ve, forwardRef as me, useEffect as Ce, useMemo as Ze, useId as $6, createElement as Y, Children as Tn, isValidElement as ya, cloneElement as Qi, Fragment as E6, useReducer as Oc } from "react";
import * as Or from "react-dom";
import Ac, { createPortal as x6, flushSync as Tc } from "react-dom";
import { M as kc, a as M6, b as C6, c as P6, d as S6, e as F6, f as z6, g as N6, h as D6, i as Bn, j as O6, k as A6, l as T6, m as k6, n as H6, o as R6, p as _6 } from "./xmark-j2hzaTsQ.js";
import ye from "./colors.js";
import { g as Hc } from "./_commonjsHelpers-C6fGbg64.js";
var ai = { exports: {} }, or = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m1;
function I6() {
  if (m1) return or;
  m1 = 1;
  var e = o, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(s, c, d) {
    var f, u = {}, h = null, p = null;
    d !== void 0 && (h = "" + d), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (f in c) r.call(c, f) && !i.hasOwnProperty(f) && (u[f] = c[f]);
    if (s && s.defaultProps) for (f in c = s.defaultProps, c) u[f] === void 0 && (u[f] = c[f]);
    return { $$typeof: t, type: s, key: h, ref: p, props: u, _owner: a.current };
  }
  return or.Fragment = n, or.jsx = l, or.jsxs = l, or;
}
var ir = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v1;
function L6() {
  return v1 || (v1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = o, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y = Symbol.iterator, m = "@@iterator";
    function b(S) {
      if (S === null || typeof S != "object")
        return null;
      var I = y && S[y] || S[m];
      return typeof I == "function" ? I : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(S) {
      {
        for (var I = arguments.length, Z = new Array(I > 1 ? I - 1 : 0), fe = 1; fe < I; fe++)
          Z[fe - 1] = arguments[fe];
        E("error", S, Z);
      }
    }
    function E(S, I, Z) {
      {
        var fe = $.ReactDebugCurrentFrame, Fe = fe.getStackAddendum();
        Fe !== "" && (I += "%s", Z = Z.concat([Fe]));
        var ke = Z.map(function(Me) {
          return String(Me);
        });
        ke.unshift("Warning: " + I), Function.prototype.apply.call(console[S], console, ke);
      }
    }
    var P = !1, x = !1, F = !1, z = !1, N = !1, A;
    A = Symbol.for("react.module.reference");
    function _(S) {
      return !!(typeof S == "string" || typeof S == "function" || S === r || S === i || N || S === a || S === d || S === f || z || S === p || P || x || F || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === u || S.$$typeof === l || S.$$typeof === s || S.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      S.$$typeof === A || S.getModuleId !== void 0));
    }
    function B(S, I, Z) {
      var fe = S.displayName;
      if (fe)
        return fe;
      var Fe = I.displayName || I.name || "";
      return Fe !== "" ? Z + "(" + Fe + ")" : Z;
    }
    function j(S) {
      return S.displayName || "Context";
    }
    function ee(S) {
      if (S == null)
        return null;
      if (typeof S.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof S == "function")
        return S.displayName || S.name || null;
      if (typeof S == "string")
        return S;
      switch (S) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof S == "object")
        switch (S.$$typeof) {
          case s:
            var I = S;
            return j(I) + ".Consumer";
          case l:
            var Z = S;
            return j(Z._context) + ".Provider";
          case c:
            return B(S, S.render, "ForwardRef");
          case u:
            var fe = S.displayName || null;
            return fe !== null ? fe : ee(S.type) || "Memo";
          case h: {
            var Fe = S, ke = Fe._payload, Me = Fe._init;
            try {
              return ee(Me(ke));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var R = Object.assign, X = 0, V, G, ne, k, D, O, J;
    function oe() {
    }
    oe.__reactDisabledLog = !0;
    function te() {
      {
        if (X === 0) {
          V = console.log, G = console.info, ne = console.warn, k = console.error, D = console.group, O = console.groupCollapsed, J = console.groupEnd;
          var S = {
            configurable: !0,
            enumerable: !0,
            value: oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: S,
            log: S,
            warn: S,
            error: S,
            group: S,
            groupCollapsed: S,
            groupEnd: S
          });
        }
        X++;
      }
    }
    function se() {
      {
        if (X--, X === 0) {
          var S = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: R({}, S, {
              value: V
            }),
            info: R({}, S, {
              value: G
            }),
            warn: R({}, S, {
              value: ne
            }),
            error: R({}, S, {
              value: k
            }),
            group: R({}, S, {
              value: D
            }),
            groupCollapsed: R({}, S, {
              value: O
            }),
            groupEnd: R({}, S, {
              value: J
            })
          });
        }
        X < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Q = $.ReactCurrentDispatcher, H;
    function U(S, I, Z) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (Fe) {
            var fe = Fe.stack.trim().match(/\n( *(at )?)/);
            H = fe && fe[1] || "";
          }
        return `
` + H + S;
      }
    }
    var q = !1, W;
    {
      var de = typeof WeakMap == "function" ? WeakMap : Map;
      W = new de();
    }
    function T(S, I) {
      if (!S || q)
        return "";
      {
        var Z = W.get(S);
        if (Z !== void 0)
          return Z;
      }
      var fe;
      q = !0;
      var Fe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ke;
      ke = Q.current, Q.current = null, te();
      try {
        if (I) {
          var Me = function() {
            throw Error();
          };
          if (Object.defineProperty(Me.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Me, []);
            } catch (rt) {
              fe = rt;
            }
            Reflect.construct(S, [], Me);
          } else {
            try {
              Me.call();
            } catch (rt) {
              fe = rt;
            }
            S.call(Me.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (rt) {
            fe = rt;
          }
          S();
        }
      } catch (rt) {
        if (rt && fe && typeof rt.stack == "string") {
          for (var we = rt.stack.split(`
`), et = fe.stack.split(`
`), je = we.length - 1, Be = et.length - 1; je >= 1 && Be >= 0 && we[je] !== et[Be]; )
            Be--;
          for (; je >= 1 && Be >= 0; je--, Be--)
            if (we[je] !== et[Be]) {
              if (je !== 1 || Be !== 1)
                do
                  if (je--, Be--, Be < 0 || we[je] !== et[Be]) {
                    var mt = `
` + we[je].replace(" at new ", " at ");
                    return S.displayName && mt.includes("<anonymous>") && (mt = mt.replace("<anonymous>", S.displayName)), typeof S == "function" && W.set(S, mt), mt;
                  }
                while (je >= 1 && Be >= 0);
              break;
            }
        }
      } finally {
        q = !1, Q.current = ke, se(), Error.prepareStackTrace = Fe;
      }
      var xn = S ? S.displayName || S.name : "", un = xn ? U(xn) : "";
      return typeof S == "function" && W.set(S, un), un;
    }
    function Se(S, I, Z) {
      return T(S, !1);
    }
    function Le(S) {
      var I = S.prototype;
      return !!(I && I.isReactComponent);
    }
    function Ie(S, I, Z) {
      if (S == null)
        return "";
      if (typeof S == "function")
        return T(S, Le(S));
      if (typeof S == "string")
        return U(S);
      switch (S) {
        case d:
          return U("Suspense");
        case f:
          return U("SuspenseList");
      }
      if (typeof S == "object")
        switch (S.$$typeof) {
          case c:
            return Se(S.render);
          case u:
            return Ie(S.type, I, Z);
          case h: {
            var fe = S, Fe = fe._payload, ke = fe._init;
            try {
              return Ie(ke(Fe), I, Z);
            } catch {
            }
          }
        }
      return "";
    }
    var Ke = Object.prototype.hasOwnProperty, ht = {}, Kt = $.ReactDebugCurrentFrame;
    function ot(S) {
      if (S) {
        var I = S._owner, Z = Ie(S.type, S._source, I ? I.type : null);
        Kt.setExtraStackFrame(Z);
      } else
        Kt.setExtraStackFrame(null);
    }
    function Zn(S, I, Z, fe, Fe) {
      {
        var ke = Function.call.bind(Ke);
        for (var Me in S)
          if (ke(S, Me)) {
            var we = void 0;
            try {
              if (typeof S[Me] != "function") {
                var et = Error((fe || "React class") + ": " + Z + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw et.name = "Invariant Violation", et;
              }
              we = S[Me](I, Me, fe, Z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (je) {
              we = je;
            }
            we && !(we instanceof Error) && (ot(Fe), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", fe || "React class", Z, Me, typeof we), ot(null)), we instanceof Error && !(we.message in ht) && (ht[we.message] = !0, ot(Fe), w("Failed %s type: %s", Z, we.message), ot(null));
          }
      }
    }
    var Xt = Array.isArray;
    function Jn(S) {
      return Xt(S);
    }
    function Kr(S) {
      {
        var I = typeof Symbol == "function" && Symbol.toStringTag, Z = I && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return Z;
      }
    }
    function Qn(S) {
      try {
        return En(S), !1;
      } catch {
        return !0;
      }
    }
    function En(S) {
      return "" + S;
    }
    function Xr(S) {
      if (Qn(S))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Kr(S)), En(S);
    }
    var qr = $.ReactCurrentOwner, bo = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Zr, Jr;
    function wo(S) {
      if (Ke.call(S, "ref")) {
        var I = Object.getOwnPropertyDescriptor(S, "ref").get;
        if (I && I.isReactWarning)
          return !1;
      }
      return S.ref !== void 0;
    }
    function $o(S) {
      if (Ke.call(S, "key")) {
        var I = Object.getOwnPropertyDescriptor(S, "key").get;
        if (I && I.isReactWarning)
          return !1;
      }
      return S.key !== void 0;
    }
    function Eo(S, I) {
      typeof S.ref == "string" && qr.current;
    }
    function xo(S, I) {
      {
        var Z = function() {
          Zr || (Zr = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", I));
        };
        Z.isReactWarning = !0, Object.defineProperty(S, "key", {
          get: Z,
          configurable: !0
        });
      }
    }
    function Mo(S, I) {
      {
        var Z = function() {
          Jr || (Jr = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", I));
        };
        Z.isReactWarning = !0, Object.defineProperty(S, "ref", {
          get: Z,
          configurable: !0
        });
      }
    }
    var Co = function(S, I, Z, fe, Fe, ke, Me) {
      var we = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: S,
        key: I,
        ref: Z,
        props: Me,
        // Record the component responsible for creating this element.
        _owner: ke
      };
      return we._store = {}, Object.defineProperty(we._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(we, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: fe
      }), Object.defineProperty(we, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.freeze && (Object.freeze(we.props), Object.freeze(we)), we;
    };
    function Qr(S, I, Z, fe, Fe) {
      {
        var ke, Me = {}, we = null, et = null;
        Z !== void 0 && (Xr(Z), we = "" + Z), $o(I) && (Xr(I.key), we = "" + I.key), wo(I) && (et = I.ref, Eo(I, Fe));
        for (ke in I)
          Ke.call(I, ke) && !bo.hasOwnProperty(ke) && (Me[ke] = I[ke]);
        if (S && S.defaultProps) {
          var je = S.defaultProps;
          for (ke in je)
            Me[ke] === void 0 && (Me[ke] = je[ke]);
        }
        if (we || et) {
          var Be = typeof S == "function" ? S.displayName || S.name || "Unknown" : S;
          we && xo(Me, Be), et && Mo(Me, Be);
        }
        return Co(S, we, et, Fe, fe, qr.current, Me);
      }
    }
    var er = $.ReactCurrentOwner, tr = $.ReactDebugCurrentFrame;
    function ue(S) {
      if (S) {
        var I = S._owner, Z = Ie(S.type, S._source, I ? I.type : null);
        tr.setExtraStackFrame(Z);
      } else
        tr.setExtraStackFrame(null);
    }
    var Ee;
    Ee = !1;
    function ce(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function xe() {
      {
        if (er.current) {
          var S = ee(er.current.type);
          if (S)
            return `

Check the render method of \`` + S + "`.";
        }
        return "";
      }
    }
    function Qe(S) {
      return "";
    }
    var be = {};
    function Po(S) {
      {
        var I = xe();
        if (!I) {
          var Z = typeof S == "string" ? S : S.displayName || S.name;
          Z && (I = `

Check the top-level render call using <` + Z + ">.");
        }
        return I;
      }
    }
    function ea(S, I) {
      {
        if (!S._store || S._store.validated || S.key != null)
          return;
        S._store.validated = !0;
        var Z = Po(I);
        if (be[Z])
          return;
        be[Z] = !0;
        var fe = "";
        S && S._owner && S._owner !== er.current && (fe = " It was passed a child from " + ee(S._owner.type) + "."), ue(S), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Z, fe), ue(null);
      }
    }
    function ta(S, I) {
      {
        if (typeof S != "object")
          return;
        if (Jn(S))
          for (var Z = 0; Z < S.length; Z++) {
            var fe = S[Z];
            ce(fe) && ea(fe, I);
          }
        else if (ce(S))
          S._store && (S._store.validated = !0);
        else if (S) {
          var Fe = b(S);
          if (typeof Fe == "function" && Fe !== S.entries)
            for (var ke = Fe.call(S), Me; !(Me = ke.next()).done; )
              ce(Me.value) && ea(Me.value, I);
        }
      }
    }
    function nr(S) {
      {
        var I = S.type;
        if (I == null || typeof I == "string")
          return;
        var Z;
        if (typeof I == "function")
          Z = I.propTypes;
        else if (typeof I == "object" && (I.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        I.$$typeof === u))
          Z = I.propTypes;
        else
          return;
        if (Z) {
          var fe = ee(I);
          Zn(Z, S.props, "prop", fe, S);
        } else if (I.PropTypes !== void 0 && !Ee) {
          Ee = !0;
          var Fe = ee(I);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Fe || "Unknown");
        }
        typeof I.getDefaultProps == "function" && !I.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rr(S) {
      {
        for (var I = Object.keys(S.props), Z = 0; Z < I.length; Z++) {
          var fe = I[Z];
          if (fe !== "children" && fe !== "key") {
            ue(S), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", fe), ue(null);
            break;
          }
        }
        S.ref !== null && (ue(S), w("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    var f1 = {};
    function h1(S, I, Z, fe, Fe, ke) {
      {
        var Me = _(S);
        if (!Me) {
          var we = "";
          (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (we += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var et = Qe();
          et ? we += et : we += xe();
          var je;
          S === null ? je = "null" : Jn(S) ? je = "array" : S !== void 0 && S.$$typeof === t ? (je = "<" + (ee(S.type) || "Unknown") + " />", we = " Did you accidentally export a JSX literal instead of a component?") : je = typeof S, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", je, we);
        }
        var Be = Qr(S, I, Z, Fe, ke);
        if (Be == null)
          return Be;
        if (Me) {
          var mt = I.children;
          if (mt !== void 0)
            if (fe)
              if (Jn(mt)) {
                for (var xn = 0; xn < mt.length; xn++)
                  ta(mt[xn], S);
                Object.freeze && Object.freeze(mt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ta(mt, S);
        }
        if (Ke.call(I, "key")) {
          var un = ee(S), rt = Object.keys(I).filter(function(y6) {
            return y6 !== "key";
          }), So = rt.length > 0 ? "{key: someKey, " + rt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!f1[un + So]) {
            var g6 = rt.length > 0 ? "{" + rt.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, So, un, g6, un), f1[un + So] = !0;
          }
        }
        return S === r ? rr(Be) : nr(Be), Be;
      }
    }
    function h6(S, I, Z) {
      return h1(S, I, Z, !0);
    }
    function m6(S, I, Z) {
      return h1(S, I, Z, !1);
    }
    var v6 = m6, p6 = h6;
    ir.Fragment = r, ir.jsx = v6, ir.jsxs = p6;
  }()), ir;
}
process.env.NODE_ENV === "production" ? ai.exports = I6() : ai.exports = L6();
var v = ai.exports;
function Ar(e, t = []) {
  let n = [];
  function r(i, l) {
    const s = g.createContext(l), c = n.length;
    n = [...n, l];
    function d(u) {
      const { scope: h, children: p, ...y } = u, m = (h == null ? void 0 : h[e][c]) || s, b = g.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ v.jsx(m.Provider, { value: b, children: p });
    }
    function f(u, h) {
      const p = (h == null ? void 0 : h[e][c]) || s, y = g.useContext(p);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, f];
  }
  const a = () => {
    const i = n.map((l) => g.createContext(l));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [r, j6(a, ...t)];
}
function j6(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const u = c(i)[`__scope${d}`];
        return { ...s, ...u };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function B6(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ra(...e) {
  return (t) => e.forEach((n) => B6(n, t));
}
function De(...e) {
  return g.useCallback(Ra(...e), e);
}
var pn = g.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = g.Children.toArray(n), i = a.find(V6);
  if (i) {
    const l = i.props.children, s = a.map((c) => c === i ? g.Children.count(l) > 1 ? g.Children.only(null) : g.isValidElement(l) ? l.props.children : null : c);
    return /* @__PURE__ */ v.jsx(oi, { ...r, ref: t, children: g.isValidElement(l) ? g.cloneElement(l, void 0, s) : null });
  }
  return /* @__PURE__ */ v.jsx(oi, { ...r, ref: t, children: n });
});
pn.displayName = "Slot";
var oi = g.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (g.isValidElement(n)) {
    const a = Y6(n);
    return g.cloneElement(n, {
      ...G6(r, n.props),
      // @ts-ignore
      ref: t ? Ra(t, a) : a
    });
  }
  return g.Children.count(n) > 1 ? g.Children.only(null) : null;
});
oi.displayName = "SlotClone";
var W6 = ({ children: e }) => /* @__PURE__ */ v.jsx(v.Fragment, { children: e });
function V6(e) {
  return g.isValidElement(e) && e.type === W6;
}
function G6(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Y6(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function _a(e) {
  const t = e + "CollectionProvider", [n, r] = Ar(t), [a, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (p) => {
    const { scope: y, children: m } = p, b = o.useRef(null), $ = o.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v.jsx(a, { scope: y, itemMap: $, collectionRef: b, children: m });
  };
  l.displayName = t;
  const s = e + "CollectionSlot", c = o.forwardRef(
    (p, y) => {
      const { scope: m, children: b } = p, $ = i(s, m), w = De(y, $.collectionRef);
      return /* @__PURE__ */ v.jsx(pn, { ref: w, children: b });
    }
  );
  c.displayName = s;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", u = o.forwardRef(
    (p, y) => {
      const { scope: m, children: b, ...$ } = p, w = o.useRef(null), E = De(y, w), P = i(d, m);
      return o.useEffect(() => (P.itemMap.set(w, { ref: w, ...$ }), () => void P.itemMap.delete(w))), /* @__PURE__ */ v.jsx(pn, { [f]: "", ref: E, children: b });
    }
  );
  u.displayName = d;
  function h(p) {
    const y = i(e + "CollectionConsumer", p);
    return o.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const $ = Array.from(b.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, x) => $.indexOf(P.ref.current) - $.indexOf(x.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: c, ItemSlot: u },
    h,
    r
  ];
}
function ie(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function dt(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function At({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = U6({ defaultProp: t, onChange: n }), i = e !== void 0, l = i ? e : r, s = dt(n), c = g.useCallback(
    (d) => {
      if (i) {
        const u = typeof d == "function" ? d(e) : d;
        u !== e && s(u);
      } else
        a(d);
    },
    [i, e, a, s]
  );
  return [l, c];
}
function U6({
  defaultProp: e,
  onChange: t
}) {
  const n = g.useState(e), [r] = n, a = g.useRef(r), i = dt(t);
  return g.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [r, a, i]), n;
}
var K6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ge = K6.reduce((e, t) => {
  const n = g.forwardRef((r, a) => {
    const { asChild: i, ...l } = r, s = i ? pn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v.jsx(s, { ...l, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Rc(e, t) {
  e && Or.flushSync(() => e.dispatchEvent(t));
}
var Ye = globalThis != null && globalThis.document ? g.useLayoutEffect : () => {
};
function X6(e, t) {
  return g.useReducer((n, r) => t[n][r] ?? n, e);
}
var _c = (e) => {
  const { present: t, children: n } = e, r = q6(t), a = typeof n == "function" ? n({ present: r.isPresent }) : g.Children.only(n), i = De(r.ref, Z6(a));
  return typeof n == "function" || r.isPresent ? g.cloneElement(a, { ref: i }) : null;
};
_c.displayName = "Presence";
function q6(e) {
  const [t, n] = g.useState(), r = g.useRef({}), a = g.useRef(e), i = g.useRef("none"), l = e ? "mounted" : "unmounted", [s, c] = X6(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const d = na(r.current);
    i.current = s === "mounted" ? d : "none";
  }, [s]), Ye(() => {
    const d = r.current, f = a.current;
    if (f !== e) {
      const h = i.current, p = na(d);
      e ? c("MOUNT") : p === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(f && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), Ye(() => {
    if (t) {
      const d = (u) => {
        const p = na(r.current).includes(u.animationName);
        u.target === t && p && Or.flushSync(() => c("ANIMATION_END"));
      }, f = (u) => {
        u.target === t && (i.current = na(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function na(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Z6(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var J6 = g.useId || (() => {
}), Q6 = 0;
function st(e) {
  const [t, n] = g.useState(J6());
  return Ye(() => {
    n((r) => r ?? String(Q6++));
  }, [e]), t ? `radix-${t}` : "";
}
var el = "Collapsible", [e7, Ic] = Ar(el), [t7, tl] = e7(el), Lc = g.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: a,
      disabled: i,
      onOpenChange: l,
      ...s
    } = e, [c = !1, d] = At({
      prop: r,
      defaultProp: a,
      onChange: l
    });
    return /* @__PURE__ */ v.jsx(
      t7,
      {
        scope: n,
        disabled: i,
        contentId: st(),
        open: c,
        onOpenToggle: g.useCallback(() => d((f) => !f), [d]),
        children: /* @__PURE__ */ v.jsx(
          ge.div,
          {
            "data-state": rl(c),
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
Lc.displayName = el;
var jc = "CollapsibleTrigger", Bc = g.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, a = tl(jc, n);
    return /* @__PURE__ */ v.jsx(
      ge.button,
      {
        type: "button",
        "aria-controls": a.contentId,
        "aria-expanded": a.open || !1,
        "data-state": rl(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        disabled: a.disabled,
        ...r,
        ref: t,
        onClick: ie(e.onClick, a.onOpenToggle)
      }
    );
  }
);
Bc.displayName = jc;
var nl = "CollapsibleContent", Wc = g.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, a = tl(nl, e.__scopeCollapsible);
    return /* @__PURE__ */ v.jsx(_c, { present: n || a.open, children: ({ present: i }) => /* @__PURE__ */ v.jsx(n7, { ...r, ref: t, present: i }) });
  }
);
Wc.displayName = nl;
var n7 = g.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: a, ...i } = e, l = tl(nl, n), [s, c] = g.useState(r), d = g.useRef(null), f = De(t, d), u = g.useRef(0), h = u.current, p = g.useRef(0), y = p.current, m = l.open || s, b = g.useRef(m), $ = g.useRef();
  return g.useEffect(() => {
    const w = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), Ye(() => {
    const w = d.current;
    if (w) {
      $.current = $.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const E = w.getBoundingClientRect();
      u.current = E.height, p.current = E.width, b.current || (w.style.transitionDuration = $.current.transitionDuration, w.style.animationName = $.current.animationName), c(r);
    }
  }, [l.open, r]), /* @__PURE__ */ v.jsx(
    ge.div,
    {
      "data-state": rl(l.open),
      "data-disabled": l.disabled ? "" : void 0,
      id: l.contentId,
      hidden: !m,
      ...i,
      ref: f,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": y ? `${y}px` : void 0,
        ...e.style
      },
      children: m && a
    }
  );
});
function rl(e) {
  return e ? "open" : "closed";
}
var r7 = Lc, a7 = Bc, o7 = Wc, i7 = g.createContext(void 0);
function Ia(e) {
  const t = g.useContext(i7);
  return e || t || "ltr";
}
var Gt = "Accordion", l7 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [al, s7, c7] = _a(Gt), [La] = Ar(Gt, [
  c7,
  Ic
]), ol = Ic(), Vc = o.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, a = r, i = r;
    return /* @__PURE__ */ v.jsx(al.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ v.jsx(h7, { ...i, ref: t }) : /* @__PURE__ */ v.jsx(f7, { ...a, ref: t }) });
  }
);
Vc.displayName = Gt;
var [Gc, d7] = La(Gt), [Yc, u7] = La(
  Gt,
  { collapsible: !1 }
), f7 = o.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: a = () => {
      },
      collapsible: i = !1,
      ...l
    } = e, [s, c] = At({
      prop: n,
      defaultProp: r,
      onChange: a
    });
    return /* @__PURE__ */ v.jsx(
      Gc,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: c,
        onItemClose: o.useCallback(() => i && c(""), [i, c]),
        children: /* @__PURE__ */ v.jsx(Yc, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ v.jsx(Uc, { ...l, ref: t }) })
      }
    );
  }
), h7 = o.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: a = () => {
    },
    ...i
  } = e, [l = [], s] = At({
    prop: n,
    defaultProp: r,
    onChange: a
  }), c = o.useCallback(
    (f) => s((u = []) => [...u, f]),
    [s]
  ), d = o.useCallback(
    (f) => s((u = []) => u.filter((h) => h !== f)),
    [s]
  );
  return /* @__PURE__ */ v.jsx(
    Gc,
    {
      scope: e.__scopeAccordion,
      value: l,
      onItemOpen: c,
      onItemClose: d,
      children: /* @__PURE__ */ v.jsx(Yc, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ v.jsx(Uc, { ...i, ref: t }) })
    }
  );
}), [m7, ja] = La(Gt), Uc = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: a, orientation: i = "vertical", ...l } = e, s = o.useRef(null), c = De(s, t), d = s7(n), u = Ia(a) === "ltr", h = ie(e.onKeyDown, (p) => {
      var N;
      if (!l7.includes(p.key)) return;
      const y = p.target, m = d().filter((A) => {
        var _;
        return !((_ = A.ref.current) != null && _.disabled);
      }), b = m.findIndex((A) => A.ref.current === y), $ = m.length;
      if (b === -1) return;
      p.preventDefault();
      let w = b;
      const E = 0, P = $ - 1, x = () => {
        w = b + 1, w > P && (w = E);
      }, F = () => {
        w = b - 1, w < E && (w = P);
      };
      switch (p.key) {
        case "Home":
          w = E;
          break;
        case "End":
          w = P;
          break;
        case "ArrowRight":
          i === "horizontal" && (u ? x() : F());
          break;
        case "ArrowDown":
          i === "vertical" && x();
          break;
        case "ArrowLeft":
          i === "horizontal" && (u ? F() : x());
          break;
        case "ArrowUp":
          i === "vertical" && F();
          break;
      }
      const z = w % $;
      (N = m[z].ref.current) == null || N.focus();
    });
    return /* @__PURE__ */ v.jsx(
      m7,
      {
        scope: n,
        disabled: r,
        direction: a,
        orientation: i,
        children: /* @__PURE__ */ v.jsx(al.Slot, { scope: n, children: /* @__PURE__ */ v.jsx(
          ge.div,
          {
            ...l,
            "data-orientation": i,
            ref: c,
            onKeyDown: r ? void 0 : h
          }
        ) })
      }
    );
  }
), ba = "AccordionItem", [v7, il] = La(ba), Kc = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...a } = e, i = ja(ba, n), l = d7(ba, n), s = ol(n), c = st(), d = r && l.value.includes(r) || !1, f = i.disabled || e.disabled;
    return /* @__PURE__ */ v.jsx(
      v7,
      {
        scope: n,
        open: d,
        disabled: f,
        triggerId: c,
        children: /* @__PURE__ */ v.jsx(
          r7,
          {
            "data-orientation": i.orientation,
            "data-state": ed(d),
            ...s,
            ...a,
            ref: t,
            disabled: f,
            open: d,
            onOpenChange: (u) => {
              u ? l.onItemOpen(r) : l.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
Kc.displayName = ba;
var Xc = "AccordionHeader", qc = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, a = ja(Gt, n), i = il(Xc, n);
    return /* @__PURE__ */ v.jsx(
      ge.h3,
      {
        "data-orientation": a.orientation,
        "data-state": ed(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
qc.displayName = Xc;
var ii = "AccordionTrigger", Zc = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, a = ja(Gt, n), i = il(ii, n), l = u7(ii, n), s = ol(n);
    return /* @__PURE__ */ v.jsx(al.ItemSlot, { scope: n, children: /* @__PURE__ */ v.jsx(
      a7,
      {
        "aria-disabled": i.open && !l.collapsible || void 0,
        "data-orientation": a.orientation,
        id: i.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
Zc.displayName = ii;
var Jc = "AccordionContent", Qc = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, a = ja(Gt, n), i = il(Jc, n), l = ol(n);
    return /* @__PURE__ */ v.jsx(
      o7,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": a.orientation,
        ...l,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Qc.displayName = Jc;
function ed(e) {
  return e ? "open" : "closed";
}
var p7 = Vc, td = Kc, nd = qc, rd = Zc, ad = Qc;
const ll = "-";
function g7(e) {
  const t = b7(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  function a(l) {
    const s = l.split(ll);
    return s[0] === "" && s.length !== 1 && s.shift(), od(s, t) || y7(l);
  }
  function i(l, s) {
    const c = n[l] || [];
    return s && r[l] ? [...c, ...r[l]] : c;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: i
  };
}
function od(e, t) {
  var l;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? od(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const i = e.join(ll);
  return (l = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : l.classGroupId;
}
const p1 = /^\[(.+)\]$/;
function y7(e) {
  if (p1.test(e)) {
    const t = p1.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function b7(e) {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return $7(Object.entries(e.classGroups), n).forEach(([i, l]) => {
    li(l, r, i, t);
  }), r;
}
function li(e, t, n, r) {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : g1(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (w7(a)) {
        li(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, l]) => {
      li(l, g1(t, i), n, r);
    });
  });
}
function g1(e, t) {
  let n = e;
  return t.split(ll).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function w7(e) {
  return e.isThemeGetter;
}
function $7(e, t) {
  return t ? e.map(([n, r]) => {
    const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([l, s]) => [t + l, s])) : i);
    return [n, a];
  }) : e;
}
function E7(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function a(i, l) {
    n.set(i, l), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(i) {
      let l = n.get(i);
      if (l !== void 0)
        return l;
      if ((l = r.get(i)) !== void 0)
        return a(i, l), l;
    },
    set(i, l) {
      n.has(i) ? n.set(i, l) : a(i, l);
    }
  };
}
const id = "!";
function x7(e) {
  const t = e.separator, n = t.length === 1, r = t[0], a = t.length;
  return function(l) {
    const s = [];
    let c = 0, d = 0, f;
    for (let m = 0; m < l.length; m++) {
      let b = l[m];
      if (c === 0) {
        if (b === r && (n || l.slice(m, m + a) === t)) {
          s.push(l.slice(d, m)), d = m + a;
          continue;
        }
        if (b === "/") {
          f = m;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const u = s.length === 0 ? l : l.substring(d), h = u.startsWith(id), p = h ? u.substring(1) : u, y = f && f > d ? f - d : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: p,
      maybePostfixModifierPosition: y
    };
  };
}
function M7(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}
function C7(e) {
  return {
    cache: E7(e.cacheSize),
    splitModifiers: x7(e),
    ...g7(e)
  };
}
const P7 = /\s+/;
function S7(e, t) {
  const {
    splitModifiers: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = /* @__PURE__ */ new Set();
  return e.trim().split(P7).map((l) => {
    const {
      modifiers: s,
      hasImportantModifier: c,
      baseClassName: d,
      maybePostfixModifierPosition: f
    } = n(l);
    let u = r(f ? d.substring(0, f) : d), h = !!f;
    if (!u) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (u = r(d), !u)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      h = !1;
    }
    const p = M7(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: c ? p + id : p,
      classGroupId: u,
      originalClassName: l,
      hasPostfixModifier: h
    };
  }).reverse().filter((l) => {
    if (!l.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: c,
      hasPostfixModifier: d
    } = l, f = s + c;
    return i.has(f) ? !1 : (i.add(f), a(c, d).forEach((u) => i.add(s + u)), !0);
  }).reverse().map((l) => l.originalClassName).join(" ");
}
function F7() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = ld(t)) && (r && (r += " "), r += n);
  return r;
}
function ld(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = ld(e[r])) && (n && (n += " "), n += t);
  return n;
}
function z7(e, ...t) {
  let n, r, a, i = l;
  function l(c) {
    const d = t.reduce((f, u) => u(f), e());
    return n = C7(d), r = n.cache.get, a = n.cache.set, i = s, s(c);
  }
  function s(c) {
    const d = r(c);
    if (d)
      return d;
    const f = S7(c, n);
    return a(c, f), f;
  }
  return function() {
    return i(F7.apply(null, arguments));
  };
}
function Re(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const sd = /^\[(?:([a-z-]+):)?(.+)\]$/i, N7 = /^\d+\/\d+$/, D7 = /* @__PURE__ */ new Set(["px", "full", "screen"]), O7 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, A7 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, T7 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, k7 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, H7 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Ht(e) {
  return hn(e) || D7.has(e) || N7.test(e);
}
function qt(e) {
  return Wn(e, "length", V7);
}
function hn(e) {
  return !!e && !Number.isNaN(Number(e));
}
function ra(e) {
  return Wn(e, "number", hn);
}
function lr(e) {
  return !!e && Number.isInteger(Number(e));
}
function R7(e) {
  return e.endsWith("%") && hn(e.slice(0, -1));
}
function pe(e) {
  return sd.test(e);
}
function Zt(e) {
  return O7.test(e);
}
const _7 = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function I7(e) {
  return Wn(e, _7, cd);
}
function L7(e) {
  return Wn(e, "position", cd);
}
const j7 = /* @__PURE__ */ new Set(["image", "url"]);
function B7(e) {
  return Wn(e, j7, Y7);
}
function W7(e) {
  return Wn(e, "", G7);
}
function sr() {
  return !0;
}
function Wn(e, t, n) {
  const r = sd.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function V7(e) {
  return A7.test(e) && !T7.test(e);
}
function cd() {
  return !1;
}
function G7(e) {
  return k7.test(e);
}
function Y7(e) {
  return H7.test(e);
}
function U7() {
  const e = Re("colors"), t = Re("spacing"), n = Re("blur"), r = Re("brightness"), a = Re("borderColor"), i = Re("borderRadius"), l = Re("borderSpacing"), s = Re("borderWidth"), c = Re("contrast"), d = Re("grayscale"), f = Re("hueRotate"), u = Re("invert"), h = Re("gap"), p = Re("gradientColorStops"), y = Re("gradientColorStopPositions"), m = Re("inset"), b = Re("margin"), $ = Re("opacity"), w = Re("padding"), E = Re("saturate"), P = Re("scale"), x = Re("sepia"), F = Re("skew"), z = Re("space"), N = Re("translate"), A = () => ["auto", "contain", "none"], _ = () => ["auto", "hidden", "clip", "visible", "scroll"], B = () => ["auto", pe, t], j = () => [pe, t], ee = () => ["", Ht, qt], R = () => ["auto", hn, pe], X = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], V = () => ["solid", "dashed", "dotted", "double", "none"], G = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], ne = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], k = () => ["", "0", pe], D = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], O = () => [hn, ra], J = () => [hn, pe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [sr],
      spacing: [Ht, qt],
      blur: ["none", "", Zt, pe],
      brightness: O(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Zt, pe],
      borderSpacing: j(),
      borderWidth: ee(),
      contrast: O(),
      grayscale: k(),
      hueRotate: J(),
      invert: k(),
      gap: j(),
      gradientColorStops: [e],
      gradientColorStopPositions: [R7, qt],
      inset: B(),
      margin: B(),
      opacity: O(),
      padding: j(),
      saturate: O(),
      scale: O(),
      sepia: k(),
      skew: J(),
      space: j(),
      translate: j()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", pe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Zt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...X(), pe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: _()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": _()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": _()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", lr, pe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: B()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", pe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: k()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: k()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", lr, pe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [sr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", lr, pe]
        }, pe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": R()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": R()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [sr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [lr, pe]
        }, pe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": R()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": R()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", pe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", pe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...ne()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ne(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...ne(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [z]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [z]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", pe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [pe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [pe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Zt]
        }, Zt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [pe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [pe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [pe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [pe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Zt, qt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ra]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [sr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", pe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", hn, ra]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ht, pe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", pe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", pe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [$]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [$]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...V(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ht, qt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ht, pe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: j()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", pe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", pe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [$]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...X(), L7]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", I7]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, B7]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [y]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [$]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...V(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [$]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: V()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...V()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ht, pe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ht, qt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ee()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [$]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ht, qt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Zt, W7]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [sr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [$]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": G()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": G()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Zt, pe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [d]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [E]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [d]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [$]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [E]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", pe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: J()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", pe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: J()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", pe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [P]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [P]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [P]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [lr, pe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [N]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [N]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [F]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [F]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", pe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", pe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": j()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": j()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": j()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": j()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": j()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": j()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": j()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": j()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": j()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": j()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": j()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": j()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": j()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": j()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": j()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": j()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": j()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": j()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", pe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ht, qt, ra]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const dd = /* @__PURE__ */ z7(U7);
function ud(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = ud(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function fd() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = ud(e)) && (r && (r += " "), r += t);
  return r;
}
function K(...e) {
  return dd(fd(...e));
}
const y1 = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, b1 = fd, K7 = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return b1(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: a, defaultVariants: i } = t, l = Object.keys(a).map((d) => {
    const f = n == null ? void 0 : n[d], u = i == null ? void 0 : i[d];
    if (f === null) return null;
    const h = y1(f) || y1(u);
    return a[d][h];
  }), s = n && Object.entries(n).reduce((d, f) => {
    let [u, h] = f;
    return h === void 0 || (d[u] = h), d;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, f) => {
    let { class: u, className: h, ...p } = f;
    return Object.entries(p).every((y) => {
      let [m, b] = y;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...s
      }[m]) : {
        ...i,
        ...s
      }[m] === b;
    }) ? [
      ...d,
      u,
      h
    ] : d;
  }, []);
  return b1(e, l, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Pe(...e) {
  const t = K7(...e);
  return (...n) => dd(t(...n));
}
function X7() {
  const [, e] = Ae({});
  return he(() => e({}), []);
}
function aL(e) {
  const t = jt({
    registerSlot: () => null,
    unregisterSlot: () => null,
    context: {}
  }), n = Object.freeze({});
  function r({
    context: l = n,
    slotChildren: s,
    children: c
  }) {
    const d = {};
    e.map(($) => d[$] = []);
    const f = ve(d), u = X7(), [h, p] = Ae(!1);
    _n(() => {
      u(), p(!0);
    }, [u]);
    const y = he(
      ($, w) => {
        var E;
        (E = f.current[$]) == null || E.push(w), h && u();
      },
      [h, u]
    ), m = he(
      ($, w) => {
        const E = f.current[$];
        if (E) {
          const P = E.indexOf(w);
          P !== -1 && E.splice(P, 1);
        }
        u();
      },
      [u]
    ), { current: b } = f;
    return /* @__PURE__ */ v.jsx(
      t.Provider,
      {
        value: {
          registerSlot: y,
          unregisterSlot: m,
          context: l
        },
        children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          c(
            Object.fromEntries(
              Object.entries(b).map(([$, w]) => Array.isArray(w) && w.length === 1 ? [$, w[0]] : [$, w])
            )
          ),
          s
        ] })
      }
    );
  }
  function a({ name: l, children: s }) {
    const { registerSlot: c, unregisterSlot: d, context: f } = gt(t);
    return _n(() => {
      const u = typeof s == "function" ? s(f) : s;
      return c(l, u), () => d(l, u);
    }, [l, s, c, d, f]), null;
  }
  function i() {
    const { context: l } = gt(t);
    return l;
  }
  return { Slots: r, Slot: a, useSlotsContext: i };
}
function q7() {
  const e = Date.now().toString(36), t = Math.random().toString(36).substring(2, 9);
  return `${e}-${t}`;
}
class Vn {
  constructor() {
    ar(this, "x");
    ar(this, "y");
    ar(this, "z");
    ar(this, "duration");
    this.x = 0, this.y = 0, this.z = 0, this.duration = 500;
  }
  findFurthestPoint(t, n, r, a, i, l) {
    return this.x = t - r > n / 2 ? 0 : n, this.y = a - l > i / 2 ? 0 : i, this.z = Math.hypot(this.x - (t - r), this.y - (a - l)), this.z;
  }
  appyStyles(t, n, r, a, i) {
    t.classList.add("ripple"), t.style.backgroundColor = n, t.style.borderRadius = "50%", t.style.pointerEvents = "none", t.style.position = "absolute", t.style.left = `${i.clientX - r.left - a}px`, t.style.top = `${i.clientY - r.top - a}px`, t.style.width = t.style.height = `${a * 2}px`;
  }
  applyAnimation(t, n) {
    t.animate(
      [
        {
          transform: "scale(0)",
          opacity: n
        },
        {
          transform: "scale(1.5)",
          opacity: 0
        }
      ],
      {
        duration: this.duration,
        easing: "linear"
      }
    );
  }
  apply(t, n) {
    const r = t.currentTarget;
    r.style.position = "relative", r.style.overflow = "hidden";
    const a = r.getBoundingClientRect(), i = this.findFurthestPoint(
      t.clientX,
      r.offsetWidth,
      a.left,
      t.clientY,
      r.offsetHeight,
      a.top
    ), l = document.createElement("span");
    this.appyStyles(l, n.color, a, i, t), this.applyAnimation(l, n.opacity), r.appendChild(l), setTimeout(() => l.remove(), this.duration);
  }
}
const Z7 = Pe(["animate-spin", "text-transparent"], {
  variants: {
    variant: {
      primary: ["fill-white"],
      secondary: ["fill-secondary-500"],
      tertiary: ["fill-secondary-500"],
      ancillary: ["fill-secondary-500"],
      destructive: ["fill-white"],
      cta: ["fill-white"],
      link: ["fill-blue-500"]
    },
    inverse: {
      true: []
    },
    size: {
      sm: ["h-4", "w-4"],
      md: ["h-4", "w-4"],
      lg: ["h-5", "w-5"]
    }
  },
  compoundVariants: [
    {
      variant: "primary",
      inverse: !0,
      class: ["fill-secondary-500"]
    },
    {
      variant: "secondary",
      inverse: !0,
      class: ["fill-white"]
    },
    {
      variant: "ancillary",
      inverse: !0,
      class: ["fill-white"]
    },
    {
      variant: "destructive",
      inverse: !0,
      class: ["fill-error-500"]
    }
  ],
  defaultVariants: {
    variant: "primary",
    size: "md"
  }
}), hd = ({
  inverse: e = !1,
  size: t,
  variant: n
}) => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
  /* @__PURE__ */ v.jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: Z7({ inverse: e, size: t, variant: n }),
      fill: "none",
      viewBox: "0 0 100 101",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ v.jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ v.jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: "Loading" })
] }), bt = {
  deepBlueRipple: {
    color: ye.secondary[500],
    opacity: 0.2
  },
  grayRipple: {
    color: ye.deepGray[900]
  },
  linkRipple: {
    color: ye.blue[500],
    opacity: 0.3
  },
  whiteRipple: {
    color: ye.white,
    opacity: 0.3
  }
}, tn = {
  ancillary: bt.deepBlueRipple,
  "ancillary-inverse": bt.whiteRipple,
  cta: bt.whiteRipple,
  "cta-inverse": bt.whiteRipple,
  destructive: bt.whiteRipple,
  link: bt.linkRipple,
  primary: bt.whiteRipple,
  "primary-inverse": bt.deepBlueRipple,
  secondary: bt.deepBlueRipple,
  "secondary-inverse": bt.whiteRipple,
  tertiary: bt.whiteRipple
}, md = Pe(
  [
    "relative",
    "flex",
    "shrink-0",
    "select-none",
    "flex-nowrap",
    "items-center",
    "justify-center",
    "rounded-full",
    "transition-all",
    "duration-200",
    "disabled:pointer-events-none",
    "disabled:opacity-38",
    "overflow-hidden",
    // Baseline styles for focus effect
    "focus:outline-0",
    "focus:outline-offset-0",
    "focus-visible:outline-0",
    "focus-visible:outline-offset-0",
    "outline-none",
    "before:absolute",
    "before:block",
    "before:-inset-y-1",
    "before:inset-x-2",
    "before:bg-transparent",
    // baseline bg of transparent for transition effects
    "focus-visible:before:bg-white/30",
    // This bg color is overridden later in certain variants
    "before:transition-all",
    "before:scale-75",
    // baseline scale of 75 for transition effects
    "focus-visible:before:scale-100",
    // scale to 100 on focus
    "before:rounded-full",
    "before:content-['']",
    "before:pointer-events-none"
  ],
  {
    variants: {
      variant: {
        primary: ["bg-secondary-500", "hover:bg-secondary-700"],
        secondary: ["bg-secondary-500/5", "hover:bg-secondary-500/10", "border-secondary-500", "border-[1.5px]"],
        tertiary: ["bg-gray-200", "hover:bg-gray-400", "focus-visible:before:bg-deepGray-900/10"],
        ancillary: ["bg-transparent", "hover:bg-secondary-100"],
        destructive: ["bg-error-500", "hover:bg-error-600"],
        cta: ["relative", "bg-primary-500", "button-3d-secondary-500", "hover:bg-primary-700"],
        link: ["bg-transparent", "hover:bg-blue-500/[.04]", "focus-visible:before:bg-blue-500/30"]
      },
      inverse: {
        true: []
      },
      dark: {
        true: []
      },
      size: {
        sm: ["h-[2.25rem]", "w-[2.25rem]"],
        md: ["h-[2.75rem]", "w-[2.75rem]"],
        lg: ["h-[3.5rem]", "w-[3.5rem]"]
      }
    },
    compoundVariants: [
      // Size compound variants
      {
        variant: "secondary",
        size: "sm",
        // Using calcs here to subtract the size of the border from the padding and keep consistent button sizing across variants,
        // We tried other tricks, but this works better for subpixel rendering in Safari, and allows our focus state to be consistent.
        class: ["h-[calc(2.25rem-1.5px)]", "w-[calc(2.25rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "md",
        class: ["h-[calc(2.75rem-1.5px)]", "w-[calc(2.75rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "lg",
        class: ["h-[calc(3.5rem-1.5px)]", "w-[calc(3.5rem-1.5px)]"]
      },
      // Inverse compound variants
      {
        variant: "cta",
        inverse: !0,
        class: ["button-3d-white"]
      },
      {
        variant: "cta",
        dark: !0,
        class: ["bg-secondary-500", "button-3d-white", "hover:bg-secondary-800"]
      },
      {
        variant: "primary",
        inverse: !0,
        class: ["bg-white", "hover:bg-secondary-100", "focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "secondary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "secondary",
        inverse: !0,
        class: ["border-white", "bg-white/5", "hover:bg-white/10"]
      },
      {
        variant: "ancillary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "ancillary",
        inverse: !0,
        class: ["hover:bg-white/20"]
      },
      {
        variant: "destructive",
        inverse: !0,
        class: ["bg-white", "hover:bg-gray-100", "focus-visible:before:bg-deepGray-900/10"]
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), wa = {
  ancillary: ye.secondary[500],
  "ancillary-inverse": ye.white,
  cta: ye.white,
  "cta-inverse": ye.white,
  destructive: ye.white,
  "destructive-inverse": ye.error[500],
  link: ye.blue[500],
  primary: ye.white,
  "primary-inverse": ye.secondary[500],
  secondary: ye.secondary[500],
  "secondary-inverse": ye.white,
  tertiary: ye.secondary[500]
}, vd = me(function({ className: t, dark: n = !1, icon: r, inverse: a = !1, loading: i, name: l, size: s = "md", variant: c = "primary", ...d }, f) {
  const u = new Vn(), h = `${c}${a ? "-inverse" : ""}`;
  return /* @__PURE__ */ v.jsx(
    "button",
    {
      "aria-label": l,
      className: md({ className: t, dark: n, inverse: a, size: s, variant: c }),
      ref: f,
      type: "button",
      ...d,
      ...i && { disabled: !0 },
      onMouseDown: (p) => {
        const y = d == null ? void 0 : d.onMouseDown;
        return u.apply(p, tn[h] ?? tn.primary), typeof y == "function" && y(p);
      },
      children: i ? /* @__PURE__ */ v.jsx(hd, { inverse: a, size: s, variant: c }) : /* @__PURE__ */ v.jsx(r, { fill: wa[h] ?? wa.primary, className: "h-6 w-6" })
    }
  );
}), oL = p7, J7 = Pe([], {
  variants: {
    divided: {
      true: ["border-t", "border-b", "first:border-t-0", "last:border-b-0"],
      false: []
    }
  },
  defaultVariants: {
    divided: !1
  }
}), Q7 = g.forwardRef(({ children: e, className: t, divided: n, ...r }, a) => /* @__PURE__ */ v.jsx(td, { ref: a, className: K(J7({ divided: n }), t), ...r, children: e }));
Q7.displayName = td.displayName;
const e8 = g.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ v.jsx(
  nd,
  {
    ref: r,
    className: K("m-0 flex items-center px-4 py-2 text-base font-normal text-text-primary", t),
    ...n,
    children: e
  }
));
e8.displayName = nd.displayName;
const t8 = g.forwardRef(({ className: e, name: t, size: n = "sm", variant: r = "ancillary", ...a }, i) => /* @__PURE__ */ v.jsx(rd, { ref: i, ...a, asChild: !0, children: /* @__PURE__ */ v.jsx(
  vd,
  {
    icon: kc,
    name: t ?? "Accordion Toggle",
    size: n,
    variant: r,
    className: K(
      "ml-2 fill-text-primary [&>svg]:transition-transform [&>svg]:duration-200 [&>svg]:data-[state=open]:rotate-180",
      e
    )
  }
) }));
t8.displayName = rd.displayName;
const n8 = g.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ v.jsx(
  ad,
  {
    ref: r,
    className: "overflow-hidden data-[state=closed]:animate-close-up data-[state=open]:animate-open-down",
    ...n,
    children: /* @__PURE__ */ v.jsx("div", { className: K("pb-4", t), children: e })
  }
));
n8.displayName = ad.displayName;
const r8 = Pe(["p-4", "rounded-md"], {
  variants: {
    variant: {
      standard: ["border"],
      filled: [],
      outlined: ["border", "bg-white"]
    },
    type: {
      default: [],
      success: [],
      info: [],
      error: [],
      warning: []
    },
    full: {
      false: ["w-fit"],
      true: ["w-full"]
    }
  },
  compoundVariants: [
    // filled
    {
      variant: "filled",
      type: "default",
      className: ["bg-gray-100", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "success",
      className: ["bg-success-200", "text-success-900"]
    },
    {
      variant: "filled",
      type: "info",
      className: ["bg-info-200", "text-info-900"]
    },
    {
      variant: "filled",
      type: "warning",
      className: ["bg-warning-200", "text-warning-900"]
    },
    {
      variant: "filled",
      type: "error",
      className: ["bg-error-200", "text-error-900"]
    },
    // standard
    {
      variant: "standard",
      type: "default",
      className: ["border-gray-700", "bg-gray-100", "text-text-primary"]
    },
    {
      variant: "standard",
      type: "success",
      className: ["border-success-900", "bg-success-100", "text-success-900"]
    },
    {
      variant: "standard",
      type: "info",
      className: ["border-info-900", "bg-info-100", "text-info-900"]
    },
    {
      variant: "standard",
      type: "warning",
      className: ["border-warning-900", "bg-warning-100", "text-warning-900"]
    },
    {
      variant: "standard",
      type: "error",
      className: ["border-error-900", "bg-error-100", "text-error-900"]
    },
    // outlined
    {
      variant: "outlined",
      type: "default",
      className: ["border-gray-700", "text-text-primary", "bg-gray-100"]
    },
    {
      variant: "outlined",
      type: "success",
      className: ["border-success-900", "text-success-900", "bg-success-50"]
    },
    {
      variant: "outlined",
      type: "info",
      className: ["border-info-900", "text-info-900", "bg-info-50"]
    },
    {
      variant: "outlined",
      type: "warning",
      className: ["border-warning-900", "text-warning-900", "bg-warning-50"]
    },
    {
      variant: "outlined",
      type: "error",
      className: ["border-error-900", "text-error-900", "bg-error-50"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    type: "default",
    full: !1
  }
}), w1 = {
  default: { fill: ye.text.primary, icon: /* @__PURE__ */ v.jsx(F6, { fill: ye.text.primary }) },
  error: { fill: ye.error[900], icon: /* @__PURE__ */ v.jsx(S6, { fill: ye.error[900] }) },
  info: { fill: ye.info[900], icon: /* @__PURE__ */ v.jsx(P6, { fill: ye.info[900] }) },
  success: { fill: ye.success[900], icon: /* @__PURE__ */ v.jsx(C6, { fill: ye.success[900] }) },
  warning: { fill: ye.warning[900], icon: /* @__PURE__ */ v.jsx(M6, { fill: ye.warning[900] }) }
};
function iL({
  action: e,
  description: t,
  full: n = !1,
  icon: r = !0,
  title: a,
  type: i = "default",
  variant: l = "standard"
}) {
  const s = new Vn();
  return /* @__PURE__ */ v.jsxs("div", { "aria-atomic": "true", "aria-live": "assertive", className: r8({ variant: l, type: i, full: n }), role: "alert", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
      r && /* @__PURE__ */ v.jsx("div", { className: K("mr-3"), children: w1[i].icon }),
      a && /* @__PURE__ */ v.jsx("div", { className: "font-bold", children: a }),
      t && !a && /* @__PURE__ */ v.jsx("div", { className: "text-sm", children: t }),
      e && /* @__PURE__ */ v.jsx("div", { className: "ml-auto shrink-0 pl-4", children: /* @__PURE__ */ v.jsxs(
        "button",
        {
          className: K(
            "flex items-center gap-2 rounded-full px-2 py-1 font-bold hover:enabled:bg-black/10 disabled:opacity-38"
          ),
          onClick: e.onClick,
          type: "button",
          onMouseDown: (c) => {
            s.apply(c, { color: ye.black, opacity: 0.1 });
          },
          disabled: e.loading,
          children: [
            e.loading && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
              /* @__PURE__ */ v.jsxs(
                "svg",
                {
                  "aria-hidden": "true",
                  className: "h-4 w-4 animate-spin text-transparent",
                  fill: w1[i].fill,
                  viewBox: "0 0 100 101",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ v.jsx(
                      "path",
                      {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                      }
                    ),
                    /* @__PURE__ */ v.jsx(
                      "path",
                      {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: "Loading" })
            ] }),
            e.text
          ]
        }
      ) })
    ] }),
    t && a && /* @__PURE__ */ v.jsx("div", { className: K("mt-0.5 text-sm", { "ml-7": r }), children: t })
  ] });
}
const pd = Pe(
  [
    "relative",
    "text-center",
    "font-bold",
    "rounded-full",
    "select-none",
    "disabled:pointer-events-none",
    "transition-all",
    "duration-200",
    "disabled:opacity-38",
    "flex",
    "shrink-0",
    "items-center",
    "flex-nowrap",
    "justify-center",
    "overflow-hidden",
    // Baseline styles for focus effect
    "focus:outline-0",
    "focus:outline-offset-0",
    "focus-visible:outline-0",
    "focus-visible:outline-offset-0",
    "outline-none",
    "before:absolute",
    "before:block",
    "before:-inset-y-3",
    "before:inset-x-2",
    "before:bg-transparent",
    // baseline bg of transparent for transition effects
    "focus-visible:before:bg-white/30",
    // This bg color is overridden later in certain variants
    "before:transition-all",
    "before:scale-75",
    // baseline scale of 75 for transition effects
    "focus-visible:before:scale-100",
    // scale to 100 on focus
    "before:rounded-full",
    "before:content-['']",
    "before:pointer-events-none"
  ],
  {
    variants: {
      variant: {
        primary: ["hover:bg-secondary-700", "text-white", "bg-secondary-500"],
        secondary: [
          "text-secondary-500",
          "hover:bg-secondary-500/10",
          "bg-secondary-500/5",
          "border-secondary-500",
          "border-[1.5px]"
        ],
        tertiary: ["text-secondary-500", "bg-gray-200", "hover:bg-gray-400", "focus-visible:before:bg-deepGray-900/10"],
        ancillary: ["hover:bg-secondary-100", "bg-transparent", "text-secondary-500"],
        destructive: ["bg-error-500", "hover:bg-error-600", "text-white"],
        cta: ["text-white", "relative", "button-3d-secondary-500", "bg-primary-500", "hover:bg-primary-700"],
        link: ["text-blue-500", "hover:bg-blue-500/[.04]", "bg-transparent", "focus-visible:before:bg-blue-500/30"]
      },
      inverse: {
        true: []
      },
      dark: {
        true: []
      },
      full: {
        true: "w-full"
      },
      size: {
        sm: ["px-[0.75rem]", "py-[0.25rem]", "gap-2", "before:inset-x-2"],
        md: ["text-lg", "px-[1.25rem]", "py-[0.5rem]", "gap-2", "before:inset-x-4"],
        lg: ["text-xl", "px-[1.5rem]", "py-[1rem]", "gap-3", "before:inset-x-4"]
      }
    },
    compoundVariants: [
      // Size compound variants
      {
        variant: "secondary",
        size: "sm",
        // Using calcs here to subtract the size of the border from the padding and keep consistent button sizing across variants,
        // We tried other tricks (like box shadow), but this works better for subpixel rendering in Safari, and allows our focus state to be consistent.
        class: ["px-[calc(0.75rem-1.5px)]", "py-[calc(0.25rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "md",
        class: ["px-[calc(1.25rem-1.5px)]", "py-[calc(0.5rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "lg",
        class: ["px-[calc(1.5rem-1.5px)]", "py-[calc(1rem-1.5px)]"]
      },
      // Inverse compound variants
      {
        variant: "cta",
        inverse: !0,
        class: ["button-3d-white"]
      },
      {
        variant: "cta",
        dark: !0,
        class: ["button-3d-white", "bg-secondary-500", "hover:bg-secondary-800"]
      },
      {
        variant: "primary",
        inverse: !0,
        class: ["hover:bg-secondary-100", "text-secondary-500", "bg-white", "focus-visible:before:bg-secondary-500/30"]
      },
      {
        variant: "secondary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "secondary",
        inverse: !0,
        class: ["hover:bg-white/10", "text-white", "bg-white/5", "border-white"]
      },
      {
        variant: "ancillary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "ancillary",
        inverse: !0,
        class: ["text-white", "hover:bg-white/20"]
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), a8 = me(function({
  children: t,
  className: n,
  dark: r = !1,
  full: a,
  icon: i,
  inverse: l = !1,
  loading: s,
  size: c = "md",
  variant: d = "primary",
  ...f
}, u) {
  const h = new Vn();
  return /* @__PURE__ */ v.jsxs(
    "button",
    {
      type: "button",
      ref: u,
      className: pd({ variant: d, size: c, full: a, inverse: l, className: n, dark: r }),
      ...f,
      ...s && { disabled: !0 },
      onMouseDown: (p) => {
        const y = f == null ? void 0 : f.onMouseDown;
        return h.apply(
          p,
          tn[`${d}${l ? "-inverse" : ""}`] ?? tn.primary
        ), typeof y == "function" && y(p);
      },
      children: [
        s ? /* @__PURE__ */ v.jsx(hd, { inverse: l, size: c, variant: d }) : i ? /* @__PURE__ */ v.jsx(
          "span",
          {
            className: K("[&>*]:h-full [&>*]:w-full", {
              "h-4 w-4": c === "sm",
              "h-5 w-5": c === "md",
              "h-6 w-6": c === "lg"
            }),
            children: i
          }
        ) : null,
        /* @__PURE__ */ v.jsx("span", { className: "relative z-[1]", children: t })
      ]
    }
  );
}), lL = me(function({
  as: t,
  children: n,
  className: r,
  dark: a = !1,
  disabled: i = !1,
  full: l,
  icon: s,
  inverse: c = !1,
  size: d = "md",
  variant: f = "primary",
  ...u
}, h) {
  const p = pd({ variant: f, size: d, full: l, inverse: c, className: r, dark: a }), y = /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    s ? /* @__PURE__ */ v.jsx(
      "span",
      {
        className: K("[&>*]:h-full [&>*]:w-full", {
          "h-4 w-4": d === "sm",
          "h-5 w-5": d === "md",
          "h-6 w-6": d === "lg"
        }),
        children: s
      }
    ) : null,
    /* @__PURE__ */ v.jsx("span", { className: "relative z-[1]", children: n })
  ] });
  if (i)
    return /* @__PURE__ */ v.jsx("span", { ref: h, className: K(p, "pointer-events-none opacity-38"), children: y });
  const m = t ?? "a", b = new Vn();
  return /* @__PURE__ */ v.jsx(
    m,
    {
      ref: h,
      className: p,
      ...u,
      onMouseDown: ($) => {
        const w = u == null ? void 0 : u.onMouseDown;
        return b.apply(
          $,
          tn[`${f}${c ? "-inverse" : ""}`] ?? tn.primary
        ), typeof w == "function" && w($);
      },
      children: y
    }
  );
});
function o8(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const Fo = {}, hr = {};
function mn(e, t) {
  try {
    const r = (Fo[e] || (Fo[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1];
    return r in hr ? hr[r] : $1(r, r.split(":"));
  } catch {
    if (e in hr) return hr[e];
    const n = e == null ? void 0 : e.match(i8);
    return n ? $1(e, n.slice(1)) : NaN;
  }
}
const i8 = /([+-]\d\d):?(\d\d)?/;
function $1(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), a = +(t[2] || 0) / 60;
  return hr[e] = n * 60 + r > 0 ? n * 60 + r + a : n * 60 - r - a;
}
class Dt extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(mn(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), gd(this), si(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Dt(...n, t) : new Dt(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Dt(+this, t);
  }
  getTimezoneOffset() {
    const t = -mn(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), si(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Dt(+new Date(t), this.timeZone);
  }
  //#endregion
}
const E1 = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!E1.test(e)) return;
  const t = e.replace(E1, "$1UTC");
  Dt.prototype[t] && (e.startsWith("get") ? Dt.prototype[e] = function() {
    return this.internal[t]();
  } : (Dt.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), l8(this), +this;
  }, Dt.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), si(this), +this;
  }));
});
function si(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-mn(e.timeZone, e) * 60));
}
function l8(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), gd(e);
}
function gd(e) {
  const t = mn(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), r = /* @__PURE__ */ new Date(+e);
  r.setUTCHours(r.getUTCHours() - 1);
  const a = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), l = a - i, s = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  l && s && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + l);
  const c = a - n;
  c && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + c);
  const d = /* @__PURE__ */ new Date(+e);
  d.setUTCSeconds(0);
  const f = a > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, u = Math.round(-(mn(e.timeZone, e) * 60)) % 60;
  (u || f) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + u), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + u + f));
  const h = mn(e.timeZone, e), p = h > 0 ? Math.floor(h) : Math.ceil(h), m = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - p, b = p !== n, $ = m - c;
  if (b && $) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + $);
    const w = mn(e.timeZone, e), E = w > 0 ? Math.floor(w) : Math.ceil(w), P = p - E;
    P && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + P), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + P));
  }
}
class Xe extends Dt {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Xe(...n, t) : new Xe(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), a = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + a;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, a] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${a}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, a] = this.tzComponents();
    return `${t} GMT${n}${r}${a} (${o8(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), a = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, a];
  }
  //#endregion
  withTimeZone(t) {
    return new Xe(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Xe(+new Date(t), this.timeZone);
  }
  //#endregion
}
const yd = 6048e5, s8 = 864e5, x1 = Symbol.for("constructDateFrom");
function Ve(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && x1 in e ? e[x1](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Te(e, t) {
  return Ve(t || e, e);
}
function bd(e, t, n) {
  const r = Te(e, n == null ? void 0 : n.in);
  return isNaN(t) ? Ve(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function wd(e, t, n) {
  const r = Te(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return Ve(e, NaN);
  if (!t)
    return r;
  const a = r.getDate(), i = Ve(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const l = i.getDate();
  return a >= l ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), r);
}
let c8 = {};
function Tr() {
  return c8;
}
function In(e, t) {
  var s, c, d, f;
  const n = Tr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, a = Te(e, t == null ? void 0 : t.in), i = a.getDay(), l = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - l), a.setHours(0, 0, 0, 0), a;
}
function br(e, t) {
  return In(e, { ...t, weekStartsOn: 1 });
}
function $d(e, t) {
  const n = Te(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = Ve(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = br(a), l = Ve(n, 0);
  l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0);
  const s = br(l);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function M1(e) {
  const t = Te(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Gn(e, ...t) {
  const n = Ve.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function wr(e, t) {
  const n = Te(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function sl(e, t, n) {
  const [r, a] = Gn(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = wr(r), l = wr(a), s = +i - M1(i), c = +l - M1(l);
  return Math.round((s - c) / s8);
}
function d8(e, t) {
  const n = $d(e, t), r = Ve(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), br(r);
}
function u8(e, t, n) {
  return bd(e, t * 7, n);
}
function f8(e, t, n) {
  return wd(e, t * 12, n);
}
function h8(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((a) => {
    !r && typeof a == "object" && (r = Ve.bind(null, a));
    const i = Te(a, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Ve(r, n || NaN);
}
function m8(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((a) => {
    !r && typeof a == "object" && (r = Ve.bind(null, a));
    const i = Te(a, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Ve(r, n || NaN);
}
function v8(e, t, n) {
  const [r, a] = Gn(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +wr(r) == +wr(a);
}
function Ed(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function p8(e) {
  return !(!Ed(e) && typeof e != "number" || isNaN(+Te(e)));
}
function xd(e, t, n) {
  const [r, a] = Gn(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = r.getFullYear() - a.getFullYear(), l = r.getMonth() - a.getMonth();
  return i * 12 + l;
}
function g8(e, t) {
  const n = Te(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Md(e, t) {
  const [n, r] = Gn(e, t.start, t.end);
  return { start: n, end: r };
}
function y8(e, t) {
  const { start: n, end: r } = Md(t == null ? void 0 : t.in, e);
  let a = +n > +r;
  const i = a ? +n : +r, l = a ? r : n;
  l.setHours(0, 0, 0, 0), l.setDate(1);
  let s = 1;
  const c = [];
  for (; +l <= i; )
    c.push(Ve(n, l)), l.setMonth(l.getMonth() + s);
  return a ? c.reverse() : c;
}
function b8(e, t) {
  const n = Te(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function w8(e, t) {
  const n = Te(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Cd(e, t) {
  const n = Te(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function $8(e, t) {
  const { start: n, end: r } = Md(t == null ? void 0 : t.in, e);
  let a = +n > +r;
  const i = a ? +n : +r, l = a ? r : n;
  l.setHours(0, 0, 0, 0), l.setMonth(0, 1);
  let s = 1;
  const c = [];
  for (; +l <= i; )
    c.push(Ve(n, l)), l.setFullYear(l.getFullYear() + s);
  return a ? c.reverse() : c;
}
function Pd(e, t) {
  var s, c, d, f;
  const n = Tr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, a = Te(e, t == null ? void 0 : t.in), i = a.getDay(), l = (i < r ? -7 : 0) + 6 - (i - r);
  return a.setDate(a.getDate() + l), a.setHours(23, 59, 59, 999), a;
}
function E8(e, t) {
  return Pd(e, { ...t, weekStartsOn: 1 });
}
const x8 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, M8 = (e, t, n) => {
  let r;
  const a = x8[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function zo(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const C8 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, P8 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, S8 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, F8 = {
  date: zo({
    formats: C8,
    defaultWidth: "full"
  }),
  time: zo({
    formats: P8,
    defaultWidth: "full"
  }),
  dateTime: zo({
    formats: S8,
    defaultWidth: "full"
  })
}, z8 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, N8 = (e, t, n, r) => z8[e];
function cr(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : l;
      a = e.formattingValues[s] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[l];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const D8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, O8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, A8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, T8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, k8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, H8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, R8 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, _8 = {
  ordinalNumber: R8,
  era: cr({
    values: D8,
    defaultWidth: "wide"
  }),
  quarter: cr({
    values: O8,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: cr({
    values: A8,
    defaultWidth: "wide"
  }),
  day: cr({
    values: T8,
    defaultWidth: "wide"
  }),
  dayPeriod: cr({
    values: k8,
    defaultWidth: "wide",
    formattingValues: H8,
    defaultFormattingWidth: "wide"
  })
};
function dr(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const l = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? L8(s, (u) => u.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      I8(s, (u) => u.test(l))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(c) : c, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(l.length);
    return { value: d, rest: f };
  };
}
function I8(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function L8(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function j8(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let l = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const s = t.slice(a.length);
    return { value: l, rest: s };
  };
}
const B8 = /^(\d+)(th|st|nd|rd)?/i, W8 = /\d+/i, V8 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, G8 = {
  any: [/^b/i, /^(a|c)/i]
}, Y8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, U8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, K8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, X8 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, q8 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Z8 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, J8 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Q8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, e9 = {
  ordinalNumber: j8({
    matchPattern: B8,
    parsePattern: W8,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: dr({
    matchPatterns: V8,
    defaultMatchWidth: "wide",
    parsePatterns: G8,
    defaultParseWidth: "any"
  }),
  quarter: dr({
    matchPatterns: Y8,
    defaultMatchWidth: "wide",
    parsePatterns: U8,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: dr({
    matchPatterns: K8,
    defaultMatchWidth: "wide",
    parsePatterns: X8,
    defaultParseWidth: "any"
  }),
  day: dr({
    matchPatterns: q8,
    defaultMatchWidth: "wide",
    parsePatterns: Z8,
    defaultParseWidth: "any"
  }),
  dayPeriod: dr({
    matchPatterns: J8,
    defaultMatchWidth: "any",
    parsePatterns: Q8,
    defaultParseWidth: "any"
  })
}, On = {
  code: "en-US",
  formatDistance: M8,
  formatLong: F8,
  formatRelative: N8,
  localize: _8,
  match: e9,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function t9(e, t) {
  const n = Te(e, t == null ? void 0 : t.in);
  return sl(n, Cd(n)) + 1;
}
function cl(e, t) {
  const n = Te(e, t == null ? void 0 : t.in), r = +br(n) - +d8(n);
  return Math.round(r / yd) + 1;
}
function Sd(e, t) {
  var f, u, h, p;
  const n = Te(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = Tr(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : u.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, l = Ve((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r + 1, 0, i), l.setHours(0, 0, 0, 0);
  const s = In(l, t), c = Ve((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(r, 0, i), c.setHours(0, 0, 0, 0);
  const d = In(c, t);
  return +n >= +s ? r + 1 : +n >= +d ? r : r - 1;
}
function n9(e, t) {
  var s, c, d, f;
  const n = Tr(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, a = Sd(e, t), i = Ve((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), In(i, t);
}
function dl(e, t) {
  const n = Te(e, t == null ? void 0 : t.in), r = +In(n, t) - +n9(n, t);
  return Math.round(r / yd) + 1;
}
function Oe(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Jt = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Oe(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Oe(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Oe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Oe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Oe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Oe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Oe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Oe(a, t.length);
  }
}, Mn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, C1 = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return Jt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = Sd(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const l = i % 100;
      return Oe(l, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Oe(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = $d(e);
    return Oe(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Oe(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Oe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Oe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Jt.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Oe(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = dl(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : Oe(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = cl(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Oe(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Jt.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = t9(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Oe(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Oe(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Oe(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Oe(a, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = Mn.noon : r === 0 ? a = Mn.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = Mn.evening : r >= 12 ? a = Mn.afternoon : r >= 4 ? a = Mn.morning : a = Mn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Jt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Jt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Oe(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Oe(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Jt.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Jt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Jt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return S1(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return fn(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return fn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return S1(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return fn(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return fn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + P1(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + fn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + P1(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + fn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Oe(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Oe(+e, t.length);
  }
};
function P1(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + Oe(i, 2);
}
function S1(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Oe(Math.abs(e) / 60, 2) : fn(e, t);
}
function fn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Oe(Math.trunc(r / 60), 2), i = Oe(r % 60, 2);
  return n + a + t + i;
}
const F1 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Fd = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, r9 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return F1(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", F1(r, t)).replace("{{time}}", Fd(a, t));
}, a9 = {
  p: Fd,
  P: r9
}, o9 = /^D+$/, i9 = /^Y+$/, l9 = ["D", "DD", "YY", "YYYY"];
function s9(e) {
  return o9.test(e);
}
function c9(e) {
  return i9.test(e);
}
function d9(e, t, n) {
  const r = u9(e, t, n);
  if (console.warn(r), l9.includes(e)) throw new RangeError(r);
}
function u9(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const f9 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, h9 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, m9 = /^'([^]*?)'?$/, v9 = /''/g, p9 = /[a-zA-Z]/;
function mr(e, t, n) {
  var f, u, h, p, y, m, b, $;
  const r = Tr(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? On, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, l = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? (($ = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : $.weekStartsOn) ?? 0, s = Te(e, n == null ? void 0 : n.in);
  if (!p8(s))
    throw new RangeError("Invalid time value");
  let c = t.match(h9).map((w) => {
    const E = w[0];
    if (E === "p" || E === "P") {
      const P = a9[E];
      return P(w, a.formatLong);
    }
    return w;
  }).join("").match(f9).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const E = w[0];
    if (E === "'")
      return { isToken: !1, value: g9(w) };
    if (C1[E])
      return { isToken: !0, value: w };
    if (E.match(p9))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + E + "`"
      );
    return { isToken: !1, value: w };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: l,
    locale: a
  };
  return c.map((w) => {
    if (!w.isToken) return w.value;
    const E = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && c9(E) || !(n != null && n.useAdditionalDayOfYearTokens) && s9(E)) && d9(E, t, String(e));
    const P = C1[E[0]];
    return P(s, E, a.localize, d);
  }).join("");
}
function g9(e) {
  const t = e.match(m9);
  return t ? t[1].replace(v9, "'") : e;
}
function y9(e, t) {
  const n = Te(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = n.getMonth(), i = Ve(n, 0);
  return i.setFullYear(r, a + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function b9(e, t) {
  return Te(e, t == null ? void 0 : t.in).getMonth();
}
function w9(e, t) {
  return Te(e, t == null ? void 0 : t.in).getFullYear();
}
function $9(e, t) {
  return +Te(e) > +Te(t);
}
function E9(e, t) {
  return +Te(e) < +Te(t);
}
function x9(e, t, n) {
  const [r, a] = Gn(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === a.getFullYear() && r.getMonth() === a.getMonth();
}
function M9(e, t, n) {
  const [r, a] = Gn(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === a.getFullYear();
}
function C9(e, t, n) {
  const r = Te(e, n == null ? void 0 : n.in), a = r.getFullYear(), i = r.getDate(), l = Ve(e, 0);
  l.setFullYear(a, t, 15), l.setHours(0, 0, 0, 0);
  const s = y9(l);
  return r.setMonth(t, Math.min(i, s)), r;
}
function P9(e, t, n) {
  const r = Te(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? Ve(e, NaN) : (r.setFullYear(t), r);
}
const z1 = 5, S9 = 4;
function F9(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, a = t.addDays(e, -r + 1), i = t.addDays(a, z1 * 7 - 1);
  return t.getMonth(e) === t.getMonth(i) ? z1 : S9;
}
function zd(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function z9(e, t) {
  const n = zd(e, t), r = F9(e, t);
  return t.addDays(n, r * 7 - 1);
}
const Nd = {
  ...On,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let a;
      r && typeof r.format == "function" ? a = r.format.bind(r) : a = (l, s) => mr(l, s, { locale: On, ...n });
      let i = a(e, "PPPP");
      return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (a, i) => mr(a, i, { locale: On, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let a;
      r && typeof r.format == "function" ? a = r.format.bind(r) : a = (l, s) => mr(l, s, { locale: On, ...n });
      let i = a(e, "PPPP");
      return t != null && t.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (a, i) => mr(a, i, { locale: On, ...t }), r(e, "cccc");
    }
  }
};
class ut {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? Xe.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, a, i) => {
      var l;
      return (l = this.overrides) != null && l.newDate ? this.overrides.newDate(r, a, i) : this.options.timeZone ? new Xe(r, a, i, this.options.timeZone) : new Date(r, a, i);
    }, this.addDays = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.addDays ? this.overrides.addDays(r, a) : bd(r, a);
    }, this.addMonths = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.addMonths ? this.overrides.addMonths(r, a) : wd(r, a);
    }, this.addWeeks = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.addWeeks ? this.overrides.addWeeks(r, a) : u8(r, a);
    }, this.addYears = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.addYears ? this.overrides.addYears(r, a) : f8(r, a);
    }, this.differenceInCalendarDays = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, a) : sl(r, a);
    }, this.differenceInCalendarMonths = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, a) : xd(r, a);
    }, this.eachMonthOfInterval = (r) => {
      var a;
      return (a = this.overrides) != null && a.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : y8(r);
    }, this.eachYearOfInterval = (r) => {
      var s;
      const a = (s = this.overrides) != null && s.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : $8(r), i = new Set(a.map((c) => this.getYear(c)));
      if (i.size === a.length)
        return a;
      const l = [];
      return i.forEach((c) => {
        l.push(new Date(c, 0, 1));
      }), l;
    }, this.endOfBroadcastWeek = (r) => {
      var a;
      return (a = this.overrides) != null && a.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : z9(r, this);
    }, this.endOfISOWeek = (r) => {
      var a;
      return (a = this.overrides) != null && a.endOfISOWeek ? this.overrides.endOfISOWeek(r) : E8(r);
    }, this.endOfMonth = (r) => {
      var a;
      return (a = this.overrides) != null && a.endOfMonth ? this.overrides.endOfMonth(r) : g8(r);
    }, this.endOfWeek = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, a) : Pd(r, this.options);
    }, this.endOfYear = (r) => {
      var a;
      return (a = this.overrides) != null && a.endOfYear ? this.overrides.endOfYear(r) : w8(r);
    }, this.format = (r, a, i) => {
      var s;
      const l = (s = this.overrides) != null && s.format ? this.overrides.format(r, a, this.options) : mr(r, a, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(l) : l;
    }, this.getISOWeek = (r) => {
      var a;
      return (a = this.overrides) != null && a.getISOWeek ? this.overrides.getISOWeek(r) : cl(r);
    }, this.getMonth = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.getMonth ? this.overrides.getMonth(r, this.options) : b9(r, this.options);
    }, this.getYear = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.getYear ? this.overrides.getYear(r, this.options) : w9(r, this.options);
    }, this.getWeek = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : dl(r, this.options);
    }, this.isAfter = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.isAfter ? this.overrides.isAfter(r, a) : $9(r, a);
    }, this.isBefore = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.isBefore ? this.overrides.isBefore(r, a) : E9(r, a);
    }, this.isDate = (r) => {
      var a;
      return (a = this.overrides) != null && a.isDate ? this.overrides.isDate(r) : Ed(r);
    }, this.isSameDay = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.isSameDay ? this.overrides.isSameDay(r, a) : v8(r, a);
    }, this.isSameMonth = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.isSameMonth ? this.overrides.isSameMonth(r, a) : x9(r, a);
    }, this.isSameYear = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.isSameYear ? this.overrides.isSameYear(r, a) : M9(r, a);
    }, this.max = (r) => {
      var a;
      return (a = this.overrides) != null && a.max ? this.overrides.max(r) : h8(r);
    }, this.min = (r) => {
      var a;
      return (a = this.overrides) != null && a.min ? this.overrides.min(r) : m8(r);
    }, this.setMonth = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.setMonth ? this.overrides.setMonth(r, a) : C9(r, a);
    }, this.setYear = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.setYear ? this.overrides.setYear(r, a) : P9(r, a);
    }, this.startOfBroadcastWeek = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : zd(r, this);
    }, this.startOfDay = (r) => {
      var a;
      return (a = this.overrides) != null && a.startOfDay ? this.overrides.startOfDay(r) : wr(r);
    }, this.startOfISOWeek = (r) => {
      var a;
      return (a = this.overrides) != null && a.startOfISOWeek ? this.overrides.startOfISOWeek(r) : br(r);
    }, this.startOfMonth = (r) => {
      var a;
      return (a = this.overrides) != null && a.startOfMonth ? this.overrides.startOfMonth(r) : b8(r);
    }, this.startOfWeek = (r, a) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : In(r, this.options);
    }, this.startOfYear = (r) => {
      var a;
      return (a = this.overrides) != null && a.startOfYear ? this.overrides.startOfYear(r) : Cd(r);
    }, this.options = { locale: Nd, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let a = 0; a < 10; a++)
      r[a.toString()] = n.format(a);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    var n;
    const t = (n = this.options.locale) == null ? void 0 : n.code;
    return t && ut.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: a } = this.options, i = n == null ? void 0 : n.code;
    if (i && ut.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: a
        }).format(t);
      } catch {
      }
    const l = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, l);
  }
}
ut.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const kt = new ut();
class Dd {
  constructor(t, n, r = kt) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class N9 {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class D9 {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function O9(e) {
  return o.createElement("button", { ...e });
}
function A9(e) {
  return o.createElement("span", { ...e });
}
function T9(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    o.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && o.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && o.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && o.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && o.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function k9(e) {
  const { day: t, modifiers: n, ...r } = e;
  return o.createElement("td", { ...r });
}
function H9(e) {
  const { day: t, modifiers: n, ...r } = e, a = o.useRef(null);
  return o.useEffect(() => {
    var i;
    n.focused && ((i = a.current) == null || i.focus());
  }, [n.focused]), o.createElement("button", { ref: a, ...r });
}
var le;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(le || (le = {}));
var _e;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(_e || (_e = {}));
var Ct;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Ct || (Ct = {}));
var it;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(it || (it = {}));
function R9(e) {
  const { options: t, className: n, components: r, classNames: a, ...i } = e, l = [a[le.Dropdown], n].join(" "), s = t == null ? void 0 : t.find(({ value: c }) => c === i.value);
  return o.createElement(
    "span",
    { "data-disabled": i.disabled, className: a[le.DropdownRoot] },
    o.createElement(r.Select, { className: l, ...i }, t == null ? void 0 : t.map(({ value: c, label: d, disabled: f }) => o.createElement(r.Option, { key: c, value: c, disabled: f }, d))),
    o.createElement(
      "span",
      { className: a[le.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      o.createElement(r.Chevron, { orientation: "down", size: 18, className: a[le.Chevron] })
    )
  );
}
function _9(e) {
  return o.createElement("div", { ...e });
}
function I9(e) {
  return o.createElement("div", { ...e });
}
function L9(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return o.createElement("div", { ...r }, e.children);
}
function j9(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return o.createElement("div", { ...r });
}
function B9(e) {
  return o.createElement("table", { ...e });
}
function W9(e) {
  return o.createElement("div", { ...e });
}
const Od = jt(void 0);
function kr() {
  const e = gt(Od);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function V9(e) {
  const { components: t } = kr();
  return o.createElement(t.Dropdown, { ...e });
}
function G9(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: a, ...i } = e, { components: l, classNames: s, labels: { labelPrevious: c, labelNext: d } } = kr(), f = he((h) => {
    a && (n == null || n(h));
  }, [a, n]), u = he((h) => {
    r && (t == null || t(h));
  }, [r, t]);
  return o.createElement(
    "nav",
    { ...i },
    o.createElement(
      l.PreviousMonthButton,
      { type: "button", className: s[le.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      o.createElement(l.Chevron, { disabled: r ? void 0 : !0, className: s[le.Chevron], orientation: "left" })
    ),
    o.createElement(
      l.NextMonthButton,
      { type: "button", className: s[le.NextMonthButton], tabIndex: a ? void 0 : -1, "aria-disabled": a ? void 0 : !0, "aria-label": d(a), onClick: f },
      o.createElement(l.Chevron, { disabled: a ? void 0 : !0, orientation: "right", className: s[le.Chevron] })
    )
  );
}
function Y9(e) {
  const { components: t } = kr();
  return o.createElement(t.Button, { ...e });
}
function U9(e) {
  return o.createElement("option", { ...e });
}
function K9(e) {
  const { components: t } = kr();
  return o.createElement(t.Button, { ...e });
}
function X9(e) {
  const { rootRef: t, ...n } = e;
  return o.createElement("div", { ...n, ref: t });
}
function q9(e) {
  return o.createElement("select", { ...e });
}
function Z9(e) {
  const { week: t, ...n } = e;
  return o.createElement("tr", { ...n });
}
function J9(e) {
  return o.createElement("th", { ...e });
}
function Q9(e) {
  return o.createElement(
    "thead",
    { "aria-hidden": !0 },
    o.createElement("tr", { ...e })
  );
}
function ev(e) {
  const { week: t, ...n } = e;
  return o.createElement("th", { ...n });
}
function tv(e) {
  return o.createElement("th", { ...e });
}
function nv(e) {
  return o.createElement("tbody", { ...e });
}
function rv(e) {
  const { components: t } = kr();
  return o.createElement(t.Dropdown, { ...e });
}
const av = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: O9,
  CaptionLabel: A9,
  Chevron: T9,
  Day: k9,
  DayButton: H9,
  Dropdown: R9,
  DropdownNav: _9,
  Footer: I9,
  Month: L9,
  MonthCaption: j9,
  MonthGrid: B9,
  Months: W9,
  MonthsDropdown: V9,
  Nav: G9,
  NextMonthButton: Y9,
  Option: U9,
  PreviousMonthButton: K9,
  Root: X9,
  Select: q9,
  Week: Z9,
  WeekNumber: ev,
  WeekNumberHeader: tv,
  Weekday: J9,
  Weekdays: Q9,
  Weeks: nv,
  YearsDropdown: rv
}, Symbol.toStringTag, { value: "Module" }));
function _t(e, t, n = !1, r = kt) {
  let { from: a, to: i } = e;
  const { differenceInCalendarDays: l, isSameDay: s } = r;
  return a && i ? (l(i, a) < 0 && ([a, i] = [i, a]), l(t, a) >= (n ? 1 : 0) && l(i, t) >= (n ? 1 : 0)) : !n && i ? s(i, t) : !n && a ? s(a, t) : !1;
}
function ul(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Ba(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function fl(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function hl(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Ad(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Td(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function It(e, t, n = kt) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: a, differenceInCalendarDays: i, isAfter: l } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return a(e, s);
    if (Td(s, n))
      return s.some((c) => a(e, c));
    if (Ba(s))
      return _t(s, e, !1, n);
    if (Ad(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (ul(s)) {
      const c = i(s.before, e), d = i(s.after, e), f = c > 0, u = d < 0;
      return l(s.before, s.after) ? u && f : f || u;
    }
    return fl(s) ? i(e, s.after) > 0 : hl(s) ? i(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function ov(e, t, n, r, a) {
  const { disabled: i, hidden: l, modifiers: s, showOutsideDays: c, broadcastCalendar: d, today: f = a.today() } = t, { isSameDay: u, isSameMonth: h, startOfMonth: p, isBefore: y, endOfMonth: m, isAfter: b } = a, $ = n && p(n), w = r && m(r), E = {
    [_e.focused]: [],
    [_e.outside]: [],
    [_e.disabled]: [],
    [_e.hidden]: [],
    [_e.today]: []
  }, P = {};
  for (const x of e) {
    const { date: F, displayMonth: z } = x, N = !!(z && !h(F, z)), A = !!($ && y(F, $)), _ = !!(w && b(F, w)), B = !!(i && It(F, i, a)), j = !!(l && It(F, l, a)) || A || _ || // Broadcast calendar will show outside days as default
    !d && !c && N || d && c === !1 && N, ee = u(F, f);
    N && E.outside.push(x), B && E.disabled.push(x), j && E.hidden.push(x), ee && E.today.push(x), s && Object.keys(s).forEach((R) => {
      const X = s == null ? void 0 : s[R];
      X && It(F, X, a) && (P[R] ? P[R].push(x) : P[R] = [x]);
    });
  }
  return (x) => {
    const F = {
      [_e.focused]: !1,
      [_e.disabled]: !1,
      [_e.hidden]: !1,
      [_e.outside]: !1,
      [_e.today]: !1
    }, z = {};
    for (const N in E) {
      const A = E[N];
      F[N] = A.some((_) => _ === x);
    }
    for (const N in P)
      z[N] = P[N].some((A) => A === x);
    return {
      ...F,
      // custom modifiers should override all the previous ones
      ...z
    };
  };
}
function iv(e, t, n = {}) {
  return Object.entries(e).filter(([, a]) => a === !0).reduce((a, [i]) => (n[i] ? a.push(n[i]) : t[_e[i]] ? a.push(t[_e[i]]) : t[Ct[i]] && a.push(t[Ct[i]]), a), [t[le.Day]]);
}
function lv(e) {
  return {
    ...av,
    ...e
  };
}
function sv(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function cv() {
  const e = {};
  for (const t in le)
    e[le[t]] = `rdp-${le[t]}`;
  for (const t in _e)
    e[_e[t]] = `rdp-${_e[t]}`;
  for (const t in Ct)
    e[Ct[t]] = `rdp-${Ct[t]}`;
  for (const t in it)
    e[it[t]] = `rdp-${it[t]}`;
  return e;
}
function kd(e, t, n) {
  return (n ?? new ut(t)).formatMonthYear(e);
}
const dv = kd;
function uv(e, t, n) {
  return (n ?? new ut(t)).format(e, "d");
}
function fv(e, t = kt) {
  return t.format(e, "LLLL");
}
function hv(e, t, n) {
  return (n ?? new ut(t)).format(e, "cccccc");
}
function mv(e, t = kt) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function vv() {
  return "";
}
function Hd(e, t = kt) {
  return t.format(e, "yyyy");
}
const pv = Hd, gv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: kd,
  formatDay: uv,
  formatMonthCaption: dv,
  formatMonthDropdown: fv,
  formatWeekNumber: mv,
  formatWeekNumberHeader: vv,
  formatWeekdayName: hv,
  formatYearCaption: pv,
  formatYearDropdown: Hd
}, Symbol.toStringTag, { value: "Module" }));
function yv(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...gv,
    ...e
  };
}
function ml(e, t, n, r) {
  let a = (r ?? new ut(n)).format(e, "PPPP");
  return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
}
const bv = ml;
function vl(e, t, n) {
  return (n ?? new ut(t)).formatMonthYear(e);
}
const wv = vl;
function Rd(e, t, n, r) {
  let a = (r ?? new ut(n)).format(e, "PPPP");
  return t != null && t.today && (a = `Today, ${a}`), a;
}
function _d(e) {
  return "Choose the Month";
}
function Id() {
  return "";
}
const $v = "Go to the Next Month";
function Ld(e, t) {
  return $v;
}
function jd(e) {
  return "Go to the Previous Month";
}
function Bd(e, t, n) {
  return (n ?? new ut(t)).format(e, "cccc");
}
function Wd(e, t) {
  return `Week ${e}`;
}
function Vd(e) {
  return "Week Number";
}
function Gd(e) {
  return "Choose the Year";
}
const Ev = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: wv,
  labelDay: bv,
  labelDayButton: ml,
  labelGrid: vl,
  labelGridcell: Rd,
  labelMonthDropdown: _d,
  labelNav: Id,
  labelNext: Ld,
  labelPrevious: jd,
  labelWeekNumber: Wd,
  labelWeekNumberHeader: Vd,
  labelWeekday: Bd,
  labelYearDropdown: Gd
}, Symbol.toStringTag, { value: "Module" })), wt = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function xv(e, t) {
  var r;
  const n = ((r = t.locale) == null ? void 0 : r.labels) ?? {};
  return {
    ...Ev,
    ...e ?? {},
    labelDayButton: wt(ml, e == null ? void 0 : e.labelDayButton, n.labelDayButton),
    labelMonthDropdown: wt(_d, e == null ? void 0 : e.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: wt(Ld, e == null ? void 0 : e.labelNext, n.labelNext),
    labelPrevious: wt(jd, e == null ? void 0 : e.labelPrevious, n.labelPrevious),
    labelWeekNumber: wt(Wd, e == null ? void 0 : e.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: wt(Gd, e == null ? void 0 : e.labelYearDropdown, n.labelYearDropdown),
    labelGrid: wt(vl, e == null ? void 0 : e.labelGrid, n.labelGrid),
    labelGridcell: wt(Rd, e == null ? void 0 : e.labelGridcell, n.labelGridcell),
    labelNav: wt(Id, e == null ? void 0 : e.labelNav, n.labelNav),
    labelWeekNumberHeader: wt(Vd, e == null ? void 0 : e.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: wt(Bd, e == null ? void 0 : e.labelWeekday, n.labelWeekday)
  };
}
function Mv(e, t, n, r, a) {
  const { startOfMonth: i, startOfYear: l, endOfYear: s, eachMonthOfInterval: c, getMonth: d } = a;
  return c({
    start: l(e),
    end: s(e)
  }).map((h) => {
    const p = r.formatMonthDropdown(h, a), y = d(h), m = t && h < i(t) || n && h > i(n) || !1;
    return { value: y, label: p, disabled: m };
  });
}
function Cv(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[le.Day] };
  return Object.entries(e).filter(([, a]) => a === !0).forEach(([a]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[a]
    };
  }), r;
}
function Pv(e, t, n, r) {
  const a = r ?? e.today(), i = n ? e.startOfBroadcastWeek(a, e) : t ? e.startOfISOWeek(a) : e.startOfWeek(a), l = [];
  for (let s = 0; s < 7; s++) {
    const c = e.addDays(i, s);
    l.push(c);
  }
  return l;
}
function Sv(e, t, n, r, a = !1) {
  if (!e || !t)
    return;
  const { startOfYear: i, endOfYear: l, eachYearOfInterval: s, getYear: c } = r, d = i(e), f = l(t), u = s({ start: d, end: f });
  return a && u.reverse(), u.map((h) => {
    const p = n.formatYearDropdown(h, r);
    return {
      value: c(h),
      label: p,
      disabled: !1
    };
  });
}
function Fv(e, t = {}) {
  var s;
  const { weekStartsOn: n, locale: r } = t, a = n ?? ((s = r == null ? void 0 : r.options) == null ? void 0 : s.weekStartsOn) ?? 0, i = (c) => {
    const d = typeof c == "number" || typeof c == "string" ? new Date(c) : c;
    return new Xe(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, e);
  }, l = (c) => {
    const d = i(c);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(Xe.tz(e)),
    newDate: (c, d, f) => new Xe(c, d, f, 12, 0, 0, e),
    startOfDay: (c) => i(c),
    startOfWeek: (c, d) => {
      const f = i(c), u = (d == null ? void 0 : d.weekStartsOn) ?? a, h = (f.getDay() - u + 7) % 7;
      return f.setDate(f.getDate() - h), f;
    },
    startOfISOWeek: (c) => {
      const d = i(c), f = (d.getDay() - 1 + 7) % 7;
      return d.setDate(d.getDate() - f), d;
    },
    startOfMonth: (c) => {
      const d = i(c);
      return d.setDate(1), d;
    },
    startOfYear: (c) => {
      const d = i(c);
      return d.setMonth(0, 1), d;
    },
    endOfWeek: (c, d) => {
      const f = i(c), p = ((((d == null ? void 0 : d.weekStartsOn) ?? a) + 6) % 7 - f.getDay() + 7) % 7;
      return f.setDate(f.getDate() + p), f;
    },
    endOfISOWeek: (c) => {
      const d = i(c), f = (7 - d.getDay()) % 7;
      return d.setDate(d.getDate() + f), d;
    },
    endOfMonth: (c) => {
      const d = i(c);
      return d.setMonth(d.getMonth() + 1, 0), d;
    },
    endOfYear: (c) => {
      const d = i(c);
      return d.setMonth(11, 31), d;
    },
    eachMonthOfInterval: (c) => {
      const d = i(c.start), f = i(c.end), u = [], h = new Xe(d.getFullYear(), d.getMonth(), 1, 12, 0, 0, e), p = f.getFullYear() * 12 + f.getMonth();
      for (; h.getFullYear() * 12 + h.getMonth() <= p; )
        u.push(new Xe(h, e)), h.setMonth(h.getMonth() + 1, 1);
      return u;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (c, d) => {
      const f = i(c);
      return f.setDate(f.getDate() + d), f;
    },
    addWeeks: (c, d) => {
      const f = i(c);
      return f.setDate(f.getDate() + d * 7), f;
    },
    addMonths: (c, d) => {
      const f = i(c);
      return f.setMonth(f.getMonth() + d), f;
    },
    addYears: (c, d) => {
      const f = i(c);
      return f.setFullYear(f.getFullYear() + d), f;
    },
    eachYearOfInterval: (c) => {
      const d = i(c.start), f = i(c.end), u = [], h = new Xe(d.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; h.getFullYear() <= f.getFullYear(); )
        u.push(new Xe(h, e)), h.setFullYear(h.getFullYear() + 1, 0, 1);
      return u;
    },
    getWeek: (c, d) => {
      var u;
      const f = l(c);
      return dl(f, {
        weekStartsOn: (d == null ? void 0 : d.weekStartsOn) ?? a,
        firstWeekContainsDate: (d == null ? void 0 : d.firstWeekContainsDate) ?? ((u = r == null ? void 0 : r.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1
      });
    },
    getISOWeek: (c) => {
      const d = l(c);
      return cl(d);
    },
    differenceInCalendarDays: (c, d) => {
      const f = l(c), u = l(d);
      return sl(f, u);
    },
    differenceInCalendarMonths: (c, d) => {
      const f = l(c), u = l(d);
      return xd(f, u);
    }
  };
}
const Hr = (e) => e instanceof HTMLElement ? e : null, No = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], zv = (e) => Hr(e.querySelector("[data-animated-month]")), Do = (e) => Hr(e.querySelector("[data-animated-caption]")), Oo = (e) => Hr(e.querySelector("[data-animated-weeks]")), Nv = (e) => Hr(e.querySelector("[data-animated-nav]")), Dv = (e) => Hr(e.querySelector("[data-animated-weekdays]"));
function Ov(e, t, { classNames: n, months: r, focused: a, dateLib: i }) {
  const l = ve(null), s = ve(r), c = ve(!1);
  _n(() => {
    const d = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || d.length === 0 || r.length !== d.length)
      return;
    const f = i.isSameMonth(r[0].date, d[0].date), u = i.isAfter(r[0].date, d[0].date), h = u ? n[it.caption_after_enter] : n[it.caption_before_enter], p = u ? n[it.weeks_after_enter] : n[it.weeks_before_enter], y = l.current, m = e.current.cloneNode(!0);
    if (m instanceof HTMLElement ? (No(m).forEach((E) => {
      if (!(E instanceof HTMLElement))
        return;
      const P = zv(E);
      P && E.contains(P) && E.removeChild(P);
      const x = Do(E);
      x && x.classList.remove(h);
      const F = Oo(E);
      F && F.classList.remove(p);
    }), l.current = m) : l.current = null, c.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    a)
      return;
    const b = y instanceof HTMLElement ? No(y) : [], $ = No(e.current);
    if ($ != null && $.every((w) => w instanceof HTMLElement) && b && b.every((w) => w instanceof HTMLElement)) {
      c.current = !0, e.current.style.isolation = "isolate";
      const w = Nv(e.current);
      w && (w.style.zIndex = "1"), $.forEach((E, P) => {
        const x = b[P];
        if (!x)
          return;
        E.style.position = "relative", E.style.overflow = "hidden";
        const F = Do(E);
        F && F.classList.add(h);
        const z = Oo(E);
        z && z.classList.add(p);
        const N = () => {
          c.current = !1, e.current && (e.current.style.isolation = ""), w && (w.style.zIndex = ""), F && F.classList.remove(h), z && z.classList.remove(p), E.style.position = "", E.style.overflow = "", E.contains(x) && E.removeChild(x);
        };
        x.style.pointerEvents = "none", x.style.position = "absolute", x.style.overflow = "hidden", x.setAttribute("aria-hidden", "true");
        const A = Dv(x);
        A && (A.style.opacity = "0");
        const _ = Do(x);
        _ && (_.classList.add(u ? n[it.caption_before_exit] : n[it.caption_after_exit]), _.addEventListener("animationend", N));
        const B = Oo(x);
        B && B.classList.add(u ? n[it.weeks_before_exit] : n[it.weeks_after_exit]), E.insertBefore(x, E.firstChild);
      });
    }
  });
}
function Av(e, t, n, r) {
  const a = e[0], i = e[e.length - 1], { ISOWeek: l, fixedWeeks: s, broadcastCalendar: c } = n ?? {}, { addDays: d, differenceInCalendarDays: f, differenceInCalendarMonths: u, endOfBroadcastWeek: h, endOfISOWeek: p, endOfMonth: y, endOfWeek: m, isAfter: b, startOfBroadcastWeek: $, startOfISOWeek: w, startOfWeek: E } = r, P = c ? $(a, r) : l ? w(a) : E(a), x = c ? h(i) : l ? p(y(i)) : m(y(i)), F = t && (c ? h(t) : l ? p(t) : m(t)), z = F && b(x, F) ? F : x, N = f(z, P), A = u(i, a) + 1, _ = [];
  for (let ee = 0; ee <= N; ee++) {
    const R = d(P, ee);
    _.push(R);
  }
  const j = (c ? 35 : 42) * A;
  if (s && _.length < j) {
    const ee = j - _.length;
    for (let R = 0; R < ee; R++) {
      const X = d(_[_.length - 1], 1);
      _.push(X);
    }
  }
  return _;
}
function Tv(e) {
  const t = [];
  return e.reduce((n, r) => {
    const a = r.weeks.reduce((i, l) => i.concat(l.days.slice()), t.slice());
    return n.concat(a.slice());
  }, t.slice());
}
function kv(e, t, n, r) {
  const { numberOfMonths: a = 1 } = n, i = [];
  for (let l = 0; l < a; l++) {
    const s = r.addMonths(e, l);
    if (t && s > t)
      break;
    i.push(s);
  }
  return i;
}
function N1(e, t, n, r) {
  const { month: a, defaultMonth: i, today: l = r.today(), numberOfMonths: s = 1 } = e;
  let c = a || i || l;
  const { differenceInCalendarMonths: d, addMonths: f, startOfMonth: u } = r;
  if (n && d(n, c) < s - 1) {
    const h = -1 * (s - 1);
    c = f(n, h);
  }
  return t && d(c, t) < 0 && (c = t), u(c);
}
function Hv(e, t, n, r) {
  const { addDays: a, endOfBroadcastWeek: i, endOfISOWeek: l, endOfMonth: s, endOfWeek: c, getISOWeek: d, getWeek: f, startOfBroadcastWeek: u, startOfISOWeek: h, startOfWeek: p } = r, y = e.reduce((m, b) => {
    const $ = n.broadcastCalendar ? u(b, r) : n.ISOWeek ? h(b) : p(b), w = n.broadcastCalendar ? i(b) : n.ISOWeek ? l(s(b)) : c(s(b)), E = t.filter((z) => z >= $ && z <= w), P = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && E.length < P) {
      const z = t.filter((N) => {
        const A = P - E.length;
        return N > w && N <= a(w, A);
      });
      E.push(...z);
    }
    const x = E.reduce((z, N) => {
      const A = n.ISOWeek ? d(N) : f(N), _ = z.find((j) => j.weekNumber === A), B = new Dd(N, b, r);
      return _ ? _.days.push(B) : z.push(new D9(A, [B])), z;
    }, []), F = new N9(b, x);
    return m.push(F), m;
  }, []);
  return n.reverseMonths ? y.reverse() : y;
}
function Rv(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: a, startOfDay: i, startOfMonth: l, endOfMonth: s, addYears: c, endOfYear: d, newDate: f, today: u } = t, { fromYear: h, toYear: p, fromMonth: y, toMonth: m } = e;
  !n && y && (n = y), !n && h && (n = t.newDate(h, 0, 1)), !r && m && (r = m), !r && p && (r = f(p, 11, 31));
  const b = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = l(n) : h ? n = f(h, 0, 1) : !n && b && (n = a(c(e.today ?? u(), -100))), r ? r = s(r) : p ? r = f(p, 11, 31) : !r && b && (r = d(e.today ?? u())), [
    n && i(n),
    r && i(r)
  ];
}
function _v(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: a, numberOfMonths: i = 1 } = n, { startOfMonth: l, addMonths: s, differenceInCalendarMonths: c } = r, d = a ? i : 1, f = l(e);
  if (!t)
    return s(f, d);
  if (!(c(t, e) < i))
    return s(f, d);
}
function Iv(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: a, numberOfMonths: i } = n, { startOfMonth: l, addMonths: s, differenceInCalendarMonths: c } = r, d = a ? i ?? 1 : 1, f = l(e);
  if (!t)
    return s(f, -d);
  if (!(c(f, t) <= 0))
    return s(f, -d);
}
function Lv(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Wa(e, t) {
  const [n, r] = Ae(e);
  return [t === void 0 ? n : t, r];
}
function jv(e, t) {
  var P;
  const [n, r] = Rv(e, t), { startOfMonth: a, endOfMonth: i } = t, l = N1(e, n, r, t), [s, c] = Wa(
    l,
    // initialMonth is always computed from props.month if provided
    e.month ? l : void 0
  );
  Ce(() => {
    const x = N1(e, n, r, t);
    c(x);
  }, [e.timeZone]);
  const { months: d, weeks: f, days: u, previousMonth: h, nextMonth: p } = Ze(() => {
    const x = kv(s, r, { numberOfMonths: e.numberOfMonths }, t), F = Av(x, e.endMonth ? i(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), z = Hv(x, F, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), N = Lv(z), A = Tv(z), _ = Iv(s, n, e, t), B = _v(s, r, e, t);
    return {
      months: z,
      weeks: N,
      days: A,
      previousMonth: _,
      nextMonth: B
    };
  }, [
    t,
    s.getTime(),
    r == null ? void 0 : r.getTime(),
    n == null ? void 0 : n.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    (P = e.endMonth) == null ? void 0 : P.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: y, onMonthChange: m } = e, b = (x) => f.some((F) => F.days.some((z) => z.isEqualTo(x))), $ = (x) => {
    if (y)
      return;
    let F = a(x);
    n && F < a(n) && (F = a(n)), r && F > a(r) && (F = a(r)), c(F), m == null || m(F);
  };
  return {
    months: d,
    weeks: f,
    days: u,
    navStart: n,
    navEnd: r,
    previousMonth: h,
    nextMonth: p,
    goToMonth: $,
    goToDay: (x) => {
      b(x) || $(x.date);
    }
  };
}
var Nt;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Nt || (Nt = {}));
function D1(e) {
  return !e[_e.disabled] && !e[_e.hidden] && !e[_e.outside];
}
function Bv(e, t, n, r) {
  let a, i = -1;
  for (const l of e) {
    const s = t(l);
    D1(s) && (s[_e.focused] && i < Nt.FocusedModifier ? (a = l, i = Nt.FocusedModifier) : r != null && r.isEqualTo(l) && i < Nt.LastFocused ? (a = l, i = Nt.LastFocused) : n(l.date) && i < Nt.Selected ? (a = l, i = Nt.Selected) : s[_e.today] && i < Nt.Today && (a = l, i = Nt.Today));
  }
  return a || (a = e.find((l) => D1(t(l)))), a;
}
function Wv(e, t, n, r, a, i, l) {
  const { ISOWeek: s, broadcastCalendar: c } = i, { addDays: d, addMonths: f, addWeeks: u, addYears: h, endOfBroadcastWeek: p, endOfISOWeek: y, endOfWeek: m, max: b, min: $, startOfBroadcastWeek: w, startOfISOWeek: E, startOfWeek: P } = l;
  let F = {
    day: d,
    week: u,
    month: f,
    year: h,
    startOfWeek: (z) => c ? w(z, l) : s ? E(z) : P(z),
    endOfWeek: (z) => c ? p(z) : s ? y(z) : m(z)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? F = b([r, F]) : t === "after" && a && (F = $([a, F])), F;
}
function Yd(e, t, n, r, a, i, l, s = 0) {
  if (s > 365)
    return;
  const c = Wv(e, t, n.date, r, a, i, l), d = !!(i.disabled && It(c, i.disabled, l)), f = !!(i.hidden && It(c, i.hidden, l)), u = c, h = new Dd(c, u, l);
  return !d && !f ? h : Yd(e, t, h, r, a, i, l, s + 1);
}
function Vv(e, t, n, r, a) {
  const { autoFocus: i } = e, [l, s] = Ae(), c = Bv(t.days, n, r || (() => !1), l), [d, f] = Ae(i ? c : void 0);
  return {
    isFocusTarget: (m) => !!(c != null && c.isEqualTo(m)),
    setFocused: f,
    focused: d,
    blur: () => {
      s(d), f(void 0);
    },
    moveFocus: (m, b) => {
      if (!d)
        return;
      const $ = Yd(m, b, d, t.navStart, t.navEnd, e, a);
      $ && (e.disableNavigation && !t.days.some((E) => E.isEqualTo($)) || (t.goToDay($), f($)));
    }
  };
}
function Gv(e, t) {
  const { selected: n, required: r, onSelect: a } = e, [i, l] = Wa(n, a ? n : void 0), s = a ? n : i, { isSameDay: c } = t, d = (p) => (s == null ? void 0 : s.some((y) => c(y, p))) ?? !1, { min: f, max: u } = e;
  return {
    selected: s,
    select: (p, y, m) => {
      let b = [...s ?? []];
      if (d(p)) {
        if ((s == null ? void 0 : s.length) === f || r && (s == null ? void 0 : s.length) === 1)
          return;
        b = s == null ? void 0 : s.filter(($) => !c($, p));
      } else
        (s == null ? void 0 : s.length) === u ? b = [p] : b = [...b, p];
      return a || l(b), a == null || a(b, p, y, m), b;
    },
    isSelected: d
  };
}
function Yv(e, t, n = 0, r = 0, a = !1, i = kt) {
  const { from: l, to: s } = t || {}, { isSameDay: c, isAfter: d, isBefore: f } = i;
  let u;
  if (!l && !s)
    u = { from: e, to: n > 0 ? void 0 : e };
  else if (l && !s)
    c(l, e) ? n === 0 ? u = { from: l, to: e } : a ? u = { from: l, to: void 0 } : u = void 0 : f(e, l) ? u = { from: e, to: l } : u = { from: l, to: e };
  else if (l && s)
    if (c(l, e) && c(s, e))
      a ? u = { from: l, to: s } : u = void 0;
    else if (c(l, e))
      u = { from: l, to: n > 0 ? void 0 : e };
    else if (c(s, e))
      u = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, l))
      u = { from: e, to: s };
    else if (d(e, l))
      u = { from: l, to: e };
    else if (d(e, s))
      u = { from: l, to: e };
    else
      throw new Error("Invalid range");
  if (u != null && u.from && (u != null && u.to)) {
    const h = i.differenceInCalendarDays(u.to, u.from);
    r > 0 && h > r ? u = { from: e, to: void 0 } : n > 1 && h < n && (u = { from: e, to: void 0 });
  }
  return u;
}
function Uv(e, t, n = kt) {
  const r = Array.isArray(t) ? t : [t];
  let a = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), l = Math.min(i, 6);
  for (let s = 0; s <= l; s++) {
    if (r.includes(a.getDay()))
      return !0;
    a = n.addDays(a, 1);
  }
  return !1;
}
function O1(e, t, n = kt) {
  return _t(e, t.from, !1, n) || _t(e, t.to, !1, n) || _t(t, e.from, !1, n) || _t(t, e.to, !1, n);
}
function Kv(e, t, n = kt) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? _t(e, s, !1, n) : Td(s, n) ? s.some((c) => _t(e, c, !1, n)) : Ba(s) ? s.from && s.to ? O1(e, { from: s.from, to: s.to }, n) : !1 : Ad(s) ? Uv(e, s.dayOfWeek, n) : ul(s) ? n.isAfter(s.before, s.after) ? O1(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : It(e.from, s, n) || It(e.to, s, n) : fl(s) || hl(s) ? It(e.from, s, n) || It(e.to, s, n) : !1))
    return !0;
  const l = r.filter((s) => typeof s == "function");
  if (l.length) {
    let s = e.from;
    const c = n.differenceInCalendarDays(e.to, e.from);
    for (let d = 0; d <= c; d++) {
      if (l.some((f) => f(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function Xv(e, t) {
  const { disabled: n, excludeDisabled: r, selected: a, required: i, onSelect: l } = e, [s, c] = Wa(a, l ? a : void 0), d = l ? a : s;
  return {
    selected: d,
    select: (h, p, y) => {
      const { min: m, max: b } = e, $ = h ? Yv(h, d, m, b, i, t) : void 0;
      return r && n && ($ != null && $.from) && $.to && Kv({ from: $.from, to: $.to }, n, t) && ($.from = h, $.to = void 0), l || c($), l == null || l($, h, p, y), $;
    },
    isSelected: (h) => d && _t(d, h, !1, t)
  };
}
function qv(e, t) {
  const { selected: n, required: r, onSelect: a } = e, [i, l] = Wa(n, a ? n : void 0), s = a ? n : i, { isSameDay: c } = t;
  return {
    selected: s,
    select: (u, h, p) => {
      let y = u;
      return !r && s && s && c(u, s) && (y = void 0), a || l(y), a == null || a(y, u, h, p), y;
    },
    isSelected: (u) => s ? c(s, u) : !1
  };
}
function Zv(e, t) {
  const n = qv(e, t), r = Gv(e, t), a = Xv(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return a;
    default:
      return;
  }
}
function vt(e, t) {
  return e instanceof Xe && e.timeZone === t ? e : new Xe(e, t);
}
function Cn(e, t, n) {
  return vt(e, t);
}
function A1(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? Cn(e, t) : Array.isArray(e) ? e.map((r) => r instanceof Date ? Cn(r, t) : r) : Ba(e) ? {
    ...e,
    from: e.from ? vt(e.from, t) : e.from,
    to: e.to ? vt(e.to, t) : e.to
  } : ul(e) ? {
    before: Cn(e.before, t),
    after: Cn(e.after, t)
  } : fl(e) ? {
    after: Cn(e.after, t)
  } : hl(e) ? {
    before: Cn(e.before, t)
  } : e;
}
function Ao(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => A1(r, t)) : A1(e, t));
}
function Jv(e) {
  var tr;
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = vt(t.today, n)), t.month && (t.month = vt(t.month, n)), t.defaultMonth && (t.defaultMonth = vt(t.defaultMonth, n)), t.startMonth && (t.startMonth = vt(t.startMonth, n)), t.endMonth && (t.endMonth = vt(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = vt(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = (tr = t.selected) == null ? void 0 : tr.map((ue) => vt(ue, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? vt(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? vt(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = Ao(t.disabled, n)), t.hidden !== void 0 && (t.hidden = Ao(t.hidden, n)), t.modifiers)) {
    const ue = {};
    Object.keys(t.modifiers).forEach((Ee) => {
      var ce;
      ue[Ee] = Ao((ce = t.modifiers) == null ? void 0 : ce[Ee], n);
    }), t.modifiers = ue;
  }
  const { components: r, formatters: a, labels: i, dateLib: l, locale: s, classNames: c } = Ze(() => {
    const ue = { ...Nd, ...t.locale }, Ee = t.broadcastCalendar ? 1 : t.weekStartsOn, ce = t.noonSafe && t.timeZone ? Fv(t.timeZone, {
      weekStartsOn: Ee,
      locale: ue
    }) : void 0, xe = t.dateLib && ce ? { ...ce, ...t.dateLib } : t.dateLib ?? ce, Qe = new ut({
      locale: ue,
      weekStartsOn: Ee,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, xe);
    return {
      dateLib: Qe,
      components: lv(t.components),
      formatters: yv(t.formatters),
      labels: xv(t.labels, Qe.options),
      locale: ue,
      classNames: { ...cv(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: l.today() });
  const { captionLayout: d, mode: f, navLayout: u, numberOfMonths: h = 1, onDayBlur: p, onDayClick: y, onDayFocus: m, onDayKeyDown: b, onDayMouseEnter: $, onDayMouseLeave: w, onNextClick: E, onPrevClick: P, showWeekNumber: x, styles: F } = t, { formatCaption: z, formatDay: N, formatMonthDropdown: A, formatWeekNumber: _, formatWeekNumberHeader: B, formatWeekdayName: j, formatYearDropdown: ee } = a, R = jv(t, l), { days: X, months: V, navStart: G, navEnd: ne, previousMonth: k, nextMonth: D, goToMonth: O } = R, J = ov(X, t, G, ne, l), { isSelected: oe, select: te, selected: se } = Zv(t, l) ?? {}, { blur: Q, focused: H, isFocusTarget: U, moveFocus: q, setFocused: W } = Vv(t, R, J, oe ?? (() => !1), l), { labelDayButton: de, labelGridcell: T, labelGrid: Se, labelMonthDropdown: Le, labelNav: Ie, labelPrevious: Ke, labelNext: ht, labelWeekday: Kt, labelWeekNumber: ot, labelWeekNumberHeader: Zn, labelYearDropdown: Xt } = i, Jn = Ze(() => Pv(l, t.ISOWeek, t.broadcastCalendar, t.today), [l, t.ISOWeek, t.broadcastCalendar, t.today]), Kr = f !== void 0 || y !== void 0, Qn = he(() => {
    k && (O(k), P == null || P(k));
  }, [k, O, P]), En = he(() => {
    D && (O(D), E == null || E(D));
  }, [O, D, E]), Xr = he((ue, Ee) => (ce) => {
    ce.preventDefault(), ce.stopPropagation(), W(ue), !Ee.disabled && (te == null || te(ue.date, Ee, ce), y == null || y(ue.date, Ee, ce));
  }, [te, y, W]), qr = he((ue, Ee) => (ce) => {
    W(ue), m == null || m(ue.date, Ee, ce);
  }, [m, W]), bo = he((ue, Ee) => (ce) => {
    Q(), p == null || p(ue.date, Ee, ce);
  }, [Q, p]), Zr = he((ue, Ee) => (ce) => {
    const xe = {
      ArrowLeft: [
        ce.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        ce.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [ce.shiftKey ? "year" : "week", "after"],
      ArrowUp: [ce.shiftKey ? "year" : "week", "before"],
      PageUp: [ce.shiftKey ? "year" : "month", "before"],
      PageDown: [ce.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (xe[ce.key]) {
      ce.preventDefault(), ce.stopPropagation();
      const [Qe, be] = xe[ce.key];
      q(Qe, be);
    }
    b == null || b(ue.date, Ee, ce);
  }, [q, b, t.dir]), Jr = he((ue, Ee) => (ce) => {
    $ == null || $(ue.date, Ee, ce);
  }, [$]), wo = he((ue, Ee) => (ce) => {
    w == null || w(ue.date, Ee, ce);
  }, [w]), $o = he((ue) => (Ee) => {
    const ce = Number(Ee.target.value), xe = l.setMonth(l.startOfMonth(ue), ce);
    O(xe);
  }, [l, O]), Eo = he((ue) => (Ee) => {
    const ce = Number(Ee.target.value), xe = l.setYear(l.startOfMonth(ue), ce);
    O(xe);
  }, [l, O]), { className: xo, style: Mo } = Ze(() => ({
    className: [c[le.Root], t.className].filter(Boolean).join(" "),
    style: { ...F == null ? void 0 : F[le.Root], ...t.style }
  }), [c, t.className, t.style, F]), Co = sv(t), Qr = ve(null);
  Ov(Qr, !!t.animate, {
    classNames: c,
    months: V,
    focused: H,
    dateLib: l
  });
  const er = {
    dayPickerProps: t,
    selected: se,
    select: te,
    isSelected: oe,
    months: V,
    nextMonth: D,
    previousMonth: k,
    goToMonth: O,
    getModifiers: J,
    components: r,
    classNames: c,
    styles: F,
    labels: i,
    formatters: a
  };
  return o.createElement(
    Od.Provider,
    { value: er },
    o.createElement(
      r.Root,
      { rootRef: t.animate ? Qr : void 0, className: xo, style: Mo, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...Co },
      o.createElement(
        r.Months,
        { className: c[le.Months], style: F == null ? void 0 : F[le.Months] },
        !t.hideNavigation && !u && o.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[le.Nav], style: F == null ? void 0 : F[le.Nav], "aria-label": Ie(), onPreviousClick: Qn, onNextClick: En, previousMonth: k, nextMonth: D }),
        V.map((ue, Ee) => o.createElement(
          r.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: c[le.Month],
            style: F == null ? void 0 : F[le.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Ee,
            displayIndex: Ee,
            calendarMonth: ue
          },
          u === "around" && !t.hideNavigation && Ee === 0 && o.createElement(
            r.PreviousMonthButton,
            { type: "button", className: c[le.PreviousMonthButton], tabIndex: k ? void 0 : -1, "aria-disabled": k ? void 0 : !0, "aria-label": Ke(k), onClick: Qn, "data-animated-button": t.animate ? "true" : void 0 },
            o.createElement(r.Chevron, { disabled: k ? void 0 : !0, className: c[le.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          o.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: c[le.MonthCaption], style: F == null ? void 0 : F[le.MonthCaption], calendarMonth: ue, displayIndex: Ee }, d != null && d.startsWith("dropdown") ? o.createElement(
            r.DropdownNav,
            { className: c[le.Dropdowns], style: F == null ? void 0 : F[le.Dropdowns] },
            (() => {
              const ce = d === "dropdown" || d === "dropdown-months" ? o.createElement(r.MonthsDropdown, { key: "month", className: c[le.MonthsDropdown], "aria-label": Le(), classNames: c, components: r, disabled: !!t.disableNavigation, onChange: $o(ue.date), options: Mv(ue.date, G, ne, a, l), style: F == null ? void 0 : F[le.Dropdown], value: l.getMonth(ue.date) }) : o.createElement("span", { key: "month" }, A(ue.date, l)), xe = d === "dropdown" || d === "dropdown-years" ? o.createElement(r.YearsDropdown, { key: "year", className: c[le.YearsDropdown], "aria-label": Xt(l.options), classNames: c, components: r, disabled: !!t.disableNavigation, onChange: Eo(ue.date), options: Sv(G, ne, a, l, !!t.reverseYears), style: F == null ? void 0 : F[le.Dropdown], value: l.getYear(ue.date) }) : o.createElement("span", { key: "year" }, ee(ue.date, l));
              return l.getMonthYearOrder() === "year-first" ? [xe, ce] : [ce, xe];
            })(),
            o.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, z(ue.date, l.options, l))
          ) : o.createElement(r.CaptionLabel, { className: c[le.CaptionLabel], role: "status", "aria-live": "polite" }, z(ue.date, l.options, l))),
          u === "around" && !t.hideNavigation && Ee === h - 1 && o.createElement(
            r.NextMonthButton,
            { type: "button", className: c[le.NextMonthButton], tabIndex: D ? void 0 : -1, "aria-disabled": D ? void 0 : !0, "aria-label": ht(D), onClick: En, "data-animated-button": t.animate ? "true" : void 0 },
            o.createElement(r.Chevron, { disabled: D ? void 0 : !0, className: c[le.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          Ee === h - 1 && u === "after" && !t.hideNavigation && o.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[le.Nav], style: F == null ? void 0 : F[le.Nav], "aria-label": Ie(), onPreviousClick: Qn, onNextClick: En, previousMonth: k, nextMonth: D }),
          o.createElement(
            r.MonthGrid,
            { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": Se(ue.date, l.options, l) || void 0, className: c[le.MonthGrid], style: F == null ? void 0 : F[le.MonthGrid] },
            !t.hideWeekdays && o.createElement(
              r.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: c[le.Weekdays], style: F == null ? void 0 : F[le.Weekdays] },
              x && o.createElement(r.WeekNumberHeader, { "aria-label": Zn(l.options), className: c[le.WeekNumberHeader], style: F == null ? void 0 : F[le.WeekNumberHeader], scope: "col" }, B()),
              Jn.map((ce) => o.createElement(r.Weekday, { "aria-label": Kt(ce, l.options, l), className: c[le.Weekday], key: String(ce), style: F == null ? void 0 : F[le.Weekday], scope: "col" }, j(ce, l.options, l)))
            ),
            o.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: c[le.Weeks], style: F == null ? void 0 : F[le.Weeks] }, ue.weeks.map((ce) => o.createElement(
              r.Week,
              { className: c[le.Week], key: ce.weekNumber, style: F == null ? void 0 : F[le.Week], week: ce },
              x && o.createElement(r.WeekNumber, { week: ce, style: F == null ? void 0 : F[le.WeekNumber], "aria-label": ot(ce.weekNumber, {
                locale: s
              }), className: c[le.WeekNumber], scope: "row", role: "rowheader" }, _(ce.weekNumber, l)),
              ce.days.map((xe) => {
                const { date: Qe } = xe, be = J(xe);
                if (be[_e.focused] = !be.hidden && !!(H != null && H.isEqualTo(xe)), be[Ct.selected] = (oe == null ? void 0 : oe(Qe)) || be.selected, Ba(se)) {
                  const { from: nr, to: rr } = se;
                  be[Ct.range_start] = !!(nr && rr && l.isSameDay(Qe, nr)), be[Ct.range_end] = !!(nr && rr && l.isSameDay(Qe, rr)), be[Ct.range_middle] = _t(se, Qe, !0, l);
                }
                const Po = Cv(be, F, t.modifiersStyles), ea = iv(be, c, t.modifiersClassNames), ta = !Kr && !be.hidden ? T(Qe, be, l.options, l) : void 0;
                return o.createElement(r.Day, { key: `${xe.isoDate}_${xe.displayMonthId}`, day: xe, modifiers: be, className: ea.join(" "), style: Po, role: "gridcell", "aria-selected": be.selected || void 0, "aria-label": ta, "data-day": xe.isoDate, "data-month": xe.outside ? xe.dateMonthId : void 0, "data-selected": be.selected || void 0, "data-disabled": be.disabled || void 0, "data-hidden": be.hidden || void 0, "data-outside": xe.outside || void 0, "data-focused": be.focused || void 0, "data-today": be.today || void 0 }, !be.hidden && Kr ? o.createElement(r.DayButton, { className: c[le.DayButton], style: F == null ? void 0 : F[le.DayButton], type: "button", day: xe, modifiers: be, disabled: !be.focused && be.disabled || void 0, "aria-disabled": be.focused && be.disabled || void 0, tabIndex: U(xe) ? 0 : -1, "aria-label": de(Qe, be, l.options, l), onClick: Xr(xe, be), onBlur: bo(xe, be), onFocus: qr(xe, be), onKeyDown: Zr(xe, be), onMouseEnter: Jr(xe, be), onMouseLeave: wo(xe, be) }, N(Qe, l.options, l)) : !be.hidden && N(xe.date, l.options, l));
              })
            )))
          )
        ))
      ),
      t.footer && o.createElement(r.Footer, { className: c[le.Footer], style: F == null ? void 0 : F[le.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function $e(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
function re(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : l;
      a = e.formattingValues[s] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[l];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
function ae(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const l = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? ep(s, (u) => u.test(l)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Qv(s, (u) => u.test(l))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(c) : c, d = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(l.length);
    return { value: d, rest: f };
  };
}
function Qv(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function ep(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function yt(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let l = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const s = t.slice(a.length);
    return { value: l, rest: s };
  };
}
function tp(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
let np = {};
function rp() {
  return np;
}
function T1(e, t) {
  var s, c, d, f;
  const n = rp(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, a = tp(e), i = a.getDay(), l = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - l), a.setHours(0, 0, 0, 0), a;
}
function $r(e, t, n) {
  const r = T1(e, n), a = T1(t, n);
  return +r == +a;
}
const k1 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, ap = (e, t, n) => {
  let r;
  const a = n != null && n.addSuffix ? k1[e].withPreposition : k1[e].standalone;
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : "vor " + r : r;
}, op = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, ip = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, lp = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, sp = {
  date: $e({
    formats: op,
    defaultWidth: "full"
  }),
  time: $e({
    formats: ip,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: lp,
    defaultWidth: "full"
  })
}, cp = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, dp = (e, t, n, r) => cp[e], up = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, fp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, ci = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, hp = {
  narrow: ci.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: ci.wide
}, mp = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, vp = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, pp = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, gp = (e) => Number(e) + ".", yp = {
  ordinalNumber: gp,
  era: re({
    values: up,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: fp,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: ci,
    formattingValues: hp,
    defaultWidth: "wide"
  }),
  day: re({
    values: mp,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: vp,
    defaultWidth: "wide",
    formattingValues: pp,
    defaultFormattingWidth: "wide"
  })
}, bp = /^(\d+)(\.)?/i, wp = /\d+/i, $p = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, Ep = {
  any: [/^v/i, /^n/i]
}, xp = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Mp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, Pp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Sp = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Fp = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, zp = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Np = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, Dp = {
  ordinalNumber: yt({
    matchPattern: bp,
    parsePattern: wp,
    valueCallback: (e) => parseInt(e)
  }),
  era: ae({
    matchPatterns: $p,
    defaultMatchWidth: "wide",
    parsePatterns: Ep,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: xp,
    defaultMatchWidth: "wide",
    parsePatterns: Mp,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: Cp,
    defaultMatchWidth: "wide",
    parsePatterns: Pp,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: Sp,
    defaultMatchWidth: "wide",
    parsePatterns: Fp,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: zp,
    defaultMatchWidth: "wide",
    parsePatterns: Np,
    defaultParseWidth: "any"
  })
}, Op = {
  code: "de",
  formatDistance: ap,
  formatLong: sp,
  formatRelative: dp,
  localize: yp,
  match: Dp,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ap = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Tp = (e, t, n) => {
  let r;
  const a = Ap[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
}, kp = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Hp = (e, t, n, r) => kp[e], Rp = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, _p = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ip = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Lp = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, jp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Bp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Wp = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Vp = {
  ordinalNumber: Wp,
  era: re({
    values: Rp,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: _p,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: Ip,
    defaultWidth: "wide"
  }),
  day: re({
    values: Lp,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: jp,
    defaultWidth: "wide",
    formattingValues: Bp,
    defaultFormattingWidth: "wide"
  })
}, Gp = /^(\d+)(th|st|nd|rd)?/i, Yp = /\d+/i, Up = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Kp = {
  any: [/^b/i, /^(a|c)/i]
}, Xp = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, qp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Jp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Qp = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, eg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, tg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ng = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, rg = {
  ordinalNumber: yt({
    matchPattern: Gp,
    parsePattern: Yp,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: Up,
    defaultMatchWidth: "wide",
    parsePatterns: Kp,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: Xp,
    defaultMatchWidth: "wide",
    parsePatterns: qp,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: Zp,
    defaultMatchWidth: "wide",
    parsePatterns: Jp,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: Qp,
    defaultMatchWidth: "wide",
    parsePatterns: eg,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: tg,
    defaultMatchWidth: "any",
    parsePatterns: ng,
    defaultParseWidth: "any"
  })
}, ag = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, og = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ig = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lg = {
  date: $e({
    formats: ag,
    defaultWidth: "full"
  }),
  time: $e({
    formats: og,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: ig,
    defaultWidth: "full"
  })
}, sg = {
  code: "en-US",
  formatDistance: Tp,
  formatLong: lg,
  formatRelative: Hp,
  localize: Vp,
  match: rg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, cg = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, dg = (e, t, n) => {
  let r;
  const a = cg[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + r : "hace " + r : r;
}, ug = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, fg = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, hg = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mg = {
  date: $e({
    formats: ug,
    defaultWidth: "full"
  }),
  time: $e({
    formats: fg,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: hg,
    defaultWidth: "full"
  })
}, vg = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, pg = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, gg = (e, t, n, r) => t.getHours() !== 1 ? pg[e] : vg[e], yg = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, bg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, wg = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, $g = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Eg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, xg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Mg = (e, t) => Number(e) + "º", Cg = {
  ordinalNumber: Mg,
  era: re({
    values: yg,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: bg,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: re({
    values: wg,
    defaultWidth: "wide"
  }),
  day: re({
    values: $g,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: Eg,
    defaultWidth: "wide",
    formattingValues: xg,
    defaultFormattingWidth: "wide"
  })
}, Pg = /^(\d+)(º)?/i, Sg = /\d+/i, Fg = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, zg = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Ng = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Dg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Og = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Ag = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, Tg = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, kg = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Hg = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Rg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, _g = {
  ordinalNumber: yt({
    matchPattern: Pg,
    parsePattern: Sg,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: ae({
    matchPatterns: Fg,
    defaultMatchWidth: "wide",
    parsePatterns: zg,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: Ng,
    defaultMatchWidth: "wide",
    parsePatterns: Dg,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: Og,
    defaultMatchWidth: "wide",
    parsePatterns: Ag,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: Tg,
    defaultMatchWidth: "wide",
    parsePatterns: kg,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: Hg,
    defaultMatchWidth: "any",
    parsePatterns: Rg,
    defaultParseWidth: "any"
  })
}, Ig = {
  code: "es",
  formatDistance: dg,
  formatLong: mg,
  formatRelative: gg,
  localize: Cg,
  match: _g,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Lg = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, jg = (e, t, n) => {
  let r;
  const a = Lg[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dans " + r : "il y a " + r : r;
}, Bg = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Wg = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vg = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Gg = {
  date: $e({
    formats: Bg,
    defaultWidth: "full"
  }),
  time: $e({
    formats: Wg,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: Vg,
    defaultWidth: "full"
  })
}, Yg = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, Ug = (e, t, n, r) => Yg[e], Kg = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, Xg = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, qg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, Zg = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, Jg = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, Qg = (e, t) => {
  const n = Number(e), r = t == null ? void 0 : t.unit;
  if (n === 0) return "0";
  const a = ["year", "week", "hour", "minute", "second"];
  let i;
  return n === 1 ? i = r && a.includes(r) ? "ère" : "er" : i = "ème", n + i;
}, ey = ["MMM", "MMMM"], ty = {
  preprocessor: (e, t) => e.getDate() === 1 || !t.some(
    (r) => r.isToken && ey.includes(r.value)
  ) ? t : t.map(
    (r) => r.isToken && r.value === "do" ? { isToken: !0, value: "d" } : r
  ),
  ordinalNumber: Qg,
  era: re({
    values: Kg,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: Xg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: qg,
    defaultWidth: "wide"
  }),
  day: re({
    values: Zg,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: Jg,
    defaultWidth: "wide"
  })
}, ny = /^(\d+)(ième|ère|ème|er|e)?/i, ry = /\d+/i, ay = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, oy = {
  any: [/^av/i, /^ap/i]
}, iy = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, ly = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, sy = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, cy = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, dy = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, uy = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, fy = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, hy = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, my = {
  ordinalNumber: yt({
    matchPattern: ny,
    parsePattern: ry,
    valueCallback: (e) => parseInt(e)
  }),
  era: ae({
    matchPatterns: ay,
    defaultMatchWidth: "wide",
    parsePatterns: oy,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: iy,
    defaultMatchWidth: "wide",
    parsePatterns: ly,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: sy,
    defaultMatchWidth: "wide",
    parsePatterns: cy,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: dy,
    defaultMatchWidth: "wide",
    parsePatterns: uy,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: fy,
    defaultMatchWidth: "any",
    parsePatterns: hy,
    defaultParseWidth: "any"
  })
}, vy = {
  code: "fr",
  formatDistance: jg,
  formatLong: Gg,
  formatRelative: Ug,
  localize: ty,
  match: my,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, py = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, gy = (e, t, n) => {
  let r;
  const a = py[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "tra " + r : r + " fa" : r;
}, yy = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, by = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, wy = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, $y = {
  date: $e({
    formats: yy,
    defaultWidth: "full"
  }),
  time: $e({
    formats: by,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: wy,
    defaultWidth: "full"
  })
}, pl = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function Ey(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + pl[e] + " scorso alle' p";
  }
}
function H1(e) {
  return "'" + pl[e] + " alle' p";
}
function xy(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + pl[e] + " prossimo alle' p";
  }
}
const My = {
  lastWeek: (e, t, n) => {
    const r = e.getDay();
    return $r(e, t, n) ? H1(r) : Ey(r);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (e, t, n) => {
    const r = e.getDay();
    return $r(e, t, n) ? H1(r) : xy(r);
  },
  other: "P"
}, Cy = (e, t, n, r) => {
  const a = My[e];
  return typeof a == "function" ? a(t, n, r) : a;
}, Py = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, Sy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Fy = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, zy = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, Ny = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, Dy = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, Oy = (e, t) => {
  const n = Number(e);
  return String(n);
}, Ay = {
  ordinalNumber: Oy,
  era: re({
    values: Py,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: Sy,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: Fy,
    defaultWidth: "wide"
  }),
  day: re({
    values: zy,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: Ny,
    defaultWidth: "wide",
    formattingValues: Dy,
    defaultFormattingWidth: "wide"
  })
}, Ty = /^(\d+)(º)?/i, ky = /\d+/i, Hy = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, Ry = {
  any: [/^a/i, /^(d|e)/i]
}, _y = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Iy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ly = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, jy = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, By = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, Wy = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, Vy = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, Gy = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, Yy = {
  ordinalNumber: yt({
    matchPattern: Ty,
    parsePattern: ky,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: Hy,
    defaultMatchWidth: "wide",
    parsePatterns: Ry,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: _y,
    defaultMatchWidth: "wide",
    parsePatterns: Iy,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: Ly,
    defaultMatchWidth: "wide",
    parsePatterns: jy,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: By,
    defaultMatchWidth: "wide",
    parsePatterns: Wy,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: Vy,
    defaultMatchWidth: "any",
    parsePatterns: Gy,
    defaultParseWidth: "any"
  })
}, Uy = {
  code: "it",
  formatDistance: gy,
  formatLong: $y,
  formatRelative: Cy,
  localize: Ay,
  match: Yy,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ky = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, Xy = (e, t, n) => {
  n = n || {};
  let r;
  const a = Ky[e];
  return typeof a == "string" ? r = a : t === 1 ? n.addSuffix && a.oneWithSuffix ? r = a.oneWithSuffix : r = a.one : n.addSuffix && a.otherWithSuffix ? r = a.otherWithSuffix.replace("{{count}}", String(t)) : r = a.other.replace("{{count}}", String(t)), n.addSuffix ? n.comparison && n.comparison > 0 ? r + "後" : r + "前" : r;
}, qy = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, Zy = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Jy = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Qy = {
  date: $e({
    formats: qy,
    defaultWidth: "full"
  }),
  time: $e({
    formats: Zy,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: Jy,
    defaultWidth: "full"
  })
}, eb = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, tb = (e, t, n, r) => eb[e], nb = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, rb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, ab = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ]
}, ob = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, ib = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, lb = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, sb = (e, t) => {
  const n = Number(e);
  switch (String(t == null ? void 0 : t.unit)) {
    case "year":
      return `${n}年`;
    case "quarter":
      return `第${n}四半期`;
    case "month":
      return `${n}月`;
    case "week":
      return `第${n}週`;
    case "date":
      return `${n}日`;
    case "hour":
      return `${n}時`;
    case "minute":
      return `${n}分`;
    case "second":
      return `${n}秒`;
    default:
      return `${n}`;
  }
}, cb = {
  ordinalNumber: sb,
  era: re({
    values: nb,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: rb,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: re({
    values: ab,
    defaultWidth: "wide"
  }),
  day: re({
    values: ob,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: ib,
    defaultWidth: "wide",
    formattingValues: lb,
    defaultFormattingWidth: "wide"
  })
}, db = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, ub = /\d+/i, fb = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, hb = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, mb = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, vb = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, pb = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, gb = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, yb = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, bb = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, wb = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, $b = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, Eb = {
  ordinalNumber: yt({
    matchPattern: db,
    parsePattern: ub,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: ae({
    matchPatterns: fb,
    defaultMatchWidth: "wide",
    parsePatterns: hb,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: mb,
    defaultMatchWidth: "wide",
    parsePatterns: vb,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: pb,
    defaultMatchWidth: "wide",
    parsePatterns: gb,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: yb,
    defaultMatchWidth: "wide",
    parsePatterns: bb,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: wb,
    defaultMatchWidth: "any",
    parsePatterns: $b,
    defaultParseWidth: "any"
  })
}, xb = {
  code: "ja",
  formatDistance: Xy,
  formatLong: Qy,
  formatRelative: tb,
  localize: cb,
  match: Eb,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Mb = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, Cb = (e, t, n) => {
  let r;
  const a = Mb[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "over " + r : r + " geleden" : r;
}, Pb = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, Sb = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Fb = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zb = {
  date: $e({
    formats: Pb,
    defaultWidth: "full"
  }),
  time: $e({
    formats: Sb,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: Fb,
    defaultWidth: "full"
  })
}, Nb = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Db = (e, t, n, r) => Nb[e], Ob = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Ab = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Tb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, kb = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, Hb = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Rb = (e, t) => Number(e) + "e", _b = {
  ordinalNumber: Rb,
  era: re({
    values: Ob,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: Ab,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: Tb,
    defaultWidth: "wide"
  }),
  day: re({
    values: kb,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: Hb,
    defaultWidth: "wide"
  })
}, Ib = /^(\d+)e?/i, Lb = /\d+/i, jb = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, Bb = {
  any: [/^v/, /^n/]
}, Wb = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Vb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Gb = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Yb = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, Ub = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Kb = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Xb = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, qb = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, Zb = {
  ordinalNumber: yt({
    matchPattern: Ib,
    parsePattern: Lb,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: jb,
    defaultMatchWidth: "wide",
    parsePatterns: Bb,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: Wb,
    defaultMatchWidth: "wide",
    parsePatterns: Vb,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: Gb,
    defaultMatchWidth: "wide",
    parsePatterns: Yb,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: Ub,
    defaultMatchWidth: "wide",
    parsePatterns: Kb,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: Xb,
    defaultMatchWidth: "any",
    parsePatterns: qb,
    defaultParseWidth: "any"
  })
}, Jb = {
  code: "nl",
  formatDistance: Cb,
  formatLong: zb,
  formatRelative: Db,
  localize: _b,
  match: Zb,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Qb = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, ew = (e, t, n) => {
  let r;
  const a = Qb[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "em " + r : "há " + r : r;
}, tw = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, nw = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, rw = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, aw = {
  date: $e({
    formats: tw,
    defaultWidth: "full"
  }),
  time: $e({
    formats: nw,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: rw,
    defaultWidth: "full"
  })
}, ow = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, iw = (e, t, n, r) => {
  const a = ow[e];
  return typeof a == "function" ? a(t) : a;
}, lw = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, sw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, cw = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, dw = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, uw = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, fw = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, hw = (e, t) => {
  const n = Number(e);
  return (t == null ? void 0 : t.unit) === "week" ? n + "ª" : n + "º";
}, mw = {
  ordinalNumber: hw,
  era: re({
    values: lw,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: sw,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: cw,
    defaultWidth: "wide"
  }),
  day: re({
    values: dw,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: uw,
    defaultWidth: "wide",
    formattingValues: fw,
    defaultFormattingWidth: "wide"
  })
}, vw = /^(\d+)[ºªo]?/i, pw = /\d+/i, gw = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, yw = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, bw = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, ww = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $w = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Ew = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, xw = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, Mw = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, Cw = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Pw = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, Sw = {
  ordinalNumber: yt({
    matchPattern: vw,
    parsePattern: pw,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: gw,
    defaultMatchWidth: "wide",
    parsePatterns: yw,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: bw,
    defaultMatchWidth: "wide",
    parsePatterns: ww,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: $w,
    defaultMatchWidth: "wide",
    parsePatterns: Ew,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: xw,
    defaultMatchWidth: "wide",
    parsePatterns: Mw,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: Cw,
    defaultMatchWidth: "any",
    parsePatterns: Pw,
    defaultParseWidth: "any"
  })
}, Fw = {
  code: "pt-BR",
  formatDistance: ew,
  formatLong: aw,
  formatRelative: iw,
  localize: mw,
  match: Sw,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ur(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function tt(e) {
  return (t, n) => n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? ur(e.future, t) : "через " + ur(e.regular, t) : e.past ? ur(e.past, t) : ur(e.regular, t) + " назад" : ur(e.regular, t);
}
const zw = {
  lessThanXSeconds: tt({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: tt({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (e, t) => t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: tt({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: tt({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: tt({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: tt({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: tt({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: tt({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: tt({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: tt({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: tt({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: tt({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: tt({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: tt({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: tt({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Nw = (e, t, n) => zw[e](t, n), Dw = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Ow = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Aw = {
  any: "{{date}}, {{time}}"
}, Tw = {
  date: $e({
    formats: Dw,
    defaultWidth: "full"
  }),
  time: $e({
    formats: Ow,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: Aw,
    defaultWidth: "any"
  })
}, gl = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function kw(e) {
  const t = gl[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function R1(e) {
  const t = gl[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function Hw(e) {
  const t = gl[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
const Rw = {
  lastWeek: (e, t, n) => {
    const r = e.getDay();
    return $r(e, t, n) ? R1(r) : kw(r);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (e, t, n) => {
    const r = e.getDay();
    return $r(e, t, n) ? R1(r) : Hw(r);
  },
  other: "P"
}, _w = (e, t, n, r) => {
  const a = Rw[e];
  return typeof a == "function" ? a(t, n, r) : a;
}, Iw = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, Lw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, jw = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, Bw = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, Ww = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, Vw = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, Gw = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, Yw = (e, t) => {
  const n = Number(e), r = t == null ? void 0 : t.unit;
  let a;
  return r === "date" ? a = "-е" : r === "week" || r === "minute" || r === "second" ? a = "-я" : a = "-й", n + a;
}, Uw = {
  ordinalNumber: Yw,
  era: re({
    values: Iw,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: Lw,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: jw,
    defaultWidth: "wide",
    formattingValues: Bw,
    defaultFormattingWidth: "wide"
  }),
  day: re({
    values: Ww,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: Vw,
    defaultWidth: "any",
    formattingValues: Gw,
    defaultFormattingWidth: "wide"
  })
}, Kw = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, Xw = /\d+/i, qw = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, Zw = {
  any: [/^д/i, /^н/i]
}, Jw = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, Qw = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, e$ = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, t$ = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, n$ = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, r$ = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, a$ = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, o$ = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, i$ = {
  ordinalNumber: yt({
    matchPattern: Kw,
    parsePattern: Xw,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: qw,
    defaultMatchWidth: "wide",
    parsePatterns: Zw,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: Jw,
    defaultMatchWidth: "wide",
    parsePatterns: Qw,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: e$,
    defaultMatchWidth: "wide",
    parsePatterns: t$,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: n$,
    defaultMatchWidth: "wide",
    parsePatterns: r$,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: a$,
    defaultMatchWidth: "wide",
    parsePatterns: o$,
    defaultParseWidth: "any"
  })
}, l$ = {
  code: "ru",
  formatDistance: Nw,
  formatLong: Tw,
  formatRelative: _w,
  localize: Uw,
  match: i$,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, s$ = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, c$ = (e, t, n) => {
  let r;
  const a = s$[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " sonra" : r + " önce" : r;
}, d$ = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, u$ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, f$ = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, h$ = {
  date: $e({
    formats: d$,
    defaultWidth: "full"
  }),
  time: $e({
    formats: u$,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: f$,
    defaultWidth: "full"
  })
}, m$ = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, v$ = (e, t, n, r) => m$[e], p$ = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, g$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, y$ = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara"
  ],
  wide: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ]
}, b$ = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi"
  ]
}, w$ = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, $$ = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, E$ = (e, t) => Number(e) + ".", x$ = {
  ordinalNumber: E$,
  era: re({
    values: p$,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: g$,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: re({
    values: y$,
    defaultWidth: "wide"
  }),
  day: re({
    values: b$,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: w$,
    defaultWidth: "wide",
    formattingValues: $$,
    defaultFormattingWidth: "wide"
  })
}, M$ = /^(\d+)(\.)?/i, C$ = /\d+/i, P$ = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, S$ = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, F$ = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, z$ = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [
    /^(i|İ)lk çeyrek/i,
    /(i|İ)kinci çeyrek/i,
    /üçüncü çeyrek/i,
    /son çeyrek/i
  ]
}, N$ = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, D$ = {
  narrow: [
    /^o/i,
    /^ş/i,
    /^m/i,
    /^n/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^a/i,
    /^e/i,
    /^e/i,
    /^k/i,
    /^a/i
  ],
  any: [
    /^o/i,
    /^ş/i,
    /^mar/i,
    /^n/i,
    /^may/i,
    /^h/i,
    /^t/i,
    /^ağ/i,
    /^ey/i,
    /^ek/i,
    /^k/i,
    /^ar/i
  ]
}, O$ = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, A$ = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [
    /^pazar(?!tesi)/i,
    /^pazartesi/i,
    /^salı/i,
    /^çarşamba/i,
    /^perşembe/i,
    /^cuma(?!rtesi)/i,
    /^cumartesi/i
  ]
}, T$ = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, k$ = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, H$ = {
  ordinalNumber: yt({
    matchPattern: M$,
    parsePattern: C$,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: ae({
    matchPatterns: P$,
    defaultMatchWidth: "wide",
    parsePatterns: S$,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: F$,
    defaultMatchWidth: "wide",
    parsePatterns: z$,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: N$,
    defaultMatchWidth: "wide",
    parsePatterns: D$,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: O$,
    defaultMatchWidth: "wide",
    parsePatterns: A$,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: T$,
    defaultMatchWidth: "any",
    parsePatterns: k$,
    defaultParseWidth: "any"
  })
}, R$ = {
  code: "tr",
  formatDistance: c$,
  formatLong: h$,
  formatRelative: v$,
  localize: x$,
  match: H$,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, _$ = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分钟",
  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟"
  },
  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟"
  },
  xHours: {
    one: "1 小时",
    other: "{{count}} 小时"
  },
  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期"
  },
  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期"
  },
  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月"
  },
  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月"
  },
  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年"
  },
  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年"
  }
}, I$ = (e, t, n) => {
  let r;
  const a = _$[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "内" : r + "前" : r;
}, L$ = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, j$ = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, B$ = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, W$ = {
  date: $e({
    formats: L$,
    defaultWidth: "full"
  }),
  time: $e({
    formats: j$,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: B$,
    defaultWidth: "full"
  })
};
function _1(e, t, n) {
  const r = "eeee p";
  return $r(e, t, n) ? r : e.getTime() > t.getTime() ? "'下个'" + r : "'上个'" + r;
}
const V$ = {
  lastWeek: _1,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: _1,
  // days after tomorrow, maybe in this week or next week
  other: "PP p"
}, G$ = (e, t, n, r) => {
  const a = V$[e];
  return typeof a == "function" ? a(t, n, r) : a;
}, Y$ = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, U$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, K$ = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, X$ = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, q$ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, Z$ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, J$ = (e, t) => {
  const n = Number(e);
  switch (t == null ? void 0 : t.unit) {
    case "date":
      return n.toString() + "日";
    case "hour":
      return n.toString() + "时";
    case "minute":
      return n.toString() + "分";
    case "second":
      return n.toString() + "秒";
    default:
      return "第 " + n.toString();
  }
}, Q$ = {
  ordinalNumber: J$,
  era: re({
    values: Y$,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: U$,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: K$,
    defaultWidth: "wide"
  }),
  day: re({
    values: X$,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: q$,
    defaultWidth: "wide",
    formattingValues: Z$,
    defaultFormattingWidth: "wide"
  })
}, eE = /^(第\s*)?\d+(日|时|分|秒)?/i, tE = /\d+/i, nE = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, rE = {
  any: [/^(前)/i, /^(公元)/i]
}, aE = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
}, oE = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, iE = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, lE = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, sE = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, cE = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, dE = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
}, uE = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, fE = {
  ordinalNumber: yt({
    matchPattern: eE,
    parsePattern: tE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: nE,
    defaultMatchWidth: "wide",
    parsePatterns: rE,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: aE,
    defaultMatchWidth: "wide",
    parsePatterns: oE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: iE,
    defaultMatchWidth: "wide",
    parsePatterns: lE,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: sE,
    defaultMatchWidth: "wide",
    parsePatterns: cE,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: dE,
    defaultMatchWidth: "any",
    parsePatterns: uE,
    defaultParseWidth: "any"
  })
}, hE = {
  code: "zh-CN",
  formatDistance: I$,
  formatLong: W$,
  formatRelative: G$,
  localize: Q$,
  match: fE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, mE = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, vE = (e, t, n) => {
  let r;
  const a = mE[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "內" : r + "前" : r;
}, pE = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, gE = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, yE = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, bE = {
  date: $e({
    formats: pE,
    defaultWidth: "full"
  }),
  time: $e({
    formats: gE,
    defaultWidth: "full"
  }),
  dateTime: $e({
    formats: yE,
    defaultWidth: "full"
  })
}, wE = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, $E = (e, t, n, r) => wE[e], EE = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, xE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"]
}, ME = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, CE = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, PE = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, SE = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, FE = (e, t) => {
  const n = Number(e);
  switch (t == null ? void 0 : t.unit) {
    case "date":
      return n + "日";
    case "hour":
      return n + "時";
    case "minute":
      return n + "分";
    case "second":
      return n + "秒";
    default:
      return "第 " + n;
  }
}, zE = {
  ordinalNumber: FE,
  era: re({
    values: EE,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: xE,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: ME,
    defaultWidth: "wide"
  }),
  day: re({
    values: CE,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: PE,
    defaultWidth: "wide",
    formattingValues: SE,
    defaultFormattingWidth: "wide"
  })
}, NE = /^(第\s*)?\d+(日|時|分|秒)?/i, DE = /\d+/i, OE = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, AE = {
  any: [/^(前)/i, /^(公元)/i]
}, TE = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
}, kE = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, HE = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, RE = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, _E = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, IE = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, LE = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, jE = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, BE = {
  ordinalNumber: yt({
    matchPattern: NE,
    parsePattern: DE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: OE,
    defaultMatchWidth: "wide",
    parsePatterns: AE,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: TE,
    defaultMatchWidth: "wide",
    parsePatterns: kE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: HE,
    defaultMatchWidth: "wide",
    parsePatterns: RE,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: _E,
    defaultMatchWidth: "wide",
    parsePatterns: IE,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: LE,
    defaultMatchWidth: "any",
    parsePatterns: jE,
    defaultParseWidth: "any"
  })
}, WE = {
  code: "zh-TW",
  formatDistance: vE,
  formatLong: bE,
  formatRelative: $E,
  localize: zE,
  match: BE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, VE = (e) => {
  switch (e) {
    case "de":
      return Op;
    case "es":
      return Ig;
    case "fr":
      return vy;
    case "it":
      return Uy;
    case "ja":
      return xb;
    case "nl":
      return Jb;
    case "pt-BR":
      return Fw;
    case "ru":
      return l$;
    case "tr":
      return R$;
    case "zh-CN":
      return hE;
    case "zh-TW":
      return WE;
    case "en":
    default:
      return sg;
  }
};
function sL(e) {
  const t = {
    month_caption: "flex justify-center items-center h-10",
    caption_label: "font-medium",
    day: "w-10 h-10 align-middle text-center border-0 px-0 hover:bg-primary-50",
    day_button: "w-10 h-10 bg-transparent text-inherit transition-colors focus:outline-none focus-visible:ring focus-visible:ring-primary-300 focus-visible:ring-opacity-50",
    disabled: "opacity-25 hover:!bg-white active:!bg-white active:!text-gray-800",
    outside: "opacity-50 !bg-transparent !text-gray-900 hover:!bg-transparent",
    selected: "bg-primary-500 text-white hover:bg-primary-500",
    range_start: "bg-primary-500 text-white hover:!bg-primary-500",
    range_end: "bg-primary-500 text-white hover:!bg-primary-500",
    range_middle: "!bg-primary-50 !text-gray-900 hover:!bg-primary-100",
    today: "font-bold",
    weekday: "w-10 h-10 uppercase align-middle text-center font-medium text-sm",
    months: "flex gap-4 relative px-4",
    button_next: "inline-flex justify-center items-center absolute top-0 right-0 w-10 h-10 rounded-full hover:bg-gray-100",
    button_previous: "inline-flex justify-center items-center absolute top-0 left-0 w-10 h-10 rounded-full hover:bg-gray-100",
    root: "text-text-primary",
    month_grid: "border-collapse border-spacing-0"
  };
  return /* @__PURE__ */ v.jsx(
    Jv,
    {
      ...e,
      classNames: t,
      components: {
        Chevron: ({ orientation: n }) => n === "left" ? /* @__PURE__ */ v.jsx(z6, { "data-testid": "leftIcon", className: "h-5 w-5 fill-gray-600" }) : /* @__PURE__ */ v.jsx(N6, { "data-testid": "rightIcon", className: "h-5 w-5 fill-gray-600" })
      },
      locale: VE(e.language ?? "en")
    }
  );
}
const GE = 'before:content-[" "]', YE = Pe(
  [
    GE,
    "peer",
    "relative",
    "cursor-pointer",
    "appearance-none",
    "rounded",
    "border-stroke",
    "before:absolute",
    "before:top-2/4",
    "before:left-2/4",
    "before:block",
    "before:-translate-y-2/4",
    "before:-translate-x-2/4",
    "before:rounded-full",
    "before:opacity-0",
    "before:transition-opacity",
    "hover:before:opacity-10",
    "focus:before:opacity-10",
    "focus:outline-none",
    "disabled:hover:before:opacity-0",
    "disabled:focus:before:opacity-0",
    "disabled:opacity-38",
    "disabled:cursor-not-allowed"
  ],
  {
    variants: {
      color: {
        primary: [
          "before:bg-primary-500",
          "checked:border-primary-500",
          "checked:bg-primary-500",
          "checked:before:bg-primary-500",
          "indeterminate:border-primary-500",
          "indeterminate:bg-primary-500",
          "indeterminate:before:bg-primary-500",
          "focus:border-primary-500"
        ],
        secondary: [
          "before:bg-secondary-500",
          "checked:border-secondary-500",
          "checked:bg-secondary-500",
          "checked:before:bg-secondary-500",
          "indeterminate:border-secondary-500",
          "indeterminate:bg-secondary-500",
          "indeterminate:before:bg-secondary-500",
          "focus:border-secondary-500"
        ]
      },
      size: {
        sm: ["h-4", "w-4", "border-[1px]", "before:h-6", "before:w-6"],
        md: ["h-5", "w-5", "border-[1.5px]", "before:h-8", "before:w-8"],
        lg: ["h-6", "w-6", "border-[2px]", "before:h-10", "before:w-10"]
      }
    },
    defaultVariants: {
      color: "primary",
      size: "md"
    }
  }
), UE = /* @__PURE__ */ v.jsx("svg", { width: "8", height: "6", viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v.jsx(
  "path",
  {
    d: "M7.35717 0.682099L7.35229 0.676201L7.34697 0.670694C7.19199 0.510193 6.94179 0.50977 6.7863 0.669425L2.87156 4.60131L0.974464 2.69097C0.818984 2.53122 0.568718 2.53161 0.413701 2.69214L0.557573 2.83107L0.413701 2.69214C0.2621 2.84914 0.2621 3.09692 0.413701 3.25391L0.413687 3.25393L0.41566 3.25591L2.39967 5.25377C2.52672 5.3847 2.69957 5.45 2.86048 5.45C3.03491 5.45 3.19601 5.38288 3.3212 5.25386L7.31982 1.23774C7.48732 1.08179 7.4858 0.837501 7.35717 0.682099ZM2.9605 4.69087L2.95881 4.68917L2.96048 4.69088L2.9605 4.69087Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.4"
  }
) }), KE = /* @__PURE__ */ v.jsx("svg", { width: "11", height: "7", viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v.jsx(
  "path",
  {
    d: "M10.0915 0.451972L10.0867 0.446075L10.0813 0.440568C9.90076 0.253564 9.61034 0.253146 9.42927 0.439309L4.16201 5.72962L1.58507 3.13469C1.40401 2.94841 1.11351 2.94879 0.932892 3.13584C0.755703 3.31933 0.755703 3.60875 0.932892 3.79224L0.932878 3.79225L0.934851 3.79424L3.58046 6.45832C3.73676 6.61955 3.94983 6.7 4.1473 6.7C4.36196 6.7 4.55963 6.61773 4.71406 6.4584L10.0468 1.10234C10.2436 0.919903 10.2421 0.633904 10.0915 0.451972ZM4.2327 5.80081L4.2317 5.7998C4.23206 5.80015 4.23237 5.80049 4.23269 5.80082L4.2327 5.80081Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.4"
  }
) }), XE = /* @__PURE__ */ v.jsx("svg", { width: "13", height: "9", viewBox: "0 0 13 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v.jsx(
  "path",
  {
    d: "M11.8259 0.721846L11.821 0.715949L11.8157 0.710441C11.6095 0.496939 11.2789 0.49652 11.0723 0.709185L4.45247 7.35794L1.19567 4.0784C0.98902 3.86561 0.658291 3.86598 0.452083 4.07953C0.249306 4.28952 0.249306 4.62058 0.452083 4.83057L0.452069 4.83058L0.454042 4.83257L3.76127 8.16287C3.94681 8.3544 4.20009 8.45 4.43413 8.45C4.68901 8.45 4.92324 8.35258 5.10692 8.16295L11.7738 1.46693C11.9999 1.25799 11.9984 0.930301 11.8259 0.721846ZM4.50491 7.41074L4.50457 7.4104C4.5047 7.41053 4.50479 7.41065 4.50489 7.41076L4.50491 7.41074Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.4"
  }
) }), qE = /* @__PURE__ */ v.jsx("svg", { width: "6", height: "1.5", viewBox: "0 0 6 1.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v.jsx("rect", { x: "0", y: "0", width: "6", height: "1.5", rx: "1", fill: "white" }) }), ZE = /* @__PURE__ */ v.jsx("svg", { width: "8", height: "1.5", viewBox: "0 0 8 1.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v.jsx("rect", { x: "0", y: "0", width: "8", height: "1.5", rx: "1", fill: "white" }) }), JE = /* @__PURE__ */ v.jsx("svg", { width: "10", height: "1.5", viewBox: "0 0 10 1.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v.jsx("rect", { x: "0", y: "0", width: "10", height: "1.5", rx: "1", fill: "white" }) }), cL = me(function({ className: t, color: n, id: r, indeterminate: a, label: i, size: l = "md", ...s }, c) {
  const d = (u) => {
    u && (u.indeterminate = !!a), typeof c == "function" ? c(u) : c && (c.current = u);
  }, f = () => a ? l === "sm" ? qE : l === "md" ? ZE : JE : l === "sm" ? UE : l === "md" ? KE : XE;
  return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "relative flex cursor-pointer items-center rounded-full", children: [
      /* @__PURE__ */ v.jsx(
        "input",
        {
          ref: d,
          type: "checkbox",
          id: r,
          className: YE({ color: n, className: t, size: l }),
          checked: a || s.checked,
          ...s
        }
      ),
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: K(
            "pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-white transition-opacity",
            {
              "opacity-0 peer-checked:opacity-100": !a,
              "opacity-100": a
            }
          ),
          children: f()
        }
      )
    ] }),
    i && /* @__PURE__ */ v.jsx(
      "label",
      {
        htmlFor: r,
        className: K(
          "cursor-pointer select-none",
          { "ml-1.5": l === "sm", "ml-2": l === "md", "ml-2.5": l === "lg" },
          { "cursor-not-allowed opacity-38": s.disabled }
        ),
        children: i
      }
    )
  ] });
}), QE = Pe(["flex max-w-fit items-center gap-1 border border-transparent px-2.5 py-0.5"], {
  variants: {
    variant: {
      standard: [""],
      filled: [""],
      outlined: [""]
    },
    type: {
      default: [],
      primary: [],
      secondary: [],
      info: [],
      error: [],
      warning: []
    },
    isRound: {
      false: ["rounded-md"],
      true: ["rounded-full"]
    },
    size: {
      xs: [],
      sm: [],
      lg: ["px-5", "py-3"]
    },
    disabled: {
      true: ["opacity-[.38]", "pointer-events-none"],
      false: []
    },
    useHoverStyles: {
      true: [],
      // override the hover styles if not a button and useHoverStyles is false
      false: ["pointer-events-none"]
    }
  },
  compoundVariants: [
    // filled
    {
      variant: "filled",
      type: "default",
      className: ["bg-gray-200", "hover:bg-gray-300", "text-gray-900"]
    },
    {
      variant: "filled",
      type: "primary",
      className: ["bg-primary-500", "hover:bg-primary-600", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "secondary",
      className: ["bg-secondary-500", "hover:bg-deepBlue-600", "text-white"]
    },
    {
      variant: "filled",
      type: "info",
      className: ["bg-lightBlue-500", "hover:bg-lightBlue-600", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "warning",
      className: ["bg-warning-500", "hover:bg-warning-600", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "error",
      className: ["bg-error-500", "hover:bg-error-600", "text-white"]
    },
    // outlined
    {
      variant: "outlined",
      type: "default",
      className: ["border-gray-500", "text-gray-900", "bg-gray-50", "hover:bg-gray-100"]
    },
    {
      variant: "outlined",
      type: "primary",
      className: ["border-green-500", "text-green-900", "bg-green-50", "hover:bg-green-100"]
    },
    {
      variant: "outlined",
      type: "secondary",
      className: ["border-secondary-500", "text-deepBlue-900", "bg-deepBlue-50", "hover:bg-deepBlue-100"]
    },
    {
      variant: "outlined",
      type: "info",
      className: ["border-lightBlue-500", "text-lightBlue-900", "bg-lightBlue-50", "hover:bg-lightBlue-100"]
    },
    {
      variant: "outlined",
      type: "warning",
      className: ["border-warning-500", "text-warning-900", "bg-warning-50", "hover:bg-warning-100"]
    },
    {
      variant: "outlined",
      type: "error",
      className: ["border-error-500", "text-error-900", "bg-error-50", "hover:bg-error-100"]
    },
    // standard
    {
      variant: "standard",
      type: "default",
      className: ["bg-gray-100", "text-gray-900", "hover:bg-gray-200"]
    },
    {
      variant: "standard",
      type: "primary",
      className: ["bg-green-100", "text-green-900", "hover:bg-green-200"]
    },
    {
      variant: "standard",
      type: "secondary",
      className: ["bg-deepBlue-100", "text-deepBlue-900", "hover:bg-deepBlue-200"]
    },
    {
      variant: "standard",
      type: "info",
      className: ["bg-lightBlue-100", "text-lightBlue-900", "hover:bg-lightBlue-200"]
    },
    {
      variant: "standard",
      type: "warning",
      className: ["bg-warning-100", "text-warning-900", "hover:bg-warning-200"]
    },
    {
      variant: "standard",
      type: "error",
      className: ["bg-error-100", "text-error-900", "hover:bg-error-200"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    type: "default",
    isRound: !1,
    size: "sm",
    disabled: !1,
    useHoverStyles: !1
  }
}), I1 = Pe(["h-4 w-4"], {
  variants: {
    variant: {
      standard: [""],
      filled: [""],
      outlined: [""]
    },
    type: {
      default: [""],
      primary: [""],
      secondary: [""],
      info: [""],
      warning: [""],
      error: [""]
    }
  },
  compoundVariants: [
    // filled
    {
      variant: "filled",
      type: "default",
      className: ["fill-gray-900"]
    },
    {
      variant: "filled",
      type: "primary",
      className: ["fill-text-primary"]
    },
    {
      variant: "filled",
      type: "secondary",
      className: ["fill-white"]
    },
    {
      variant: "filled",
      type: "info",
      className: ["fill-text-primary"]
    },
    {
      variant: "filled",
      type: "warning",
      className: ["fill-text-primary"]
    },
    {
      variant: "filled",
      type: "error",
      className: ["fill-white"]
    },
    // outlined
    {
      variant: "outlined",
      type: "default",
      className: ["fill-gray-900"]
    },
    {
      variant: "outlined",
      type: "primary",
      className: ["fill-green-900"]
    },
    {
      variant: "outlined",
      type: "secondary",
      className: ["fill-deepBlue-900"]
    },
    {
      variant: "outlined",
      type: "info",
      className: ["fill-lightBlue-900"]
    },
    {
      variant: "outlined",
      type: "warning",
      className: ["fill-warning-900"]
    },
    {
      variant: "outlined",
      type: "error",
      className: ["fill-error-900"]
    },
    // standard
    {
      variant: "standard",
      type: "default",
      className: ["fill-gray-900"]
    },
    {
      variant: "standard",
      type: "primary",
      className: ["fill-green-900"]
    },
    {
      variant: "standard",
      type: "secondary",
      className: ["fill-deepBlue-900"]
    },
    {
      variant: "standard",
      type: "info",
      className: ["fill-lightBlue-900"]
    },
    {
      variant: "standard",
      type: "warning",
      className: ["fill-warning-900"]
    },
    {
      variant: "standard",
      type: "error",
      className: ["fill-error-900"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    type: "default"
  }
}), ex = Pe(["truncate text-nowrap font-medium"], {
  variants: {
    size: {
      xs: ["text-xs"],
      sm: ["text-sm"],
      lg: ["text-sm"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function L1({
  type: e = "default",
  variant: t = "standard",
  isRound: n = !1,
  size: r = "sm",
  label: a,
  startIcon: i,
  endIcon: l,
  disabled: s = !1,
  onClick: c,
  useHoverStyles: d = !1,
  className: f
}) {
  const u = i == null ? void 0 : i.icon, h = i == null ? void 0 : i.name, p = l == null ? void 0 : l.icon, y = l == null ? void 0 : l.name;
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: QE({
        variant: t,
        type: e,
        isRound: n,
        size: r,
        disabled: s,
        useHoverStyles: !!c || d,
        className: f
      }),
      children: [
        i && u && /* @__PURE__ */ v.jsx(u, { "aria-label": h, className: I1({ variant: t, type: e }) }),
        /* @__PURE__ */ v.jsx("div", { className: ex({ size: r }), children: a }),
        l && p && /* @__PURE__ */ v.jsx(p, { "aria-label": y, className: I1({ variant: t, type: e }) })
      ]
    }
  );
}
function dL(e) {
  return e.onClick ? /* @__PURE__ */ v.jsx("button", { type: "button", onClick: e.onClick, disabled: e.disabled, children: /* @__PURE__ */ v.jsx(L1, { ...e }) }) : /* @__PURE__ */ v.jsx(L1, { ...e });
}
function tx(e, t) {
  const n = g.createContext(t), r = (i) => {
    const { children: l, ...s } = i, c = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v.jsx(n.Provider, { value: c, children: l });
  };
  r.displayName = e + "Provider";
  function a(i) {
    const l = g.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, a];
}
function Rr(e, t = []) {
  let n = [];
  function r(i, l) {
    const s = g.createContext(l), c = n.length;
    n = [...n, l];
    const d = (u) => {
      var $;
      const { scope: h, children: p, ...y } = u, m = (($ = h == null ? void 0 : h[e]) == null ? void 0 : $[c]) || s, b = g.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ v.jsx(m.Provider, { value: b, children: p });
    };
    d.displayName = i + "Provider";
    function f(u, h) {
      var m;
      const p = ((m = h == null ? void 0 : h[e]) == null ? void 0 : m[c]) || s, y = g.useContext(p);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return [d, f];
  }
  const a = () => {
    const i = n.map((l) => g.createContext(l));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [r, nx(a, ...t)];
}
function nx(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const u = c(i)[`__scope${d}`];
        return { ...s, ...u };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function rx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = dt(e);
  g.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var ax = "DismissableLayer", di = "dismissableLayer.update", ox = "dismissableLayer.pointerDownOutside", ix = "dismissableLayer.focusOutside", j1, Ud = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Va = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: s,
      ...c
    } = e, d = g.useContext(Ud), [f, u] = g.useState(null), h = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = g.useState({}), y = De(t, (z) => u(z)), m = Array.from(d.layers), [b] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), $ = m.indexOf(b), w = f ? m.indexOf(f) : -1, E = d.layersWithOutsidePointerEventsDisabled.size > 0, P = w >= $, x = cx((z) => {
      const N = z.target, A = [...d.branches].some((_) => _.contains(N));
      !P || A || (a == null || a(z), l == null || l(z), z.defaultPrevented || s == null || s());
    }, h), F = dx((z) => {
      const N = z.target;
      [...d.branches].some((_) => _.contains(N)) || (i == null || i(z), l == null || l(z), z.defaultPrevented || s == null || s());
    }, h);
    return rx((z) => {
      w === d.layers.size - 1 && (r == null || r(z), !z.defaultPrevented && s && (z.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (f)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (j1 = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), B1(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = j1);
        };
    }, [f, h, n, d]), g.useEffect(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), B1());
    }, [f, d]), g.useEffect(() => {
      const z = () => p({});
      return document.addEventListener(di, z), () => document.removeEventListener(di, z);
    }, []), /* @__PURE__ */ v.jsx(
      ge.div,
      {
        ...c,
        ref: y,
        style: {
          pointerEvents: E ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ie(e.onFocusCapture, F.onFocusCapture),
        onBlurCapture: ie(e.onBlurCapture, F.onBlurCapture),
        onPointerDownCapture: ie(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Va.displayName = ax;
var lx = "DismissableLayerBranch", sx = g.forwardRef((e, t) => {
  const n = g.useContext(Ud), r = g.useRef(null), a = De(t, r);
  return g.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ v.jsx(ge.div, { ...e, ref: a });
});
sx.displayName = lx;
function cx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = dt(e), r = g.useRef(!1), a = g.useRef(() => {
  });
  return g.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          Kd(
            ox,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function dx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = dt(e), r = g.useRef(!1);
  return g.useEffect(() => {
    const a = (i) => {
      i.target && !r.current && Kd(ix, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function B1() {
  const e = new CustomEvent(di);
  document.dispatchEvent(e);
}
function Kd(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? Rc(a, i) : a.dispatchEvent(i);
}
var To = 0;
function yl() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? W1()), document.body.insertAdjacentElement("beforeend", e[1] ?? W1()), To++, () => {
      To === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), To--;
    };
  }, []);
}
function W1() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ko = "focusScope.autoFocusOnMount", Ho = "focusScope.autoFocusOnUnmount", V1 = { bubbles: !1, cancelable: !0 }, ux = "FocusScope", Ga = g.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...l
  } = e, [s, c] = g.useState(null), d = dt(a), f = dt(i), u = g.useRef(null), h = De(t, (m) => c(m)), p = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (r) {
      let m = function(E) {
        if (p.paused || !s) return;
        const P = E.target;
        s.contains(P) ? u.current = P : Qt(u.current, { select: !0 });
      }, b = function(E) {
        if (p.paused || !s) return;
        const P = E.relatedTarget;
        P !== null && (s.contains(P) || Qt(u.current, { select: !0 }));
      }, $ = function(E) {
        if (document.activeElement === document.body)
          for (const x of E)
            x.removedNodes.length > 0 && Qt(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const w = new MutationObserver($);
      return s && w.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), w.disconnect();
      };
    }
  }, [r, s, p.paused]), g.useEffect(() => {
    if (s) {
      Y1.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const $ = new CustomEvent(ko, V1);
        s.addEventListener(ko, d), s.dispatchEvent($), $.defaultPrevented || (fx(gx(Xd(s)), { select: !0 }), document.activeElement === m && Qt(s));
      }
      return () => {
        s.removeEventListener(ko, d), setTimeout(() => {
          const $ = new CustomEvent(Ho, V1);
          s.addEventListener(Ho, f), s.dispatchEvent($), $.defaultPrevented || Qt(m ?? document.body, { select: !0 }), s.removeEventListener(Ho, f), Y1.remove(p);
        }, 0);
      };
    }
  }, [s, d, f, p]);
  const y = g.useCallback(
    (m) => {
      if (!n && !r || p.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, $ = document.activeElement;
      if (b && $) {
        const w = m.currentTarget, [E, P] = hx(w);
        E && P ? !m.shiftKey && $ === P ? (m.preventDefault(), n && Qt(E, { select: !0 })) : m.shiftKey && $ === E && (m.preventDefault(), n && Qt(P, { select: !0 })) : $ === w && m.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ v.jsx(ge.div, { tabIndex: -1, ...l, ref: h, onKeyDown: y });
});
Ga.displayName = ux;
function fx(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Qt(r, { select: t }), document.activeElement !== n) return;
}
function hx(e) {
  const t = Xd(e), n = G1(t, e), r = G1(t.reverse(), e);
  return [n, r];
}
function Xd(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function G1(e, t) {
  for (const n of e)
    if (!mx(n, { upTo: t })) return n;
}
function mx(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function vx(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Qt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && vx(e) && t && e.select();
  }
}
var Y1 = px();
function px() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = U1(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = U1(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function U1(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function gx(e) {
  return e.filter((t) => t.tagName !== "A");
}
const yx = ["top", "right", "bottom", "left"], Ot = Math.min, lt = Math.max, $a = Math.round, aa = Math.floor, nn = (e) => ({
  x: e,
  y: e
}), bx = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, wx = {
  start: "end",
  end: "start"
};
function ui(e, t, n) {
  return lt(e, Ot(t, n));
}
function Bt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Wt(e) {
  return e.split("-")[0];
}
function Yn(e) {
  return e.split("-")[1];
}
function bl(e) {
  return e === "x" ? "y" : "x";
}
function wl(e) {
  return e === "y" ? "height" : "width";
}
function rn(e) {
  return ["top", "bottom"].includes(Wt(e)) ? "y" : "x";
}
function $l(e) {
  return bl(rn(e));
}
function $x(e, t, n) {
  n === void 0 && (n = !1);
  const r = Yn(e), a = $l(e), i = wl(a);
  let l = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (l = Ea(l)), [l, Ea(l)];
}
function Ex(e) {
  const t = Ea(e);
  return [fi(e), t, fi(t)];
}
function fi(e) {
  return e.replace(/start|end/g, (t) => wx[t]);
}
function xx(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], l = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : l;
    default:
      return [];
  }
}
function Mx(e, t, n, r) {
  const a = Yn(e);
  let i = xx(Wt(e), n === "start", r);
  return a && (i = i.map((l) => l + "-" + a), t && (i = i.concat(i.map(fi)))), i;
}
function Ea(e) {
  return e.replace(/left|right|bottom|top/g, (t) => bx[t]);
}
function Cx(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function qd(e) {
  return typeof e != "number" ? Cx(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function xa(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function K1(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = rn(t), l = $l(t), s = wl(l), c = Wt(t), d = i === "y", f = r.x + r.width / 2 - a.width / 2, u = r.y + r.height / 2 - a.height / 2, h = r[s] / 2 - a[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: f,
        y: r.y - a.height
      };
      break;
    case "bottom":
      p = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - a.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Yn(t)) {
    case "start":
      p[l] -= h * (n && d ? -1 : 1);
      break;
    case "end":
      p[l] += h * (n && d ? -1 : 1);
      break;
  }
  return p;
}
const Px = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: l
  } = n, s = i.filter(Boolean), c = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let d = await l.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: f,
    y: u
  } = K1(d, r, c), h = r, p = {}, y = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: b,
      fn: $
    } = s[m], {
      x: w,
      y: E,
      data: P,
      reset: x
    } = await $({
      x: f,
      y: u,
      initialPlacement: r,
      placement: h,
      strategy: a,
      middlewareData: p,
      rects: d,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = w ?? f, u = E ?? u, p = {
      ...p,
      [b]: {
        ...p[b],
        ...P
      }
    }, x && y <= 50 && (y++, typeof x == "object" && (x.placement && (h = x.placement), x.rects && (d = x.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : x.rects), {
      x: f,
      y: u
    } = K1(d, h, c)), m = -1);
  }
  return {
    x: f,
    y: u,
    placement: h,
    strategy: a,
    middlewareData: p
  };
};
async function Er(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: l,
    elements: s,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = Bt(t, e), y = qd(p), b = s[h ? u === "floating" ? "reference" : "floating" : u], $ = xa(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: f,
    strategy: c
  })), w = u === "floating" ? {
    x: r,
    y: a,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, E = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), P = await (i.isElement == null ? void 0 : i.isElement(E)) ? await (i.getScale == null ? void 0 : i.getScale(E)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = xa(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: E,
    strategy: c
  }) : w);
  return {
    top: ($.top - x.top + y.top) / P.y,
    bottom: (x.bottom - $.bottom + y.bottom) / P.y,
    left: ($.left - x.left + y.left) / P.x,
    right: (x.right - $.right + y.right) / P.x
  };
}
const Sx = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: l,
      elements: s,
      middlewareData: c
    } = t, {
      element: d,
      padding: f = 0
    } = Bt(e, t) || {};
    if (d == null)
      return {};
    const u = qd(f), h = {
      x: n,
      y: r
    }, p = $l(a), y = wl(p), m = await l.getDimensions(d), b = p === "y", $ = b ? "top" : "left", w = b ? "bottom" : "right", E = b ? "clientHeight" : "clientWidth", P = i.reference[y] + i.reference[p] - h[p] - i.floating[y], x = h[p] - i.reference[p], F = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(d));
    let z = F ? F[E] : 0;
    (!z || !await (l.isElement == null ? void 0 : l.isElement(F))) && (z = s.floating[E] || i.floating[y]);
    const N = P / 2 - x / 2, A = z / 2 - m[y] / 2 - 1, _ = Ot(u[$], A), B = Ot(u[w], A), j = _, ee = z - m[y] - B, R = z / 2 - m[y] / 2 + N, X = ui(j, R, ee), V = !c.arrow && Yn(a) != null && R !== X && i.reference[y] / 2 - (R < j ? _ : B) - m[y] / 2 < 0, G = V ? R < j ? R - j : R - ee : 0;
    return {
      [p]: h[p] + G,
      data: {
        [p]: X,
        centerOffset: R - X - G,
        ...V && {
          alignmentOffset: G
        }
      },
      reset: V
    };
  }
}), Fx = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: l,
        initialPlacement: s,
        platform: c,
        elements: d
      } = t, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: m = !0,
        ...b
      } = Bt(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const $ = Wt(a), w = rn(s), E = Wt(s) === s, P = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), x = h || (E || !m ? [Ea(s)] : Ex(s)), F = y !== "none";
      !h && F && x.push(...Mx(s, m, y, P));
      const z = [s, ...x], N = await Er(t, b), A = [];
      let _ = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (f && A.push(N[$]), u) {
        const R = $x(a, l, P);
        A.push(N[R[0]], N[R[1]]);
      }
      if (_ = [..._, {
        placement: a,
        overflows: A
      }], !A.every((R) => R <= 0)) {
        var B, j;
        const R = (((B = i.flip) == null ? void 0 : B.index) || 0) + 1, X = z[R];
        if (X)
          return {
            data: {
              index: R,
              overflows: _
            },
            reset: {
              placement: X
            }
          };
        let V = (j = _.filter((G) => G.overflows[0] <= 0).sort((G, ne) => G.overflows[1] - ne.overflows[1])[0]) == null ? void 0 : j.placement;
        if (!V)
          switch (p) {
            case "bestFit": {
              var ee;
              const G = (ee = _.filter((ne) => {
                if (F) {
                  const k = rn(ne.placement);
                  return k === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  k === "y";
                }
                return !0;
              }).map((ne) => [ne.placement, ne.overflows.filter((k) => k > 0).reduce((k, D) => k + D, 0)]).sort((ne, k) => ne[1] - k[1])[0]) == null ? void 0 : ee[0];
              G && (V = G);
              break;
            }
            case "initialPlacement":
              V = s;
              break;
          }
        if (a !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function X1(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function q1(e) {
  return yx.some((t) => e[t] >= 0);
}
const zx = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Bt(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await Er(t, {
            ...a,
            elementContext: "reference"
          }), l = X1(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: q1(l)
            }
          };
        }
        case "escaped": {
          const i = await Er(t, {
            ...a,
            altBoundary: !0
          }), l = X1(i, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: q1(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Nx(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), l = Wt(n), s = Yn(n), c = rn(n) === "y", d = ["left", "top"].includes(l) ? -1 : 1, f = i && c ? -1 : 1, u = Bt(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: y
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof y == "number" && (p = s === "end" ? y * -1 : y), c ? {
    x: p * f,
    y: h * d
  } : {
    x: h * d,
    y: p * f
  };
}
const Dx = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: l,
        middlewareData: s
      } = t, c = await Nx(t, e);
      return l === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: l
        }
      };
    }
  };
}, Ox = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: $,
              y: w
            } = b;
            return {
              x: $,
              y: w
            };
          }
        },
        ...c
      } = Bt(e, t), d = {
        x: n,
        y: r
      }, f = await Er(t, c), u = rn(Wt(a)), h = bl(u);
      let p = d[h], y = d[u];
      if (i) {
        const b = h === "y" ? "top" : "left", $ = h === "y" ? "bottom" : "right", w = p + f[b], E = p - f[$];
        p = ui(w, p, E);
      }
      if (l) {
        const b = u === "y" ? "top" : "left", $ = u === "y" ? "bottom" : "right", w = y + f[b], E = y - f[$];
        y = ui(w, y, E);
      }
      const m = s.fn({
        ...t,
        [h]: p,
        [u]: y
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r
        }
      };
    }
  };
}, Ax = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: i,
        middlewareData: l
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: d = !0
      } = Bt(e, t), f = {
        x: n,
        y: r
      }, u = rn(a), h = bl(u);
      let p = f[h], y = f[u];
      const m = Bt(s, t), b = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const E = h === "y" ? "height" : "width", P = i.reference[h] - i.floating[E] + b.mainAxis, x = i.reference[h] + i.reference[E] - b.mainAxis;
        p < P ? p = P : p > x && (p = x);
      }
      if (d) {
        var $, w;
        const E = h === "y" ? "width" : "height", P = ["top", "left"].includes(Wt(a)), x = i.reference[u] - i.floating[E] + (P && (($ = l.offset) == null ? void 0 : $[u]) || 0) + (P ? 0 : b.crossAxis), F = i.reference[u] + i.reference[E] + (P ? 0 : ((w = l.offset) == null ? void 0 : w[u]) || 0) - (P ? b.crossAxis : 0);
        y < x ? y = x : y > F && (y = F);
      }
      return {
        [h]: p,
        [u]: y
      };
    }
  };
}, Tx = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: a,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...s
      } = Bt(e, t), c = await Er(t, s), d = Wt(n), f = Yn(n), u = rn(n) === "y", {
        width: h,
        height: p
      } = r.floating;
      let y, m;
      d === "top" || d === "bottom" ? (y = d, m = f === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (m = d, y = f === "end" ? "top" : "bottom");
      const b = p - c.top - c.bottom, $ = h - c.left - c.right, w = Ot(p - c[y], b), E = Ot(h - c[m], $), P = !t.middlewareData.shift;
      let x = w, F = E;
      if (u ? F = f || P ? Ot(E, $) : $ : x = f || P ? Ot(w, b) : b, P && !f) {
        const N = lt(c.left, 0), A = lt(c.right, 0), _ = lt(c.top, 0), B = lt(c.bottom, 0);
        u ? F = h - 2 * (N !== 0 || A !== 0 ? N + A : lt(c.left, c.right)) : x = p - 2 * (_ !== 0 || B !== 0 ? _ + B : lt(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: F,
        availableHeight: x
      });
      const z = await a.getDimensions(i.floating);
      return h !== z.width || p !== z.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Un(e) {
  return Zd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ct(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Yt(e) {
  var t;
  return (t = (Zd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Zd(e) {
  return e instanceof Node || e instanceof ct(e).Node;
}
function St(e) {
  return e instanceof Element || e instanceof ct(e).Element;
}
function Tt(e) {
  return e instanceof HTMLElement || e instanceof ct(e).HTMLElement;
}
function Z1(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ct(e).ShadowRoot;
}
function _r(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Ft(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function kx(e) {
  return ["table", "td", "th"].includes(Un(e));
}
function Ya(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function El(e) {
  const t = xl(), n = St(e) ? Ft(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Hx(e) {
  let t = an(e);
  for (; Tt(t) && !Ln(t); ) {
    if (El(t))
      return t;
    if (Ya(t))
      return null;
    t = an(t);
  }
  return null;
}
function xl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ln(e) {
  return ["html", "body", "#document"].includes(Un(e));
}
function Ft(e) {
  return ct(e).getComputedStyle(e);
}
function Ua(e) {
  return St(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function an(e) {
  if (Un(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Z1(e) && e.host || // Fallback.
    Yt(e)
  );
  return Z1(t) ? t.host : t;
}
function Jd(e) {
  const t = an(e);
  return Ln(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Tt(t) && _r(t) ? t : Jd(t);
}
function xr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = Jd(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), l = ct(a);
  if (i) {
    const s = hi(l);
    return t.concat(l, l.visualViewport || [], _r(a) ? a : [], s && n ? xr(s) : []);
  }
  return t.concat(a, xr(a, [], n));
}
function hi(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Qd(e) {
  const t = Ft(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = Tt(e), i = a ? e.offsetWidth : n, l = a ? e.offsetHeight : r, s = $a(n) !== i || $a(r) !== l;
  return s && (n = i, r = l), {
    width: n,
    height: r,
    $: s
  };
}
function Ml(e) {
  return St(e) ? e : e.contextElement;
}
function kn(e) {
  const t = Ml(e);
  if (!Tt(t))
    return nn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = Qd(t);
  let l = (i ? $a(n.width) : n.width) / r, s = (i ? $a(n.height) : n.height) / a;
  return (!l || !Number.isFinite(l)) && (l = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: l,
    y: s
  };
}
const Rx = /* @__PURE__ */ nn(0);
function e2(e) {
  const t = ct(e);
  return !xl() || !t.visualViewport ? Rx : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function _x(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ct(e) ? !1 : t;
}
function gn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = Ml(e);
  let l = nn(1);
  t && (r ? St(r) && (l = kn(r)) : l = kn(e));
  const s = _x(i, n, r) ? e2(i) : nn(0);
  let c = (a.left + s.x) / l.x, d = (a.top + s.y) / l.y, f = a.width / l.x, u = a.height / l.y;
  if (i) {
    const h = ct(i), p = r && St(r) ? ct(r) : r;
    let y = h, m = hi(y);
    for (; m && r && p !== y; ) {
      const b = kn(m), $ = m.getBoundingClientRect(), w = Ft(m), E = $.left + (m.clientLeft + parseFloat(w.paddingLeft)) * b.x, P = $.top + (m.clientTop + parseFloat(w.paddingTop)) * b.y;
      c *= b.x, d *= b.y, f *= b.x, u *= b.y, c += E, d += P, y = ct(m), m = hi(y);
    }
  }
  return xa({
    width: f,
    height: u,
    x: c,
    y: d
  });
}
function Ix(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", l = Yt(r), s = t ? Ya(t.floating) : !1;
  if (r === l || s && i)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = nn(1);
  const f = nn(0), u = Tt(r);
  if ((u || !u && !i) && ((Un(r) !== "body" || _r(l)) && (c = Ua(r)), Tt(r))) {
    const h = gn(r);
    d = kn(r), f.x = h.x + r.clientLeft, f.y = h.y + r.clientTop;
  }
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + f.x,
    y: n.y * d.y - c.scrollTop * d.y + f.y
  };
}
function Lx(e) {
  return Array.from(e.getClientRects());
}
function t2(e) {
  return gn(Yt(e)).left + Ua(e).scrollLeft;
}
function jx(e) {
  const t = Yt(e), n = Ua(e), r = e.ownerDocument.body, a = lt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = lt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let l = -n.scrollLeft + t2(e);
  const s = -n.scrollTop;
  return Ft(r).direction === "rtl" && (l += lt(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: l,
    y: s
  };
}
function Bx(e, t) {
  const n = ct(e), r = Yt(e), a = n.visualViewport;
  let i = r.clientWidth, l = r.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, l = a.height;
    const d = xl();
    (!d || d && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function Wx(e, t) {
  const n = gn(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = Tt(e) ? kn(e) : nn(1), l = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, d = r * i.y;
  return {
    width: l,
    height: s,
    x: c,
    y: d
  };
}
function J1(e, t, n) {
  let r;
  if (t === "viewport")
    r = Bx(e, n);
  else if (t === "document")
    r = jx(Yt(e));
  else if (St(t))
    r = Wx(t, n);
  else {
    const a = e2(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return xa(r);
}
function n2(e, t) {
  const n = an(e);
  return n === t || !St(n) || Ln(n) ? !1 : Ft(n).position === "fixed" || n2(n, t);
}
function Vx(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = xr(e, [], !1).filter((s) => St(s) && Un(s) !== "body"), a = null;
  const i = Ft(e).position === "fixed";
  let l = i ? an(e) : e;
  for (; St(l) && !Ln(l); ) {
    const s = Ft(l), c = El(l);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || _r(l) && !c && n2(e, l)) ? r = r.filter((f) => f !== l) : a = s, l = an(l);
  }
  return t.set(e, r), r;
}
function Gx(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const l = [...n === "clippingAncestors" ? Ya(t) ? [] : Vx(t, this._c) : [].concat(n), r], s = l[0], c = l.reduce((d, f) => {
    const u = J1(t, f, a);
    return d.top = lt(u.top, d.top), d.right = Ot(u.right, d.right), d.bottom = Ot(u.bottom, d.bottom), d.left = lt(u.left, d.left), d;
  }, J1(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Yx(e) {
  const {
    width: t,
    height: n
  } = Qd(e);
  return {
    width: t,
    height: n
  };
}
function Ux(e, t, n) {
  const r = Tt(t), a = Yt(t), i = n === "fixed", l = gn(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = nn(0);
  if (r || !r && !i)
    if ((Un(t) !== "body" || _r(a)) && (s = Ua(t)), r) {
      const u = gn(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else a && (c.x = t2(a));
  const d = l.left + s.scrollLeft - c.x, f = l.top + s.scrollTop - c.y;
  return {
    x: d,
    y: f,
    width: l.width,
    height: l.height
  };
}
function Ro(e) {
  return Ft(e).position === "static";
}
function Q1(e, t) {
  return !Tt(e) || Ft(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function r2(e, t) {
  const n = ct(e);
  if (Ya(e))
    return n;
  if (!Tt(e)) {
    let a = an(e);
    for (; a && !Ln(a); ) {
      if (St(a) && !Ro(a))
        return a;
      a = an(a);
    }
    return n;
  }
  let r = Q1(e, t);
  for (; r && kx(r) && Ro(r); )
    r = Q1(r, t);
  return r && Ln(r) && Ro(r) && !El(r) ? n : r || Hx(e) || n;
}
const Kx = async function(e) {
  const t = this.getOffsetParent || r2, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Ux(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Xx(e) {
  return Ft(e).direction === "rtl";
}
const qx = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ix,
  getDocumentElement: Yt,
  getClippingRect: Gx,
  getOffsetParent: r2,
  getElementRects: Kx,
  getClientRects: Lx,
  getDimensions: Yx,
  getScale: kn,
  isElement: St,
  isRTL: Xx
};
function Zx(e, t) {
  let n = null, r;
  const a = Yt(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function l(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: d,
      top: f,
      width: u,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !u || !h)
      return;
    const p = aa(f), y = aa(a.clientWidth - (d + u)), m = aa(a.clientHeight - (f + h)), b = aa(d), w = {
      rootMargin: -p + "px " + -y + "px " + -m + "px " + -b + "px",
      threshold: lt(0, Ot(1, c)) || 1
    };
    let E = !0;
    function P(x) {
      const F = x[0].intersectionRatio;
      if (F !== c) {
        if (!E)
          return l();
        F ? l(!1, F) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      E = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...w,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, w);
    }
    n.observe(e);
  }
  return l(!0), i;
}
function a2(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, d = Ml(e), f = a || i ? [...d ? xr(d) : [], ...xr(t)] : [];
  f.forEach(($) => {
    a && $.addEventListener("scroll", n, {
      passive: !0
    }), i && $.addEventListener("resize", n);
  });
  const u = d && s ? Zx(d, n) : null;
  let h = -1, p = null;
  l && (p = new ResizeObserver(($) => {
    let [w] = $;
    w && w.target === d && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var E;
      (E = p) == null || E.observe(t);
    })), n();
  }), d && !c && p.observe(d), p.observe(t));
  let y, m = c ? gn(e) : null;
  c && b();
  function b() {
    const $ = gn(e);
    m && ($.x !== m.x || $.y !== m.y || $.width !== m.width || $.height !== m.height) && n(), m = $, y = requestAnimationFrame(b);
  }
  return n(), () => {
    var $;
    f.forEach((w) => {
      a && w.removeEventListener("scroll", n), i && w.removeEventListener("resize", n);
    }), u == null || u(), ($ = p) == null || $.disconnect(), p = null, c && cancelAnimationFrame(y);
  };
}
const Jx = Dx, Qx = Ox, eM = Fx, tM = Tx, nM = zx, es = Sx, rM = Ax, aM = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: qx,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return Px(e, t, {
    ...a,
    platform: i
  });
};
var va = typeof document < "u" ? _n : Ce;
function Ma(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ma(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !Ma(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function o2(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ts(e, t) {
  const n = o2(e);
  return Math.round(t * n) / n;
}
function ns(e) {
  const t = g.useRef(e);
  return va(() => {
    t.current = e;
  }), t;
}
function i2(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: l
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: d
  } = e, [f, u] = g.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = g.useState(r);
  Ma(h, r) || p(r);
  const [y, m] = g.useState(null), [b, $] = g.useState(null), w = g.useCallback((G) => {
    G !== F.current && (F.current = G, m(G));
  }, []), E = g.useCallback((G) => {
    G !== z.current && (z.current = G, $(G));
  }, []), P = i || y, x = l || b, F = g.useRef(null), z = g.useRef(null), N = g.useRef(f), A = c != null, _ = ns(c), B = ns(a), j = g.useCallback(() => {
    if (!F.current || !z.current)
      return;
    const G = {
      placement: t,
      strategy: n,
      middleware: h
    };
    B.current && (G.platform = B.current), aM(F.current, z.current, G).then((ne) => {
      const k = {
        ...ne,
        isPositioned: !0
      };
      ee.current && !Ma(N.current, k) && (N.current = k, Or.flushSync(() => {
        u(k);
      }));
    });
  }, [h, t, n, B]);
  va(() => {
    d === !1 && N.current.isPositioned && (N.current.isPositioned = !1, u((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [d]);
  const ee = g.useRef(!1);
  va(() => (ee.current = !0, () => {
    ee.current = !1;
  }), []), va(() => {
    if (P && (F.current = P), x && (z.current = x), P && x) {
      if (_.current)
        return _.current(P, x, j);
      j();
    }
  }, [P, x, j, _, A]);
  const R = g.useMemo(() => ({
    reference: F,
    floating: z,
    setReference: w,
    setFloating: E
  }), [w, E]), X = g.useMemo(() => ({
    reference: P,
    floating: x
  }), [P, x]), V = g.useMemo(() => {
    const G = {
      position: n,
      left: 0,
      top: 0
    };
    if (!X.floating)
      return G;
    const ne = ts(X.floating, f.x), k = ts(X.floating, f.y);
    return s ? {
      ...G,
      transform: "translate(" + ne + "px, " + k + "px)",
      ...o2(X.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ne,
      top: k
    };
  }, [n, s, X.floating, f.x, f.y]);
  return g.useMemo(() => ({
    ...f,
    update: j,
    refs: R,
    elements: X,
    floatingStyles: V
  }), [f, j, R, X, V]);
}
const oM = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? es({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? es({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
}, l2 = (e, t) => ({
  ...Jx(e),
  options: [e, t]
}), s2 = (e, t) => ({
  ...Qx(e),
  options: [e, t]
}), c2 = (e, t) => ({
  ...rM(e),
  options: [e, t]
}), d2 = (e, t) => ({
  ...eM(e),
  options: [e, t]
}), u2 = (e, t) => ({
  ...tM(e),
  options: [e, t]
}), f2 = (e, t) => ({
  ...nM(e),
  options: [e, t]
}), h2 = (e, t) => ({
  ...oM(e),
  options: [e, t]
});
var iM = "Arrow", m2 = g.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: a = 5, ...i } = e;
  return /* @__PURE__ */ v.jsx(
    ge.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ v.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
m2.displayName = iM;
var lM = m2;
function v2(e) {
  const [t, n] = g.useState(void 0);
  return Ye(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let l, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          l = d.inlineSize, s = d.blockSize;
        } else
          l = e.offsetWidth, s = e.offsetHeight;
        n({ width: l, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Cl = "Popper", [p2, Ka] = Ar(Cl), [sM, g2] = p2(Cl), y2 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = g.useState(null);
  return /* @__PURE__ */ v.jsx(sM, { scope: t, anchor: r, onAnchorChange: a, children: n });
};
y2.displayName = Cl;
var b2 = "PopperAnchor", w2 = g.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...a } = e, i = g2(b2, n), l = g.useRef(null), s = De(t, l);
    return g.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || l.current);
    }), r ? null : /* @__PURE__ */ v.jsx(ge.div, { ...a, ref: s });
  }
);
w2.displayName = b2;
var Pl = "PopperContent", [cM, dM] = p2(Pl), $2 = g.forwardRef(
  (e, t) => {
    var H, U, q, W, de, T;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: a = 0,
      align: i = "center",
      alignOffset: l = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: y,
      ...m
    } = e, b = g2(Pl, n), [$, w] = g.useState(null), E = De(t, (Se) => w(Se)), [P, x] = g.useState(null), F = v2(P), z = (F == null ? void 0 : F.width) ?? 0, N = (F == null ? void 0 : F.height) ?? 0, A = r + (i !== "center" ? "-" + i : ""), _ = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, B = Array.isArray(d) ? d : [d], j = B.length > 0, ee = {
      padding: _,
      boundary: B.filter(fM),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: R, floatingStyles: X, placement: V, isPositioned: G, middlewareData: ne } = i2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: A,
      whileElementsMounted: (...Se) => a2(...Se, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        l2({ mainAxis: a + N, alignmentAxis: l }),
        c && s2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? c2() : void 0,
          ...ee
        }),
        c && d2({ ...ee }),
        u2({
          ...ee,
          apply: ({ elements: Se, rects: Le, availableWidth: Ie, availableHeight: Ke }) => {
            const { width: ht, height: Kt } = Le.reference, ot = Se.floating.style;
            ot.setProperty("--radix-popper-available-width", `${Ie}px`), ot.setProperty("--radix-popper-available-height", `${Ke}px`), ot.setProperty("--radix-popper-anchor-width", `${ht}px`), ot.setProperty("--radix-popper-anchor-height", `${Kt}px`);
          }
        }),
        P && h2({ element: P, padding: s }),
        hM({ arrowWidth: z, arrowHeight: N }),
        h && f2({ strategy: "referenceHidden", ...ee })
      ]
    }), [k, D] = M2(V), O = dt(y);
    Ye(() => {
      G && (O == null || O());
    }, [G, O]);
    const J = (H = ne.arrow) == null ? void 0 : H.x, oe = (U = ne.arrow) == null ? void 0 : U.y, te = ((q = ne.arrow) == null ? void 0 : q.centerOffset) !== 0, [se, Q] = g.useState();
    return Ye(() => {
      $ && Q(window.getComputedStyle($).zIndex);
    }, [$]), /* @__PURE__ */ v.jsx(
      "div",
      {
        ref: R.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...X,
          transform: G ? X.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: se,
          "--radix-popper-transform-origin": [
            (W = ne.transformOrigin) == null ? void 0 : W.x,
            (de = ne.transformOrigin) == null ? void 0 : de.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((T = ne.hide) == null ? void 0 : T.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ v.jsx(
          cM,
          {
            scope: n,
            placedSide: k,
            onArrowChange: x,
            arrowX: J,
            arrowY: oe,
            shouldHideArrow: te,
            children: /* @__PURE__ */ v.jsx(
              ge.div,
              {
                "data-side": k,
                "data-align": D,
                ...m,
                ref: E,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: G ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
$2.displayName = Pl;
var E2 = "PopperArrow", uM = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, x2 = g.forwardRef(function(t, n) {
  const { __scopePopper: r, ...a } = t, i = dM(E2, r), l = uM[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ v.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [l]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ v.jsx(
          lM,
          {
            ...a,
            ref: n,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
x2.displayName = E2;
function fM(e) {
  return e !== null;
}
var hM = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, $, w;
    const { placement: n, rects: r, middlewareData: a } = t, l = ((b = a.arrow) == null ? void 0 : b.centerOffset) !== 0, s = l ? 0 : e.arrowWidth, c = l ? 0 : e.arrowHeight, [d, f] = M2(n), u = { start: "0%", center: "50%", end: "100%" }[f], h = ((($ = a.arrow) == null ? void 0 : $.x) ?? 0) + s / 2, p = (((w = a.arrow) == null ? void 0 : w.y) ?? 0) + c / 2;
    let y = "", m = "";
    return d === "bottom" ? (y = l ? u : `${h}px`, m = `${-c}px`) : d === "top" ? (y = l ? u : `${h}px`, m = `${r.floating.height + c}px`) : d === "right" ? (y = `${-c}px`, m = l ? u : `${p}px`) : d === "left" && (y = `${r.floating.width + c}px`, m = l ? u : `${p}px`), { data: { x: y, y: m } };
  }
});
function M2(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Sl = y2, C2 = w2, P2 = $2, S2 = x2, mM = "Portal", Xa = g.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [a, i] = g.useState(!1);
  Ye(() => i(!0), []);
  const l = n || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return l ? Ac.createPortal(/* @__PURE__ */ v.jsx(ge.div, { ...r, ref: t }), l) : null;
});
Xa.displayName = mM;
function vM(e, t) {
  return g.useReducer((n, r) => t[n][r] ?? n, e);
}
var ln = (e) => {
  const { present: t, children: n } = e, r = pM(t), a = typeof n == "function" ? n({ present: r.isPresent }) : g.Children.only(n), i = De(r.ref, gM(a));
  return typeof n == "function" || r.isPresent ? g.cloneElement(a, { ref: i }) : null;
};
ln.displayName = "Presence";
function pM(e) {
  const [t, n] = g.useState(), r = g.useRef({}), a = g.useRef(e), i = g.useRef("none"), l = e ? "mounted" : "unmounted", [s, c] = vM(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const d = oa(r.current);
    i.current = s === "mounted" ? d : "none";
  }, [s]), Ye(() => {
    const d = r.current, f = a.current;
    if (f !== e) {
      const h = i.current, p = oa(d);
      e ? c("MOUNT") : p === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(f && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), Ye(() => {
    if (t) {
      let d;
      const f = t.ownerDocument.defaultView ?? window, u = (p) => {
        const m = oa(r.current).includes(p.animationName);
        if (p.target === t && m && (c("ANIMATION_END"), !a.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, h = (p) => {
        p.target === t && (i.current = oa(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(d), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function oa(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function gM(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _o = "rovingFocusGroup.onEntryFocus", yM = { bubbles: !1, cancelable: !0 }, qa = "RovingFocusGroup", [mi, F2, bM] = _a(qa), [wM, z2] = Ar(
  qa,
  [bM]
), [$M, EM] = wM(qa), N2 = g.forwardRef(
  (e, t) => /* @__PURE__ */ v.jsx(mi.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v.jsx(mi.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v.jsx(xM, { ...e, ref: t }) }) })
);
N2.displayName = qa;
var xM = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: a = !1,
    dir: i,
    currentTabStopId: l,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: d,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, h = g.useRef(null), p = De(t, h), y = Ia(i), [m = null, b] = At({
    prop: l,
    defaultProp: s,
    onChange: c
  }), [$, w] = g.useState(!1), E = dt(d), P = F2(n), x = g.useRef(!1), [F, z] = g.useState(0);
  return g.useEffect(() => {
    const N = h.current;
    if (N)
      return N.addEventListener(_o, E), () => N.removeEventListener(_o, E);
  }, [E]), /* @__PURE__ */ v.jsx(
    $M,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: a,
      currentTabStopId: m,
      onItemFocus: g.useCallback(
        (N) => b(N),
        [b]
      ),
      onItemShiftTab: g.useCallback(() => w(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => z((N) => N + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => z((N) => N - 1),
        []
      ),
      children: /* @__PURE__ */ v.jsx(
        ge.div,
        {
          tabIndex: $ || F === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: ie(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: ie(e.onFocus, (N) => {
            const A = !x.current;
            if (N.target === N.currentTarget && A && !$) {
              const _ = new CustomEvent(_o, yM);
              if (N.currentTarget.dispatchEvent(_), !_.defaultPrevented) {
                const B = P().filter((V) => V.focusable), j = B.find((V) => V.active), ee = B.find((V) => V.id === m), X = [j, ee, ...B].filter(
                  Boolean
                ).map((V) => V.ref.current);
                A2(X, f);
              }
            }
            x.current = !1;
          }),
          onBlur: ie(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), D2 = "RovingFocusGroupItem", O2 = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: a = !1,
      tabStopId: i,
      ...l
    } = e, s = st(), c = i || s, d = EM(D2, n), f = d.currentTabStopId === c, u = F2(n), { onFocusableItemAdd: h, onFocusableItemRemove: p } = d;
    return g.useEffect(() => {
      if (r)
        return h(), () => p();
    }, [r, h, p]), /* @__PURE__ */ v.jsx(
      mi.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: a,
        children: /* @__PURE__ */ v.jsx(
          ge.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...l,
            ref: t,
            onMouseDown: ie(e.onMouseDown, (y) => {
              r ? d.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: ie(e.onFocus, () => d.onItemFocus(c)),
            onKeyDown: ie(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const m = PM(y, d.orientation, d.dir);
              if (m !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let $ = u().filter((w) => w.focusable).map((w) => w.ref.current);
                if (m === "last") $.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && $.reverse();
                  const w = $.indexOf(y.currentTarget);
                  $ = d.loop ? SM($, w + 1) : $.slice(w + 1);
                }
                setTimeout(() => A2($));
              }
            })
          }
        )
      }
    );
  }
);
O2.displayName = D2;
var MM = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function CM(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function PM(e, t, n) {
  const r = CM(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return MM[r];
}
function A2(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function SM(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var FM = N2, zM = O2, NM = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Pn = /* @__PURE__ */ new WeakMap(), ia = /* @__PURE__ */ new WeakMap(), la = {}, Io = 0, T2 = function(e) {
  return e && (e.host || T2(e.parentNode));
}, DM = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = T2(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, OM = function(e, t, n, r) {
  var a = DM(t, Array.isArray(e) ? e : [e]);
  la[n] || (la[n] = /* @__PURE__ */ new WeakMap());
  var i = la[n], l = [], s = /* @__PURE__ */ new Set(), c = new Set(a), d = function(u) {
    !u || s.has(u) || (s.add(u), d(u.parentNode));
  };
  a.forEach(d);
  var f = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(h) {
      if (s.has(h))
        f(h);
      else
        try {
          var p = h.getAttribute(r), y = p !== null && p !== "false", m = (Pn.get(h) || 0) + 1, b = (i.get(h) || 0) + 1;
          Pn.set(h, m), i.set(h, b), l.push(h), m === 1 && y && ia.set(h, !0), b === 1 && h.setAttribute(n, "true"), y || h.setAttribute(r, "true");
        } catch ($) {
          console.error("aria-hidden: cannot operate on ", h, $);
        }
    });
  };
  return f(t), s.clear(), Io++, function() {
    l.forEach(function(u) {
      var h = Pn.get(u) - 1, p = i.get(u) - 1;
      Pn.set(u, h), i.set(u, p), h || (ia.has(u) || u.removeAttribute(r), ia.delete(u)), p || u.removeAttribute(n);
    }), Io--, Io || (Pn = /* @__PURE__ */ new WeakMap(), Pn = /* @__PURE__ */ new WeakMap(), ia = /* @__PURE__ */ new WeakMap(), la = {});
  };
}, Za = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = NM(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), OM(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, qe = function() {
  return qe = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, qe.apply(this, arguments);
};
function Fl(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function k2(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, i; r < a; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var gr = "right-scroll-bar-position", yr = "width-before-scroll-bar", AM = "with-scroll-bars-hidden", TM = "--removed-body-scroll-bar-size";
function Lo(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function kM(e, t) {
  var n = Ae(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var HM = typeof window < "u" ? g.useLayoutEffect : g.useEffect, rs = /* @__PURE__ */ new WeakMap();
function H2(e, t) {
  var n = kM(null, function(r) {
    return e.forEach(function(a) {
      return Lo(a, r);
    });
  });
  return HM(function() {
    var r = rs.get(n);
    if (r) {
      var a = new Set(r), i = new Set(e), l = n.current;
      a.forEach(function(s) {
        i.has(s) || Lo(s, null);
      }), i.forEach(function(s) {
        a.has(s) || Lo(s, l);
      });
    }
    rs.set(n, e);
  }, [e]), n;
}
function RM(e) {
  return e;
}
function _M(e, t) {
  t === void 0 && (t = RM);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var l = t(i, r);
      return n.push(l), function() {
        n = n.filter(function(s) {
          return s !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var l = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), l = n;
      }
      var c = function() {
        var f = l;
        l = [], f.forEach(i);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(f) {
          l.push(f), d();
        },
        filter: function(f) {
          return l = l.filter(f), n;
        }
      };
    }
  };
  return a;
}
function R2(e) {
  e === void 0 && (e = {});
  var t = _M(null);
  return t.options = qe({ async: !0, ssr: !1 }, e), t;
}
var _2 = function(e) {
  var t = e.sideCar, n = Fl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return g.createElement(r, qe({}, n));
};
_2.isSideCarExport = !0;
function I2(e, t) {
  return e.useMedium(t), _2;
}
var L2 = R2(), jo = function() {
}, Ja = g.forwardRef(function(e, t) {
  var n = g.useRef(null), r = g.useState({
    onScrollCapture: jo,
    onWheelCapture: jo,
    onTouchMoveCapture: jo
  }), a = r[0], i = r[1], l = e.forwardProps, s = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, u = e.shards, h = e.sideCar, p = e.noIsolation, y = e.inert, m = e.allowPinchZoom, b = e.as, $ = b === void 0 ? "div" : b, w = e.gapMode, E = Fl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = h, x = H2([n, t]), F = qe(qe({}, E), a);
  return g.createElement(
    g.Fragment,
    null,
    f && g.createElement(P, { sideCar: L2, removeScrollBar: d, shards: u, noIsolation: p, inert: y, setCallbacks: i, allowPinchZoom: !!m, lockRef: n, gapMode: w }),
    l ? g.cloneElement(g.Children.only(s), qe(qe({}, F), { ref: x })) : g.createElement($, qe({}, F, { className: c, ref: x }), s)
  );
});
Ja.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ja.classNames = {
  fullWidth: yr,
  zeroRight: gr
};
var IM = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function LM() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = IM();
  return t && e.setAttribute("nonce", t), e;
}
function jM(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function BM(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var WM = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = LM()) && (jM(t, n), BM(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, VM = function() {
  var e = WM();
  return function(t, n) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, zl = function() {
  var e = VM(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, GM = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Bo = function(e) {
  return parseInt(e || "", 10) || 0;
}, YM = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Bo(n), Bo(r), Bo(a)];
}, UM = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return GM;
  var t = YM(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, KM = zl(), Hn = "data-scroll-locked", XM = function(e, t, n, r) {
  var a = e.left, i = e.top, l = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(AM, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Hn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(gr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(yr, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(gr, " .").concat(gr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(yr, " .").concat(yr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Hn, `] {
    `).concat(TM, ": ").concat(s, `px;
  }
`);
}, as = function() {
  var e = parseInt(document.body.getAttribute(Hn) || "0", 10);
  return isFinite(e) ? e : 0;
}, qM = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Hn, (as() + 1).toString()), function() {
      var e = as() - 1;
      e <= 0 ? document.body.removeAttribute(Hn) : document.body.setAttribute(Hn, e.toString());
    };
  }, []);
}, j2 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  qM();
  var i = g.useMemo(function() {
    return UM(a);
  }, [a]);
  return g.createElement(KM, { styles: XM(i, !t, a, n ? "" : "!important") });
}, vi = !1;
if (typeof window < "u")
  try {
    var sa = Object.defineProperty({}, "passive", {
      get: function() {
        return vi = !0, !0;
      }
    });
    window.addEventListener("test", sa, sa), window.removeEventListener("test", sa, sa);
  } catch {
    vi = !1;
  }
var Sn = vi ? { passive: !1 } : !1, ZM = function(e) {
  return e.tagName === "TEXTAREA";
}, B2 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ZM(e) && n[t] === "visible")
  );
}, JM = function(e) {
  return B2(e, "overflowY");
}, QM = function(e) {
  return B2(e, "overflowX");
}, os = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = W2(e, r);
    if (a) {
      var i = V2(e, r), l = i[1], s = i[2];
      if (l > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, eC = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, tC = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, W2 = function(e, t) {
  return e === "v" ? JM(t) : QM(t);
}, V2 = function(e, t) {
  return e === "v" ? eC(t) : tC(t);
}, nC = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, rC = function(e, t, n, r, a) {
  var i = nC(e, window.getComputedStyle(t).direction), l = i * r, s = n.target, c = t.contains(s), d = !1, f = l > 0, u = 0, h = 0;
  do {
    var p = V2(e, s), y = p[0], m = p[1], b = p[2], $ = m - b - i * y;
    (y || $) && W2(e, s) && (u += $, h += y), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && Math.abs(u) < 1 || !f && Math.abs(h) < 1) && (d = !0), d;
}, ca = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, is = function(e) {
  return [e.deltaX, e.deltaY];
}, ls = function(e) {
  return e && "current" in e ? e.current : e;
}, aC = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, oC = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, iC = 0, Fn = [];
function lC(e) {
  var t = g.useRef([]), n = g.useRef([0, 0]), r = g.useRef(), a = g.useState(iC++)[0], i = g.useState(zl)[0], l = g.useRef(e);
  g.useEffect(function() {
    l.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var m = k2([e.lockRef.current], (e.shards || []).map(ls), !0).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !l.current.allowPinchZoom;
    var $ = ca(m), w = n.current, E = "deltaX" in m ? m.deltaX : w[0] - $[0], P = "deltaY" in m ? m.deltaY : w[1] - $[1], x, F = m.target, z = Math.abs(E) > Math.abs(P) ? "h" : "v";
    if ("touches" in m && z === "h" && F.type === "range")
      return !1;
    var N = os(z, F);
    if (!N)
      return !0;
    if (N ? x = z : (x = z === "v" ? "h" : "v", N = os(z, F)), !N)
      return !1;
    if (!r.current && "changedTouches" in m && (E || P) && (r.current = x), !x)
      return !0;
    var A = r.current || x;
    return rC(A, b, m, A === "h" ? E : P);
  }, []), c = g.useCallback(function(m) {
    var b = m;
    if (!(!Fn.length || Fn[Fn.length - 1] !== i)) {
      var $ = "deltaY" in b ? is(b) : ca(b), w = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && aC(x.delta, $);
      })[0];
      if (w && w.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!w) {
        var E = (l.current.shards || []).map(ls).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), P = E.length > 0 ? s(b, E[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), d = g.useCallback(function(m, b, $, w) {
    var E = { name: m, delta: b, target: $, should: w, shadowParent: sC($) };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== E;
      });
    }, 1);
  }, []), f = g.useCallback(function(m) {
    n.current = ca(m), r.current = void 0;
  }, []), u = g.useCallback(function(m) {
    d(m.type, is(m), m.target, s(m, e.lockRef.current));
  }, []), h = g.useCallback(function(m) {
    d(m.type, ca(m), m.target, s(m, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Fn.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, Sn), document.addEventListener("touchmove", c, Sn), document.addEventListener("touchstart", f, Sn), function() {
      Fn = Fn.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", c, Sn), document.removeEventListener("touchmove", c, Sn), document.removeEventListener("touchstart", f, Sn);
    };
  }, []);
  var p = e.removeScrollBar, y = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    y ? g.createElement(i, { styles: oC(a) }) : null,
    p ? g.createElement(j2, { gapMode: e.gapMode }) : null
  );
}
function sC(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const cC = I2(L2, lC);
var Qa = g.forwardRef(function(e, t) {
  return g.createElement(Ja, qe({}, e, { ref: t, sideCar: cC }));
});
Qa.classNames = Ja.classNames;
var pi = ["Enter", " "], dC = ["ArrowDown", "PageUp", "Home"], G2 = ["ArrowUp", "PageDown", "End"], uC = [...dC, ...G2], fC = {
  ltr: [...pi, "ArrowRight"],
  rtl: [...pi, "ArrowLeft"]
}, hC = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ir = "Menu", [Mr, mC, vC] = _a(Ir), [wn, Y2] = Rr(Ir, [
  vC,
  Ka,
  z2
]), Lr = Ka(), U2 = z2(), [K2, sn] = wn(Ir), [pC, jr] = wn(Ir), X2 = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: a, onOpenChange: i, modal: l = !0 } = e, s = Lr(t), [c, d] = g.useState(null), f = g.useRef(!1), u = dt(i), h = Ia(a);
  return g.useEffect(() => {
    const p = () => {
      f.current = !0, document.addEventListener("pointerdown", y, { capture: !0, once: !0 }), document.addEventListener("pointermove", y, { capture: !0, once: !0 });
    }, y = () => f.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", y, { capture: !0 }), document.removeEventListener("pointermove", y, { capture: !0 });
    };
  }, []), /* @__PURE__ */ v.jsx(Sl, { ...s, children: /* @__PURE__ */ v.jsx(
    K2,
    {
      scope: t,
      open: n,
      onOpenChange: u,
      content: c,
      onContentChange: d,
      children: /* @__PURE__ */ v.jsx(
        pC,
        {
          scope: t,
          onClose: g.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: f,
          dir: h,
          modal: l,
          children: r
        }
      )
    }
  ) });
};
X2.displayName = Ir;
var gC = "MenuAnchor", Nl = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, a = Lr(n);
    return /* @__PURE__ */ v.jsx(C2, { ...a, ...r, ref: t });
  }
);
Nl.displayName = gC;
var Dl = "MenuPortal", [yC, q2] = wn(Dl, {
  forceMount: void 0
}), Z2 = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: a } = e, i = sn(Dl, t);
  return /* @__PURE__ */ v.jsx(yC, { scope: t, forceMount: n, children: /* @__PURE__ */ v.jsx(ln, { present: n || i.open, children: /* @__PURE__ */ v.jsx(Xa, { asChild: !0, container: a, children: r }) }) });
};
Z2.displayName = Dl;
var pt = "MenuContent", [bC, Ol] = wn(pt), J2 = g.forwardRef(
  (e, t) => {
    const n = q2(pt, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, i = sn(pt, e.__scopeMenu), l = jr(pt, e.__scopeMenu);
    return /* @__PURE__ */ v.jsx(Mr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ v.jsx(ln, { present: r || i.open, children: /* @__PURE__ */ v.jsx(Mr.Slot, { scope: e.__scopeMenu, children: l.modal ? /* @__PURE__ */ v.jsx(wC, { ...a, ref: t }) : /* @__PURE__ */ v.jsx($C, { ...a, ref: t }) }) }) });
  }
), wC = g.forwardRef(
  (e, t) => {
    const n = sn(pt, e.__scopeMenu), r = g.useRef(null), a = De(t, r);
    return g.useEffect(() => {
      const i = r.current;
      if (i) return Za(i);
    }, []), /* @__PURE__ */ v.jsx(
      Al,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ie(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), $C = g.forwardRef((e, t) => {
  const n = sn(pt, e.__scopeMenu);
  return /* @__PURE__ */ v.jsx(
    Al,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Al = g.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: a,
      onOpenAutoFocus: i,
      onCloseAutoFocus: l,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: d,
      onPointerDownOutside: f,
      onFocusOutside: u,
      onInteractOutside: h,
      onDismiss: p,
      disableOutsideScroll: y,
      ...m
    } = e, b = sn(pt, n), $ = jr(pt, n), w = Lr(n), E = U2(n), P = mC(n), [x, F] = g.useState(null), z = g.useRef(null), N = De(t, z, b.onContentChange), A = g.useRef(0), _ = g.useRef(""), B = g.useRef(0), j = g.useRef(null), ee = g.useRef("right"), R = g.useRef(0), X = y ? Qa : g.Fragment, V = y ? { as: pn, allowPinchZoom: !0 } : void 0, G = (k) => {
      var H, U;
      const D = _.current + k, O = P().filter((q) => !q.disabled), J = document.activeElement, oe = (H = O.find((q) => q.ref.current === J)) == null ? void 0 : H.textValue, te = O.map((q) => q.textValue), se = AC(te, D, oe), Q = (U = O.find((q) => q.textValue === se)) == null ? void 0 : U.ref.current;
      (function q(W) {
        _.current = W, window.clearTimeout(A.current), W !== "" && (A.current = window.setTimeout(() => q(""), 1e3));
      })(D), Q && setTimeout(() => Q.focus());
    };
    g.useEffect(() => () => window.clearTimeout(A.current), []), yl();
    const ne = g.useCallback((k) => {
      var O, J;
      return ee.current === ((O = j.current) == null ? void 0 : O.side) && kC(k, (J = j.current) == null ? void 0 : J.area);
    }, []);
    return /* @__PURE__ */ v.jsx(
      bC,
      {
        scope: n,
        searchRef: _,
        onItemEnter: g.useCallback(
          (k) => {
            ne(k) && k.preventDefault();
          },
          [ne]
        ),
        onItemLeave: g.useCallback(
          (k) => {
            var D;
            ne(k) || ((D = z.current) == null || D.focus(), F(null));
          },
          [ne]
        ),
        onTriggerLeave: g.useCallback(
          (k) => {
            ne(k) && k.preventDefault();
          },
          [ne]
        ),
        pointerGraceTimerRef: B,
        onPointerGraceIntentChange: g.useCallback((k) => {
          j.current = k;
        }, []),
        children: /* @__PURE__ */ v.jsx(X, { ...V, children: /* @__PURE__ */ v.jsx(
          Ga,
          {
            asChild: !0,
            trapped: a,
            onMountAutoFocus: ie(i, (k) => {
              var D;
              k.preventDefault(), (D = z.current) == null || D.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: l,
            children: /* @__PURE__ */ v.jsx(
              Va,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: d,
                onPointerDownOutside: f,
                onFocusOutside: u,
                onInteractOutside: h,
                onDismiss: p,
                children: /* @__PURE__ */ v.jsx(
                  FM,
                  {
                    asChild: !0,
                    ...E,
                    dir: $.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: x,
                    onCurrentTabStopIdChange: F,
                    onEntryFocus: ie(c, (k) => {
                      $.isUsingKeyboardRef.current || k.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ v.jsx(
                      P2,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": v0(b.open),
                        "data-radix-menu-content": "",
                        dir: $.dir,
                        ...w,
                        ...m,
                        ref: N,
                        style: { outline: "none", ...m.style },
                        onKeyDown: ie(m.onKeyDown, (k) => {
                          const O = k.target.closest("[data-radix-menu-content]") === k.currentTarget, J = k.ctrlKey || k.altKey || k.metaKey, oe = k.key.length === 1;
                          O && (k.key === "Tab" && k.preventDefault(), !J && oe && G(k.key));
                          const te = z.current;
                          if (k.target !== te || !uC.includes(k.key)) return;
                          k.preventDefault();
                          const Q = P().filter((H) => !H.disabled).map((H) => H.ref.current);
                          G2.includes(k.key) && Q.reverse(), DC(Q);
                        }),
                        onBlur: ie(e.onBlur, (k) => {
                          k.currentTarget.contains(k.target) || (window.clearTimeout(A.current), _.current = "");
                        }),
                        onPointerMove: ie(
                          e.onPointerMove,
                          Cr((k) => {
                            const D = k.target, O = R.current !== k.clientX;
                            if (k.currentTarget.contains(D) && O) {
                              const J = k.clientX > R.current ? "right" : "left";
                              ee.current = J, R.current = k.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
J2.displayName = pt;
var EC = "MenuGroup", Tl = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ v.jsx(ge.div, { role: "group", ...r, ref: t });
  }
);
Tl.displayName = EC;
var xC = "MenuLabel", Q2 = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ v.jsx(ge.div, { ...r, ref: t });
  }
);
Q2.displayName = xC;
var Ca = "MenuItem", ss = "menu.itemSelect", eo = g.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...a } = e, i = g.useRef(null), l = jr(Ca, e.__scopeMenu), s = Ol(Ca, e.__scopeMenu), c = De(t, i), d = g.useRef(!1), f = () => {
      const u = i.current;
      if (!n && u) {
        const h = new CustomEvent(ss, { bubbles: !0, cancelable: !0 });
        u.addEventListener(ss, (p) => r == null ? void 0 : r(p), { once: !0 }), Rc(u, h), h.defaultPrevented ? d.current = !1 : l.onClose();
      }
    };
    return /* @__PURE__ */ v.jsx(
      e0,
      {
        ...a,
        ref: c,
        disabled: n,
        onClick: ie(e.onClick, f),
        onPointerDown: (u) => {
          var h;
          (h = e.onPointerDown) == null || h.call(e, u), d.current = !0;
        },
        onPointerUp: ie(e.onPointerUp, (u) => {
          var h;
          d.current || (h = u.currentTarget) == null || h.click();
        }),
        onKeyDown: ie(e.onKeyDown, (u) => {
          const h = s.searchRef.current !== "";
          n || h && u.key === " " || pi.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
eo.displayName = Ca;
var e0 = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: a, ...i } = e, l = Ol(Ca, n), s = U2(n), c = g.useRef(null), d = De(t, c), [f, u] = g.useState(!1), [h, p] = g.useState("");
    return g.useEffect(() => {
      const y = c.current;
      y && p((y.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ v.jsx(
      Mr.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: a ?? h,
        children: /* @__PURE__ */ v.jsx(zM, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ v.jsx(
          ge.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: d,
            onPointerMove: ie(
              e.onPointerMove,
              Cr((y) => {
                r ? l.onItemLeave(y) : (l.onItemEnter(y), y.defaultPrevented || y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ie(
              e.onPointerLeave,
              Cr((y) => l.onItemLeave(y))
            ),
            onFocus: ie(e.onFocus, () => u(!0)),
            onBlur: ie(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), MC = "MenuCheckboxItem", t0 = g.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...a } = e;
    return /* @__PURE__ */ v.jsx(i0, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ v.jsx(
      eo,
      {
        role: "menuitemcheckbox",
        "aria-checked": Pa(n) ? "mixed" : n,
        ...a,
        ref: t,
        "data-state": Rl(n),
        onSelect: ie(
          a.onSelect,
          () => r == null ? void 0 : r(Pa(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
t0.displayName = MC;
var n0 = "MenuRadioGroup", [CC, PC] = wn(
  n0,
  { value: void 0, onValueChange: () => {
  } }
), r0 = g.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...a } = e, i = dt(r);
    return /* @__PURE__ */ v.jsx(CC, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ v.jsx(Tl, { ...a, ref: t }) });
  }
);
r0.displayName = n0;
var a0 = "MenuRadioItem", o0 = g.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, a = PC(a0, e.__scopeMenu), i = n === a.value;
    return /* @__PURE__ */ v.jsx(i0, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ v.jsx(
      eo,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": Rl(i),
        onSelect: ie(
          r.onSelect,
          () => {
            var l;
            return (l = a.onValueChange) == null ? void 0 : l.call(a, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
o0.displayName = a0;
var kl = "MenuItemIndicator", [i0, SC] = wn(
  kl,
  { checked: !1 }
), l0 = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...a } = e, i = SC(kl, n);
    return /* @__PURE__ */ v.jsx(
      ln,
      {
        present: r || Pa(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ v.jsx(
          ge.span,
          {
            ...a,
            ref: t,
            "data-state": Rl(i.checked)
          }
        )
      }
    );
  }
);
l0.displayName = kl;
var FC = "MenuSeparator", s0 = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ v.jsx(
      ge.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
s0.displayName = FC;
var zC = "MenuArrow", c0 = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, a = Lr(n);
    return /* @__PURE__ */ v.jsx(S2, { ...a, ...r, ref: t });
  }
);
c0.displayName = zC;
var Hl = "MenuSub", [NC, d0] = wn(Hl), u0 = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: a } = e, i = sn(Hl, t), l = Lr(t), [s, c] = g.useState(null), [d, f] = g.useState(null), u = dt(a);
  return g.useEffect(() => (i.open === !1 && u(!1), () => u(!1)), [i.open, u]), /* @__PURE__ */ v.jsx(Sl, { ...l, children: /* @__PURE__ */ v.jsx(
    K2,
    {
      scope: t,
      open: r,
      onOpenChange: u,
      content: d,
      onContentChange: f,
      children: /* @__PURE__ */ v.jsx(
        NC,
        {
          scope: t,
          contentId: st(),
          triggerId: st(),
          trigger: s,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
u0.displayName = Hl;
var vr = "MenuSubTrigger", f0 = g.forwardRef(
  (e, t) => {
    const n = sn(vr, e.__scopeMenu), r = jr(vr, e.__scopeMenu), a = d0(vr, e.__scopeMenu), i = Ol(vr, e.__scopeMenu), l = g.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = i, d = { __scopeMenu: e.__scopeMenu }, f = g.useCallback(() => {
      l.current && window.clearTimeout(l.current), l.current = null;
    }, []);
    return g.useEffect(() => f, [f]), g.useEffect(() => {
      const u = s.current;
      return () => {
        window.clearTimeout(u), c(null);
      };
    }, [s, c]), /* @__PURE__ */ v.jsx(Nl, { asChild: !0, ...d, children: /* @__PURE__ */ v.jsx(
      e0,
      {
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": a.contentId,
        "data-state": v0(n.open),
        ...e,
        ref: Ra(t, a.onTriggerChange),
        onClick: (u) => {
          var h;
          (h = e.onClick) == null || h.call(e, u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ie(
          e.onPointerMove,
          Cr((u) => {
            i.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !l.current && (i.onPointerGraceIntentChange(null), l.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: ie(
          e.onPointerLeave,
          Cr((u) => {
            var p, y;
            f();
            const h = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (h) {
              const m = (y = n.content) == null ? void 0 : y.dataset.side, b = m === "right", $ = b ? -5 : 5, w = h[b ? "left" : "right"], E = h[b ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + $, y: u.clientY },
                  { x: w, y: h.top },
                  { x: E, y: h.top },
                  { x: E, y: h.bottom },
                  { x: w, y: h.bottom }
                ],
                side: m
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(u), u.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ie(e.onKeyDown, (u) => {
          var p;
          const h = i.searchRef.current !== "";
          e.disabled || h && u.key === " " || fC[r.dir].includes(u.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
f0.displayName = vr;
var h0 = "MenuSubContent", m0 = g.forwardRef(
  (e, t) => {
    const n = q2(pt, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, i = sn(pt, e.__scopeMenu), l = jr(pt, e.__scopeMenu), s = d0(h0, e.__scopeMenu), c = g.useRef(null), d = De(t, c);
    return /* @__PURE__ */ v.jsx(Mr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ v.jsx(ln, { present: r || i.open, children: /* @__PURE__ */ v.jsx(Mr.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ v.jsx(
      Al,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...a,
        ref: d,
        align: "start",
        side: l.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var u;
          l.isUsingKeyboardRef.current && ((u = c.current) == null || u.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: ie(e.onFocusOutside, (f) => {
          f.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: ie(e.onEscapeKeyDown, (f) => {
          l.onClose(), f.preventDefault();
        }),
        onKeyDown: ie(e.onKeyDown, (f) => {
          var p;
          const u = f.currentTarget.contains(f.target), h = hC[l.dir].includes(f.key);
          u && h && (i.onOpenChange(!1), (p = s.trigger) == null || p.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
m0.displayName = h0;
function v0(e) {
  return e ? "open" : "closed";
}
function Pa(e) {
  return e === "indeterminate";
}
function Rl(e) {
  return Pa(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function DC(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function OC(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function AC(e, t, n) {
  const a = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let l = OC(e, Math.max(i, 0));
  a.length === 1 && (l = l.filter((d) => d !== n));
  const c = l.find(
    (d) => d.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function TC(e, t) {
  const { x: n, y: r } = e;
  let a = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const s = t[i].x, c = t[i].y, d = t[l].x, f = t[l].y;
    c > r != f > r && n < (d - s) * (r - c) / (f - c) + s && (a = !a);
  }
  return a;
}
function kC(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return TC(n, t);
}
function Cr(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var HC = X2, RC = Nl, _C = Z2, IC = J2, LC = Tl, jC = Q2, BC = eo, WC = t0, VC = r0, GC = o0, YC = l0, UC = s0, KC = c0, XC = u0, qC = f0, ZC = m0, _l = "DropdownMenu", [JC] = Rr(
  _l,
  [Y2]
), Je = Y2(), [QC, p0] = JC(_l), g0 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: a,
    defaultOpen: i,
    onOpenChange: l,
    modal: s = !0
  } = e, c = Je(t), d = g.useRef(null), [f = !1, u] = At({
    prop: a,
    defaultProp: i,
    onChange: l
  });
  return /* @__PURE__ */ v.jsx(
    QC,
    {
      scope: t,
      triggerId: st(),
      triggerRef: d,
      contentId: st(),
      open: f,
      onOpenChange: u,
      onOpenToggle: g.useCallback(() => u((h) => !h), [u]),
      modal: s,
      children: /* @__PURE__ */ v.jsx(HC, { ...c, open: f, onOpenChange: u, dir: r, modal: s, children: n })
    }
  );
};
g0.displayName = _l;
var y0 = "DropdownMenuTrigger", b0 = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...a } = e, i = p0(y0, n), l = Je(n);
    return /* @__PURE__ */ v.jsx(RC, { asChild: !0, ...l, children: /* @__PURE__ */ v.jsx(
      ge.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...a,
        ref: Ra(t, i.triggerRef),
        onPointerDown: ie(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: ie(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
b0.displayName = y0;
var eP = "DropdownMenuPortal", w0 = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Je(t);
  return /* @__PURE__ */ v.jsx(_C, { ...r, ...n });
};
w0.displayName = eP;
var $0 = "DropdownMenuContent", E0 = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = p0($0, n), i = Je(n), l = g.useRef(!1);
    return /* @__PURE__ */ v.jsx(
      IC,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: ie(e.onCloseAutoFocus, (s) => {
          var c;
          l.current || (c = a.triggerRef.current) == null || c.focus(), l.current = !1, s.preventDefault();
        }),
        onInteractOutside: ie(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, d = c.button === 0 && c.ctrlKey === !0, f = c.button === 2 || d;
          (!a.modal || f) && (l.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
E0.displayName = $0;
var tP = "DropdownMenuGroup", x0 = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
    return /* @__PURE__ */ v.jsx(LC, { ...a, ...r, ref: t });
  }
);
x0.displayName = tP;
var nP = "DropdownMenuLabel", M0 = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
    return /* @__PURE__ */ v.jsx(jC, { ...a, ...r, ref: t });
  }
);
M0.displayName = nP;
var rP = "DropdownMenuItem", C0 = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
    return /* @__PURE__ */ v.jsx(BC, { ...a, ...r, ref: t });
  }
);
C0.displayName = rP;
var aP = "DropdownMenuCheckboxItem", oP = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(WC, { ...a, ...r, ref: t });
});
oP.displayName = aP;
var iP = "DropdownMenuRadioGroup", P0 = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(VC, { ...a, ...r, ref: t });
});
P0.displayName = iP;
var lP = "DropdownMenuRadioItem", sP = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(GC, { ...a, ...r, ref: t });
});
sP.displayName = lP;
var cP = "DropdownMenuItemIndicator", dP = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(YC, { ...a, ...r, ref: t });
});
dP.displayName = cP;
var uP = "DropdownMenuSeparator", S0 = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(UC, { ...a, ...r, ref: t });
});
S0.displayName = uP;
var fP = "DropdownMenuArrow", hP = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
    return /* @__PURE__ */ v.jsx(KC, { ...a, ...r, ref: t });
  }
);
hP.displayName = fP;
var mP = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: a, defaultOpen: i } = e, l = Je(t), [s = !1, c] = At({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ v.jsx(XC, { ...l, open: s, onOpenChange: c, children: n });
}, vP = "DropdownMenuSubTrigger", F0 = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(qC, { ...a, ...r, ref: t });
});
F0.displayName = vP;
var pP = "DropdownMenuSubContent", z0 = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = Je(n);
  return /* @__PURE__ */ v.jsx(
    ZC,
    {
      ...a,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
z0.displayName = pP;
var gP = g0, N0 = b0, Il = w0, D0 = E0, yP = x0, O0 = M0, A0 = C0, bP = P0, T0 = S0, wP = mP, k0 = F0, H0 = z0;
const uL = yP, fL = Il, hL = bP, mL = wP, vL = (e) => /* @__PURE__ */ v.jsx(gP, { modal: !1, ...e }), $P = g.forwardRef((e, t) => /* @__PURE__ */ v.jsx(N0, { ref: t, className: "focus-visible:outline-none", ...e }));
$P.displayName = N0.displayName;
const EP = g.forwardRef(({ align: e, className: t, ...n }, r) => /* @__PURE__ */ v.jsx(Il, { children: /* @__PURE__ */ v.jsx(
  D0,
  {
    ref: r,
    align: e ?? "start",
    className: K(
      "z-10 mt-2 rounded-md bg-white py-2 text-base font-normal text-text-primary shadow-[0px_1px_3px_0px_rgba(166,175,195,0.4)] ring-1 ring-[rgba(166,175,195,0.1)]",
      t
    ),
    ...n
  }
) }));
EP.displayName = D0.displayName;
const xP = g.forwardRef(({ className: e, selected: t, ...n }, r) => /* @__PURE__ */ v.jsx(
  A0,
  {
    ref: r,
    className: K(
      "flex cursor-pointer select-none items-center border-l-4 border-transparent py-2 pl-4 pr-5 text-text-primary outline-none transition-colors duration-200 data-[disabled]:pointer-events-none data-[highlighted]:bg-lightBlue-50 data-[disabled]:opacity-38",
      { "border-lightBlue-500 bg-lightBlue-50": t },
      e
    ),
    ...n
  }
));
xP.displayName = A0.displayName;
const MP = g.forwardRef((e, t) => /* @__PURE__ */ v.jsx(O0, { ref: t, className: "px-5 py-2 text-sm text-text-secondary", ...e }));
MP.displayName = O0.displayName;
const CP = g.forwardRef((e, t) => /* @__PURE__ */ v.jsx(T0, { ref: t, className: "my-2 h-[0.5px] bg-stroke", ...e }));
CP.displayName = T0.displayName;
const PP = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ v.jsxs(
  k0,
  {
    ref: r,
    className: K(
      "flex cursor-pointer items-center justify-between gap-2 px-5 py-2 text-text-primary outline-none transition-colors duration-200 data-[highlighted]:bg-lightBlue-50 data-[highlighted]:data-[state=open]:bg-lightBlue-50 data-[state=open]:bg-lightBlue-100",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ v.jsx(D6, { className: "size-4 fill-text-secondary" })
    ]
  }
));
PP.displayName = k0.displayName;
const SP = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v.jsx(Il, { children: /* @__PURE__ */ v.jsx(
  H0,
  {
    ref: n,
    className: K(
      "z-20 rounded-md bg-white py-2 text-base font-normal text-text-primary shadow-[0px_1px_3px_0px_rgba(166,175,195,0.4)] ring-1 ring-[rgba(166,175,195,0.1)]",
      e
    ),
    ...t
  }
) }));
SP.displayName = H0.displayName;
const FP = Pe(["text-sm", "text-text-secondary"], {
  variants: {
    disabled: { true: ["opacity-38"] },
    variant: {
      error: ["text-red-600"],
      success: ["text-success-500"]
    }
  },
  compoundVariants: [
    {
      variant: "error",
      disabled: !0,
      class: ["opacity-38", "text-text-secondary"]
    },
    {
      variant: "success",
      disabled: !0,
      class: ["opacity-38", "text-text-secondary"]
    }
  ]
}), pL = ({ children: e, disabled: t, variant: n }) => /* @__PURE__ */ v.jsx("div", { className: K(FP({ disabled: t, variant: n })), children: e }), gL = me(function({
  as: t,
  className: n,
  dark: r = !1,
  disabled: a = !1,
  icon: i,
  inverse: l = !1,
  name: s,
  size: c = "md",
  variant: d = "primary",
  ...f
}, u) {
  const h = `${d}${l ? "-inverse" : ""}`, p = md({ className: n, dark: r, inverse: l, size: c, variant: d }), y = /* @__PURE__ */ v.jsx(i, { fill: wa[h] ?? wa.primary, className: "h-6 w-6" });
  if (a)
    return /* @__PURE__ */ v.jsx(
      "span",
      {
        ref: u,
        "aria-label": s,
        className: K(p, "pointer-events-none opacity-38"),
        children: y
      }
    );
  const m = t ?? "a", b = new Vn();
  return /* @__PURE__ */ v.jsx(
    m,
    {
      ref: u,
      "aria-label": s,
      className: p,
      ...f,
      onMouseDown: ($) => {
        const w = f == null ? void 0 : f.onMouseDown;
        return b.apply($, tn[h] ?? tn.primary), typeof w == "function" && w($);
      },
      children: y
    }
  );
});
var zP = "Label", R0 = g.forwardRef((e, t) => /* @__PURE__ */ v.jsx(
  ge.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var a;
      n.target.closest("button, input, select, textarea") || ((a = e.onMouseDown) == null || a.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
R0.displayName = zP;
var _0 = R0;
const NP = Pe(["font-medium", "space-x-0.5"], {
  variants: {
    disabled: { true: ["opacity-38"] },
    size: {
      sm: ["text-sm"]
    }
  }
}), DP = me(
  ({ className: e, children: t, required: n, ...r }, a) => /* @__PURE__ */ v.jsxs(
    _0,
    {
      ref: a,
      className: K(NP({ disabled: r.disabled, size: r.size }), e),
      ...r,
      children: [
        /* @__PURE__ */ v.jsx("span", { children: t }),
        n && /* @__PURE__ */ v.jsx("span", { className: "text-red-600", children: "*" })
      ]
    }
  )
);
DP.displayName = _0.displayName;
const OP = ({ iconColor: e, className: t, height: n, width: r }) => /* @__PURE__ */ v.jsxs("svg", { x: "0px", y: "0px", viewBox: "0 0 1725.5 2000", className: t, height: n, width: r, children: [
  /* @__PURE__ */ v.jsx("title", { children: "c2fo-brand-mark" }),
  /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsxs("g", { children: [
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: e,
        d: `M1038,0.2c217.5,0,435,0,652.6,0c1.9,3,5.3,2.9,8.1,4c19.4,7.8,29.9,34.5,18.2,55.1
      c-15.8,27.7-31.8,55.2-47.7,82.9c-34,59.2-68,118.4-102,177.6c-33.9,59-67.7,118-101.6,177c-38.8,67.4-77.5,134.8-116.4,202.2
      c-19.6,34.1-48.7,51.5-88.5,51.7c-187.9,1-375.8-2.7-563.7,1.8c-20.9,0.5-41.4,3.6-61.7,7.6c-33.6,6.5-66.5,16.2-98.2,29.2
      c-11.3,4.6-13.4,8.2-10.5,20c0.3,1.1,1,2.1,1.1,3.2c6.2,41.4,17.5,81.3,33.7,120c25.8,61.4,62.2,115.7,108.7,163.1
      c28.7,29.2,60.7,54.5,95.5,76.2c29.5,18.4,60.5,33.7,92.9,45.9c29.3,11,59.6,19.5,90.5,24.6c19.9,3.3,40.1,6.8,60.2,6.9
      c72,0.3,144-0.8,215.9-1.4c54.6-0.5,109.3-1.2,163.9-1.7c43.1-0.4,86.2-0.8,129.2-0.8c32.9,0,50,33.4,34.3,58.8
      c-11.8,19.1-22.8,38.6-34,58c-49.2,85.9-98.2,171.9-147.7,257.7c-26.9,46.7-53.8,93.4-80.2,140.3c-35.5,63-71.1,125.9-108,188
      c-17.9,30.2-45.6,46.6-81.8,46.7c-43.7,0.2-87.3,0.2-131,0.9c-78,1.2-155.9-0.3-233.9,1.9c-20.6,0.6-41.7-1-62.6-2.7
      c-24.4-1.9-48.6-4.9-72.5-9.3c-28.6-5.3-57-11.9-84.7-21.1c-31.1-10.4-61.8-21.4-91.5-35.4c-37.8-17.9-73.9-38.6-108.3-62.6
      c-30.7-21.3-59.3-45-86.7-70.3c-13.7-12.7-26.4-26.5-39-40.4c-21.6-23.9-41.6-48.9-59.9-75.3c-39.7-57.3-70.3-119.2-93-185.1
      c-9.1-26.5-15.8-53.6-22-80.8c-5.9-25.9-9.7-52.2-12.3-78.7c-1.7-17.1-1.5-34.5-2.2-51.7c0-13.4,0-26.8,0-40.1
      c0.3-19.5,1.3-38.9,3.5-58.3c1.7-14.9,3.1-30,5.9-44.6c5.2-27.8,11.6-55.3,19.5-82.5c8.5-29.7,18.9-58.8,31.5-86.8
      c19.6-43.4,42.3-85.2,69.7-124.5c21-30.1,43.1-59.2,68.6-85.5c18-18.5,35.3-38,55.6-54.2c11.2-9,21.6-18.9,33.6-27
      c11.3-7.7,22.4-16,21.8-32.9c-0.7-17.8,4-35.4,7.2-52.8c4.9-25.8,11.6-51.3,19.3-76.5c9-29.1,19.2-57.7,32-85.2
      c19.1-41,41-80.4,67.4-117.5c83.7-117.6,191-205.6,324.6-260.8c48-19.8,97.3-35.1,148.9-42.8c21.6-3.2,43.1-7.1,65-8.9
      c6.1-0.5,13.1,0.8,18.9-3.1c5.8,0,11.6,0,17.4,0C1020.6,3,1029.3,2.9,1038,0.2z M219,1270.4c-0.8,19.1,1.3,43.3,5,67.4
      c5.9,38.2,15,75.4,29.1,111.6c25.3,64.9,62.3,122.2,109.9,172.5c46.8,49.4,101.5,87.8,163.8,115.3c23.3,10.3,47.2,18.9,72,25.2
      c24.6,6.3,49.4,11.4,74.6,14.8c13.3,1.8,26.8,3.9,40.1,3.4c40.7-1.7,81.5-1.2,122.2-2.2c52.3-1.3,104.6-2.2,156.9-2.5
      c27-0.2,45.8-13.3,59-35.1c19.6-32.5,38-65.7,57-98.6c26.2-45.4,52.4-90.8,78.4-136.4c11.3-19.8-1.6-42.2-24.3-42.5
      c-9.5-0.1-19,0.6-28.6,0.8c-41.6,0.8-83.1,2.7-124.7,1.8c-17.7-0.4-35.7-2.2-53.5-4.5c-32.1-4.1-63.8-9.6-95.3-17
      c-50.7-12-99-30.8-145.5-53.9c-35.7-17.7-69.8-38.4-102-62c-18.9-13.8-37-28.6-54.6-44.2c-20.5-18.2-39.6-37.8-58.4-57.5
      c-15.7-16.5-29.6-34.9-43.5-53.2c-22.5-29.8-42.6-61.1-60.3-93.8c-21.3-39.4-39.6-80.2-52.6-123.3c-1.3-4.3-2.9-8.6-4.7-12.7
      c-1.8-4-4.1-5.1-7.5-0.9c-37.1,45.8-66.1,96.2-85,152.1C227.9,1150.1,218.5,1206.8,219,1270.4z M932,531.8c0-0.1,0-0.2,0-0.3
      c75.2,0,150.3,0.3,225.5-0.1c25.2-0.1,44.6-12.9,57.2-33.8c18.5-30.6,35-62.4,52.8-93.5c27.3-47.9,55.1-95.5,82.3-143.5
      c11-19.3,0.8-43.6-25.2-43.4c-106,0.9-212-2.6-318,1.6c-18.9,0.7-37.5,2.7-56,5.7c-32.1,5.2-63.6,13.6-94,25.2
      c-99.9,38-180,101.4-241.3,188.8c-23.4,33.4-41.6,69.6-57.9,106.9c-1.5,3.5-2.9,7.3,4.6,5.8c24.8-4.9,49.6-9.6,74.6-13.1
      c23.5-3.2,47.1-5.7,70.6-6C782.2,531.1,857.1,531.8,932,531.8z`
      }
    ),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: "transparent",
        d: `M1.6,1284.1c0.7,17.2,0.5,34.6,2.2,51.7c2.6,26.4,6.4,52.8,12.3,78.7c6.2,27.2,12.9,54.3,22,80.8
      c22.7,65.9,53.3,127.8,93,185.1c18.3,26.4,38.3,51.4,59.9,75.3c12.6,13.9,25.3,27.7,39,40.4c27.3,25.3,55.9,49,86.7,70.3
      c34.5,23.9,70.5,44.7,108.3,62.6c29.6,14,60.4,25,91.5,35.4c27.8,9.3,56.2,15.8,84.7,21.1c23.9,4.4,48.1,7.5,72.5,9.3
      c20.9,1.6,42,3.2,62.6,2.7c78-2.2,155.9-0.7,233.9-1.9c43.7-0.7,87.3-0.8,131-0.9c36.1-0.1,63.8-16.5,81.8-46.7
      c36.9-62.1,72.5-125,108-188c26.5-46.9,53.3-93.7,80.2-140.3c49.4-85.8,98.4-171.8,147.7-257.7c11.1-19.4,22.2-39,34-58
      c15.7-25.4-1.4-58.8-34.3-58.8c-43.1,0-86.2,0.4-129.2,0.8c-54.6,0.5-109.3,1.2-163.9,1.7c-72,0.6-144,1.7-215.9,1.4
      c-20.1-0.1-40.3-3.6-60.2-6.9c-30.9-5.2-61.2-13.6-90.5-24.6c-32.4-12.1-63.4-27.5-92.9-45.9c-34.9-21.7-66.9-47-95.5-76.2
      c-46.5-47.4-82.9-101.7-108.7-163.1c-16.2-38.7-27.6-78.6-33.7-120c-0.2-1.1-0.9-2.1-1.1-3.2c-2.9-11.8-0.8-15.4,10.5-20
      c31.8-13,64.7-22.6,98.2-29.2c20.2-3.9,40.8-7.1,61.7-7.6c187.9-4.4,375.8-0.7,563.7-1.8c39.8-0.2,68.8-17.6,88.5-51.7
      c38.8-67.4,77.6-134.8,116.4-202.2c33.9-59,67.7-118,101.6-177c34-59.2,68-118.4,102-177.6c15.9-27.6,31.8-55.2,47.7-82.9
      c11.8-20.6,1.2-47.3-18.2-55.1c-2.8-1.1-6.2-1-8.1-4c10.4,0,20.8,0.1,31.2-0.1c3-0.1,4.1,0.5,3.5,3.6c-0.3,1.4,0,2.9,0,4.3
      c0,661.2,0,1322.4,0.2,1983.6c0,7.1-1.5,8.4-8.5,8.4c-569.4-0.2-1138.8-0.2-1708.3,0c-7.7,0-8.7-2.1-8.7-9
      c0.2-235.6,0.2-471.3,0.2-706.9l0.7,0.1C0.9,1284.2,1.6,1284.1,1.6,1284.1z`
      }
    ),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: "transparent",
        d: `M994.6,0.2c-5.8,3.9-12.7,2.6-18.9,3.1c-21.9,1.7-43.4,5.6-65,8.9c-51.6,7.7-100.9,23-148.9,42.8
      C628.3,110.1,521,198.1,437.3,315.7c-26.4,37-48.3,76.4-67.4,117.5c-12.8,27.5-23.1,56.1-32,85.2c-7.8,25.2-14.4,50.6-19.3,76.5
      c-3.3,17.4-7.9,35-7.2,52.8c0.7,16.9-10.4,25.3-21.8,32.9c-12,8.2-22.4,18.1-33.6,27c-20.3,16.2-37.6,35.6-55.6,54.2
      c-25.5,26.2-47.6,55.4-68.6,85.5c-27.4,39.3-50.1,81-69.7,124.5c-12.6,28-22.9,57.1-31.5,86.8c-7.8,27.2-14.2,54.7-19.5,82.5
      c-2.8,14.7-4.2,29.7-5.9,44.6c-2.2,19.4-3.3,38.8-3.5,58.3c-0.5-0.1-1-0.1-1.5,0.1C0.2,832,0.2,420,0,8c0-6.5,1.5-8,8-8
      C336.9,0.2,665.7,0.2,994.6,0.2z`
      }
    ),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        d: `M0.2,1244.1c0.5-0.2,1-0.2,1.5-0.1c0,13.4,0,26.8,0,40.1l-0.7,0.1l-0.7-0.1C0.2,1270.7,0.2,1257.4,0.2,1244.1
      z`
      }
    ),
    /* @__PURE__ */ v.jsx("path", { d: "M1038,0.2c-8.7,2.8-17.4,2.9-26,0C1020.6,0.2,1029.3,0.2,1038,0.2z" }),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: "transparent",
        d: `M219,1270.4c-0.5-63.6,8.9-120.3,27.5-175.4c18.9-55.9,47.9-106.3,85-152.1c3.4-4.1,5.7-3,7.5,0.9
      c1.9,4.1,3.4,8.4,4.7,12.7c13,43,31.3,83.9,52.6,123.3c17.7,32.7,37.7,64,60.3,93.8c13.9,18.3,27.7,36.7,43.5,53.2
      c18.8,19.7,37.9,39.4,58.4,57.5c17.6,15.6,35.6,30.4,54.6,44.2c32.2,23.6,66.2,44.3,102,62c46.6,23.1,94.9,41.9,145.5,53.9
      c31.4,7.5,63.2,13,95.3,17c17.8,2.2,35.8,4.1,53.5,4.5c41.5,0.9,83.1-1,124.7-1.8c9.5-0.2,19.1-0.9,28.6-0.8
      c22.7,0.3,35.6,22.6,24.3,42.5c-26,45.6-52.2,90.9-78.4,136.4c-18.9,32.9-37.4,66.1-57,98.6c-13.2,21.8-32,35-59,35.1
      c-52.3,0.3-104.6,1.2-156.9,2.5c-40.7,1-81.5,0.6-122.2,2.2c-13.3,0.5-26.8-1.6-40.1-3.4c-25.1-3.4-50-8.5-74.6-14.8
      c-24.8-6.3-48.7-15-72-25.2c-62.3-27.5-117-65.9-163.8-115.3c-47.7-50.4-84.7-107.6-109.9-172.5c-14.1-36.2-23.2-73.4-29.1-111.6
      C220.3,1313.7,218.3,1289.5,219,1270.4z`
      }
    ),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: "transparent",
        d: `M932,531.8c-74.9,0-149.8-0.7-224.6,0.4c-23.5,0.3-47.1,2.8-70.6,6c-25.1,3.4-49.9,8.2-74.6,13.1
      c-7.6,1.5-6.2-2.3-4.6-5.8c16.2-37.3,34.4-73.5,57.9-106.9c61.3-87.4,141.4-150.8,241.3-188.8c30.5-11.6,61.9-19.9,94-25.2
      c18.4-3,37.1-5,56-5.7c106-4.2,212-0.8,318-1.6c26-0.2,36.1,24,25.2,43.4c-27.2,48-55,95.6-82.3,143.5
      c-17.7,31.1-34.3,62.9-52.8,93.5c-12.6,20.9-32.1,33.7-57.2,33.8c-75.2,0.4-150.3,0.1-225.5,0.1C932,531.6,932,531.7,932,531.8z`
      }
    )
  ] }) })
] }), yL = (e) => {
  const { brandMark: t, color: n, className: r, height: a, width: i } = e;
  let l = ye.primary[500], s = ye.secondary[500];
  return n === "white" ? (l = ye.white, s = ye.text.inverse) : n === "primary-white" ? s = ye.text.inverse : n === "black" && (l = ye.text.primary), t ? /* @__PURE__ */ v.jsx(OP, { iconColor: l, ...e }) : /* @__PURE__ */ v.jsxs("svg", { x: "0px", y: "0px", viewBox: "0 0 668.97 287.68", className: r, height: a, width: i, children: [
    /* @__PURE__ */ v.jsx("title", { children: "c2fo-logo" }),
    /* @__PURE__ */ v.jsx(
      "path",
      {
        fill: l,
        d: `M166.19,135.37c-0.69-1.55-2.17-2.51-3.86-2.51l-51.51,0.4c-27.76,0-51.25-20.76-54.64-48.28l-0.06-0.49
      l0.45-0.19c6.85-2.94,14.12-4.43,21.62-4.43h57.02c3.63,0,7.01-1.95,8.81-5.1L183.4,6.32c0.84-1.46,0.74-3.22-0.26-4.6
      C182.38,0.64,181.01,0,179.49,0h-68.67C91.25,0,72.5,7.3,58.04,20.55C43.66,33.72,34.76,51.6,32.96,70.88l-0.03,0.3l-0.24,0.17
      C12.22,86.05,0,109.81,0,134.91c0,43.13,35.13,78.21,78.31,78.21l39.52-0.31c3.6-0.03,6.94-1.98,8.73-5.1l39.3-68.32
      C166.61,138.09,166.74,136.58,166.19,135.37z M78.21,189.96c-17.25,0-33.18-7.89-43.72-21.63c-10.52-13.74-13.91-31.45-9.28-48.6
      c1.75-6.47,4.91-12.66,9.41-18.39l1.06-1.35l0.37,1.2c4.82,15.65,14.73,29.71,27.92,39.61c13.64,10.23,29.87,15.64,46.95,15.64
      l13.31-0.11c1.09,0,2.06,0.55,2.6,1.49s0.54,2.04,0,2.97l-14.6,25.39c-1.26,2.19-3.61,3.56-6.13,3.58L78.21,189.96z M59.68,57.86
      c8.41-21.07,28.49-34.69,51.14-34.69h31.03c1.07,0,2.04,0.55,2.57,1.48c0.54,0.93,0.54,2.04,0,2.97l-14.67,25.5
      c-1.27,2.21-3.64,3.58-6.19,3.58H78.21c-6,0-11.98,0.68-17.77,2.04l-1.22,0.29L59.68,57.86z`
      }
    ),
    /* @__PURE__ */ v.jsxs("g", { children: [
      /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: s,
          d: `M243.77,132.89c-19.63,0-37.45,6.43-50.18,18.11c-14.82,13.6-22.66,34.2-22.66,59.58
        c0,25.34,7.83,45.84,22.64,59.27c12.68,11.5,30.5,17.83,50.2,17.83c16.51,0,55.79-4.92,64.09-50.51c0.19-1.06-0.09-2.14-0.77-2.95
        c-0.66-0.79-1.57-1.22-2.58-1.22h-20.83c-1.51,0-2.82,1.02-3.26,2.54c-5.08,17.55-17.86,28.58-36.94,28.58
        c-27.66,0-44.17-21.11-44.17-53.53c0-15.49,3.9-30.26,11.28-39.41c7.76-9.63,19.13-14.71,32.89-14.71
        c19.07,0,31.84,11.33,36.95,28.93c0.44,1.52,1.75,2.55,3.27,2.55h20.7c1.01,0,1.93-0.44,2.58-1.23c0.69-0.84,0.96-1.94,0.75-3.03
        C299.05,139.72,263.93,132.89,243.77,132.89z`
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: s,
          d: `M527.82,99.57V79.95c0-1.11-0.9-2.01-2.01-2.01h-19.88c-27.52,0-43.95,16.09-43.95,43.05v9.52v1.75v1.75h-1.75
        h-1.75h-15.74c-1.26,0-2.28,1.02-2.28,2.28v17.63c0,0.61,0.24,1.18,0.67,1.61c0.43,0.43,1,0.67,1.61,0.67h15.74h1.75h1.75v1.75
        v1.75v124.06c0,1.26,1.02,2.28,2.28,2.28h26.17c1.26,0,2.28-1.02,2.28-2.28V159.69v-1.75v-1.75h1.75h1.75h18.86
        c1.26,0,2.28-1.02,2.28-2.28v-17.63c0-1.26-1.02-2.28-2.28-2.28h-18.86h-1.75h-1.75v-1.75v-1.75v-5.1
        c0-16.04,7.31-23.83,22.36-23.83h10.74C526.92,101.58,527.82,100.68,527.82,99.57z`
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: s,
          d: `M641,269.3c14.73-13.65,22.52-34.03,22.52-58.94s-7.79-45.29-22.52-58.94c-12.8-11.86-30.56-18.38-50.02-18.38
        c-33.46,0-72.54,20.25-72.54,77.33c0,26.16,7.97,46.38,23.7,60.11c12.72,11.1,30.07,17.22,48.85,17.22
        C610.44,287.68,628.21,281.15,641,269.3z M559.69,251.6c-8.54-9.24-12.87-24.28-12.87-41.25s4.33-32,12.87-41.25
        c7.76-8.4,18.58-12.84,31.3-12.84c12.58,0,23.31,4.44,31.04,12.85c8.51,9.26,12.83,24.3,12.83,41.24s-4.32,31.98-12.83,41.24
        c-7.73,8.4-18.46,12.84-31.04,12.84C578.27,264.44,567.45,260,559.69,251.6z`
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: s,
          d: `M324.81,286.03h101.43c1.94,0,3.52-1.58,3.52-3.52v-15.57c0-1.94-1.58-3.52-3.52-3.52h-28.65h-40.35h-0.51
        h-1.75v-1.75v-0.51v-0.67c0-11.56,10.09-19.24,32.7-32.1l1.57-0.86c18.26-9.99,40.97-22.41,40.97-50.96
        c0-27.36-19.85-43.69-53.09-43.69c-20.99,0-36.11,6.29-44.94,18.68c-7.49,10.52-8.61,23.13-8.61,29.71v3.14
        c0,1.94,1.58,3.52,3.52,3.52h20.7c1.94,0,3.52-1.58,3.52-3.52v-1.79c0-16.32,9.71-26.46,25.35-26.46c8.18,0,15.03,2.42,19.29,6.8
        c3.76,3.86,5.56,9.14,5.38,15.69c-0.22,16.64-14.05,24.22-31.57,33.81c-2.45,1.34-4.96,2.71-7.54,4.17
        c-34.41,19.82-40.93,37.87-40.93,64.25v1.62C321.29,284.45,322.87,286.03,324.81,286.03z`
        }
      )
    ] }),
    /* @__PURE__ */ v.jsxs("g", { children: [
      /* @__PURE__ */ v.jsx("path", { fill: s, d: "M658.21,143.17h-2.66v7.34h-1.47v-7.34h-2.64v-1.2h6.77L658.21,143.17L658.21,143.17z" }),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: s,
          d: `M661.25,141.98l2.46,6.54l2.46-6.54h1.92v8.53h-1.48v-2.81l0.15-3.76l-2.52,6.57h-1.06l-2.51-6.57l0.15,3.76
        v2.81h-1.48v-8.53H661.25z`
        }
      )
    ] })
  ] });
};
var Ll = "Dialog", [I0] = Rr(Ll), [AP, zt] = I0(Ll), L0 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: l = !0
  } = e, s = g.useRef(null), c = g.useRef(null), [d = !1, f] = At({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ v.jsx(
    AP,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: st(),
      titleId: st(),
      descriptionId: st(),
      open: d,
      onOpenChange: f,
      onOpenToggle: g.useCallback(() => f((u) => !u), [f]),
      modal: l,
      children: n
    }
  );
};
L0.displayName = Ll;
var j0 = "DialogTrigger", TP = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = zt(j0, n), i = De(t, a.triggerRef);
    return /* @__PURE__ */ v.jsx(
      ge.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Wl(a.open),
        ...r,
        ref: i,
        onClick: ie(e.onClick, a.onOpenToggle)
      }
    );
  }
);
TP.displayName = j0;
var jl = "DialogPortal", [kP, B0] = I0(jl, {
  forceMount: void 0
}), W0 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: a } = e, i = zt(jl, t);
  return /* @__PURE__ */ v.jsx(kP, { scope: t, forceMount: n, children: g.Children.map(r, (l) => /* @__PURE__ */ v.jsx(ln, { present: n || i.open, children: /* @__PURE__ */ v.jsx(Xa, { asChild: !0, container: a, children: l }) })) });
};
W0.displayName = jl;
var Sa = "DialogOverlay", V0 = g.forwardRef(
  (e, t) => {
    const n = B0(Sa, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, i = zt(Sa, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ v.jsx(ln, { present: r || i.open, children: /* @__PURE__ */ v.jsx(HP, { ...a, ref: t }) }) : null;
  }
);
V0.displayName = Sa;
var HP = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = zt(Sa, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v.jsx(Qa, { as: pn, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ v.jsx(
        ge.div,
        {
          "data-state": Wl(a.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), yn = "DialogContent", G0 = g.forwardRef(
  (e, t) => {
    const n = B0(yn, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, i = zt(yn, e.__scopeDialog);
    return /* @__PURE__ */ v.jsx(ln, { present: r || i.open, children: i.modal ? /* @__PURE__ */ v.jsx(RP, { ...a, ref: t }) : /* @__PURE__ */ v.jsx(_P, { ...a, ref: t }) });
  }
);
G0.displayName = yn;
var RP = g.forwardRef(
  (e, t) => {
    const n = zt(yn, e.__scopeDialog), r = g.useRef(null), a = De(t, n.contentRef, r);
    return g.useEffect(() => {
      const i = r.current;
      if (i) return Za(i);
    }, []), /* @__PURE__ */ v.jsx(
      Y0,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ie(e.onCloseAutoFocus, (i) => {
          var l;
          i.preventDefault(), (l = n.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: ie(e.onPointerDownOutside, (i) => {
          const l = i.detail.originalEvent, s = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: ie(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), _P = g.forwardRef(
  (e, t) => {
    const n = zt(yn, e.__scopeDialog), r = g.useRef(!1), a = g.useRef(!1);
    return /* @__PURE__ */ v.jsx(
      Y0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var l, s;
          (l = e.onCloseAutoFocus) == null || l.call(e, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var c, d;
          (c = e.onInteractOutside) == null || c.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const l = i.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), Y0 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, ...l } = e, s = zt(yn, n), c = g.useRef(null), d = De(t, c);
    return yl(), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(
        Ga,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ v.jsx(
            Va,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Wl(s.open),
              ...l,
              ref: d,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(jP, { titleId: s.titleId }),
        /* @__PURE__ */ v.jsx(WP, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Bl = "DialogTitle", U0 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = zt(Bl, n);
    return /* @__PURE__ */ v.jsx(ge.h2, { id: a.titleId, ...r, ref: t });
  }
);
U0.displayName = Bl;
var K0 = "DialogDescription", IP = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = zt(K0, n);
    return /* @__PURE__ */ v.jsx(ge.p, { id: a.descriptionId, ...r, ref: t });
  }
);
IP.displayName = K0;
var X0 = "DialogClose", LP = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = zt(X0, n);
    return /* @__PURE__ */ v.jsx(
      ge.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ie(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
LP.displayName = X0;
function Wl(e) {
  return e ? "open" : "closed";
}
var q0 = "DialogTitleWarning", [bL, Z0] = tx(q0, {
  contentName: yn,
  titleName: Bl,
  docsSlug: "dialog"
}), jP = ({ titleId: e }) => {
  const t = Z0(q0), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, BP = "DialogDescriptionWarning", WP = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Z0(BP).contentName}}.`;
  return g.useEffect(() => {
    var i;
    const a = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, J0 = L0, Q0 = W0, eu = V0, tu = G0, to = U0, VP = "VisuallyHidden", Vl = g.forwardRef(
  (e, t) => /* @__PURE__ */ v.jsx(
    ge.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Vl.displayName = VP;
var GP = Vl;
const Kn = jt({}), wL = ({ children: e }) => {
  const { onClose: t, onCloseAriaLabel: n = "Close Modal", isFullScreen: r = !1 } = gt(Kn);
  return /* @__PURE__ */ v.jsxs(
    to,
    {
      className: K(
        "m-0 flex shrink-0 items-center justify-between bg-secondary-500 px-6 py-3 text-lg leading-6 text-white",
        {
          "sm:rounded-t-2xl": !r
        }
      ),
      children: [
        e,
        t && /* @__PURE__ */ v.jsx(
          "button",
          {
            className: K(
              "ml-auto h-full rounded-full p-1 hover:bg-white/10 focus:outline-none focus:outline-offset-0 focus-visible:outline-offset-0 focus-visible:outline-secondary-400"
            ),
            onClick: () => t(),
            type: "button",
            "aria-label": n,
            children: /* @__PURE__ */ v.jsx(Bn, { className: "text-2xl", fill: ye.white })
          }
        )
      ]
    }
  );
}, $L = ({ children: e }) => {
  const { onClose: t, onCloseAriaLabel: n = "Close Modal", isFullScreen: r = !1 } = gt(Kn);
  return /* @__PURE__ */ v.jsxs(
    to,
    {
      className: K("m-0 flex shrink-0 items-center justify-between px-6 py-3 text-lg leading-6 text-text-primary", {
        "sm:rounded-t-2xl": !r
      }),
      children: [
        e,
        t && /* @__PURE__ */ v.jsx(
          "button",
          {
            className: K(
              "ml-auto h-full rounded-full p-1 hover:bg-black/10 focus:outline-none focus:outline-offset-0 focus-visible:outline-offset-0 focus-visible:outline-gray-100"
            ),
            onClick: () => t(),
            type: "button",
            "aria-label": n,
            children: /* @__PURE__ */ v.jsx(Bn, { className: "text-2xl", fill: ye.black })
          }
        )
      ]
    }
  );
}, EL = ({ children: e, className: t }) => {
  const { onClose: n, onCloseAriaLabel: r = "Close Modal", isFullScreen: a = !1 } = gt(Kn);
  return /* @__PURE__ */ v.jsxs(
    to,
    {
      className: K(
        "m-0 flex shrink-0 flex-col items-center justify-center px-6 pb-2 pt-12 text-center text-2xl font-bold leading-6 text-text-primary sm:text-3xl sm:font-medium",
        {
          "sm:rounded-t-2xl": !a
        },
        t
      ),
      children: [
        e,
        n && /* @__PURE__ */ v.jsx(
          "button",
          {
            className: K(
              "absolute right-3 top-3 ml-auto rounded-full p-1 hover:bg-black/10 focus:outline-none focus:outline-offset-0 focus-visible:outline-offset-0 focus-visible:outline-gray-100"
            ),
            onClick: () => n(),
            type: "button",
            "aria-label": r,
            children: /* @__PURE__ */ v.jsx(Bn, { className: "text-2xl", fill: ye.black })
          }
        )
      ]
    }
  );
}, xL = ({
  children: e,
  center: t = !1,
  className: n
}) => {
  const r = ve(null), [a, i] = Ae(!1), [l, s] = Ae(!1), c = 1, d = he(() => {
    const u = r.current;
    if (!u)
      return;
    const { scrollTop: h, scrollHeight: p, clientHeight: y } = u, m = p > y, b = h <= c, $ = p - h - y <= c;
    i(!b && m), s(!$ && m);
  }, []);
  _n(() => {
    const u = r.current;
    if (!u)
      return;
    const h = setTimeout(d, 350), p = new ResizeObserver(d);
    p.observe(u);
    const y = new MutationObserver(d);
    return y.observe(u, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      clearTimeout(h), p.disconnect(), y.disconnect();
    };
  }, [d, e]);
  const f = (u) => {
    const { scrollTop: h, scrollHeight: p, clientHeight: y } = u.currentTarget, m = p > y, b = h <= c, $ = p - h - y <= c;
    i(!b && m), s(!$ && m);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: K("relative flex h-full flex-col overflow-hidden"), children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: K(
          "absolute left-0 top-0 w-full select-none opacity-0 shadow-[0px_-8px_12px_8px_rgba(0,0,0,0.25)] transition-opacity",
          {
            "opacity-100": a
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: K(
          "h-full overflow-auto p-6",
          {
            "flex flex-col items-center gap-4 text-center": t
          },
          n
        ),
        ref: r,
        onScroll: f,
        children: e
      }
    ),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: K(
          "absolute bottom-0 left-0 w-full select-none opacity-0 shadow-[0px_8px_12px_8px_rgba(0,0,0,0.2)] transition-opacity",
          {
            "opacity-100": l
          }
        )
      }
    )
  ] });
}, ML = ({ children: e }) => /* @__PURE__ */ v.jsx(GP, { asChild: !0, children: /* @__PURE__ */ v.jsx(to, { children: e }) });
function CL({ className: e, ...t }) {
  const { isFullScreen: n = !1 } = gt(Kn);
  return /* @__PURE__ */ v.jsx(
    "div",
    {
      className: K(
        "flex shrink-0 flex-col gap-3 border-t p-6 sm:flex-row sm:justify-end",
        {
          "sm:rounded-b-2xl": !n
        },
        e
      ),
      ...t
    }
  );
}
const PL = (e) => {
  const {
    open: t,
    onClose: n,
    className: r,
    size: a = "auto",
    ariaDescription: i,
    disableOutsideClickClose: l = !1,
    children: s
  } = e;
  Ce(() => {
    const d = (f) => {
      f.key === "Escape" && t && n && n();
    };
    return document.addEventListener("keydown", d), () => {
      document.removeEventListener("keydown", d);
    };
  }, [n, t]);
  const c = Ze(() => ({ ...e, isFullScreen: !1 }), [e]);
  return /* @__PURE__ */ v.jsx(J0, { open: t, modal: !0, children: /* @__PURE__ */ v.jsx(Q0, { children: /* @__PURE__ */ v.jsx(eu, { className: "fixed inset-0 z-10 flex bg-black/[0.25] text-center data-[state=closed]:animate-fade-out data-[state=open]:animate-fade-in sm:min-h-full sm:items-center sm:justify-center", children: /* @__PURE__ */ v.jsx(Kn.Provider, { value: c, children: /* @__PURE__ */ v.jsx(
    tu,
    {
      "aria-describedby": void 0,
      "aria-description": i,
      className: K(
        "container relative flex w-full flex-col overflow-visible rounded-none bg-white text-left align-middle shadow-xl focus:outline-none focus:outline-offset-0 focus-visible:outline-none focus-visible:outline-offset-0 data-[state=closed]:animate-zoom-out data-[state=open]:animate-zoom-in sm:h-fit sm:max-h-[95%] sm:rounded-2xl",
        {
          "sm:w-fit sm:min-w-[550px]": a === "auto",
          "sm:w-[550px] sm:max-w-[95%]": a === "sm"
        },
        r
      ),
      onInteractOutside: () => n && !l ? n() : null,
      children: s
    }
  ) }) }) }) });
}, SL = (e) => {
  const { open: t, onClose: n, className: r, ariaDescription: a, disableOutsideClickClose: i = !1, children: l } = e;
  Ce(() => {
    const c = (d) => {
      d.key === "Escape" && t && n && n();
    };
    return document.addEventListener("keydown", c), () => {
      document.removeEventListener("keydown", c);
    };
  }, [n, t]);
  const s = Ze(() => ({ ...e, isFullScreen: !0 }), [e]);
  return /* @__PURE__ */ v.jsx(J0, { open: t, modal: !0, children: /* @__PURE__ */ v.jsx(Q0, { children: /* @__PURE__ */ v.jsx(eu, { className: "fixed inset-0 z-10", children: /* @__PURE__ */ v.jsx(Kn.Provider, { value: s, children: /* @__PURE__ */ v.jsx(
    tu,
    {
      "aria-describedby": void 0,
      "aria-description": a,
      className: K(
        "relative flex h-screen max-h-screen w-full flex-col overflow-hidden bg-white text-left align-middle focus:outline-none focus:outline-offset-0 focus-visible:outline-none focus-visible:outline-offset-0 data-[state=closed]:animate-zoom-out data-[state=open]:animate-zoom-in",
        r
      ),
      onInteractOutside: () => n && !i ? n() : null,
      children: l
    }
  ) }) }) }) });
}, YP = Pe(["bg-white"], {
  variants: {
    variant: {
      elevated: [],
      outlined: ["shadow-inner", "border-deepGray-200", "border"]
    },
    square: {
      true: ["rounded-md"],
      false: ["rounded-2xl"]
    },
    elevation: {
      0: ["shadow-none"],
      1: ["shadow-sm"],
      2: ["shadow-md"],
      3: ["shadow-lg"],
      4: ["shadow-xl"],
      5: ["shadow-2xl"]
    }
  },
  defaultVariants: {
    variant: "elevated",
    square: !1,
    elevation: 1
  }
}), FL = ({ variant: e, square: t, elevation: n, children: r, className: a }) => /* @__PURE__ */ v.jsx("div", { className: YP({ variant: e, square: t, elevation: n, className: a }), children: r }), nu = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
var gi = { exports: {} }, da = { exports: {} }, ze = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cs;
function UP() {
  if (cs) return ze;
  cs = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function E(x) {
    if (typeof x == "object" && x !== null) {
      var F = x.$$typeof;
      switch (F) {
        case t:
          switch (x = x.type, x) {
            case c:
            case d:
            case r:
            case i:
            case a:
            case u:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case f:
                case y:
                case p:
                case l:
                  return x;
                default:
                  return F;
              }
          }
        case n:
          return F;
      }
    }
  }
  function P(x) {
    return E(x) === d;
  }
  return ze.AsyncMode = c, ze.ConcurrentMode = d, ze.ContextConsumer = s, ze.ContextProvider = l, ze.Element = t, ze.ForwardRef = f, ze.Fragment = r, ze.Lazy = y, ze.Memo = p, ze.Portal = n, ze.Profiler = i, ze.StrictMode = a, ze.Suspense = u, ze.isAsyncMode = function(x) {
    return P(x) || E(x) === c;
  }, ze.isConcurrentMode = P, ze.isContextConsumer = function(x) {
    return E(x) === s;
  }, ze.isContextProvider = function(x) {
    return E(x) === l;
  }, ze.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ze.isForwardRef = function(x) {
    return E(x) === f;
  }, ze.isFragment = function(x) {
    return E(x) === r;
  }, ze.isLazy = function(x) {
    return E(x) === y;
  }, ze.isMemo = function(x) {
    return E(x) === p;
  }, ze.isPortal = function(x) {
    return E(x) === n;
  }, ze.isProfiler = function(x) {
    return E(x) === i;
  }, ze.isStrictMode = function(x) {
    return E(x) === a;
  }, ze.isSuspense = function(x) {
    return E(x) === u;
  }, ze.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === d || x === i || x === a || x === u || x === h || typeof x == "object" && x !== null && (x.$$typeof === y || x.$$typeof === p || x.$$typeof === l || x.$$typeof === s || x.$$typeof === f || x.$$typeof === b || x.$$typeof === $ || x.$$typeof === w || x.$$typeof === m);
  }, ze.typeOf = E, ze;
}
var Ne = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ds;
function KP() {
  return ds || (ds = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function E(T) {
      return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      T === r || T === d || T === i || T === a || T === u || T === h || typeof T == "object" && T !== null && (T.$$typeof === y || T.$$typeof === p || T.$$typeof === l || T.$$typeof === s || T.$$typeof === f || T.$$typeof === b || T.$$typeof === $ || T.$$typeof === w || T.$$typeof === m);
    }
    function P(T) {
      if (typeof T == "object" && T !== null) {
        var Se = T.$$typeof;
        switch (Se) {
          case t:
            var Le = T.type;
            switch (Le) {
              case c:
              case d:
              case r:
              case i:
              case a:
              case u:
                return Le;
              default:
                var Ie = Le && Le.$$typeof;
                switch (Ie) {
                  case s:
                  case f:
                  case y:
                  case p:
                  case l:
                    return Ie;
                  default:
                    return Se;
                }
            }
          case n:
            return Se;
        }
      }
    }
    var x = c, F = d, z = s, N = l, A = t, _ = f, B = r, j = y, ee = p, R = n, X = i, V = a, G = u, ne = !1;
    function k(T) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(T) || P(T) === c;
    }
    function D(T) {
      return P(T) === d;
    }
    function O(T) {
      return P(T) === s;
    }
    function J(T) {
      return P(T) === l;
    }
    function oe(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function te(T) {
      return P(T) === f;
    }
    function se(T) {
      return P(T) === r;
    }
    function Q(T) {
      return P(T) === y;
    }
    function H(T) {
      return P(T) === p;
    }
    function U(T) {
      return P(T) === n;
    }
    function q(T) {
      return P(T) === i;
    }
    function W(T) {
      return P(T) === a;
    }
    function de(T) {
      return P(T) === u;
    }
    Ne.AsyncMode = x, Ne.ConcurrentMode = F, Ne.ContextConsumer = z, Ne.ContextProvider = N, Ne.Element = A, Ne.ForwardRef = _, Ne.Fragment = B, Ne.Lazy = j, Ne.Memo = ee, Ne.Portal = R, Ne.Profiler = X, Ne.StrictMode = V, Ne.Suspense = G, Ne.isAsyncMode = k, Ne.isConcurrentMode = D, Ne.isContextConsumer = O, Ne.isContextProvider = J, Ne.isElement = oe, Ne.isForwardRef = te, Ne.isFragment = se, Ne.isLazy = Q, Ne.isMemo = H, Ne.isPortal = U, Ne.isProfiler = q, Ne.isStrictMode = W, Ne.isSuspense = de, Ne.isValidElementType = E, Ne.typeOf = P;
  }()), Ne;
}
var us;
function ru() {
  return us || (us = 1, process.env.NODE_ENV === "production" ? da.exports = UP() : da.exports = KP()), da.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Wo, fs;
function XP() {
  if (fs) return Wo;
  fs = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(l).map(function(f) {
        return l[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Wo = a() ? Object.assign : function(i, l) {
    for (var s, c = r(i), d, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var u in s)
        t.call(s, u) && (c[u] = s[u]);
      if (e) {
        d = e(s);
        for (var h = 0; h < d.length; h++)
          n.call(s, d[h]) && (c[d[h]] = s[d[h]]);
      }
    }
    return c;
  }, Wo;
}
var Vo, hs;
function Gl() {
  if (hs) return Vo;
  hs = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Vo = e, Vo;
}
var Go, ms;
function au() {
  return ms || (ms = 1, Go = Function.call.bind(Object.prototype.hasOwnProperty)), Go;
}
var Yo, vs;
function qP() {
  if (vs) return Yo;
  vs = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Gl(), n = {}, r = au();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function a(i, l, s, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var u;
          try {
            if (typeof i[f] != "function") {
              var h = Error(
                (c || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            u = i[f](l, f, c, s, null, t);
          } catch (y) {
            u = y;
          }
          if (u && !(u instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var p = d ? d() : "";
            e(
              "Failed " + s + " type: " + u.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Yo = a, Yo;
}
var Uo, ps;
function ZP() {
  if (ps) return Uo;
  ps = 1;
  var e = ru(), t = XP(), n = Gl(), r = au(), a = qP(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return Uo = function(s, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function u(D) {
      var O = D && (d && D[d] || D[f]);
      if (typeof O == "function")
        return O;
    }
    var h = "<<anonymous>>", p = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: w(),
      arrayOf: E,
      element: P(),
      elementType: x(),
      instanceOf: F,
      node: _(),
      objectOf: N,
      oneOf: z,
      oneOfType: A,
      shape: j,
      exact: ee
    };
    function y(D, O) {
      return D === O ? D !== 0 || 1 / D === 1 / O : D !== D && O !== O;
    }
    function m(D, O) {
      this.message = D, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(D) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, J = 0;
      function oe(se, Q, H, U, q, W, de) {
        if (U = U || h, W = W || H, de !== n) {
          if (c) {
            var T = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw T.name = "Invariant Violation", T;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Se = U + ":" + H;
            !O[Se] && // Avoid spamming the console because they are often not actionable except for lib authors
            J < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[Se] = !0, J++);
          }
        }
        return Q[H] == null ? se ? Q[H] === null ? new m("The " + q + " `" + W + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new m("The " + q + " `" + W + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : D(Q, H, U, q, W);
      }
      var te = oe.bind(null, !1);
      return te.isRequired = oe.bind(null, !0), te;
    }
    function $(D) {
      function O(J, oe, te, se, Q, H) {
        var U = J[oe], q = V(U);
        if (q !== D) {
          var W = G(U);
          return new m(
            "Invalid " + se + " `" + Q + "` of type " + ("`" + W + "` supplied to `" + te + "`, expected ") + ("`" + D + "`."),
            { expectedType: D }
          );
        }
        return null;
      }
      return b(O);
    }
    function w() {
      return b(l);
    }
    function E(D) {
      function O(J, oe, te, se, Q) {
        if (typeof D != "function")
          return new m("Property `" + Q + "` of component `" + te + "` has invalid PropType notation inside arrayOf.");
        var H = J[oe];
        if (!Array.isArray(H)) {
          var U = V(H);
          return new m("Invalid " + se + " `" + Q + "` of type " + ("`" + U + "` supplied to `" + te + "`, expected an array."));
        }
        for (var q = 0; q < H.length; q++) {
          var W = D(H, q, te, se, Q + "[" + q + "]", n);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return b(O);
    }
    function P() {
      function D(O, J, oe, te, se) {
        var Q = O[J];
        if (!s(Q)) {
          var H = V(Q);
          return new m("Invalid " + te + " `" + se + "` of type " + ("`" + H + "` supplied to `" + oe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(D);
    }
    function x() {
      function D(O, J, oe, te, se) {
        var Q = O[J];
        if (!e.isValidElementType(Q)) {
          var H = V(Q);
          return new m("Invalid " + te + " `" + se + "` of type " + ("`" + H + "` supplied to `" + oe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(D);
    }
    function F(D) {
      function O(J, oe, te, se, Q) {
        if (!(J[oe] instanceof D)) {
          var H = D.name || h, U = k(J[oe]);
          return new m("Invalid " + se + " `" + Q + "` of type " + ("`" + U + "` supplied to `" + te + "`, expected ") + ("instance of `" + H + "`."));
        }
        return null;
      }
      return b(O);
    }
    function z(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function O(J, oe, te, se, Q) {
        for (var H = J[oe], U = 0; U < D.length; U++)
          if (y(H, D[U]))
            return null;
        var q = JSON.stringify(D, function(de, T) {
          var Se = G(T);
          return Se === "symbol" ? String(T) : T;
        });
        return new m("Invalid " + se + " `" + Q + "` of value `" + String(H) + "` " + ("supplied to `" + te + "`, expected one of " + q + "."));
      }
      return b(O);
    }
    function N(D) {
      function O(J, oe, te, se, Q) {
        if (typeof D != "function")
          return new m("Property `" + Q + "` of component `" + te + "` has invalid PropType notation inside objectOf.");
        var H = J[oe], U = V(H);
        if (U !== "object")
          return new m("Invalid " + se + " `" + Q + "` of type " + ("`" + U + "` supplied to `" + te + "`, expected an object."));
        for (var q in H)
          if (r(H, q)) {
            var W = D(H, q, te, se, Q + "." + q, n);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return b(O);
    }
    function A(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var O = 0; O < D.length; O++) {
        var J = D[O];
        if (typeof J != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(J) + " at index " + O + "."
          ), l;
      }
      function oe(te, se, Q, H, U) {
        for (var q = [], W = 0; W < D.length; W++) {
          var de = D[W], T = de(te, se, Q, H, U, n);
          if (T == null)
            return null;
          T.data && r(T.data, "expectedType") && q.push(T.data.expectedType);
        }
        var Se = q.length > 0 ? ", expected one of type [" + q.join(", ") + "]" : "";
        return new m("Invalid " + H + " `" + U + "` supplied to " + ("`" + Q + "`" + Se + "."));
      }
      return b(oe);
    }
    function _() {
      function D(O, J, oe, te, se) {
        return R(O[J]) ? null : new m("Invalid " + te + " `" + se + "` supplied to " + ("`" + oe + "`, expected a ReactNode."));
      }
      return b(D);
    }
    function B(D, O, J, oe, te) {
      return new m(
        (D || "React class") + ": " + O + " type `" + J + "." + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + te + "`."
      );
    }
    function j(D) {
      function O(J, oe, te, se, Q) {
        var H = J[oe], U = V(H);
        if (U !== "object")
          return new m("Invalid " + se + " `" + Q + "` of type `" + U + "` " + ("supplied to `" + te + "`, expected `object`."));
        for (var q in D) {
          var W = D[q];
          if (typeof W != "function")
            return B(te, se, Q, q, G(W));
          var de = W(H, q, te, se, Q + "." + q, n);
          if (de)
            return de;
        }
        return null;
      }
      return b(O);
    }
    function ee(D) {
      function O(J, oe, te, se, Q) {
        var H = J[oe], U = V(H);
        if (U !== "object")
          return new m("Invalid " + se + " `" + Q + "` of type `" + U + "` " + ("supplied to `" + te + "`, expected `object`."));
        var q = t({}, J[oe], D);
        for (var W in q) {
          var de = D[W];
          if (r(D, W) && typeof de != "function")
            return B(te, se, Q, W, G(de));
          if (!de)
            return new m(
              "Invalid " + se + " `" + Q + "` key `" + W + "` supplied to `" + te + "`.\nBad object: " + JSON.stringify(J[oe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
            );
          var T = de(H, W, te, se, Q + "." + W, n);
          if (T)
            return T;
        }
        return null;
      }
      return b(O);
    }
    function R(D) {
      switch (typeof D) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !D;
        case "object":
          if (Array.isArray(D))
            return D.every(R);
          if (D === null || s(D))
            return !0;
          var O = u(D);
          if (O) {
            var J = O.call(D), oe;
            if (O !== D.entries) {
              for (; !(oe = J.next()).done; )
                if (!R(oe.value))
                  return !1;
            } else
              for (; !(oe = J.next()).done; ) {
                var te = oe.value;
                if (te && !R(te[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(D, O) {
      return D === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function V(D) {
      var O = typeof D;
      return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : X(O, D) ? "symbol" : O;
    }
    function G(D) {
      if (typeof D > "u" || D === null)
        return "" + D;
      var O = V(D);
      if (O === "object") {
        if (D instanceof Date)
          return "date";
        if (D instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function ne(D) {
      var O = G(D);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function k(D) {
      return !D.constructor || !D.constructor.name ? h : D.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, Uo;
}
var Ko, gs;
function JP() {
  if (gs) return Ko;
  gs = 1;
  var e = Gl();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Ko = function() {
    function r(l, s, c, d, f, u) {
      if (u !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Ko;
}
if (process.env.NODE_ENV !== "production") {
  var QP = ru(), eS = !0;
  gi.exports = ZP()(QP.isElement, eS);
} else
  gi.exports = JP()();
var tS = gi.exports;
const L = /* @__PURE__ */ Hc(tS);
var ou = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var l = "";
      for (var s in i)
        t.call(i, s) && i[s] && (l = a(l, s));
      return l;
    }
    function a(i, l) {
      return l ? i ? i + " " + l : i + l : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(ou);
var nS = ou.exports;
const Fa = /* @__PURE__ */ Hc(nS);
function rS(e, t, n) {
  switch (n) {
    case "Backspace":
      t > 0 && (e = e.slice(0, t - 1) + e.slice(t), t--);
      break;
    case "Delete":
      e = e.slice(0, t) + e.slice(t + 1);
      break;
  }
  return {
    value: e,
    caret: t
  };
}
function aS(e, t, n) {
  for (var r = {}, a = "", i = 0, l = 0; l < e.length; ) {
    var s = n(e[l], a, r);
    s !== void 0 && (a += s, t !== void 0 && (t === l ? i = a.length - 1 : t > l && (i = a.length))), l++;
  }
  t === void 0 && (i = a.length);
  var c = {
    value: a,
    caret: i
  };
  return c;
}
function oS(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = iS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iS(e, t) {
  if (e) {
    if (typeof e == "string") return ys(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ys(e, t);
  }
}
function ys(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function yi(e, t) {
  for (var n = 0, r = oS(t.split("")), a; !(a = r()).done; ) {
    var i = a.value;
    i === e && n++;
  }
  return n;
}
function lS(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", a = e.length, i = yi("(", e), l = yi(")", e), s = i - l; s > 0 && a < t.length; )
    e += t[a].replace(n, r), t[a] === ")" && s--, a++;
  return e;
}
function sS(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = cS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cS(e, t) {
  if (e) {
    if (typeof e == "string") return bs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bs(e, t);
  }
}
function bs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function dS(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", n = arguments.length > 2 ? arguments[2] : void 0;
  if (!e)
    return function(a) {
      return {
        text: a
      };
    };
  var r = yi(t, e);
  return function(a) {
    if (!a)
      return {
        text: "",
        template: e
      };
    for (var i = 0, l = "", s = sS(e.split("")), c; !(c = s()).done; ) {
      var d = c.value;
      if (d !== t) {
        l += d;
        continue;
      }
      if (l += a[i], i++, i === a.length && a.length < r)
        break;
    }
    return n && (l = lS(l, e)), {
      text: l,
      template: e
    };
  };
}
function uS(e, t, n) {
  typeof n == "string" && (n = dS(n));
  var r = n(e) || {}, a = r.text, i = r.template;
  if (a === void 0 && (a = e), i)
    if (t === void 0)
      t = a.length;
    else {
      for (var l = 0, s = !1, c = -1; l < a.length && l < i.length; ) {
        if (a[l] !== i[l]) {
          if (t === 0) {
            s = !0, t = l;
            break;
          }
          c = l, t--;
        }
        l++;
      }
      s || (t = c + 1);
    }
  return {
    text: a,
    caret: t
  };
}
function fS(e) {
  return e.hasAttribute("readonly");
}
function hS(e) {
  if (e.selectionStart !== e.selectionEnd)
    return {
      start: e.selectionStart,
      end: e.selectionEnd
    };
}
var ws = {
  Backspace: 8,
  Delete: 46
};
function mS(e) {
  switch (e.keyCode) {
    case ws.Backspace:
      return "Backspace";
    case ws.Delete:
      return "Delete";
  }
}
function vS(e) {
  return e.selectionStart;
}
function iu(e, t) {
  t !== void 0 && (pS() ? setTimeout(function() {
    return e.setSelectionRange(t, t);
  }, 0) : e.setSelectionRange(t, t));
}
function pS() {
  if (typeof navigator < "u")
    return gS.test(navigator.userAgent);
}
var gS = /Android/i;
function yS(e, t, n, r, a) {
  bi(t, n, r, void 0, a);
}
function bS(e, t, n, r, a) {
  if (!fS(t)) {
    var i = mS(e);
    switch (i) {
      case "Delete":
      case "Backspace":
        e.preventDefault();
        var l = hS(t);
        return l ? (wS(t, l), bi(t, n, r, void 0, a)) : bi(t, n, r, i, a);
    }
  }
}
function wS(e, t) {
  var n = e.value;
  n = n.slice(0, t.start) + n.slice(t.end), e.value = n, iu(e, t.start);
}
function bi(e, t, n, r, a) {
  var i = aS(e.value, vS(e), t), l = i.value, s = i.caret;
  if (r) {
    var c = rS(l, s, r);
    l = c.value, s = c.caret;
  }
  var d = uS(l, s, n), f = d.text;
  s = d.caret, e.value = f, iu(e, s), a(l);
}
var $S = ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"];
function wi() {
  return wi = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wi.apply(this, arguments);
}
function ES(e, t) {
  if (e == null) return {};
  var n = xS(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function xS(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Pr(e, t) {
  var n = e.value, r = e.parse, a = e.format, i = e.inputComponent, l = e.onChange, s = e.onKeyDown, c = ES(e, $S), d = ve(), f = he(function(p) {
    d.current = p, t && (typeof t == "function" ? t(p) : t.current = p);
  }, [t]), u = he(function(p) {
    return yS(p, d.current, r, a, l);
  }, [d, r, a, l]), h = he(function(p) {
    if (s && s(p), !p.defaultPrevented)
      return bS(p, d.current, r, a, l);
  }, [d, r, a, l, s]);
  return /* @__PURE__ */ o.createElement(i, wi({}, c, {
    ref: f,
    value: a(MS(n) ? "" : n).text,
    onKeyDown: h,
    onChange: u
  }));
}
Pr = /* @__PURE__ */ o.forwardRef(Pr);
Pr.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: L.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: L.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: L.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: L.string.isRequired,
  // Is parsed from <input/> text.
  value: L.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: L.func.isRequired,
  // Passthrough
  onKeyDown: L.func,
  onCut: L.func,
  onPaste: L.func
};
Pr.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: "input",
  // `<input/>` `type` attribute.
  type: "text"
};
function MS(e) {
  return e == null;
}
function $s(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), a = 0; a < 3; a++) {
    var i = Number(n[a]), l = Number(r[a]);
    if (i > l) return 1;
    if (l > i) return -1;
    if (!isNaN(i) && isNaN(l)) return 1;
    if (isNaN(i) && !isNaN(l)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var CS = {}.constructor;
function vn(e) {
  return e != null && e.constructor === CS;
}
function $i(e) {
  "@babel/helpers - typeof";
  return $i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $i(e);
}
function no(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function PS(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ro(e, t, n) {
  return t && PS(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var SS = "1.2.0", FS = "1.7.35", Es = " ext. ", zS = /^\d+$/, Ge = /* @__PURE__ */ function() {
  function e(t) {
    no(this, e), lu(t), this.metadata = t, cu.call(this, t);
  }
  return ro(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && zS.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new xs(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new xs(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[n];
        if (a)
          return a;
      } else {
        var i = this.countryCallingCodes()[n];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), xs = /* @__PURE__ */ function() {
  function e(t, n) {
    no(this, e), this.globalMetadataObject = n, this.metadata = t, cu.call(this, n.metadata);
  }
  return ro(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(a) {
        return new NS(a, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Ms(this.types(), n))
        return new OS(Ms(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Es : this.metadata[13] || Es;
    }
  }]), e;
}(), NS = /* @__PURE__ */ function() {
  function e(t, n) {
    no(this, e), this._format = t, this.metadata = n;
  }
  return ro(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !DS.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), DS = /^\(?\$1\)?$/, OS = /* @__PURE__ */ function() {
  function e(t, n) {
    no(this, e), this.type = t, this.metadata = n;
  }
  return ro(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Ms(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function lu(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!vn(e) || !vn(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(vn(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + AS(e) + ": " + e, "."));
}
var AS = function(t) {
  return $i(t);
};
function Ut(e, t) {
  if (t = new Ge(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function su(e, t) {
  return t.countries.hasOwnProperty(e);
}
function cu(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? $s(t, SS) === -1 ? this.v2 = !0 : $s(t, FS) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function ao(e, t) {
  return TS(e, void 0, t);
}
function TS(e, t, n) {
  var r = n.type(t), a = r && r.possibleLengths() || n.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var i = e.length, l = a[0];
  return l === i ? "IS_POSSIBLE" : l > i ? "TOO_SHORT" : a[a.length - 1] < i ? "TOO_LONG" : a.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function kS(e, t, n) {
  if (t === void 0 && (t = {}), n = new Ge(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return du(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function du(e, t) {
  switch (ao(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function Vt(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function HS(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = RS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function RS(e, t) {
  if (e) {
    if (typeof e == "string") return Cs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Cs(e, t);
  }
}
function Cs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var _S = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Yl(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new Ge(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (Vt(r, n.nationalNumberPattern())) {
      if (Xo(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Xo(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = HS(_S), i; !(i = a()).done; ) {
        var l = i.value;
        if (Xo(r, l, n))
          return l;
      }
    }
  }
}
function Xo(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Vt(e, t.pattern());
}
function IS(e, t, n) {
  if (t = t || {}, n = new Ge(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return Yl(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return Vt(r, n.nationalNumberPattern());
}
function LS(e, t, n) {
  var r = new Ge(n), a = r.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(i) {
    return jS(t, i, n);
  }) : [];
}
function jS(e, t, n) {
  var r = new Ge(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Ul = 2, BS = 17, WS = 3, nt = "0-9０-９٠-٩۰-۹", VS = "-‐-―−ー－", GS = "／/", YS = "．.", US = "  ­​⁠　", KS = "()（）［］\\[\\]", XS = "~⁓∼～", Pt = "".concat(VS).concat(GS).concat(YS).concat(US).concat(KS).concat(XS), oo = "+＋", qS = new RegExp("([" + nt + "])");
function uu(e, t, n, r) {
  if (t) {
    var a = new Ge(r);
    a.selectNumberingPlan(t, n);
    var i = new RegExp(a.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var l = e.match(qS);
      if (!(l && l[1] != null && l[1].length > 0 && l[1] === "0"))
        return e;
    }
  }
}
function Ei(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var a, i, l = r.length - 1, s = l > 0 && r[l];
      if (t.nationalPrefixTransformRule() && s)
        a = e.replace(n, t.nationalPrefixTransformRule()), l > 1 && (i = r[1]);
      else {
        var c = r[0];
        a = e.slice(c.length), s && (i = r[1]);
      }
      var d;
      if (s) {
        var f = e.indexOf(r[1]), u = e.slice(0, f);
        u === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: d,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function xi(e, t) {
  var n = Ei(e, t), r = n.carrierCode, a = n.nationalNumber;
  if (a !== e) {
    if (!ZS(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !JS(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: r
  };
}
function ZS(e, t, n) {
  return !(Vt(e, n.nationalNumberPattern()) && !Vt(t, n.nationalNumberPattern()));
}
function JS(e, t) {
  switch (ao(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function fu(e, t, n, r) {
  var a = t ? Ut(t, r) : n;
  if (e.indexOf(a) === 0) {
    r = new Ge(r), r.selectNumberingPlan(t, n);
    var i = e.slice(a.length), l = xi(i, r), s = l.nationalNumber, c = xi(e, r), d = c.nationalNumber;
    if (!Vt(d, r.nationalNumberPattern()) && Vt(s, r.nationalNumberPattern()) || ao(d, r) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: i
      };
  }
  return {
    number: e
  };
}
function Kl(e, t, n, r) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var i = uu(e, t, n, r);
    if (i && i !== e)
      a = !0, e = "+" + i;
    else {
      if (t || n) {
        var l = fu(e, t, n, r), s = l.countryCallingCode, c = l.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Ge(r);
  for (var d = 2; d - 1 <= WS && d <= e.length; ) {
    var f = e.slice(1, d);
    if (r.hasCallingCode(f))
      return r.selectNumberingPlan(f), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: f,
        number: e.slice(d)
      };
    d++;
  }
  return {};
}
function hu(e) {
  return e.replace(new RegExp("[".concat(Pt, "]+"), "g"), " ").trim();
}
var mu = /(\$\d)/;
function vu(e, t, n) {
  var r = n.useInternationalFormat, a = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var i = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(mu, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? hu(i) : i;
}
var QS = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function eF(e, t, n) {
  var r = new Ge(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (QS.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var tF = ";ext=", zn = function(t) {
  return "([".concat(nt, "]{1,").concat(t, "})");
};
function pu(e) {
  var t = "20", n = "15", r = "9", a = "6", i = "[  \\t,]*", l = "[:\\.．]?[  \\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", f = "[- ]+", u = "[  \\t]*", h = "(?:,{2}|;)", p = tF + zn(t), y = i + c + l + zn(t) + s, m = i + d + l + zn(r) + s, b = f + zn(a) + "#", $ = u + h + l + zn(n) + s, w = u + "(?:,)+" + l + zn(r) + s;
  return p + "|" + y + "|" + m + "|" + b + "|" + $ + "|" + w;
}
var nF = "[" + nt + "]{" + Ul + "}", rF = "[" + oo + "]{0,1}(?:[" + Pt + "]*[" + nt + "]){3,}[" + Pt + nt + "]*", aF = new RegExp("^[" + oo + "]{0,1}(?:[" + Pt + "]*[" + nt + "]){1,2}$", "i"), oF = rF + // Phone number extensions
"(?:" + pu() + ")?", iF = new RegExp(
  // Either a short two-digit-only phone number
  "^" + nF + "$|^" + oF + "$",
  "i"
);
function lF(e) {
  return e.length >= Ul && iF.test(e);
}
function sF(e) {
  return aF.test(e);
}
function cF(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function dF(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = uF(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uF(e, t) {
  if (e) {
    if (typeof e == "string") return Ps(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ps(e, t);
  }
}
function Ps(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ss(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ss(Object(n), !0).forEach(function(r) {
      fF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ss(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fF(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var zs = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function hF(e, t, n, r) {
  if (n ? n = Fs(Fs({}, zs), n) : n = zs, r = new Ge(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var a = r.countryCallingCode(), i = n.v2 ? e.nationalNumber : e.phone, l;
  switch (t) {
    case "NATIONAL":
      return i ? (l = za(i, e.carrierCode, "NATIONAL", r, n), qo(l, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (l = za(i, null, "INTERNATIONAL", r, n), l = "+".concat(a, " ").concat(l), qo(l, e.ext, r, n.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(i);
    case "RFC3966":
      return cF({
        number: "+".concat(a).concat(i),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = vF(i, e.carrierCode, a, n.fromCountry, r);
      return qo(s, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function za(e, t, n, r, a) {
  var i = mF(r.formats(), e);
  return i ? vu(e, i, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function mF(e, t) {
  for (var n = dF(e), r; !(r = n()).done; ) {
    var a = r.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var i = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (Vt(t, a.pattern()))
      return a;
  }
}
function qo(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function vF(e, t, n, r, a) {
  var i = Ut(r, a.metadata);
  if (i === n) {
    var l = za(e, t, "NATIONAL", a);
    return n === "1" ? n + " " + l : l;
  }
  var s = eF(r, void 0, a.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(za(e, null, "INTERNATIONAL", a));
}
function Ns(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ds(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ns(Object(n), !0).forEach(function(r) {
      pF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ns(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function pF(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function bF(e, t, n) {
  return t && yF(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var gu = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (gF(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !n)
        throw new TypeError("`metadata` argument not passed");
      if (vn(n) && vn(n.countries)) {
        r = n;
        var a = t;
        if (!EF.test(a))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var i = Kl(a, void 0, void 0, r), l = i.countryCallingCode, s = i.number;
        if (n = s, t = l, !n)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!n)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof n != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    lu(r);
    var c = $F(t, r), d = c.country, f = c.countryCallingCode;
    this.country = d, this.countryCallingCode = f, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return bF(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : LS(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return kS(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return IS(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Ge(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Yl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return hF(this, n, r ? Ds(Ds({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), wF = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function $F(e, t) {
  var n, r, a = new Ge(t);
  return wF(e) ? (n = e, a.selectNumberingPlan(n), r = a.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var EF = /^\+\d+$/;
function Mi(e) {
  "@babel/helpers - typeof";
  return Mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mi(e);
}
function xF(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function MF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function CF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sr(e, t);
}
function PF(e) {
  var t = bu();
  return function() {
    var r = Fr(e), a;
    if (t) {
      var i = Fr(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return SF(this, a);
  };
}
function SF(e, t) {
  if (t && (Mi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yu(e);
}
function yu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ci(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ci = function(r) {
    if (r === null || !FF(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, a);
    }
    function a() {
      return pa(r, arguments, Fr(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), Sr(a, r);
  }, Ci(e);
}
function pa(e, t, n) {
  return bu() ? pa = Reflect.construct : pa = function(a, i, l) {
    var s = [null];
    s.push.apply(s, i);
    var c = Function.bind.apply(a, s), d = new c();
    return l && Sr(d, l.prototype), d;
  }, pa.apply(null, arguments);
}
function bu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function FF(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Sr(e, t) {
  return Sr = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Sr(e, t);
}
function Fr(e) {
  return Fr = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Fr(e);
}
var Rt = /* @__PURE__ */ function(e) {
  CF(n, e);
  var t = PF(n);
  function n(r) {
    var a;
    return MF(this, n), a = t.call(this, r), Object.setPrototypeOf(yu(a), n.prototype), a.name = a.constructor.name, a;
  }
  return xF(n);
}(/* @__PURE__ */ Ci(Error)), Os = new RegExp("(?:" + pu() + ")$", "i");
function zF(e) {
  var t = e.search(Os);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(Os), a = 1; a < r.length; ) {
    if (r[a])
      return {
        number: n,
        ext: r[a]
      };
    a++;
  }
}
function NF(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = DF(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DF(e, t) {
  if (e) {
    if (typeof e == "string") return As(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return As(e, t);
  }
}
function As(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var OF = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function wu(e) {
  return OF[e];
}
function Na(e) {
  for (var t = "", n = NF(e.split("")), r; !(r = n()).done; ) {
    var a = r.value, i = wu(a);
    i && (t += i);
  }
  return t;
}
function AF(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = TF(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TF(e, t) {
  if (e) {
    if (typeof e == "string") return Ts(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ts(e, t);
  }
}
function Ts(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Pi(e) {
  for (var t = "", n = AF(e.split("")), r; !(r = n()).done; ) {
    var a = r.value;
    t += $u(a, t) || "";
  }
  return t;
}
function $u(e, t, n) {
  if (e === "+") {
    if (t) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return wu(e);
}
function kF(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = HF(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HF(e, t) {
  if (e) {
    if (typeof e == "string") return ks(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ks(e, t);
  }
}
function ks(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Eu(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var r = t.metadata;
  r = new Ge(r);
  for (var a = kF(n), i; !(i = a()).done; ) {
    var l = i.value;
    if (r.country(l), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return l;
    } else if (Yl({
      phone: e,
      country: l
    }, void 0, r.metadata))
      return l;
  }
}
function xu(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, a = t.metadata, i = a.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : Eu(n, {
      countries: i,
      defaultCountry: r,
      metadata: a.metadata
    });
}
var Mu = "+", RF = "[\\-\\.\\(\\)]?", Hs = "([" + nt + "]|" + RF + ")", _F = "^\\" + Mu + Hs + "*[" + nt + "]" + Hs + "*$", IF = new RegExp(_F, "g"), Si = nt, LF = "[" + Si + "]+((\\-)*[" + Si + "])*", jF = "a-zA-Z", BF = "[" + jF + "]+((\\-)*[" + Si + "])*", WF = "^(" + LF + "\\.)*" + BF + "\\.?$", VF = new RegExp(WF, "g"), Rs = "tel:", Fi = ";phone-context=", GF = ";isub=";
function YF(e) {
  var t = e.indexOf(Fi);
  if (t < 0)
    return null;
  var n = t + Fi.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function UF(e) {
  return e === null ? !0 : e.length === 0 ? !1 : IF.test(e) || VF.test(e);
}
function KF(e, t) {
  var n = t.extractFormattedPhoneNumber, r = YF(e);
  if (!UF(r))
    throw new Rt("NOT_A_NUMBER");
  var a;
  if (r === null)
    a = n(e) || "";
  else {
    a = "", r.charAt(0) === Mu && (a += r);
    var i = e.indexOf(Rs), l;
    i >= 0 ? l = i + Rs.length : l = 0;
    var s = e.indexOf(Fi);
    a += e.substring(l, s);
  }
  var c = a.indexOf(GF);
  if (c > 0 && (a = a.substring(0, c)), a !== "")
    return a;
}
var XF = 250, qF = new RegExp("[" + oo + nt + "]"), ZF = new RegExp("[^" + nt + "#]+$");
function JF(e, t, n) {
  if (t = t || {}, n = new Ge(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new Rt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = ez(e, t.v2, t.extract), a = r.number, i = r.ext, l = r.error;
  if (!a) {
    if (t.v2)
      throw l === "TOO_SHORT" ? new Rt("TOO_SHORT") : new Rt("NOT_A_NUMBER");
    return {};
  }
  var s = nz(a, t.defaultCountry, t.defaultCallingCode, n), c = s.country, d = s.nationalNumber, f = s.countryCallingCode, u = s.countryCallingCodeSource, h = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Rt("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Ul) {
    if (t.v2)
      throw new Rt("TOO_SHORT");
    return {};
  }
  if (d.length > BS) {
    if (t.v2)
      throw new Rt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new gu(f, d, n.metadata);
    return c && (p.country = c), h && (p.carrierCode = h), i && (p.ext = i), p.__countryCallingCodeSource = u, p;
  }
  var y = (t.extended ? n.hasSelectedNumberingPlan() : c) ? Vt(d, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: c,
    countryCallingCode: f,
    carrierCode: h,
    valid: y,
    possible: y ? !0 : !!(t.extended === !0 && n.possibleLengths() && du(d, n)),
    phone: d,
    ext: i
  } : y ? tz(c, d, i) : {};
}
function QF(e, t, n) {
  if (e) {
    if (e.length > XF) {
      if (n)
        throw new Rt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(qF);
    if (!(r < 0))
      return e.slice(r).replace(ZF, "");
  }
}
function ez(e, t, n) {
  var r = KF(e, {
    extractFormattedPhoneNumber: function(l) {
      return QF(l, n, t);
    }
  });
  if (!r)
    return {};
  if (!lF(r))
    return sF(r) ? {
      error: "TOO_SHORT"
    } : {};
  var a = zF(r);
  return a.ext ? a : {
    number: r
  };
}
function tz(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function nz(e, t, n, r) {
  var a = Kl(Pi(e), t, n, r.metadata), i = a.countryCallingCodeSource, l = a.countryCallingCode, s = a.number, c;
  if (l)
    r.selectNumberingPlan(l);
  else if (s && (t || n))
    r.selectNumberingPlan(t, n), t && (c = t), l = n || Ut(t, r.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: l
    };
  var d = xi(Pi(s), r), f = d.nationalNumber, u = d.carrierCode, h = xu(l, {
    nationalNumber: f,
    defaultCountry: t,
    metadata: r
  });
  return h && (c = h, h === "001" || r.country(c)), {
    country: c,
    countryCallingCode: l,
    countryCallingCodeSource: i,
    nationalNumber: f,
    carrierCode: u
  };
}
function _s(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Is(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _s(Object(n), !0).forEach(function(r) {
      rz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _s(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function rz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function az(e, t, n) {
  return JF(e, Is(Is({}, t), {}, {
    v2: !0
  }), n);
}
function Ls(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oz(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ls(Object(n), !0).forEach(function(r) {
      iz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ls(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function iz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function lz(e, t) {
  return uz(e) || dz(e, t) || cz(e, t) || sz();
}
function sz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cz(e, t) {
  if (e) {
    if (typeof e == "string") return js(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return js(e, t);
  }
}
function js(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function dz(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, l, s;
    try {
      for (n = n.call(e); !(a = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); a = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function uz(e) {
  if (Array.isArray(e)) return e;
}
function Xl(e) {
  var t = Array.prototype.slice.call(e), n = lz(t, 4), r = n[0], a = n[1], i = n[2], l = n[3], s, c, d;
  if (typeof r == "string")
    s = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    l ? (c = i, d = l) : (c = void 0, d = i), a && (c = oz({
      defaultCountry: a
    }, c));
  else if (vn(a))
    i ? (c = a, d = i) : d = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: s,
    options: c,
    metadata: d
  };
}
function Bs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ws(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bs(Object(n), !0).forEach(function(r) {
      fz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ql(e, t, n) {
  t && t.defaultCountry && !su(t.defaultCountry, n) && (t = Ws(Ws({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return az(e, t, n);
  } catch (r) {
    if (!(r instanceof Rt)) throw r;
  }
}
function Cu() {
  var e = Xl(arguments), t = e.text, n = e.options, r = e.metadata;
  return ql(t, n, r);
}
function Vs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Gs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vs(Object(n), !0).forEach(function(r) {
      hz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mz() {
  var e = Xl(arguments), t = e.text, n = e.options, r = e.metadata;
  n = Gs(Gs({}, n), {}, {
    extract: !1
  });
  var a = ql(t, n, r);
  return a && a.isValid() || !1;
}
function Ys(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Us(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ys(Object(n), !0).forEach(function(r) {
      vz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ys(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function vz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pz() {
  var e = Xl(arguments), t = e.text, n = e.options, r = e.metadata;
  n = Us(Us({}, n), {}, {
    extract: !1
  });
  var a = ql(t, n, r);
  return a && a.isPossible() || !1;
}
function gz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function bz(e, t, n) {
  return t && yz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var wz = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.onCountryChange, r = t.onCallingCodeChange;
    gz(this, e), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return bz(e, [{
    key: "reset",
    value: function(n) {
      var r = n.country, a = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, a);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, a = Object.keys(n); r < a.length; r++) {
        var i = a[r];
        this[i] = n[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function $z(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ez(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ez(e, t) {
  if (e) {
    if (typeof e == "string") return Ks(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ks(e, t);
  }
}
function Ks(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var xt = "x", Zo = new RegExp(xt);
function ga(e, t) {
  if (t < 1)
    return "";
  for (var n = ""; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function Xs(e, t) {
  return e[t] === ")" && t++, xz(e.slice(0, t));
}
function xz(e) {
  for (var t = [], n = 0; n < e.length; )
    e[n] === "(" ? t.push(n) : e[n] === ")" && t.pop(), n++;
  var r = 0, a = "";
  t.push(e.length);
  for (var i = 0, l = t; i < l.length; i++) {
    var s = l[i];
    a += e.slice(r, s), r = s + 1;
  }
  return a;
}
function Mz(e, t, n) {
  for (var r = $z(n.split("")), a; !(a = r()).done; ) {
    var i = a.value;
    if (e.slice(t + 1).search(Zo) < 0)
      return;
    t = e.search(Zo), e = e.replace(Zo, i);
  }
  return [e, t];
}
function Cz(e, t, n) {
  var r = n.metadata, a = n.shouldTryNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix, l = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (l.test(e.nationalSignificantNumber))
    return Sz(e, t, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: a,
      getSeparatorAfterNationalPrefix: i
    });
}
function Pz(e, t) {
  return ao(e, t) === "IS_POSSIBLE";
}
function Sz(e, t, n) {
  var r = n.metadata, a = n.shouldTryNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, a(t)) {
    var l = qs(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: r
    });
    if (l)
      return l;
  }
  return qs(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: r
  });
}
function qs(e, t, n) {
  var r = n.metadata, a = n.useNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix, l = vu(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: a,
    metadata: r
  });
  if (a || (e.nationalPrefix ? l = e.nationalPrefix + i(t) + l : e.complexPrefixBeforeNationalSignificantNumber && (l = e.complexPrefixBeforeNationalSignificantNumber + " " + l)), Fz(l, e))
    return l;
}
function Fz(e, t) {
  return Na(e) === t.getNationalDigits();
}
function zz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Dz(e, t, n) {
  return t && Nz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Oz = /* @__PURE__ */ function() {
  function e() {
    zz(this, e);
  }
  return Dz(e, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], a = r.branches, i = r.instructions;
      if (a)
        return {
          op: "|",
          args: a.concat([Jo(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(kz);
      if (!r) {
        if (Tz.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var a = r[1], i = n.slice(0, r.index), l = n.slice(r.index + a.length);
      switch (a) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var s = this.getContext(), c = s.branches;
          c.push(Jo(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: c
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(Jo(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: Az(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(a));
      }
      l && this.parsePattern(l);
    }
  }]), e;
}();
function Az(e) {
  for (var t = [], n = 0; n < e.length; ) {
    if (e[n] === "-") {
      if (n === 0 || n === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, a = e[n + 1].charCodeAt(0) - 1, i = r; i <= a; )
        t.push(String.fromCharCode(i)), i++;
    } else
      t.push(e[n]);
    n++;
  }
  return t;
}
var Tz = /[\(\)\[\]\?\:\|]/, kz = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function Jo(e) {
  return e.length === 1 ? e[0] : e;
}
function Zs(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Hz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hz(e, t) {
  if (e) {
    if (typeof e == "string") return Js(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Js(e, t);
  }
}
function Js(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Rz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _z(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Iz(e, t, n) {
  return t && _z(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Lz = /* @__PURE__ */ function() {
  function e(t) {
    Rz(this, e), this.matchTree = new Oz().parse(t);
  }
  return Iz(e, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var i = zi(n.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !a))
        return i;
    }
  }]), e;
}();
function zi(e, t, n) {
  if (typeof t == "string") {
    var r = e.join("");
    return t.indexOf(r) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(t) === 0 ? n && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var a = e.slice(), i = 0; i < t.length; ) {
      var l = t[i], s = zi(a, l, n && i === t.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (a = a.slice(s.matchedChars.length), a.length === 0)
            return i === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      i++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - a.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var c, d = Zs(t.args), f; !(f = d()).done; ) {
        var u = f.value, h = zi(e, u, n);
        if (h) {
          if (h.overflow)
            return h;
          if (h.match)
            return {
              match: !0,
              matchedChars: h.matchedChars
            };
          if (h.partialMatch)
            c = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(h, null, 2)));
        }
      }
      return c ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var p = Zs(t.args), y; !(y = p()).done; ) {
        var m = y.value;
        if (e[0] === m)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [m]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function Qs(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = jz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jz(e, t) {
  if (e) {
    if (typeof e == "string") return ec(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ec(e, t);
  }
}
function ec(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Bz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Vz(e, t, n) {
  return t && Wz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Ni = "9", Gz = 15, Yz = ga(Ni, Gz), Uz = /[- ]/, Kz = function() {
  return /\[([^\[\]])*\]/g;
}, Xz = function() {
  return /\d(?=[^,}][^,}])/g;
}, qz = new RegExp("[" + Pt + "]*\\$1[" + Pt + "]*(\\$\\d[" + Pt + "]*)*$"), tc = 3, Zz = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var n = t.metadata;
    Bz(this, e), this.metadata = n, this.resetFormat();
  }
  return Vz(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var a = this;
      if (Pz(r.nationalSignificantNumber, this.metadata))
        for (var i = Qs(this.matchingFormats), l; !(l = i()).done; ) {
          var s = l.value, c = Cz(r, s, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(f) {
              return a.shouldTryNationalPrefixFormattingRule(f, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(f) {
              return a.getSeparatorAfterNationalPrefix(f);
            }
          });
          if (c)
            return this.resetFormat(), this.chosenFormat = s, this.setNationalNumberTemplate(c.replace(/\d/g, xt), r), this.populatedNationalNumberTemplate = c, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(xt), c;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var a = this.chosenFormat, i = this.chooseFormat(r);
      if (i)
        return i === a ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, a = n.nationalSignificantNumber, i = n.nationalPrefix, l = n.international, s = a, c = s.length - tc;
      c < 0 && (c = 0), this.matchingFormats = this.matchingFormats.filter(function(d) {
        return r.formatSuits(d, l, i) && r.formatMatches(d, s, c);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, a) {
      return !(a && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !a && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, a) {
      var i = n.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      a = Math.min(a, i - 1);
      var l = n.leadingDigitsPatterns()[a];
      if (r.length < tc)
        try {
          return new Lz(l).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (s) {
          return console.error(s), !0;
        }
      return new RegExp("^(".concat(l, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, a = function() {
        var d = l.value;
        return r.chosenFormat === d ? "break" : qz.test(r.getFormatFormat(d, n.international)) ? r.createTemplateForFormat(d, n) ? (r.chosenFormat = d, "break") : (r.matchingFormats = r.matchingFormats.filter(function(f) {
          return f !== d;
        }), "continue") : "continue";
      }, i = Qs(this.matchingFormats.slice()), l; !(l = i()).done; ) {
        var s = a();
        if (s === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var a = this.getTemplateForFormat(n, r);
        if (a)
          return this.setNationalNumberTemplate(a, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && Uz.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var a = n.IDDPrefix, i = n.missingPlus;
      return a ? r && r.spacing === !1 ? a : a + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, a = 0, i = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; a < i.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(xt, r + 1), a++;
        return Xs(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, xt) + ga(xt, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var a = r.nationalSignificantNumber, i = r.international, l = r.nationalPrefix, s = r.complexPrefixBeforeNationalSignificantNumber, c = n.pattern();
      c = c.replace(Kz(), "\\d").replace(Xz(), "\\d");
      var d = Yz.match(c)[0];
      if (!(a.length > d.length)) {
        var f = new RegExp("^" + c + "$"), u = a.replace(/\d/g, Ni);
        f.test(u) && (d = u);
        var h = this.getFormatFormat(n, i), p;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: i,
          nationalPrefix: l
        })) {
          var y = h.replace(mu, n.nationalPrefixFormattingRule());
          if (Na(n.nationalPrefixFormattingRule()) === (l || "") + Na("$1") && (h = y, p = !0, l))
            for (var m = l.length; m > 0; )
              h = h.replace(/\d/, xt), m--;
        }
        var b = d.replace(new RegExp(c), h).replace(new RegExp(Ni, "g"), xt);
        return p || (s ? b = ga(xt, s.length) + " " + b : l && (b = ga(xt, l.length) + this.getSeparatorAfterNationalPrefix(n) + b)), i && (b = hu(b)), b;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = Mz(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], Xs(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var a = r.international, i = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var l = n.usesNationalPrefix();
        if (l && i || !l && !a)
          return !0;
      }
    }
  }]), e;
}();
function Pu(e, t) {
  return tN(e) || eN(e, t) || Qz(e, t) || Jz();
}
function Jz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qz(e, t) {
  if (e) {
    if (typeof e == "string") return nc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nc(e, t);
  }
}
function nc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function eN(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, l, s;
    try {
      for (n = n.call(e); !(a = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); a = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function tN(e) {
  if (Array.isArray(e)) return e;
}
function nN(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function rN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function aN(e, t, n) {
  return t && rN(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var oN = "[" + Pt + nt + "]+", iN = new RegExp("^" + oN + "$", "i"), lN = "(?:[" + oo + "][" + Pt + nt + "]*|[" + Pt + nt + "]+)", sN = new RegExp("[^" + Pt + nt + "]+.*$"), cN = /[^\d\[\]]/, dN = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.defaultCountry, r = t.defaultCallingCode, a = t.metadata, i = t.onNationalSignificantNumberChange;
    nN(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = a, this.onNationalSignificantNumberChange = i;
  }
  return aN(e, [{
    key: "input",
    value: function(n, r) {
      var a = hN(n), i = Pu(a, 2), l = i[0], s = i[1], c = Na(l), d;
      return s && (r.digits || (r.startInternationalNumber(), c || (d = !0))), c && this.inputDigits(c, r), {
        digits: c,
        justLeadingPlus: d
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var a = r.digits, i = a.length < 3 && a.length + n.length >= 3;
      if (r.appendDigits(n), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(l) {
        return r.update(l);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, a = n.callingCode;
      return r && !a;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = Kl("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode, i = r.number;
      if (a)
        return n.setCallingCode(a), n.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && cN.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var a = Ei(n, this.metadata), i = a.nationalPrefix, l = a.nationalNumber, s = a.carrierCode;
        if (l !== n)
          return this.onExtractedNationalNumber(i, s, l, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, a) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, a);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = Ei(n, this.metadata), l = i.nationalPrefix, s = i.nationalNumber, c = i.carrierCode;
        if (s !== r)
          return this.onExtractedNationalNumber(l, c, s, n, a), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, a, i, l) {
      var s, c, d = i.lastIndexOf(a);
      if (d >= 0 && d === i.length - a.length) {
        c = !0;
        var f = i.slice(0, d);
        f !== n && (s = f);
      }
      l({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: a,
        nationalSignificantNumberMatchesInput: c,
        complexPrefixBeforeNationalSignificantNumber: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, a = n.IDDPrefix, i = n.digits;
      if (n.nationalSignificantNumber, !(r || a)) {
        var l = uu(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (l !== void 0 && l !== i)
          return n.update({
            IDDPrefix: i.slice(0, i.length - l.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = fu(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode;
        if (r.number, a)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: a
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var a = r.country, i = r.callingCode;
      n.startInternationalNumber(a, i), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]), e;
}();
function uN(e) {
  var t = e.search(lN);
  if (!(t < 0)) {
    e = e.slice(t);
    var n;
    return e[0] === "+" && (n = !0, e = e.slice(1)), e = e.replace(sN, ""), n && (e = "+" + e), e;
  }
}
function fN(e) {
  var t = uN(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function hN(e) {
  var t = fN(e), n = Pu(t, 2), r = n[0], a = n[1];
  return iN.test(r) || (r = ""), [r, a];
}
function mN(e, t) {
  return yN(e) || gN(e, t) || pN(e, t) || vN();
}
function vN() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pN(e, t) {
  if (e) {
    if (typeof e == "string") return rc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rc(e, t);
  }
}
function rc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function gN(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, l, s;
    try {
      for (n = n.call(e); !(a = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); a = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function yN(e) {
  if (Array.isArray(e)) return e;
}
function bN(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function $N(e, t, n) {
  return t && wN(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Xn = /* @__PURE__ */ function() {
  function e(t, n) {
    bN(this, e), this.metadata = new Ge(n);
    var r = this.getCountryAndCallingCode(t), a = mN(r, 2), i = a[0], l = a[1];
    this.defaultCountry = i, this.defaultCallingCode = l, this.reset();
  }
  return $N(e, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, a;
      return n && (vn(n) ? (r = n.defaultCountry, a = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, a];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), a = r.digits, i = r.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (a) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var l;
        if (this.metadata.hasSelectedNumberingPlan() && (l = this.formatter.format(a, this.state)), l === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var s = this.state.getNationalDigits();
          s && (l = this.formatter.format(s, this.state));
        }
        this.formattedOutput = l ? this.getFullNumber(l) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new wz({
        onCountryChange: function(a) {
          n.country = a;
        },
        onCallingCodeChange: function(a, i) {
          n.metadata.selectNumberingPlan(i, a), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new Zz({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new dN({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var a = function(s) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!s
          }) + s;
        }, i = this.state.callingCode;
        return a(i ? n ? "".concat(i, " ").concat(n) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, a = n.complexPrefixBeforeNationalSignificantNumber, i = n.nationalPrefix, l = r, s = a || i;
      return s && (l = s + l), l;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, xt);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(xu(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, a = n.callingCode, i = n.country, l = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return a ? "+" + a + l : "+" + r;
        if (i || a) {
          var s = i ? this.metadata.countryCallingCode() : a;
          return "+" + s + l;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, a = n.carrierCode, i = n.callingCode, l = this._getCountry();
      if (r && !(!l && !i)) {
        if (l && l === this.defaultCountry) {
          var s = new Ge(this.metadata.metadata);
          s.selectNumberingPlan(l);
          var c = s.numberingPlan.callingCode(), d = this.metadata.getCountryCodesForCallingCode(c);
          if (d.length > 1) {
            var f = Eu(r, {
              countries: d,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            f && (l = f);
          }
        }
        var u = new gu(l || i, r, this.metadata.metadata);
        return a && (u.carrierCode = a), u;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function Di(e) {
  return new Ge(e).getCountries();
}
function EN(e, t, n) {
  return n || (n = t, t = void 0), new Xn(t, n).input(e);
}
function Su(e) {
  var t = e.country, n = e.international, r = e.withCountryCallingCode, a = e.metadata;
  return t && n && !r ? "+".concat(Ut(t, a)) : "";
}
function Oi(e, t) {
  return t && (e = e.slice(t.length), e[0] === " " && (e = e.slice(1))), e;
}
function xN(e, t, n) {
  if (!(n && n.ignoreRest)) {
    var r = function(i) {
      if (n)
        switch (i) {
          case "end":
            n.ignoreRest = !0;
            break;
        }
    };
    return $u(e, t, r);
  }
}
function Fu(e) {
  var t = e.onKeyDown, n = e.international;
  return he(function(r) {
    if (r.keyCode === MN && n && r.target instanceof HTMLInputElement && CN(r.target) === PN) {
      r.preventDefault();
      return;
    }
    t && t(r);
  }, [t, n]);
}
var MN = 8;
function CN(e) {
  return e.selectionStart;
}
var PN = 1, SN = ["onKeyDown", "country", "international", "withCountryCallingCode", "metadata"];
function Ai() {
  return Ai = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ai.apply(this, arguments);
}
function FN(e, t) {
  if (e == null) return {};
  var n = zN(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function zN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function NN(e) {
  function t(n, r) {
    var a = n.onKeyDown, i = n.country, l = n.international, s = n.withCountryCallingCode, c = n.metadata, d = c === void 0 ? e : c, f = FN(n, SN), u = he(function(p) {
      var y = new Xn(i, d), m = Su({
        country: i,
        international: l,
        withCountryCallingCode: s,
        metadata: d
      }), b = y.input(m + p), $ = y.getTemplate();
      return m && (b = Oi(b, m), $ && ($ = Oi($, m))), {
        text: b,
        template: $
      };
    }, [i, d]), h = Fu({
      onKeyDown: a,
      international: l
    });
    return /* @__PURE__ */ o.createElement(Pr, Ai({}, f, {
      ref: r,
      parse: xN,
      format: u,
      onKeyDown: h
    }));
  }
  return t = /* @__PURE__ */ o.forwardRef(t), t.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: L.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: L.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: L.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: L.string,
    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: L.bool,
    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: L.bool,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: L.object
  }, t;
}
const DN = NN();
var ON = ["value", "onChange", "onKeyDown", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"];
function Ti() {
  return Ti = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ti.apply(this, arguments);
}
function AN(e, t) {
  if (e == null) return {};
  var n = TN(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function TN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function kN(e) {
  function t(n, r) {
    var a = n.value, i = n.onChange, l = n.onKeyDown, s = n.country, c = n.international, d = n.withCountryCallingCode, f = n.metadata, u = f === void 0 ? e : f, h = n.inputComponent, p = h === void 0 ? "input" : h, y = AN(n, ON), m = Su({
      country: s,
      international: c,
      withCountryCallingCode: d,
      metadata: u
    }), b = he(function(w) {
      var E = Pi(w.target.value);
      if (E === a) {
        var P = ac(m, E, s, u);
        P.indexOf(w.target.value) === 0 && (E = E.slice(0, -1));
      }
      i(E);
    }, [m, a, i, s, u]), $ = Fu({
      onKeyDown: l,
      international: c
    });
    return /* @__PURE__ */ o.createElement(p, Ti({}, y, {
      ref: r,
      value: ac(m, a, s, u),
      onChange: b,
      onKeyDown: $
    }));
  }
  return t = /* @__PURE__ */ o.forwardRef(t), t.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: L.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: L.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: L.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: L.string,
    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: L.bool,
    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: L.bool,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: L.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: L.elementType
  }, t;
}
const HN = kN();
function ac(e, t, n, r) {
  return Oi(EN(e + t, n, r), e);
}
function RN(e) {
  return oc(e[0]) + oc(e[1]);
}
function oc(e) {
  return String.fromCodePoint(127397 + e.toUpperCase().charCodeAt(0));
}
var _N = ["value", "onChange", "options", "disabled", "readOnly"], IN = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function LN(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = jN(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jN(e, t) {
  if (e) {
    if (typeof e == "string") return ic(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ic(e, t);
  }
}
function ic(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Da() {
  return Da = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Da.apply(this, arguments);
}
function zu(e, t) {
  if (e == null) return {};
  var n = BN(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function BN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Nu(e) {
  var t = e.value, n = e.onChange, r = e.options, a = e.disabled, i = e.readOnly, l = zu(e, _N), s = he(function(c) {
    var d = c.target.value;
    n(d === "ZZ" ? void 0 : d);
  }, [n]);
  return Ze(function() {
    return Ou(r, t);
  }, [r, t]), /* @__PURE__ */ o.createElement("select", Da({}, l, {
    disabled: a || i,
    readOnly: i,
    value: t || "ZZ",
    onChange: s
  }), r.map(function(c) {
    var d = c.value, f = c.label, u = c.divider;
    return /* @__PURE__ */ o.createElement("option", {
      key: u ? "|" : d || "ZZ",
      value: u ? "|" : d || "ZZ",
      disabled: !!u,
      style: u ? WN : void 0
    }, f);
  }));
}
Nu.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: L.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: L.func.isRequired,
  // `<select/>` options.
  options: L.arrayOf(L.shape({
    value: L.string,
    label: L.string,
    divider: L.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: L.bool,
  readOnly: L.bool
};
var WN = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function Du(e) {
  var t = e.value, n = e.options, r = e.className, a = e.iconComponent;
  e.getIconAspectRatio;
  var i = e.arrowComponent, l = i === void 0 ? VN : i, s = e.unicodeFlags, c = zu(e, IN), d = Ze(function() {
    return Ou(n, t);
  }, [n, t]);
  return /* @__PURE__ */ o.createElement("div", {
    className: "PhoneInputCountry"
  }, /* @__PURE__ */ o.createElement(Nu, Da({}, c, {
    value: t,
    options: n,
    className: Fa("PhoneInputCountrySelect", r)
  })), s && t && /* @__PURE__ */ o.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, RN(t)), !(s && t) && /* @__PURE__ */ o.createElement(a, {
    "aria-hidden": !0,
    country: t,
    label: d && d.label,
    aspectRatio: s ? 1 : void 0
  }), /* @__PURE__ */ o.createElement(l, null));
}
Du.propTypes = {
  // Country flag component.
  iconComponent: L.elementType,
  // Select arrow component.
  arrowComponent: L.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: L.bool
};
function VN() {
  return /* @__PURE__ */ o.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function Ou(e, t) {
  for (var n = LN(e), r; !(r = n()).done; ) {
    var a = r.value;
    if (!a.divider && a.value === t)
      return a;
  }
}
var GN = ["country", "countryName", "flags", "flagUrl"];
function ki() {
  return ki = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ki.apply(this, arguments);
}
function YN(e, t) {
  if (e == null) return {};
  var n = UN(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function UN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Zl(e) {
  var t = e.country, n = e.countryName, r = e.flags, a = e.flagUrl, i = YN(e, GN);
  return r && r[t] ? r[t]({
    title: n
  }) : /* @__PURE__ */ o.createElement("img", ki({}, i, {
    alt: n,
    role: n ? void 0 : "presentation",
    src: a.replace("{XX}", t).replace("{xx}", t.toLowerCase())
  }));
}
Zl.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: L.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: L.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: L.objectOf(L.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: L.string.isRequired
};
var KN = ["aspectRatio"], XN = ["title"], qN = ["title"];
function Oa() {
  return Oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oa.apply(this, arguments);
}
function Jl(e, t) {
  if (e == null) return {};
  var n = ZN(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function ZN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function io(e) {
  var t = e.aspectRatio, n = Jl(e, KN);
  return t === 1 ? /* @__PURE__ */ o.createElement(Tu, n) : /* @__PURE__ */ o.createElement(Au, n);
}
io.propTypes = {
  title: L.string.isRequired,
  aspectRatio: L.number
};
function Au(e) {
  var t = e.title, n = Jl(e, XN);
  return /* @__PURE__ */ o.createElement("svg", Oa({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /* @__PURE__ */ o.createElement("title", null, t), /* @__PURE__ */ o.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /* @__PURE__ */ o.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /* @__PURE__ */ o.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /* @__PURE__ */ o.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /* @__PURE__ */ o.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
Au.propTypes = {
  title: L.string.isRequired
};
function Tu(e) {
  var t = e.title, n = Jl(e, qN);
  return /* @__PURE__ */ o.createElement("svg", Oa({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /* @__PURE__ */ o.createElement("title", null, t), /* @__PURE__ */ o.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /* @__PURE__ */ o.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
Tu.propTypes = {
  title: L.string.isRequired
};
function JN(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = QN(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QN(e, t) {
  if (e) {
    if (typeof e == "string") return lc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lc(e, t);
  }
}
function lc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function eD(e, t) {
  if (!t)
    return e;
  for (var n = [], r = [], a = n, i = JN(t), l; !(l = i()).done; ) {
    var s = l.value;
    s === "|" ? a.push({
      divider: !0
    }) : s === "..." || s === "…" ? a = r : function() {
      var c = void 0;
      s === "🌐" ? c = void 0 : c = s;
      var d = e.indexOf(e.filter(function(u) {
        return u.value === c;
      })[0]), f = e[d];
      e.splice(d, 1), a.push(f);
    }();
  }
  return n.concat(e).concat(r);
}
function tD(e, t) {
  if (e && (e = e.filter(function(n) {
    switch (n) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return lo(n, t);
    }
  }), e.length > 0))
    return e;
}
function lo(e, t) {
  return su(e, t) ? !0 : (console.error("Country not found: ".concat(e)), !1);
}
function ku(e, t) {
  return e && (e = e.filter(function(n) {
    return lo(n, t);
  }), e.length === 0 && (e = void 0)), e;
}
var nD = ["country", "label", "aspectRatio"];
function Hi() {
  return Hi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hi.apply(this, arguments);
}
function rD(e, t) {
  if (e == null) return {};
  var n = aD(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function aD(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Hu(e) {
  var t = e.flags, n = e.flagUrl, r = e.flagComponent, a = e.internationalIcon;
  function i(l) {
    var s = l.country, c = l.label, d = l.aspectRatio, f = rD(l, nD), u = a === io ? d : void 0;
    return /* @__PURE__ */ o.createElement("div", Hi({}, f, {
      className: Fa("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": u === 1,
        "PhoneInputCountryIcon--border": s
      })
    }), s ? /* @__PURE__ */ o.createElement(r, {
      country: s,
      countryName: c,
      flags: t,
      flagUrl: n,
      className: "PhoneInputCountryIconImg"
    }) : /* @__PURE__ */ o.createElement(a, {
      title: c,
      aspectRatio: u,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return i.propTypes = {
    country: L.string,
    label: L.string.isRequired,
    aspectRatio: L.number
  }, i;
}
Hu({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: Zl,
  internationalIcon: io
});
function oD(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = iD(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iD(e, t) {
  if (e) {
    if (typeof e == "string") return sc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sc(e, t);
  }
}
function sc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function lD(e, t) {
  for (var n = oD(e), r; !(r = n()).done; ) {
    var a = r.value;
    a && sD(a, t);
  }
}
function sD(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
var Ru = L.shape({
  country_calling_codes: L.object.isRequired,
  countries: L.object.isRequired
}), _u = L.objectOf(L.string);
function Lt(e, t) {
  var n = "+" + Ut(e, t);
  return n;
}
function cD(e) {
  var t = e.value, n = e.phoneNumber, r = e.defaultCountry, a = e.getAnyCountry, i = e.countries, l = e.required, s = e.metadata, c;
  return n && n.country ? c = n.country : r && (!t || Bu(t, r, s)) && (c = r), i && i.indexOf(c) < 0 && (c = void 0), !c && l && i && i.length > 0 && (c = a()), c;
}
function dD(e) {
  var t = e.countries, n = e.countryNames, r = e.addInternationalOption, a = e.compareStringsLocales, i = e.compareStrings;
  i || (i = gD);
  var l = t.map(function(s) {
    return {
      value: s,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: n[s] || s
    };
  });
  return l.sort(function(s, c) {
    return i(s.label, c.label, a);
  }), r && l.unshift({
    label: n.ZZ
  }), l;
}
function Iu(e, t) {
  return Cu(e || "", t);
}
function uD(e) {
  return e.formatNational().replace(/\D/g, "");
}
function fD(e, t) {
  var n = t.prevCountry, r = t.newCountry, a = t.metadata, i = t.useNationalFormat;
  if (n === r)
    return e;
  if (!e)
    return i ? "" : r ? Lt(r, a) : "";
  if (r) {
    if (e[0] === "+") {
      if (i)
        return e.indexOf("+" + Ut(r, a)) === 0 ? yD(e, r, a) : "";
      if (n) {
        var l = Lt(r, a);
        return e.indexOf(l) === 0 ? e : l;
      } else {
        var s = Lt(r, a);
        return e.indexOf(s) === 0 ? e : s;
      }
    }
  } else if (e[0] !== "+")
    return An(e, n, a) || "";
  return e;
}
function An(e, t, n) {
  if (e) {
    if (e[0] === "+") {
      if (e === "+")
        return;
      var r = new Xn(t, n);
      return r.input(e), r.getNumberValue();
    }
    if (t) {
      var a = ju(e, t, n);
      return "+".concat(Ut(t, n)).concat(a || "");
    }
  }
}
function hD(e, t, n) {
  var r = ju(e, t, n);
  if (r) {
    var a = r.length - mD(t, n);
    if (a > 0)
      return e.slice(0, e.length - a);
  }
  return e;
}
function mD(e, t) {
  return t = new Ge(t), t.selectNumberingPlan(e), t.numberingPlan.possibleLengths()[t.numberingPlan.possibleLengths().length - 1];
}
function Lu(e, t) {
  var n = t.country, r = t.countries, a = t.required, i = t.metadata;
  if (e === "+")
    return n;
  var l = pD(e, i);
  return l && (!r || r.indexOf(l) >= 0) ? l : n && !a && !Bu(e, n, i) ? void 0 : n;
}
function vD(e, t) {
  var n = t.prevPhoneDigits, r = t.country, a = t.defaultCountry, i = t.countryRequired, l = t.getAnyCountry, s = t.countries, c = t.international, d = t.limitMaxLength, f = t.countryCallingCodeEditable, u = t.metadata;
  if (c && f === !1 && r) {
    var h = Lt(r, u);
    if (e.indexOf(h) !== 0) {
      var p, y = e && e[0] !== "+";
      return y ? (e = h + e, p = An(e, r, u)) : e = h, {
        phoneDigits: e,
        value: p,
        country: r
      };
    }
  }
  c === !1 && r && e && e[0] === "+" && (e = cc(e, r, u)), e && r && d && (e = hD(e, r, u)), e && e[0] !== "+" && (!r || c) && (e = "+" + e), !e && n && n[0] === "+" && (c ? r = void 0 : r = a), e === "+" && n && n[0] === "+" && n.length > 1 && (r = void 0);
  var m;
  return e && (e[0] === "+" && (e === "+" || r && Lt(r, u).indexOf(e) === 0) ? m = void 0 : m = An(e, r, u)), m && (r = Lu(m, {
    country: r,
    countries: s,
    metadata: u
  }), c === !1 && r && e && e[0] === "+" && (e = cc(e, r, u), m = An(e, r, u))), !r && i && (r = a || l()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: e,
    country: r,
    value: m
  };
}
function cc(e, t, n) {
  if (e.indexOf(Lt(t, n)) === 0) {
    var r = new Xn(t, n);
    r.input(e);
    var a = r.getNumber();
    return a ? a.formatNational().replace(/\D/g, "") : "";
  } else
    return e.replace(/\D/g, "");
}
function pD(e, t) {
  var n = new Xn(null, t);
  return n.input(e), n.getCountry();
}
function gD(e, t, n) {
  return String.prototype.localeCompare ? e.localeCompare(t, n) : e < t ? -1 : e > t ? 1 : 0;
}
function yD(e, t, n) {
  if (t) {
    var r = "+" + Ut(t, n);
    if (e.length < r.length) {
      if (r.indexOf(e) === 0)
        return "";
    } else if (e.indexOf(r) === 0)
      return e.slice(r.length);
  }
  for (var a = 0, i = Object.keys(n.country_calling_codes); a < i.length; a++) {
    var l = i[a];
    if (e.indexOf(l) === 1)
      return e.slice(1 + l.length);
  }
  return "";
}
function ju(e, t, n) {
  var r = new Xn(t, n);
  r.input(e);
  var a = r.getNumber();
  return a && a.nationalNumber;
}
function Bu(e, t, n) {
  for (var r = Lt(t, n), a = 0; a < e.length && a < r.length; ) {
    if (e[a] !== r[a])
      return !1;
    a++;
  }
  return !0;
}
function Wu(e) {
  var t = e.value, n = e.phoneNumber, r = e.defaultCountry, a = e.international, i = e.useNationalFormat, l = e.metadata;
  return (a === !1 || i) && n && n.country ? uD(n) : !t && a && r ? Lt(r, l) : t;
}
function dc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ua(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dc(Object(n), !0).forEach(function(r) {
      bD(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dc(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bD(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wD(e, t, n) {
  var r = e.metadata, a = e.countries, i = e.defaultCountry, l = e.value, s = e.reset, c = e.international, d = e.displayInitialValueAsLocalNumber, f = e.initialValueFormat, u = t.defaultCountry, h = t.value, p = t.reset;
  n.country;
  var y = n.value, m = n.hasUserSelectedACountry, b = function(A) {
    return Wu(ua(ua({}, A), {}, {
      international: c,
      useNationalFormat: d || f === "national",
      metadata: r
    }));
  };
  if (s !== p)
    return {
      phoneDigits: b({
        value: void 0,
        defaultCountry: i
      }),
      value: void 0,
      country: i,
      hasUserSelectedACountry: void 0
    };
  if (i !== u) {
    var $ = !i || lo(i, r), w = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !y || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      c && y === b({
        value: void 0,
        defaultCountry: u
      })
    ), E = !l && w;
    if (!m && $ && E)
      return {
        country: i,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: b({
          value: void 0,
          defaultCountry: i
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!uc(l, h) && !uc(l, y)) {
    var P, x;
    if (l) {
      P = Iu(l, r);
      var F = ku(a, r);
      P && P.country ? (!F || F.indexOf(P.country) >= 0) && (x = P.country) : (x = Lu(l, {
        country: void 0,
        countries: F,
        metadata: r
      }), x || i && l.indexOf(Lt(i, r)) === 0 && (x = i));
    }
    var z;
    return l || (z = {
      hasUserSelectedACountry: void 0
    }), ua(ua({}, z), {}, {
      phoneDigits: b({
        phoneNumber: P,
        value: l,
        defaultCountry: i
      }),
      value: l,
      country: l ? x : i
    });
  }
}
function uc(e, t) {
  return e === null && (e = void 0), t === null && (t = void 0), e === t;
}
function Ri(e) {
  "@babel/helpers - typeof";
  return Ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ri(e);
}
var $D = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function fc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fc(Object(n), !0).forEach(function(r) {
      Et(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fc(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rn.apply(this, arguments);
}
function ED(e, t) {
  if (e == null) return {};
  var n = xD(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function xD(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function MD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hc(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function CD(e, t, n) {
  return t && hc(e.prototype, t), n && hc(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function PD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _i(e, t);
}
function _i(e, t) {
  return _i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, _i(e, t);
}
function SD(e) {
  var t = zD();
  return function() {
    var r = Aa(e), a;
    if (t) {
      var i = Aa(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return FD(this, a);
  };
}
function FD(e, t) {
  if (t && (Ri(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $t(e);
}
function $t(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zD() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Aa(e) {
  return Aa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Aa(e);
}
function Et(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var ND = /* @__PURE__ */ function(e) {
  PD(n, e);
  var t = SD(n);
  function n(r) {
    var a;
    MD(this, n), a = t.call(this, r), Et($t(a), "setInputRef", function($) {
      lD([a.props.inputRef, a.inputRef], $);
    }), Et($t(a), "isCountrySupportedWithError", function($) {
      var w = a.props.metadata;
      return lo($, w);
    }), Et($t(a), "onCountryChange", function($) {
      var w = a.props, E = w.international, P = w.metadata, x = w.onChange, F = w.focusInputOnCountrySelection, z = a.state, N = z.phoneDigits, A = z.country, _ = fD(N, {
        prevCountry: A,
        newCountry: $,
        metadata: P,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !E
      }), B = An(_, $, P);
      F && a.inputRef.current.focus(), a.setState({
        country: $,
        hasUserSelectedACountry: !0,
        phoneDigits: _,
        value: B
      }, function() {
        x(B);
      });
    }), Et($t(a), "onChange", function($) {
      var w = a.props, E = w.defaultCountry, P = w.onChange, x = w.addInternationalOption, F = w.international, z = w.limitMaxLength, N = w.countryCallingCodeEditable, A = w.metadata, _ = a.state, B = _.countries, j = _.phoneDigits, ee = _.country, R = vD($, {
        prevPhoneDigits: j,
        country: ee,
        countryRequired: !x,
        defaultCountry: E,
        getAnyCountry: function() {
          return a.getFirstSupportedCountry({
            countries: B
          });
        },
        countries: B,
        international: F,
        limitMaxLength: z,
        countryCallingCodeEditable: N,
        metadata: A
      }), X = R.phoneDigits, V = R.country, G = R.value, ne = {
        phoneDigits: X,
        value: G,
        country: V
      };
      N === !1 && !G && X === a.state.phoneDigits && (ne.forceRerender = {}), a.setState(
        ne,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return P(G);
        }
      );
    }), Et($t(a), "_onFocus", function() {
      return a.setState({
        isFocused: !0
      });
    }), Et($t(a), "_onBlur", function() {
      return a.setState({
        isFocused: !1
      });
    }), Et($t(a), "onFocus", function($) {
      a._onFocus();
      var w = a.props.onFocus;
      w && w($);
    }), Et($t(a), "onBlur", function($) {
      var w = a.props.onBlur;
      a._onBlur(), w && w($);
    }), Et($t(a), "onCountryFocus", function($) {
      a._onFocus();
      var w = a.props.countrySelectProps;
      if (w) {
        var E = w.onFocus;
        E && E($);
      }
    }), Et($t(a), "onCountryBlur", function($) {
      a._onBlur();
      var w = a.props.countrySelectProps;
      if (w) {
        var E = w.onBlur;
        E && E($);
      }
    }), a.inputRef = /* @__PURE__ */ o.createRef();
    var i = a.props, l = i.value;
    i.labels;
    var s = i.international, c = i.addInternationalOption, d = i.displayInitialValueAsLocalNumber, f = i.initialValueFormat, u = i.metadata, h = a.props, p = h.defaultCountry, y = h.countries;
    p && (a.isCountrySupportedWithError(p) || (p = void 0)), y = ku(y, u);
    var m = Iu(l, u);
    a.CountryIcon = Hu(a.props);
    var b = cD({
      value: l,
      phoneNumber: m,
      defaultCountry: p,
      required: !c,
      countries: y || Di(u),
      getAnyCountry: function() {
        return a.getFirstSupportedCountry({
          countries: y
        });
      },
      metadata: u
    });
    return a.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: a.props,
      // The country selected.
      country: b,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: y,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: Wu({
        value: l,
        phoneNumber: m,
        defaultCountry: p,
        international: s,
        useNationalFormat: d || f === "national",
        metadata: u
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: l
    }, a;
  }
  return CD(n, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props.onCountryChange, i = this.props.defaultCountry, l = this.state.country;
      a && (i && (this.isCountrySupportedWithError(i) || (i = void 0)), l !== i && a(l));
    }
  }, {
    key: "componentDidUpdate",
    value: function(a, i) {
      var l = this.props.onCountryChange, s = this.state.country;
      l && s !== i.country && l(s);
    }
    // This function mimicks `refSetter` function returned from `useExternalRef()` hook
    // because this class-like React component can't use the `useExternalRef()` hook.
  }, {
    key: "getCountrySelectOptions",
    value: function(a) {
      var i = a.countries, l = this.props, s = l.international, c = l.countryCallingCodeEditable, d = l.countryOptionsOrder, f = l.addInternationalOption, u = l.labels, h = l.locales, p = l.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return eD(dD({
          countries: i || Di(p),
          countryNames: u,
          addInternationalOption: s && c === !1 ? !1 : f,
          compareStringsLocales: h
          // compareStrings
        }), tD(d, p));
      }, [i, d, f, u, p]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(a, i) {
      return (!this.countrySelectOptionsMemoDependencies || !OD(i, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = a(), this.countrySelectOptionsMemoDependencies = i), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(a) {
      var i = a.countries, l = this.getCountrySelectOptions({
        countries: i
      });
      return l[0].value;
    }
    // A shorthand for not passing `metadata` as a second argument.
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.name, l = a.disabled, s = a.readOnly, c = a.autoComplete, d = a.style, f = a.className;
      a.inputRef;
      var u = a.inputComponent, h = a.numberInputProps, p = a.smartCaret, y = a.countrySelectComponent, m = a.countrySelectProps, b = a.containerComponent, $ = a.containerComponentProps;
      a.defaultCountry, a.countries, a.countryOptionsOrder;
      var w = a.labels;
      a.flags, a.flagComponent, a.flagUrl, a.addInternationalOption, a.internationalIcon, a.displayInitialValueAsLocalNumber, a.initialValueFormat, a.onCountryChange, a.limitMaxLength, a.countryCallingCodeEditable, a.focusInputOnCountrySelection, a.reset;
      var E = a.metadata, P = a.international;
      a.locales;
      var x = ED(a, $D), F = this.state, z = F.country, N = F.countries, A = F.phoneDigits, _ = F.isFocused, B = p ? DN : HN, j = this.getCountrySelectOptions({
        countries: N
      });
      return /* @__PURE__ */ o.createElement(b, Rn({
        style: d,
        className: Fa(f, "PhoneInput", {
          "PhoneInput--focus": _,
          "PhoneInput--disabled": l,
          "PhoneInput--readOnly": s
        })
      }, $), /* @__PURE__ */ o.createElement(y, Rn({
        name: i ? "".concat(i, "Country") : void 0,
        "aria-label": w.country
      }, m, {
        value: z,
        options: j,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: l || m && m.disabled,
        readOnly: s || m && m.readOnly,
        iconComponent: this.CountryIcon
      })), /* @__PURE__ */ o.createElement(B, Rn({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: c
      }, h, x, {
        international: P ? !0 : void 0,
        withCountryCallingCode: P ? !0 : void 0,
        name: i,
        metadata: E,
        country: z,
        value: A || "",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: l,
        readOnly: s,
        inputComponent: u,
        className: Fa("PhoneInputInput", h && h.className, x.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(a, i) {
        return Vu({
          // Emulate `prevProps` via `state.props`.
          props: a
        }, wD(a, i.props, i));
      }
    )
  }]), n;
}(o.PureComponent), Gu = /* @__PURE__ */ o.forwardRef(function(e, t) {
  return /* @__PURE__ */ o.createElement(ND, Rn({}, DD(e), {
    inputRef: t
  }));
});
Gu.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: L.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: L.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: L.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: L.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: L.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: L.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: L.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: L.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: L.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: L.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: L.arrayOf(L.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: _u,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: L.oneOfType([L.string, L.arrayOf(L.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: L.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: L.objectOf(L.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: L.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: L.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: L.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: L.arrayOf(L.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: L.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: L.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: L.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: L.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: L.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: L.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: L.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: L.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: L.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: L.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: L.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: L.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: Ru,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: L.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: L.bool
};
var mc = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: Du,
  /**
   * Flag icon component.
   */
  flagComponent: Zl,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: io,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: L.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function DD(e) {
  e = Vu({}, e);
  for (var t in mc)
    e[t] === void 0 && (e[t] = mc[t]);
  return e;
}
function OD(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; ) {
    if (e[n] !== t[n])
      return !1;
    n++;
  }
  return !0;
}
const Ii = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var AD = ["metadata", "labels"];
function Li() {
  return Li = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Li.apply(this, arguments);
}
function TD(e, t) {
  if (e == null) return {};
  var n = kD(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function kD(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Yu(e) {
  var t = /* @__PURE__ */ o.forwardRef(function(n, r) {
    var a = n.metadata, i = a === void 0 ? e : a, l = n.labels, s = l === void 0 ? Ii : l, c = TD(n, AD);
    return /* @__PURE__ */ o.createElement(Gu, Li({}, c, {
      ref: r,
      metadata: i,
      labels: s
    }));
  });
  return t.propTypes = {
    metadata: Ru,
    labels: _u
  }, t;
}
Yu();
function Br(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(nu), e.apply(this, n);
}
Yu(nu);
function HD() {
  return Br(Cu, arguments);
}
function zL() {
  return Br(mz, arguments);
}
function NL() {
  return Br(pz, arguments);
}
function RD() {
  return Br(Di, arguments);
}
function Qo() {
  return Br(Ut, arguments);
}
var _D = ["title"], ID = ["title"], LD = ["title"], jD = ["title"], BD = ["title"], WD = ["title"], VD = ["title"], GD = ["title"], YD = ["title"], UD = ["title"], KD = ["title"], XD = ["title"], qD = ["title"], ZD = ["title"], JD = ["title"], QD = ["title"], eO = ["title"], tO = ["title"], nO = ["title"], rO = ["title"], aO = ["title"], oO = ["title"], iO = ["title"], lO = ["title"], sO = ["title"], cO = ["title"], dO = ["title"], uO = ["title"], fO = ["title"], hO = ["title"], mO = ["title"], vO = ["title"], pO = ["title"], gO = ["title"], yO = ["title"], bO = ["title"], wO = ["title"], $O = ["title"], EO = ["title"], xO = ["title"], MO = ["title"], CO = ["title"], PO = ["title"], SO = ["title"], FO = ["title"], zO = ["title"], NO = ["title"], DO = ["title"], OO = ["title"], AO = ["title"], TO = ["title"], kO = ["title"], HO = ["title"], RO = ["title"], _O = ["title"], IO = ["title"], LO = ["title"], jO = ["title"], BO = ["title"], WO = ["title"], VO = ["title"], GO = ["title"], YO = ["title"], UO = ["title"], KO = ["title"], XO = ["title"], qO = ["title"], ZO = ["title"], JO = ["title"], QO = ["title"], eA = ["title"], tA = ["title"], nA = ["title"], rA = ["title"], aA = ["title"], oA = ["title"], iA = ["title"], lA = ["title"], sA = ["title"], cA = ["title"], dA = ["title"], uA = ["title"], fA = ["title"], hA = ["title"], mA = ["title"], vA = ["title"], pA = ["title"], gA = ["title"], yA = ["title"], bA = ["title"], wA = ["title"], $A = ["title"], EA = ["title"], xA = ["title"], MA = ["title"], CA = ["title"], PA = ["title"], SA = ["title"], FA = ["title"], zA = ["title"], NA = ["title"], DA = ["title"], OA = ["title"], AA = ["title"], TA = ["title"], kA = ["title"], HA = ["title"], RA = ["title"], _A = ["title"], IA = ["title"], LA = ["title"], jA = ["title"], BA = ["title"], WA = ["title"], VA = ["title"], GA = ["title"], YA = ["title"], UA = ["title"], KA = ["title"], XA = ["title"], qA = ["title"], ZA = ["title"], JA = ["title"], QA = ["title"], eT = ["title"], tT = ["title"], nT = ["title"], rT = ["title"], aT = ["title"], oT = ["title"], iT = ["title"], lT = ["title"], sT = ["title"], cT = ["title"], dT = ["title"], uT = ["title"], fT = ["title"], hT = ["title"], mT = ["title"], vT = ["title"], pT = ["title"], gT = ["title"], yT = ["title"], bT = ["title"], wT = ["title"], $T = ["title"], ET = ["title"], xT = ["title"], MT = ["title"], CT = ["title"], PT = ["title"], ST = ["title"], FT = ["title"], zT = ["title"], NT = ["title"], DT = ["title"], OT = ["title"], AT = ["title"], TT = ["title"], kT = ["title"], HT = ["title"], RT = ["title"], _T = ["title"], IT = ["title"], LT = ["title"], jT = ["title"], BT = ["title"], WT = ["title"], VT = ["title"], GT = ["title"], YT = ["title"], UT = ["title"], KT = ["title"], XT = ["title"], qT = ["title"], ZT = ["title"], JT = ["title"], QT = ["title"], ek = ["title"], tk = ["title"], nk = ["title"], rk = ["title"], ak = ["title"], ok = ["title"], ik = ["title"], lk = ["title"], sk = ["title"], ck = ["title"], dk = ["title"], uk = ["title"], fk = ["title"], hk = ["title"], mk = ["title"], vk = ["title"], pk = ["title"], gk = ["title"], yk = ["title"], bk = ["title"], wk = ["title"], $k = ["title"], Ek = ["title"], xk = ["title"], Mk = ["title"], Ck = ["title"], Pk = ["title"], Sk = ["title"], Fk = ["title"], zk = ["title"], Nk = ["title"], Dk = ["title"], Ok = ["title"], Ak = ["title"], Tk = ["title"], kk = ["title"], Hk = ["title"], Rk = ["title"], _k = ["title"], Ik = ["title"], Lk = ["title"], jk = ["title"], Bk = ["title"], Wk = ["title"], Vk = ["title"], Gk = ["title"], Yk = ["title"], Uk = ["title"], Kk = ["title"], Xk = ["title"], qk = ["title"], Zk = ["title"], Jk = ["title"], Qk = ["title"], eH = ["title"], tH = ["title"], nH = ["title"], rH = ["title"], aH = ["title"], oH = ["title"], iH = ["title"], lH = ["title"], sH = ["title"], cH = ["title"], dH = ["title"], uH = ["title"], fH = ["title"], hH = ["title"], mH = ["title"], vH = ["title"], pH = ["title"], gH = ["title"], yH = ["title"], bH = ["title"], wH = ["title"], $H = ["title"];
function M() {
  return M = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M.apply(this, arguments);
}
function C(e, t) {
  if (e == null) return {};
  var n = EH(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function EH(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var Uu = function(t) {
  var n = t.title, r = C(t, _D);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }));
}, Ku = function(t) {
  var n = t.title, r = C(t, ID);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
    stroke: "#D80027",
    strokeWidth: 7
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
    stroke: "#D80027",
    strokeWidth: 5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#BC8B00",
    d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
  }));
}, Xu = function(t) {
  var n = t.title, r = C(t, LD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#009e49",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h171v342H0z"
  }));
}, qu = function(t) {
  var n = t.title, r = C(t, jD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#DB3E00",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#479900",
    d: "M331 0h182v342H331z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h181.8v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
  }));
}, Zu = function(t) {
  var n = t.title, r = C(t, BD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0072c6",
    d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#ce1126"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M256.5 342 0 0v342z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M513 342V0L256 342z"
  })));
}, Ju = function(t) {
  var n = t.title, r = C(t, WD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#8DCCFF",
    d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D87B00",
    d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D87B00",
    d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D87B00",
    d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
  }));
}, Qu = function(t) {
  var n = t.title, r = C(t, VD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED2024",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#212121",
    d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
    fill: "#212121"
  }));
}, e3 = function(t) {
  var n = t.title, r = C(t, GD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M0 228h513v114H0z"
  }));
}, t3 = function(t) {
  var n = t.title, r = C(t, YD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 171h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#000",
    d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
  })));
}, n3 = function(t) {
  var n = t.title, r = C(t, UD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 496"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#3A7DCE",
    d: "M0 0h744v496H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
  }));
}, r3 = function(t) {
  var n = t.title, r = C(t, KD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v114H0zm0 228h512v114H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    stroke: "#d6ab00",
    strokeWidth: 5,
    cx: 256.5,
    cy: 171,
    r: 40
  }));
}, a3 = function(t) {
  var n = t.title, r = C(t, XD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 287.18v24.58L81.72 171 513 30v24.16"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#EFC100",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
  }));
}, o3 = function(t) {
  var n = t.title, r = C(t, qD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0zm0 228h513v114H0z"
  }));
}, i3 = function(t) {
  var n = t.title, r = C(t, ZD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
    fill: "#D80027"
  }));
}, l3 = function(t) {
  var n = t.title, r = C(t, JD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363 242"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h363v242H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f30028",
    d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
    fill: "#FFDA44"
  }));
}, s3 = function(t) {
  var n = t.title, r = C(t, QD);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
  }));
}, c3 = function(t) {
  var n = t.title, r = C(t, eO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef3340",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00b5e2",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#509e2f",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
  })));
}, d3 = function(t) {
  var n = t.title, r = C(t, tO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#10338C",
    d: "M0 0h513.1v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F6C500",
    d: "M99.9 0h342v342"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
  })));
}, u3 = function(t) {
  var n = t.title, r = C(t, nO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc726",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#00267f"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
  }));
}, f3 = function(t) {
  var n = t.title, r = C(t, rO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#2d6e41",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#F40B32",
    cx: 218.902,
    cy: 256.5,
    r: 115
  }));
}, h3 = function(t) {
  var n = t.title, r = C(t, aO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#fdda25",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef3340",
    d: "M342 0h171v342H342z"
  }));
}, m3 = function(t) {
  var n = t.title, r = C(t, oO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#3d944f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
  }));
}, v3 = function(t) {
  var n = t.title, r = C(t, iO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#00966e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#d62612",
    d: "M0 228h513v114H0z"
  }));
}, p3 = function(t) {
  var n = t.title, r = C(t, lO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
  }));
}, g3 = function(t) {
  var n = t.title, r = C(t, sO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
    fill: "#47a644"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 251.6,
    cy: 170.7,
    r: 100.2
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
    fill: "#D80027",
    stroke: "#47a644",
    strokeWidth: 3
  }));
}, y3 = function(t) {
  var n = t.title, r = C(t, cO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#008751",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fcd116",
    d: "M196.666 85.333H513v171H196.666z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e8112d",
    d: "M196.666 256H513v171H196.666z"
  }));
}, b3 = function(t) {
  var n = t.title, r = C(t, dO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BC00",
    d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ADADAD",
    d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BC00",
    d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#125ECC",
    d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFE600",
    d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D60537",
    d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#EACE00",
    d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#7A6920",
    d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ADADAD",
    d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 258.2,
    cy: 204.19,
    r: 16.93
  }));
}, w3 = function(t) {
  var n = t.title, r = C(t, uO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#012169",
    d: "M0 .1h256.5v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#c8102e",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#c8102e",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ o.createElement("g", {
    transform: "translate(13 5)"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2F8F22",
    d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#65B5D2",
    cx: 383.65,
    cy: 214.56,
    r: 39.88
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c8102e",
    cx: 343.77,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c8102e",
    cx: 423.52,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c8102e",
    cx: 383.65,
    cy: 154.75,
    r: 19.94
  })));
}, $3 = function(t) {
  var n = t.title, r = C(t, fO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m0 193.74 513 127.19V214.26L0 97.08z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 234.26v-86.67L0 20.41v86.67"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
  })));
}, E3 = function(t) {
  var n = t.title, r = C(t, hO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f9e300",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#007934",
    d: "M0 228h513v114H0z"
  }));
}, x3 = function(t) {
  var n = t.title, r = C(t, mO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#012a87",
    d: "M0 342h513V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f9d90f",
    d: "M250.4 0H0v166.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#dc171d",
    d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    cx: 140.4,
    cy: 160.6,
    r: 57.7
  }));
}, M3 = function(t) {
  var n = t.title, r = C(t, vO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#009b3a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fedf00",
    d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002776",
    d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
  }));
}, C3 = function(t) {
  var n = t.title, r = C(t, pO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc72c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#00778b"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 171 0 342V0z"
  }));
}, P3 = function(t) {
  var n = t.title, r = C(t, gO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF7415",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 0H0v342"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 42,
    strokeMiterlimit: 10,
    d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
  }));
}, S3 = function(t) {
  var n = t.title, r = C(t, yO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  }));
}, F3 = function(t) {
  var n = t.title, r = C(t, bO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 238h513v104H0zM0 0h513v104H0z",
    fill: "#6da9d2"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 125.5h513v89.656H0z"
  }));
}, z3 = function(t) {
  var n = t.title, r = C(t, wO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#007C30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#CE1720",
    d: "M0 230h513V0H0"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100 230V0H0v342h513-413z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
    fill: "#CE1720"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
    fill: "none",
    stroke: "#CE1720",
    strokeWidth: 7
  }));
}, N3 = function(t) {
  var n = t.title, r = C(t, $O);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#003e87",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 260.9,
    cy: 170.9,
    r: 118.9
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "none",
    stroke: "#6DA544",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    cx: 261.9,
    cy: 173.1,
    r: 94.5
  }), /* @__PURE__ */ o.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#003e87",
    d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M211.3 128.1h101.3v46.7H211.3z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v35H0zm0 306h513v35H0z",
    fill: "#ce1127"
  }));
}, D3 = function(t) {
  var n = t.title, r = C(t, EO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
    fill: "red"
  }));
}, O3 = function(t) {
  var n = t.title, r = C(t, xO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "green",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
  }));
}, A3 = function(t) {
  var n = t.title, r = C(t, MO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
  }));
}, T3 = function(t) {
  var n = t.title, r = C(t, CO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#d21034",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
    fill: "#3a9927"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#003082",
    d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#ffce00"
  }));
}, k3 = function(t) {
  var n = t.title, r = C(t, PO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#da1a35",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#009543",
    d: "M443.726 85.331 102.4 426.657H0V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fbde4a",
    d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
  }));
}, H3 = function(t) {
  var n = t.title, r = C(t, SO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "red",
    d: "M0 85.337h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
  }));
}, R3 = function(t) {
  var n = t.title, r = C(t, FO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#009e60",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f77f00",
    d: "M0 0h171v342H0z"
  }));
}, _3 = function(t) {
  var n = t.title, r = C(t, zO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#01237a",
    d: "M0 85.332h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
  })));
}, I3 = function(t) {
  var n = t.title, r = C(t, NO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M196 0h317v171H196z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0037A1",
    d: "M0 0h196v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
  }));
}, L3 = function(t) {
  var n = t.title, r = C(t, DO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
    fill: "#fcd116"
  }));
}, j3 = function(t) {
  var n = t.title, r = C(t, OO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
    fill: "#FFDA44"
  }));
}, B3 = function(t) {
  var n = t.title, r = C(t, AO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 256.5h513V342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 171h513v85.5H0z"
  }));
}, W3 = function(t) {
  var n = t.title, r = C(t, TO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 285h513v57H0zM0 0h513v57H0z"
  }));
}, V3 = function(t) {
  var n = t.title, r = C(t, kO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M0-40.8v422.9-211.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
  }));
}, G3 = function(t) {
  var n = t.title, r = C(t, HO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#003893",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cf2027",
    d: "M0 182.2h513v41.4H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
    fill: "#f7d116",
    stroke: "#000"
  }));
}, Y3 = function(t) {
  var n = t.title, r = C(t, RO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f9e814",
    d: "M0 233.5h513v51H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
    fill: "#FFF"
  }));
}, U3 = function(t) {
  var n = t.title, r = C(t, _O);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1c8a42",
    d: "M0 0h513v342"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#ffc639",
    cx: 267.1,
    cy: 170.7,
    r: 74.5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1c8a42",
    d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc639",
    d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
  }));
}, K3 = function(t) {
  var n = t.title, r = C(t, IO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#DB7D00",
    d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#006651"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
  })));
}, X3 = function(t) {
  var n = t.title, r = C(t, LO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#11457e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#d7141a",
    d: "M513 171v171H0l215-171z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H215.185L0 0z"
  }));
}, q3 = function(t) {
  var n = t.title, r = C(t, jO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 228h513v114H0z"
  }));
}, Z3 = function(t) {
  var n = t.title, r = C(t, BO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6ab2e7",
    d: "M513 0v166.7L0 170.8V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#d7141a",
    d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
  }));
}, J3 = function(t) {
  var n = t.title, r = C(t, WO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  }));
}, Q3 = function(t) {
  var n = t.title, r = C(t, VO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 110.7v120h513v-120z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 110.7h513v40H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 190.7h513v40H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M196 0h120v342H196z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M196 0h40v342h-40z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M274.7 0h40v342h-40z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 170.7,
    r: 123.1
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
    fill: "#496E2D"
  }));
}, ef = function(t) {
  var n = t.title, r = C(t, GO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 215.2h211.5v126.1H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h211.5v126.2H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M300.5 0H512v126.2H300.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M300.5 215.2H512v126.1H300.5z"
  }), /* @__PURE__ */ o.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
  })));
}, tf = function(t) {
  var n = t.title, r = C(t, YO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#41662E",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0H513v342H256.5z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
  })));
}, nf = function(t) {
  var n = t.title, r = C(t, UO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 170.7h513V256H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 256h513v85.3H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 171,
    r: 60
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#4C1F00",
    d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#57BA17",
    d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
  }));
}, rf = function(t) {
  var n = t.title, r = C(t, KO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#111",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#368FD8",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 228h513v114H0z"
  }));
}, af = function(t) {
  var n = t.title, r = C(t, XO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#C09300",
    d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
  }));
}, of = function(t) {
  var n = t.title, r = C(t, qO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#428823",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
  })));
}, lf = function(t) {
  var n = t.title, r = C(t, ZO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m0 342 513-171L0 0v342z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#ffc945"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  })));
}, sf = function(t) {
  var n = t.title, r = C(t, JO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D03433",
    d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FBCA46",
    d: "M0 4h22.5v7H0V4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M7.8 7h1v.5h-1V7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A41517",
    d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A41517",
    d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
  }));
}, cf = function(t) {
  var n = t.title, r = C(t, QO);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#20AA46",
    d: "M0 0h22.5v5H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E92F3B",
    d: "M0 10h22.5v5H0v-5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FADF50",
    d: "M0 5h22.5v5H0V5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#205CCA",
    cx: 11.3,
    cy: 7.5,
    r: 5.2
  }), /* @__PURE__ */ o.createElement("g", {
    stroke: "#FFDB3D",
    fill: "none"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
    strokeWidth: 0.5
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
    strokeWidth: 0.25
  })));
}, df = function(t) {
  var n = t.title, r = C(t, eA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810 540"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FC0",
    d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
  }));
}, uf = function(t) {
  var n = t.title, r = C(t, tA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
  }));
}, ff = function(t) {
  var n = t.title, r = C(t, nA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#62b5e5",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256v170H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#F3F3F3",
    d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
  }));
}, hf = function(t) {
  var n = t.title, r = C(t, rA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1F8BDE",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#187536",
    d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
  }));
}, mf = function(t) {
  var n = t.title, r = C(t, aA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
    fill: "#FFF"
  }));
}, vf = function(t) {
  var n = t.title, r = C(t, oA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0F61A5",
    d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E50E3D",
    d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, pf = function(t) {
  var n = t.title, r = C(t, iA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, gf = function(t) {
  var n = t.title, r = C(t, lA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }));
}, yf = function(t) {
  var n = t.title, r = C(t, sA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v341.3H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z"
  })));
}, bf = function(t) {
  var n = t.title, r = C(t, cA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#c60a0a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#3E8446",
    d: "m256.5 170.7-212 126.1V44.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#3E8446",
    d: "M467.5 44.5v252.3l-211-126.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c60a0a",
    cx: 244.5,
    cy: 170.7,
    r: 76.2
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A2001D",
    cx: 99.1,
    cy: 182.1,
    r: 7.4
  }));
}, wf = function(t) {
  var n = t.title, r = C(t, dA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M.8 0h21v15H.8V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#eb000e",
    d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#eb000e",
    d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
  }));
}, $f = function(t) {
  var n = t.title, r = C(t, uA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FDEB01",
    d: "m0 0 90 60H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#58A846",
    d: "M90 0v60L0 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED3D24",
    d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
  }));
}, Ef = function(t) {
  var n = t.title, r = C(t, fA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
  }));
}, xf = function(t) {
  var n = t.title, r = C(t, hA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z"
  }));
}, Mf = function(t) {
  var n = t.title, r = C(t, mA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 230h513v112H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
  }));
}, Cf = function(t) {
  var n = t.title, r = C(t, vA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H0V0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 185.8,
    cy: 171.2,
    r: 117.8
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
  }));
}, Pf = function(t) {
  var n = t.title, r = C(t, pA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cf0d19",
    d: "M0 0h513v100H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 121h513v100H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1a7e25",
    d: "M0 242h513v100H0z"
  }));
}, Sf = function(t) {
  var n = t.title, r = C(t, gA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h171v342H0z"
  }));
}, Ff = function(t) {
  var n = t.title, r = C(t, yA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, zf = function(t) {
  var n = t.title, r = C(t, bA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v113.8H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 227.6h513V342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0070C8",
    d: "M126 171 0 342V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#786145",
    d: "M264.5 179.8h9.8l4 25.8h-17.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
    fill: "#FFDA00",
    stroke: "#000",
    strokeMiterlimit: 10
  }));
}, Nf = function(t) {
  var n = t.title, r = C(t, wA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#0d5eaf"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h190v190H0z"
  })), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 76h190v38H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M76 0h38v190H76z"
  })));
}, Df = function(t) {
  var n = t.title, r = C(t, $A);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFF",
    cx: 443.4,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 406.9,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 364,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#39B200",
    d: "m342 190.1 43.4 86.9 43.5-86.9z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#9B9B9B",
    cx: 327.5,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#757575",
    d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#C6B56F",
    cx: 385.4,
    cy: 67,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A54A00",
    cx: 386,
    cy: 88.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 443.4,
    cy: 117.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0049FF",
    cx: 342.2,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0041F9",
    cx: 429.8,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#F7D71E",
    cx: 386,
    cy: 233.6,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#CEC851",
    cx: 457.9,
    cy: 190.1,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 385.4,
    cy: 289.5,
    r: 29
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#7C0B29",
    d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 327.5,
    cy: 117.4,
    r: 29
  }));
}, Of = function(t) {
  var n = t.title, r = C(t, EA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#338AF3"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#DCC26D",
    cx: 256,
    cy: 155.8,
    r: 25.5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#628A40",
    d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
  }));
}, Af = function(t) {
  var n = t.title, r = C(t, xA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M11.1 11.1h489.7v319.1H11.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#7DBEF1",
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1C8AE6",
    d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF042",
    d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#259C7B",
    d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#8E5715",
    d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#D80027",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }));
}, Tf = function(t) {
  var n = t.title, r = C(t, MA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h182v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z"
  }));
}, kf = function(t) {
  var n = t.title, r = C(t, CA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#009E49",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m0 0 947 300L0 600V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFD00D",
    d: "M0 26.1 870 300 0 573.9V26.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2D2D2D",
    d: "m0 0 450 300L0 600V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D3132F",
    d: "m0 35 397.5 265L0 565V35z"
  }));
}, Hf = function(t) {
  var n = t.title, r = C(t, PA);
  return /* @__PURE__ */ o.createElement("svg", M({
    viewBox: "0 0.5 21 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
    fill: "#FFF"
  })));
}, Rf = function(t) {
  var n = t.title, r = C(t, SA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M223.4 170.7c.3-.3.5-.6.8-.9-.3.3-.5.6-.8.9zm-34.2 41.9 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }));
}, _f = function(t) {
  var n = t.title, r = C(t, FA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
    fill: "#338AF3"
  }));
}, If = function(t) {
  var n = t.title, r = C(t, zA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
    fill: "#338AF3"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#D80027",
    fill: "#FFF",
    d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
    fill: "#D80027"
  }));
}, Lf = function(t) {
  var n = t.title, r = C(t, NA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h513v172H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 172h513v172H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0052B4",
    cx: 270.7,
    cy: 182.3,
    r: 55.4
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A2001D",
    cx: 270.7,
    cy: 182.3,
    r: 27.7
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M229.1 113.1h83.1l-41.5 41.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256.8 140.8h27.7v83h-27.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
  }));
}, jf = function(t) {
  var n = t.title, r = C(t, DA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }));
}, Bf = function(t) {
  var n = t.title, r = C(t, OA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#fc0",
    d: "M0 0h300v200H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0768a9",
    d: "M0 0h200v200H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v200H0z"
  }));
}, Wf = function(t) {
  var n = t.title, r = C(t, AA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E00",
    d: "M0 0h513v171H0z"
  }));
}, Vf = function(t) {
  var n = t.title, r = C(t, TA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M342 0h171v342H342z"
  }));
}, Gf = function(t) {
  var n = t.title, r = C(t, kA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
    fill: "#2E52B2"
  }));
}, Yf = function(t) {
  var n = t.title, r = C(t, HA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#E52D42",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F8DD4E",
    d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
  }));
}, Uf = function(t) {
  var n = t.title, r = C(t, RA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#181A93",
    d: "M17.3 0h478.4v342H17.3V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFA44A",
    d: "M0 0h513v114H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1A9F0B",
    d: "M0 228h513v114H0V228z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0V114z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 34.2
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#181A93",
    d: "M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6zm0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#181A93",
    cx: 256.5,
    cy: 171,
    r: 22.8
  }));
}, Kf = function(t) {
  var n = t.title, r = C(t, _A);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h513V342H0V-.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h256v171H0V-.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
    fill: "#A2001D"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
  })), /* @__PURE__ */ o.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#5DA51E",
    stroke: "#45602C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E2DD24",
    stroke: "#525625",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
  }));
}, Xf = function(t) {
  var n = t.title, r = C(t, IA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
    fill: "#547C31"
  }));
}, qf = function(t) {
  var n = t.title, r = C(t, LA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
    fill: "#FFF",
    opacity: 0.5
  }));
}, Zf = function(t) {
  var n = t.title, r = C(t, jA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, Jf = function(t) {
  var n = t.title, r = C(t, BA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M342 0H0v341.3h512V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, Qf = function(t) {
  var n = t.title, r = C(t, WA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
  }));
}, e4 = function(t) {
  var n = t.title, r = C(t, VA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }));
}, t4 = function(t) {
  var n = t.title, r = C(t, GA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256.5 170.7 0 341.3V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
  }));
}, n4 = function(t) {
  var n = t.title, r = C(t, YA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#D80027",
    cx: 256.5,
    cy: 171,
    r: 96
  }));
}, r4 = function(t) {
  var n = t.title, r = C(t, UA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h512v90.579H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 251h513v91H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
    fill: "#A2001D"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z"
  }));
}, a4 = function(t) {
  var n = t.title, r = C(t, KA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 256,
    cy: 170.7,
    r: 170.7
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#D80027",
    cx: 257.4,
    cy: 170.7,
    r: 71.6
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
    fill: "#FFDA44"
  }));
}, o4 = function(t) {
  var n = t.title, r = C(t, XA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
  }));
}, i4 = function(t) {
  var n = t.title, r = C(t, qA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FCD116"
  }, /* @__PURE__ */ o.createElement("circle", {
    cx: 227.6,
    cy: 161.2,
    r: 56.2
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#003F87",
    d: "M0 175h450v125H0V175z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  }), /* @__PURE__ */ o.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCD116",
    d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
  }));
}, l4 = function(t) {
  var n = t.title, r = C(t, ZA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v85.5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513V171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 171h513v85.5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M256.5 171 0 342V0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  })));
}, s4 = function(t) {
  var n = t.title, r = C(t, JA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 0H0v342"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
    fill: "#FFF"
  }));
}, c4 = function(t) {
  var n = t.title, r = C(t, QA);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#91DC5A",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 79.9h513v181.582H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 190.33,
    cy: 171,
    r: 65.668
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
  }));
}, d4 = function(t) {
  var n = t.title, r = C(t, eT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    transform: "rotate(-56.31)"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  }));
}, u4 = function(t) {
  var n = t.title, r = C(t, tT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M167 227.6 0 341.3V0l167 113.8z"
  }));
}, f4 = function(t) {
  var n = t.title, r = C(t, nT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#6DA544",
    cx: 384,
    cy: 96.5,
    r: 29.7
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M332.1 89H436v44.5H332.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M435.9 170.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
    fill: "#F3F3F3"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })));
}, h4 = function(t) {
  var n = t.title, r = C(t, rT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#36B6CC",
    d: "M0 0h513v342H0V0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFD400",
    cx: 256.5,
    cy: 170.9,
    r: 68.4
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFD400",
    d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
  }));
}, m4 = function(t) {
  var n = t.title, r = C(t, aT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 65.9
  }));
}, v4 = function(t) {
  var n = t.title, r = C(t, oT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#14AF5A",
    d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
  }));
}, p4 = function(t) {
  var n = t.title, r = C(t, iT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#55B2FF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F3F3F3",
    d: "M148.5 298.1h216l-108-254.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#333",
    d: "m186 272.7 70.5-160.3L327 272.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M148.5 298.1h216l-108-101.7z"
  }));
}, g4 = function(t) {
  var n = t.title, r = C(t, lT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
  }));
}, y4 = function(t) {
  var n = t.title, r = C(t, sT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M222.6 22.3h267.1v296.8H222.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M22.3 22.3h200.3v296.8H22.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M200.3 0h22.3v342h-22.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M22.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M111.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#FFDA44",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
  }));
}, b4 = function(t) {
  var n = t.title, r = C(t, cT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
    fill: "#bf0a30"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002868",
    d: "M0 0h155.6v155.6H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
  }));
}, w4 = function(t) {
  var n = t.title, r = C(t, dT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 227.6h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
  }));
}, $4 = function(t) {
  var n = t.title, r = C(t, uT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }));
}, E4 = function(t) {
  var n = t.title, r = C(t, fT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 228h513v114H0z"
  }));
}, x4 = function(t) {
  var n = t.title, r = C(t, hT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    className: "prefix__st1",
    d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
    fill: "#A2001D"
  }));
}, M4 = function(t) {
  var n = t.title, r = C(t, mT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z"
  })));
}, C4 = function(t) {
  var n = t.title, r = C(t, vT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 .3V342h513V.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#20661B",
    d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
  }));
}, P4 = function(t) {
  var n = t.title, r = C(t, pT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#c70000",
    d: "M0 85.333h512V256H0z"
  }));
}, S4 = function(t) {
  var n = t.title, r = C(t, gT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#AF7F59",
    d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
  }));
}, F4 = function(t) {
  var n = t.title, r = C(t, yT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BE53",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E01D24",
    d: "M20 20h473v302H20z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BE53",
    d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#215F90",
    d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
  }));
}, z4 = function(t) {
  var n = t.title, r = C(t, bT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 72"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h108v72H0z",
    fill: "#003787"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h108L60 48v24H48V48z",
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 54,
    cy: 30,
    r: 8,
    fill: "#f9d90f"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M44 30h20L54 48z",
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M54 48 38 33h32z",
    fill: "#cf142b"
  }));
}, N4 = function(t) {
  var n = t.title, r = C(t, wT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 426.666V85.329H0v341.337h512z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331H0v170.666h512V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h181.793v341.337H0z"
  }));
}, D4 = function(t) {
  var n = t.title, r = C(t, $T);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#1E509C",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 176.1V81.3L0 342l513-165.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F18D36",
    d: "M513 0v81.3L0 342 513 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
  }));
}, O4 = function(t) {
  var n = t.title, r = C(t, ET);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
}, A4 = function(t) {
  var n = t.title, r = C(t, xT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, T4 = function(t) {
  var n = t.title, r = C(t, MT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
  }));
}, k4 = function(t) {
  var n = t.title, r = C(t, CT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#095FAD",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M342 0h171v342H342zM0 0h171v342H0z",
    fill: "#BE1229"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 86,
    cy: 203.4,
    r: 14.8
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 86,
    cy: 144,
    r: 14.8
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M76.3 123.9h19.5L86 108.3z"
  })));
}, H4 = function(t) {
  var n = t.title, r = C(t, PT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#00745a",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
    fill: "#FFF"
  }));
}, R4 = function(t) {
  var n = t.title, r = C(t, ST);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0071BC",
    d: "M0 0h750v500H0V0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.9
  }, /* @__PURE__ */ o.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 225,
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 165,
    fill: "#0071BC"
  })), /* @__PURE__ */ o.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#8C8A8C",
    strokeWidth: 1.9,
    d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
  })));
}, _4 = function(t) {
  var n = t.title, r = C(t, FT);
  return /* @__PURE__ */ o.createElement("svg", M({
    viewBox: "0 0 900 600",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#231f1e",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00a650",
    d: "M0 0h900v300H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef1923",
    d: "m0 0 450 300L0 600z"
  }));
}, I4 = function(t) {
  var n = t.title, r = C(t, zT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 100 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#006233",
    d: "M0 100h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 100h513v46H0zm0 296h513v46H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc400",
    d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc400",
    d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
  }));
}, L4 = function(t) {
  var n = t.title, r = C(t, NT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#1B4991",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00A2B8",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A35023",
    d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
  }));
}, j4 = function(t) {
  var n = t.title, r = C(t, DT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#C31B28",
    d: "M256 0h256.5v342H256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ACABB1",
    stroke: "#C31B28",
    strokeWidth: 2,
    d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
  }));
}, B4 = function(t) {
  var n = t.title, r = C(t, OT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#f7ce00",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e32737",
    d: "M0 85.331h512v85.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#191f6a",
    d: "M0 170.657h512v85.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00a04e",
    d: "M0 341.331h512v85.337H0z"
  }));
}, W4 = function(t) {
  var n = t.title, r = C(t, AT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#d01920",
    d: "M0 85.331h512v341.333H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#017c3b",
    d: "M144.696 174.375h222.609v163.25H144.696z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
  }));
}, V4 = function(t) {
  var n = t.title, r = C(t, TT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#272727",
    d: "M0 0h512v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e40112",
    d: "M0 114h512v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#07893f",
    d: "M0 228h512v114H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#e40112",
    cx: 256,
    cy: 125,
    r: 95
  }));
}, G4 = function(t) {
  var n = t.title, r = C(t, kT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#dc2339",
    d: "M342 0H0v341.3h513V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#11865d",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M171 0h171v342H171z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#8C9157",
    d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#C59262",
    cx: 256.5,
    cy: 159.1,
    rx: 24.3,
    ry: 36.4
  }));
}, Y4 = function(t) {
  var n = t.title, r = C(t, HT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
    fill: "#c00"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#006",
    d: "M0 0h256.5v195.4H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
    fill: "#fc0"
  }));
}, U4 = function(t) {
  var n = t.title, r = C(t, RT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f4d900",
    d: "M0 323.333h513v104H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#006d66",
    d: "M0 85.333h513v104H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 204.333h513v104H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cb0f31",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f4d900",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, K4 = function(t) {
  var n = t.title, r = C(t, _T);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
  }));
}, X4 = function(t) {
  var n = t.title, r = C(t, IT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  }), /* @__PURE__ */ o.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  }));
}, q4 = function(t) {
  var n = t.title, r = C(t, LT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e05206",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0db02b",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#e05206",
    cx: 256,
    cy: 256,
    r: 32
  }));
}, Z4 = function(t) {
  var n = t.title, r = C(t, jT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
    fill: "#007b23"
  }));
}, J4 = function(t) {
  var n = t.title, r = C(t, BT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342z",
    fill: "#007b23"
  }));
}, Q4 = function(t) {
  var n = t.title, r = C(t, WT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#338AF3"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  }));
}, e5 = function(t) {
  var n = t.title, r = C(t, VT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cd1f2a",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1d4185",
    d: "M0 228h513v114H0z"
  }));
}, t5 = function(t) {
  var n = t.title, r = C(t, GT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, n5 = function(t) {
  var n = t.title, r = C(t, YT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
  })));
}, r5 = function(t) {
  var n = t.title, r = C(t, UT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 239.994h512v32H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
  }));
}, a5 = function(t) {
  var n = t.title, r = C(t, KT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  })), /* @__PURE__ */ o.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
    fill: "#FFDA44"
  }));
}, o5 = function(t) {
  var n = t.title, r = C(t, XT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
    fill: "#D80027"
  }));
}, i5 = function(t) {
  var n = t.title, r = C(t, qT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M138 0h377v114H138z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#4A7C3A",
    d: "M138 230h377v114H138z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 10,
    strokeMiterlimit: 2
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
  })));
}, l5 = function(t) {
  var n = t.title, r = C(t, ZT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 256v170.663H0V256h256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H256V85.337h256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }));
}, s5 = function(t) {
  var n = t.title, r = C(t, JT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
    fill: "#D80027"
  }));
}, c5 = function(t) {
  var n = t.title, r = C(t, QT);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
    fill: "#D80027"
  }));
}, d5 = function(t) {
  var n = t.title, r = C(t, ek);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 85.33h512v341.332"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
  }));
}, u5 = function(t) {
  var n = t.title, r = C(t, tk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M512 85.337V256H256L0 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 256v170.663H0L256 256z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
    fill: "#FFDA44"
  }));
}, f5 = function(t) {
  var n = t.title, r = C(t, nk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.343h512v341.326H0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#01411c",
    d: "M128 85.331h384v341.337H128z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
    fill: "#FFF"
  }));
}, h5 = function(t) {
  var n = t.title, r = C(t, rk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512V256H0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v170.663H0z"
  }));
}, m5 = function(t) {
  var n = t.title, r = C(t, ak);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 26.666 640 426.666"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  })));
}, v5 = function(t) {
  var n = t.title, r = C(t, ok);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, p5 = function(t) {
  var n = t.title, r = C(t, ik);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, g5 = function(t) {
  var n = t.title, r = C(t, lk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#268024",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e4312b",
    d: "M256 256.006 0 426.668V85.331z"
  }));
}, y5 = function(t) {
  var n = t.title, r = C(t, sk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M196.641 85.337v341.326H0V85.337z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
  }));
}, b5 = function(t) {
  var n = t.title, r = C(t, ck);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 218.902,
    cy: 255.994,
    r: 74.207
  }));
}, w5 = function(t) {
  var n = t.title, r = C(t, dk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
  }));
}, $5 = function(t) {
  var n = t.title, r = C(t, uk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#751A46",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
  }));
}, E5 = function(t) {
  var n = t.title, r = C(t, fk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 26.666 640 426.666"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  })));
}, x5 = function(t) {
  var n = t.title, r = C(t, hk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, M5 = function(t) {
  var n = t.title, r = C(t, mk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
  }));
}, C5 = function(t) {
  var n = t.title, r = C(t, vk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.33v341.332h512V85.33z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 312.884h512v113.775H0z"
  }));
}, P5 = function(t) {
  var n = t.title, r = C(t, pk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 255.994h512v81.619H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 337.614h512v89.043H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
  }));
}, S5 = function(t) {
  var n = t.title, r = C(t, gk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#055e1c",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M207.093 248.57h32.601v22.261h-32.601z"
  })));
}, F5 = function(t) {
  var n = t.title, r = C(t, yk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.329h512"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
    fill: "#FFF"
  }));
}, z5 = function(t) {
  var n = t.title, r = C(t, bk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M235.454 85.337 0 426.663 427.345 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 329.393 0 426.663h512z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337h-84.655L0 426.663l512-204.512z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337v341.326L235.454 85.337z"
  }));
}, N5 = function(t) {
  var n = t.title, r = C(t, wk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 426.668V85.331l256 170.675z"
  }));
}, D5 = function(t) {
  var n = t.title, r = C(t, $k);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
  }));
}, O5 = function(t) {
  var n = t.title, r = C(t, Ek);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512V256H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
  })));
}, A5 = function(t) {
  var n = t.title, r = C(t, xk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffda44",
    d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#BF521B",
    d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#474747",
    d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
  }));
}, T5 = function(t) {
  var n = t.title, r = C(t, Mk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 199.112h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
  }));
}, k5 = function(t) {
  var n = t.title, r = C(t, Ck);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, H5 = function(t) {
  var n = t.title, r = C(t, Pk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 196.641h512v118.717H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 315.359h512v111.304H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
  }));
}, R5 = function(t) {
  var n = t.title, r = C(t, Sk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
}, _5 = function(t) {
  var n = t.title, r = C(t, Fk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.34h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 85.334v166.69L0 256.175V85.334z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
  }));
}, I5 = function(t) {
  var n = t.title, r = C(t, zk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
    fill: "#496E2D"
  }));
}, L5 = function(t) {
  var n = t.title, r = C(t, Nk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
  }));
}, j5 = function(t) {
  var n = t.title, r = C(t, Dk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 196.636h512v118.728H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
  }));
}, B5 = function(t) {
  var n = t.title, r = C(t, Ok);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
  }));
}, W5 = function(t) {
  var n = t.title, r = C(t, Ak);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
  }));
}, V5 = function(t) {
  var n = t.title, r = C(t, Tk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M228.582 261.936 256 214.447l27.418 47.489z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
  }));
}, G5 = function(t) {
  var n = t.title, r = C(t, kk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331v166.69L0 256.173V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 118.862,
    cy: 210.287,
    r: 18.286
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F3F3F3",
    d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
  }));
}, Y5 = function(t) {
  var n = t.title, r = C(t, Hk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m187.31 215.184 9.208 28.341h29.802l-24.11 17.518 9.209 28.342-24.109-17.516-24.11 17.516 9.209-28.342-24.109-17.518h29.801zm137.38 0 9.209 28.341H363.7l-24.109 17.518 9.209 28.342-24.11-17.516-24.109 17.516 9.209-28.342-24.11-17.518h29.802z",
    fill: "#6DA544"
  }));
}, U5 = function(t) {
  var n = t.title, r = C(t, Rk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#2B5DEA",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDF29",
    d: "M0 100h900v400H0V100z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D70000",
    d: "M0 150h900v300H0V150z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }));
}, K5 = function(t) {
  var n = t.title, r = C(t, _k);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "m385.4 251.7-22.9-43h45.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m385.4 165.8-22.9 42.9h45.8z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 474.8,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 295.3,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#A5A5A5",
    cx: 386.3,
    cy: 104.3,
    rx: 34.3,
    ry: 23.3
  }));
}, X5 = function(t) {
  var n = t.title, r = C(t, Ik);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, q5 = function(t) {
  var n = t.title, r = C(t, Lk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, Z5 = function(t) {
  var n = t.title, r = C(t, jk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#073AB6",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h11.3v7.5H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F44653",
    d: "M7.1 0h3.6v7H7.1V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1035BB",
    d: "M0 0h3.6v7H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
  }));
}, J5 = function(t) {
  var n = t.title, r = C(t, Bk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
    fill: "#496E2D"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h204.054v204.054H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
  }));
}, Q5 = function(t) {
  var n = t.title, r = C(t, Wk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512V426.66H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 194.056h512v123.882H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
    fill: "#D80027"
  }));
}, eh = function(t) {
  var n = t.title, r = C(t, Vk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
    fill: "#FFDA44"
  }));
}, th = function(t) {
  var n = t.title, r = C(t, Gk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
    fill: "#FFDA44"
  }));
}, nh = function(t) {
  var n = t.title, r = C(t, Yk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 90.691v330.618L189.217 256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
  }));
}, rh = function(t) {
  var n = t.title, r = C(t, Uk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M83.478 85.337h89.043v341.326H83.478z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
    fill: "#496E2D"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M120.576 248.576h14.84v14.84h-14.84z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 128,
    cy: 206.113,
    r: 7.421
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 128,
    cy: 305.887,
    r: 7.421
  })));
}, ah = function(t) {
  var n = t.title, r = C(t, Kk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 255.994,
    r: 96
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
  })));
}, oh = function(t) {
  var n = t.title, r = C(t, Xk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
  }));
}, ih = function(t) {
  var n = t.title, r = C(t, qk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
  }));
}, lh = function(t) {
  var n = t.title, r = C(t, Zk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
  }));
}, sh = function(t) {
  var n = t.title, r = C(t, Jk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00B2EE",
    d: "M0 300h450V0h450v600H0V300z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M449.9 39.9v53.9h-81z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
  }));
}, ch = function(t) {
  var n = t.title, r = C(t, Qk);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h256V256H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0052B4",
    cx: 128,
    cy: 170.674,
    r: 29.006
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
  }));
}, dh = function(t) {
  var n = t.title, r = C(t, eH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }));
}, uh = function(t) {
  var n = t.title, r = C(t, tH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512V256H0z"
  }));
}, fh = function(t) {
  var n = t.title, r = C(t, nH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#232323",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 56.9h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D32300",
    d: "M0 113.8h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 227.6h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D32300",
    d: "M0 284.4h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 170.7,
    r: 80.7
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
  }));
}, hh = function(t) {
  var n = t.title, r = C(t, rH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, mh = function(t) {
  var n = t.title, r = C(t, aH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, vh = function(t) {
  var n = t.title, r = C(t, oH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
    fill: "#0038a8"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h256.5v190H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FED443",
    d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
  }));
}, ph = function(t) {
  var n = t.title, r = C(t, iH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
    fill: "#FFF"
  }));
}, gh = function(t) {
  var n = t.title, r = C(t, lH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.331h256v341.337H256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ACABB1",
    d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
  }));
}, yh = function(t) {
  var n = t.title, r = C(t, sH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
    fill: "#6DA544"
  }));
}, bh = function(t) {
  var n = t.title, r = C(t, cH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFCE00",
    d: "M0 0h22.5v5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#203899",
    d: "M0 5h22.5v5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D82B2B",
    d: "M0 10h22.5v5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
  }));
}, wh = function(t) {
  var n = t.title, r = C(t, dH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M372.87 215.181h22.261v59.359H372.87z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A2001D",
    cx: 384,
    cy: 215.181,
    r: 11.13
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
    fill: "#FFDA44"
  }));
}, $h = function(t) {
  var n = t.title, r = C(t, uH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#409347",
    d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFD836",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M201.3 111.8h119.4v37.9H201.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
  }));
}, Eh = function(t) {
  var n = t.title, r = C(t, fH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M196.641 85.337H0v341.326h512V85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
  }));
}, xh = function(t) {
  var n = t.title, r = C(t, hH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 256v170.663H0L215.185 256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H215.185L0 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
  })));
}, Mh = function(t) {
  var n = t.title, r = C(t, mH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED2939",
    d: "M0 0h150v100H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002395",
    d: "M0 0h20v44.33H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M20 0h20v44.33H20z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M0 44.33h62.75V0"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
  }));
}, Ch = function(t) {
  var n = t.title, r = C(t, vH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
    fill: "#FFF"
  }));
}, Ph = function(t) {
  var n = t.title, r = C(t, pH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.34H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
  }));
}, Sh = function(t) {
  var n = t.title, r = C(t, gH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }));
}, Fh = function(t) {
  var n = t.title, r = C(t, yH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#7f7f7f",
    strokeWidth: 0.25,
    fill: "#ABABAB",
    d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#DE393A",
    d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#3951A3",
    d: "M31 13.1h28v15.7H31z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FEE05F",
    cx: 39.1,
    cy: 36.5,
    r: 3
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FEE05F",
    cx: 50.9,
    cy: 36.5,
    r: 3
  }));
}, zh = function(t) {
  var n = t.title, r = C(t, bH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M114.024 256.001 0 141.926v228.17z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffb915",
    d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#007847",
    d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#000c8a",
    d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e1392d",
    d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
  }));
}, Nh = function(t) {
  var n = t.title, r = C(t, wH);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 255.994h56.888v170.663h-56.888z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M455.112 255.994H512v170.663h-56.888z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M398.225 255.994h56.888v170.663h-56.888z"
  }));
}, Dh = function(t) {
  var n = t.title, r = C(t, $H);
  return /* @__PURE__ */ o.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#057f44",
    d: "M0 85.333h512v48.868H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#057f44",
    d: "M0 378.542h512v48.128H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
  }));
};
const xH = {
  AC: Uu,
  AD: Ku,
  AE: Xu,
  AF: qu,
  AG: Zu,
  AI: Ju,
  AL: Qu,
  AM: e3,
  AO: t3,
  AQ: n3,
  AR: r3,
  AS: a3,
  AT: o3,
  AU: i3,
  AW: l3,
  AX: s3,
  AZ: c3,
  BA: d3,
  BB: u3,
  BD: f3,
  BE: h3,
  BF: m3,
  BG: v3,
  BH: p3,
  BI: g3,
  BJ: y3,
  BL: b3,
  BM: w3,
  BN: $3,
  BO: E3,
  BQ: x3,
  BR: M3,
  BS: C3,
  BT: P3,
  BV: S3,
  BW: F3,
  BY: z3,
  BZ: N3,
  CA: D3,
  CC: O3,
  CD: A3,
  CF: T3,
  CG: k3,
  CH: H3,
  CI: R3,
  CK: _3,
  CL: I3,
  CM: L3,
  CN: j3,
  CO: B3,
  CR: W3,
  CU: V3,
  CV: G3,
  CW: Y3,
  CX: U3,
  CY: K3,
  CZ: X3,
  DE: q3,
  DJ: Z3,
  DK: J3,
  DM: Q3,
  DO: ef,
  DZ: tf,
  EC: nf,
  EE: rf,
  EG: af,
  EH: of,
  ER: lf,
  ES: sf,
  ET: cf,
  EU: df,
  FI: uf,
  FJ: ff,
  FK: hf,
  FM: mf,
  FO: vf,
  FR: pf,
  GA: gf,
  GB: yf,
  GD: bf,
  GE: wf,
  GF: $f,
  GG: Ef,
  GH: xf,
  GI: Mf,
  GL: Cf,
  GM: Pf,
  GN: Sf,
  GP: Ff,
  GQ: zf,
  GR: Nf,
  GS: Df,
  GT: Of,
  GU: Af,
  GW: Tf,
  GY: kf,
  HK: Hf,
  HM: Rf,
  HN: _f,
  HR: If,
  HT: Lf,
  HU: jf,
  IC: Bf,
  ID: Wf,
  IE: Vf,
  IL: Gf,
  IM: Yf,
  IN: Uf,
  IO: Kf,
  IQ: Xf,
  IR: qf,
  IS: Zf,
  IT: Jf,
  JE: Qf,
  JM: e4,
  JO: t4,
  JP: n4,
  KE: r4,
  KG: a4,
  KH: o4,
  KI: i4,
  KM: l4,
  KN: s4,
  KP: c4,
  KR: d4,
  KW: u4,
  KY: f4,
  KZ: h4,
  LA: m4,
  LB: v4,
  LC: p4,
  LI: g4,
  LK: y4,
  LR: b4,
  LS: w4,
  LT: $4,
  LU: E4,
  LV: x4,
  LY: M4,
  MA: C4,
  MC: P4,
  MD: S4,
  ME: F4,
  MF: z4,
  MG: N4,
  MH: D4,
  MK: O4,
  ML: A4,
  MM: T4,
  MN: k4,
  MO: H4,
  MP: R4,
  MQ: _4,
  MR: I4,
  MS: L4,
  MT: j4,
  MU: B4,
  MV: W4,
  MW: V4,
  MX: G4,
  MY: Y4,
  MZ: U4,
  NA: K4,
  NC: X4,
  NE: q4,
  NF: Z4,
  NG: J4,
  NI: Q4,
  NL: e5,
  NO: t5,
  NP: n5,
  NR: r5,
  NU: a5,
  NZ: o5,
  OM: i5,
  PA: l5,
  PE: s5,
  PF: c5,
  PG: d5,
  PH: u5,
  PK: f5,
  PL: h5,
  PM: m5,
  PN: v5,
  PR: p5,
  PS: g5,
  PT: y5,
  PW: b5,
  PY: w5,
  QA: $5,
  RE: E5,
  RO: x5,
  RS: M5,
  RU: C5,
  RW: P5,
  SA: S5,
  SB: F5,
  SC: z5,
  SD: N5,
  SE: D5,
  SG: O5,
  SH: A5,
  SI: T5,
  SJ: k5,
  SK: H5,
  SL: R5,
  SM: _5,
  SN: I5,
  SO: L5,
  SR: j5,
  SS: B5,
  ST: W5,
  SV: V5,
  SX: G5,
  SY: Y5,
  SZ: U5,
  TA: K5,
  TC: X5,
  TD: q5,
  TF: Z5,
  TG: J5,
  TH: Q5,
  TJ: eh,
  TK: th,
  TL: nh,
  TM: rh,
  TN: ah,
  TO: oh,
  TR: ih,
  TT: lh,
  TV: sh,
  TW: ch,
  TZ: dh,
  UA: uh,
  UG: fh,
  UM: hh,
  US: mh,
  UY: vh,
  UZ: ph,
  VA: gh,
  VC: yh,
  VE: bh,
  VG: wh,
  VI: $h,
  VN: Eh,
  VU: xh,
  WF: Mh,
  WS: Ch,
  XK: Ph,
  YE: Sh,
  YT: Fh,
  ZA: zh,
  ZM: Nh,
  ZW: Dh
}, Oh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AC: Uu,
  AD: Ku,
  AE: Xu,
  AF: qu,
  AG: Zu,
  AI: Ju,
  AL: Qu,
  AM: e3,
  AO: t3,
  AQ: n3,
  AR: r3,
  AS: a3,
  AT: o3,
  AU: i3,
  AW: l3,
  AX: s3,
  AZ: c3,
  BA: d3,
  BB: u3,
  BD: f3,
  BE: h3,
  BF: m3,
  BG: v3,
  BH: p3,
  BI: g3,
  BJ: y3,
  BL: b3,
  BM: w3,
  BN: $3,
  BO: E3,
  BQ: x3,
  BR: M3,
  BS: C3,
  BT: P3,
  BV: S3,
  BW: F3,
  BY: z3,
  BZ: N3,
  CA: D3,
  CC: O3,
  CD: A3,
  CF: T3,
  CG: k3,
  CH: H3,
  CI: R3,
  CK: _3,
  CL: I3,
  CM: L3,
  CN: j3,
  CO: B3,
  CR: W3,
  CU: V3,
  CV: G3,
  CW: Y3,
  CX: U3,
  CY: K3,
  CZ: X3,
  DE: q3,
  DJ: Z3,
  DK: J3,
  DM: Q3,
  DO: ef,
  DZ: tf,
  EC: nf,
  EE: rf,
  EG: af,
  EH: of,
  ER: lf,
  ES: sf,
  ET: cf,
  EU: df,
  FI: uf,
  FJ: ff,
  FK: hf,
  FM: mf,
  FO: vf,
  FR: pf,
  GA: gf,
  GB: yf,
  GD: bf,
  GE: wf,
  GF: $f,
  GG: Ef,
  GH: xf,
  GI: Mf,
  GL: Cf,
  GM: Pf,
  GN: Sf,
  GP: Ff,
  GQ: zf,
  GR: Nf,
  GS: Df,
  GT: Of,
  GU: Af,
  GW: Tf,
  GY: kf,
  HK: Hf,
  HM: Rf,
  HN: _f,
  HR: If,
  HT: Lf,
  HU: jf,
  IC: Bf,
  ID: Wf,
  IE: Vf,
  IL: Gf,
  IM: Yf,
  IN: Uf,
  IO: Kf,
  IQ: Xf,
  IR: qf,
  IS: Zf,
  IT: Jf,
  JE: Qf,
  JM: e4,
  JO: t4,
  JP: n4,
  KE: r4,
  KG: a4,
  KH: o4,
  KI: i4,
  KM: l4,
  KN: s4,
  KP: c4,
  KR: d4,
  KW: u4,
  KY: f4,
  KZ: h4,
  LA: m4,
  LB: v4,
  LC: p4,
  LI: g4,
  LK: y4,
  LR: b4,
  LS: w4,
  LT: $4,
  LU: E4,
  LV: x4,
  LY: M4,
  MA: C4,
  MC: P4,
  MD: S4,
  ME: F4,
  MF: z4,
  MG: N4,
  MH: D4,
  MK: O4,
  ML: A4,
  MM: T4,
  MN: k4,
  MO: H4,
  MP: R4,
  MQ: _4,
  MR: I4,
  MS: L4,
  MT: j4,
  MU: B4,
  MV: W4,
  MW: V4,
  MX: G4,
  MY: Y4,
  MZ: U4,
  NA: K4,
  NC: X4,
  NE: q4,
  NF: Z4,
  NG: J4,
  NI: Q4,
  NL: e5,
  NO: t5,
  NP: n5,
  NR: r5,
  NU: a5,
  NZ: o5,
  OM: i5,
  PA: l5,
  PE: s5,
  PF: c5,
  PG: d5,
  PH: u5,
  PK: f5,
  PL: h5,
  PM: m5,
  PN: v5,
  PR: p5,
  PS: g5,
  PT: y5,
  PW: b5,
  PY: w5,
  QA: $5,
  RE: E5,
  RO: x5,
  RS: M5,
  RU: C5,
  RW: P5,
  SA: S5,
  SB: F5,
  SC: z5,
  SD: N5,
  SE: D5,
  SG: O5,
  SH: A5,
  SI: T5,
  SJ: k5,
  SK: H5,
  SL: R5,
  SM: _5,
  SN: I5,
  SO: L5,
  SR: j5,
  SS: B5,
  ST: W5,
  SV: V5,
  SX: G5,
  SY: Y5,
  SZ: U5,
  TA: K5,
  TC: X5,
  TD: q5,
  TF: Z5,
  TG: J5,
  TH: Q5,
  TJ: eh,
  TK: th,
  TL: nh,
  TM: rh,
  TN: ah,
  TO: oh,
  TR: ih,
  TT: lh,
  TV: sh,
  TW: ch,
  TZ: dh,
  UA: uh,
  UG: fh,
  UM: hh,
  US: mh,
  UY: vh,
  UZ: ph,
  VA: gh,
  VC: yh,
  VE: bh,
  VG: wh,
  VI: $h,
  VN: Eh,
  VU: xh,
  WF: Mh,
  WS: Ch,
  XK: Ph,
  YE: Sh,
  YT: Fh,
  ZA: zh,
  ZM: Nh,
  ZW: Dh,
  default: xH
}, Symbol.toStringTag, { value: "Module" }));
function vc(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Ah(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var MH = [" ", "Enter", "ArrowUp", "ArrowDown"], CH = [" ", "Enter"], Wr = "Select", [so, co, PH] = _a(Wr), [qn] = Rr(Wr, [
  PH,
  Ka
]), uo = Ka(), [SH, cn] = qn(Wr), [FH, zH] = qn(Wr), Ql = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    value: l,
    defaultValue: s,
    onValueChange: c,
    dir: d,
    name: f,
    autoComplete: u,
    disabled: h,
    required: p,
    form: y
  } = e, m = uo(t), [b, $] = g.useState(null), [w, E] = g.useState(null), [P, x] = g.useState(!1), F = Ia(d), [z = !1, N] = At({
    prop: r,
    defaultProp: a,
    onChange: i
  }), [A, _] = At({
    prop: l,
    defaultProp: s,
    onChange: c
  }), B = g.useRef(null), j = b ? y || !!b.closest("form") : !0, [ee, R] = g.useState(/* @__PURE__ */ new Set()), X = Array.from(ee).map((V) => V.props.value).join(";");
  return /* @__PURE__ */ v.jsx(Sl, { ...m, children: /* @__PURE__ */ v.jsxs(
    SH,
    {
      required: p,
      scope: t,
      trigger: b,
      onTriggerChange: $,
      valueNode: w,
      onValueNodeChange: E,
      valueNodeHasChildren: P,
      onValueNodeHasChildrenChange: x,
      contentId: st(),
      value: A,
      onValueChange: _,
      open: z,
      onOpenChange: N,
      dir: F,
      triggerPointerDownPosRef: B,
      disabled: h,
      children: [
        /* @__PURE__ */ v.jsx(so.Provider, { scope: t, children: /* @__PURE__ */ v.jsx(
          FH,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: g.useCallback((V) => {
              R((G) => new Set(G).add(V));
            }, []),
            onNativeOptionRemove: g.useCallback((V) => {
              R((G) => {
                const ne = new Set(G);
                return ne.delete(V), ne;
              });
            }, []),
            children: n
          }
        ) }),
        j ? /* @__PURE__ */ v.jsxs(
          tm,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: f,
            autoComplete: u,
            value: A,
            onChange: (V) => _(V.target.value),
            disabled: h,
            form: y,
            children: [
              A === void 0 ? /* @__PURE__ */ v.jsx("option", { value: "" }) : null,
              Array.from(ee)
            ]
          },
          X
        ) : null
      ]
    }
  ) });
};
Ql.displayName = Wr;
var Th = "SelectTrigger", kh = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...a } = e, i = uo(n), l = cn(Th, n), s = l.disabled || r, c = De(t, l.onTriggerChange), d = co(n), f = g.useRef("touch"), [u, h, p] = nm((m) => {
      const b = d().filter((E) => !E.disabled), $ = b.find((E) => E.value === l.value), w = rm(b, m, $);
      w !== void 0 && l.onValueChange(w.value);
    }), y = (m) => {
      s || (l.onOpenChange(!0), p()), m && (l.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ v.jsx(C2, { asChild: !0, ...i, children: /* @__PURE__ */ v.jsx(
      ge.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": l.contentId,
        "aria-expanded": l.open,
        "aria-required": l.required,
        "aria-autocomplete": "none",
        dir: l.dir,
        "data-state": l.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": em(l.value) ? "" : void 0,
        ...a,
        ref: c,
        onClick: ie(a.onClick, (m) => {
          m.currentTarget.focus(), f.current !== "mouse" && y(m);
        }),
        onPointerDown: ie(a.onPointerDown, (m) => {
          f.current = m.pointerType;
          const b = m.target;
          b.hasPointerCapture(m.pointerId) && b.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (y(m), m.preventDefault());
        }),
        onKeyDown: ie(a.onKeyDown, (m) => {
          const b = u.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && h(m.key), !(b && m.key === " ") && MH.includes(m.key) && (y(), m.preventDefault());
        })
      }
    ) });
  }
);
kh.displayName = Th;
var Hh = "SelectValue", Rh = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: a, children: i, placeholder: l = "", ...s } = e, c = cn(Hh, n), { onValueNodeHasChildrenChange: d } = c, f = i !== void 0, u = De(t, c.onValueNodeChange);
    return Ye(() => {
      d(f);
    }, [d, f]), /* @__PURE__ */ v.jsx(
      ge.span,
      {
        ...s,
        ref: u,
        style: { pointerEvents: "none" },
        children: em(c.value) ? /* @__PURE__ */ v.jsx(v.Fragment, { children: l }) : i
      }
    );
  }
);
Rh.displayName = Hh;
var NH = "SelectIcon", _h = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...a } = e;
    return /* @__PURE__ */ v.jsx(ge.span, { "aria-hidden": !0, ...a, ref: t, children: r || "▼" });
  }
);
_h.displayName = NH;
var DH = "SelectPortal", Ih = (e) => /* @__PURE__ */ v.jsx(Xa, { asChild: !0, ...e });
Ih.displayName = DH;
var bn = "SelectContent", Lh = g.forwardRef(
  (e, t) => {
    const n = cn(bn, e.__scopeSelect), [r, a] = g.useState();
    if (Ye(() => {
      a(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Or.createPortal(
        /* @__PURE__ */ v.jsx(jh, { scope: e.__scopeSelect, children: /* @__PURE__ */ v.jsx(so.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ v.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ v.jsx(Bh, { ...e, ref: t });
  }
);
Lh.displayName = bn;
var Mt = 10, [jh, dn] = qn(bn), OH = "SelectContentImpl", Bh = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: d,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: y,
      hideWhenDetached: m,
      avoidCollisions: b,
      //
      ...$
    } = e, w = cn(bn, n), [E, P] = g.useState(null), [x, F] = g.useState(null), z = De(t, (H) => P(H)), [N, A] = g.useState(null), [_, B] = g.useState(
      null
    ), j = co(n), [ee, R] = g.useState(!1), X = g.useRef(!1);
    g.useEffect(() => {
      if (E) return Za(E);
    }, [E]), yl();
    const V = g.useCallback(
      (H) => {
        const [U, ...q] = j().map((T) => T.ref.current), [W] = q.slice(-1), de = document.activeElement;
        for (const T of H)
          if (T === de || (T == null || T.scrollIntoView({ block: "nearest" }), T === U && x && (x.scrollTop = 0), T === W && x && (x.scrollTop = x.scrollHeight), T == null || T.focus(), document.activeElement !== de)) return;
      },
      [j, x]
    ), G = g.useCallback(
      () => V([N, E]),
      [V, N, E]
    );
    g.useEffect(() => {
      ee && G();
    }, [ee, G]);
    const { onOpenChange: ne, triggerPointerDownPosRef: k } = w;
    g.useEffect(() => {
      if (E) {
        let H = { x: 0, y: 0 };
        const U = (W) => {
          var de, T;
          H = {
            x: Math.abs(Math.round(W.pageX) - (((de = k.current) == null ? void 0 : de.x) ?? 0)),
            y: Math.abs(Math.round(W.pageY) - (((T = k.current) == null ? void 0 : T.y) ?? 0))
          };
        }, q = (W) => {
          H.x <= 10 && H.y <= 10 ? W.preventDefault() : E.contains(W.target) || ne(!1), document.removeEventListener("pointermove", U), k.current = null;
        };
        return k.current !== null && (document.addEventListener("pointermove", U), document.addEventListener("pointerup", q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", U), document.removeEventListener("pointerup", q, { capture: !0 });
        };
      }
    }, [E, ne, k]), g.useEffect(() => {
      const H = () => ne(!1);
      return window.addEventListener("blur", H), window.addEventListener("resize", H), () => {
        window.removeEventListener("blur", H), window.removeEventListener("resize", H);
      };
    }, [ne]);
    const [D, O] = nm((H) => {
      const U = j().filter((de) => !de.disabled), q = U.find((de) => de.ref.current === document.activeElement), W = rm(U, H, q);
      W && setTimeout(() => W.ref.current.focus());
    }), J = g.useCallback(
      (H, U, q) => {
        const W = !X.current && !q;
        (w.value !== void 0 && w.value === U || W) && (A(H), W && (X.current = !0));
      },
      [w.value]
    ), oe = g.useCallback(() => E == null ? void 0 : E.focus(), [E]), te = g.useCallback(
      (H, U, q) => {
        const W = !X.current && !q;
        (w.value !== void 0 && w.value === U || W) && B(H);
      },
      [w.value]
    ), se = r === "popper" ? ji : Wh, Q = se === ji ? {
      side: s,
      sideOffset: c,
      align: d,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: y,
      hideWhenDetached: m,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ v.jsx(
      jh,
      {
        scope: n,
        content: E,
        viewport: x,
        onViewportChange: F,
        itemRefCallback: J,
        selectedItem: N,
        onItemLeave: oe,
        itemTextRefCallback: te,
        focusSelectedItem: G,
        selectedItemText: _,
        position: r,
        isPositioned: ee,
        searchRef: D,
        children: /* @__PURE__ */ v.jsx(Qa, { as: pn, allowPinchZoom: !0, children: /* @__PURE__ */ v.jsx(
          Ga,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (H) => {
              H.preventDefault();
            },
            onUnmountAutoFocus: ie(a, (H) => {
              var U;
              (U = w.trigger) == null || U.focus({ preventScroll: !0 }), H.preventDefault();
            }),
            children: /* @__PURE__ */ v.jsx(
              Va,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: l,
                onFocusOutside: (H) => H.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ v.jsx(
                  se,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (H) => H.preventDefault(),
                    ...$,
                    ...Q,
                    onPlaced: () => R(!0),
                    ref: z,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...$.style
                    },
                    onKeyDown: ie($.onKeyDown, (H) => {
                      const U = H.ctrlKey || H.altKey || H.metaKey;
                      if (H.key === "Tab" && H.preventDefault(), !U && H.key.length === 1 && O(H.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(H.key)) {
                        let W = j().filter((de) => !de.disabled).map((de) => de.ref.current);
                        if (["ArrowUp", "End"].includes(H.key) && (W = W.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(H.key)) {
                          const de = H.target, T = W.indexOf(de);
                          W = W.slice(T + 1);
                        }
                        setTimeout(() => V(W)), H.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Bh.displayName = OH;
var AH = "SelectItemAlignedPosition", Wh = g.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...a } = e, i = cn(bn, n), l = dn(bn, n), [s, c] = g.useState(null), [d, f] = g.useState(null), u = De(t, (z) => f(z)), h = co(n), p = g.useRef(!1), y = g.useRef(!0), { viewport: m, selectedItem: b, selectedItemText: $, focusSelectedItem: w } = l, E = g.useCallback(() => {
    if (i.trigger && i.valueNode && s && d && m && b && $) {
      const z = i.trigger.getBoundingClientRect(), N = d.getBoundingClientRect(), A = i.valueNode.getBoundingClientRect(), _ = $.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const de = _.left - N.left, T = A.left - de, Se = z.left - T, Le = z.width + Se, Ie = Math.max(Le, N.width), Ke = window.innerWidth - Mt, ht = vc(T, [
          Mt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Mt, Ke - Ie)
        ]);
        s.style.minWidth = Le + "px", s.style.left = ht + "px";
      } else {
        const de = N.right - _.right, T = window.innerWidth - A.right - de, Se = window.innerWidth - z.right - T, Le = z.width + Se, Ie = Math.max(Le, N.width), Ke = window.innerWidth - Mt, ht = vc(T, [
          Mt,
          Math.max(Mt, Ke - Ie)
        ]);
        s.style.minWidth = Le + "px", s.style.right = ht + "px";
      }
      const B = h(), j = window.innerHeight - Mt * 2, ee = m.scrollHeight, R = window.getComputedStyle(d), X = parseInt(R.borderTopWidth, 10), V = parseInt(R.paddingTop, 10), G = parseInt(R.borderBottomWidth, 10), ne = parseInt(R.paddingBottom, 10), k = X + V + ee + ne + G, D = Math.min(b.offsetHeight * 5, k), O = window.getComputedStyle(m), J = parseInt(O.paddingTop, 10), oe = parseInt(O.paddingBottom, 10), te = z.top + z.height / 2 - Mt, se = j - te, Q = b.offsetHeight / 2, H = b.offsetTop + Q, U = X + V + H, q = k - U;
      if (U <= te) {
        const de = B.length > 0 && b === B[B.length - 1].ref.current;
        s.style.bottom = "0px";
        const T = d.clientHeight - m.offsetTop - m.offsetHeight, Se = Math.max(
          se,
          Q + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (de ? oe : 0) + T + G
        ), Le = U + Se;
        s.style.height = Le + "px";
      } else {
        const de = B.length > 0 && b === B[0].ref.current;
        s.style.top = "0px";
        const Se = Math.max(
          te,
          X + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (de ? J : 0) + Q
        ) + q;
        s.style.height = Se + "px", m.scrollTop = U - te + m.offsetTop;
      }
      s.style.margin = `${Mt}px 0`, s.style.minHeight = D + "px", s.style.maxHeight = j + "px", r == null || r(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    s,
    d,
    m,
    b,
    $,
    i.dir,
    r
  ]);
  Ye(() => E(), [E]);
  const [P, x] = g.useState();
  Ye(() => {
    d && x(window.getComputedStyle(d).zIndex);
  }, [d]);
  const F = g.useCallback(
    (z) => {
      z && y.current === !0 && (E(), w == null || w(), y.current = !1);
    },
    [E, w]
  );
  return /* @__PURE__ */ v.jsx(
    kH,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: F,
      children: /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: P
          },
          children: /* @__PURE__ */ v.jsx(
            ge.div,
            {
              ...a,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
Wh.displayName = AH;
var TH = "SelectPopperPosition", ji = g.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: a = Mt,
    ...i
  } = e, l = uo(n);
  return /* @__PURE__ */ v.jsx(
    P2,
    {
      ...l,
      ...i,
      ref: t,
      align: r,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ji.displayName = TH;
var [kH, e1] = qn(bn, {}), Bi = "SelectViewport", Vh = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...a } = e, i = dn(Bi, n), l = e1(Bi, n), s = De(t, i.onViewportChange), c = g.useRef(0);
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ v.jsx(so.Slot, { scope: n, children: /* @__PURE__ */ v.jsx(
        ge.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...a.style
          },
          onScroll: ie(a.onScroll, (d) => {
            const f = d.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: h } = l;
            if (h != null && h.current && u) {
              const p = Math.abs(c.current - f.scrollTop);
              if (p > 0) {
                const y = window.innerHeight - Mt * 2, m = parseFloat(u.style.minHeight), b = parseFloat(u.style.height), $ = Math.max(m, b);
                if ($ < y) {
                  const w = $ + p, E = Math.min(y, w), P = w - E;
                  u.style.height = E + "px", u.style.bottom === "0px" && (f.scrollTop = P > 0 ? P : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Vh.displayName = Bi;
var Gh = "SelectGroup", [HH, RH] = qn(Gh), Yh = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = st();
    return /* @__PURE__ */ v.jsx(HH, { scope: n, id: a, children: /* @__PURE__ */ v.jsx(ge.div, { role: "group", "aria-labelledby": a, ...r, ref: t }) });
  }
);
Yh.displayName = Gh;
var Uh = "SelectLabel", _H = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = RH(Uh, n);
    return /* @__PURE__ */ v.jsx(ge.div, { id: a.id, ...r, ref: t });
  }
);
_H.displayName = Uh;
var Ta = "SelectItem", [IH, Kh] = qn(Ta), Xh = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: a = !1,
      textValue: i,
      ...l
    } = e, s = cn(Ta, n), c = dn(Ta, n), d = s.value === r, [f, u] = g.useState(i ?? ""), [h, p] = g.useState(!1), y = De(
      t,
      (w) => {
        var E;
        return (E = c.itemRefCallback) == null ? void 0 : E.call(c, w, r, a);
      }
    ), m = st(), b = g.useRef("touch"), $ = () => {
      a || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ v.jsx(
      IH,
      {
        scope: n,
        value: r,
        disabled: a,
        textId: m,
        isSelected: d,
        onItemTextChange: g.useCallback((w) => {
          u((E) => E || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ v.jsx(
          so.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: a,
            textValue: f,
            children: /* @__PURE__ */ v.jsx(
              ge.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": d && h,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...l,
                ref: y,
                onFocus: ie(l.onFocus, () => p(!0)),
                onBlur: ie(l.onBlur, () => p(!1)),
                onClick: ie(l.onClick, () => {
                  b.current !== "mouse" && $();
                }),
                onPointerUp: ie(l.onPointerUp, () => {
                  b.current === "mouse" && $();
                }),
                onPointerDown: ie(l.onPointerDown, (w) => {
                  b.current = w.pointerType;
                }),
                onPointerMove: ie(l.onPointerMove, (w) => {
                  var E;
                  b.current = w.pointerType, a ? (E = c.onItemLeave) == null || E.call(c) : b.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ie(l.onPointerLeave, (w) => {
                  var E;
                  w.currentTarget === document.activeElement && ((E = c.onItemLeave) == null || E.call(c));
                }),
                onKeyDown: ie(l.onKeyDown, (w) => {
                  var P;
                  ((P = c.searchRef) == null ? void 0 : P.current) !== "" && w.key === " " || (CH.includes(w.key) && $(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Xh.displayName = Ta;
var pr = "SelectItemText", qh = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: a, ...i } = e, l = cn(pr, n), s = dn(pr, n), c = Kh(pr, n), d = zH(pr, n), [f, u] = g.useState(null), h = De(
      t,
      ($) => u($),
      c.onItemTextChange,
      ($) => {
        var w;
        return (w = s.itemTextRefCallback) == null ? void 0 : w.call(s, $, c.value, c.disabled);
      }
    ), p = f == null ? void 0 : f.textContent, y = g.useMemo(
      () => /* @__PURE__ */ v.jsx("option", { value: c.value, disabled: c.disabled, children: p }, c.value),
      [c.disabled, c.value, p]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: b } = d;
    return Ye(() => (m(y), () => b(y)), [m, b, y]), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(ge.span, { id: c.textId, ...i, ref: h }),
      c.isSelected && l.valueNode && !l.valueNodeHasChildren ? Or.createPortal(i.children, l.valueNode) : null
    ] });
  }
);
qh.displayName = pr;
var Zh = "SelectItemIndicator", LH = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return Kh(Zh, n).isSelected ? /* @__PURE__ */ v.jsx(ge.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
LH.displayName = Zh;
var Wi = "SelectScrollUpButton", jH = g.forwardRef((e, t) => {
  const n = dn(Wi, e.__scopeSelect), r = e1(Wi, e.__scopeSelect), [a, i] = g.useState(!1), l = De(t, r.onScrollButtonChange);
  return Ye(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const d = c.scrollTop > 0;
        i(d);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ v.jsx(
    Jh,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
jH.displayName = Wi;
var Vi = "SelectScrollDownButton", BH = g.forwardRef((e, t) => {
  const n = dn(Vi, e.__scopeSelect), r = e1(Vi, e.__scopeSelect), [a, i] = g.useState(!1), l = De(t, r.onScrollButtonChange);
  return Ye(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const d = c.scrollHeight - c.clientHeight, f = Math.ceil(c.scrollTop) < d;
        i(f);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ v.jsx(
    Jh,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
BH.displayName = Vi;
var Jh = g.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...a } = e, i = dn("SelectScrollButton", n), l = g.useRef(null), s = co(n), c = g.useCallback(() => {
    l.current !== null && (window.clearInterval(l.current), l.current = null);
  }, []);
  return g.useEffect(() => () => c(), [c]), Ye(() => {
    var f;
    const d = s().find((u) => u.ref.current === document.activeElement);
    (f = d == null ? void 0 : d.ref.current) == null || f.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ v.jsx(
    ge.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: t,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: ie(a.onPointerDown, () => {
        l.current === null && (l.current = window.setInterval(r, 50));
      }),
      onPointerMove: ie(a.onPointerMove, () => {
        var d;
        (d = i.onItemLeave) == null || d.call(i), l.current === null && (l.current = window.setInterval(r, 50));
      }),
      onPointerLeave: ie(a.onPointerLeave, () => {
        c();
      })
    }
  );
}), WH = "SelectSeparator", Qh = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ v.jsx(ge.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Qh.displayName = WH;
var Gi = "SelectArrow", VH = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = uo(n), i = cn(Gi, n), l = dn(Gi, n);
    return i.open && l.position === "popper" ? /* @__PURE__ */ v.jsx(S2, { ...a, ...r, ref: t }) : null;
  }
);
VH.displayName = Gi;
function em(e) {
  return e === "" || e === void 0;
}
var tm = g.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, a = g.useRef(null), i = De(t, a), l = Ah(n);
    return g.useEffect(() => {
      const s = a.current, c = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (l !== n && f) {
        const u = new Event("change", { bubbles: !0 });
        f.call(s, n), s.dispatchEvent(u);
      }
    }, [l, n]), /* @__PURE__ */ v.jsx(Vl, { asChild: !0, children: /* @__PURE__ */ v.jsx("select", { ...r, ref: i, defaultValue: n }) });
  }
);
tm.displayName = "BubbleSelect";
function nm(e) {
  const t = dt(e), n = g.useRef(""), r = g.useRef(0), a = g.useCallback(
    (l) => {
      const s = n.current + l;
      t(s), function c(d) {
        n.current = d, window.clearTimeout(r.current), d !== "" && (r.current = window.setTimeout(() => c(""), 1e3));
      }(s);
    },
    [t]
  ), i = g.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return g.useEffect(() => () => window.clearTimeout(r.current), []), [n, a, i];
}
function rm(e, t, n) {
  const a = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let l = GH(e, Math.max(i, 0));
  a.length === 1 && (l = l.filter((d) => d !== n));
  const c = l.find(
    (d) => d.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function GH(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var YH = Ql, t1 = kh, UH = Rh, am = _h, om = Ih, n1 = Lh, im = Vh, KH = Yh, ka = Xh, Yi = qh, lm = Qh;
const XH = Pe(["w-full", "flex", "items-center", "justify-between", "border-none", "text-left"], {
  variants: {
    variant: {
      standard: ["bg-transparent", "px-2", "py-2", "overflow-auto", "focus-visible:outline-none"],
      outlined: ["p-3", "outline-green-500", "text-text-primary", "gap-2"]
    },
    error: {
      true: ["border-error-500", "outline-error-500", "text-error-500"]
    },
    disabled: {
      true: ["border-text-disabled", "text-text-disabled"]
    },
    size: {
      small: ["min-h-[28px]"],
      medium: ["min-h-[42px]"],
      large: ["min-h-[55px] text-lg"]
    }
  },
  compoundVariants: [
    {
      variant: "outlined",
      disabled: !1,
      error: !1,
      class: ["hover:border-text-primary"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    size: "medium"
  }
}), pc = Pe(["px-4"], {
  variants: {
    variant: {
      standard: ["py-2", "border-b", "last-of-type:border-none"],
      outlined: ["flex", "items-center", "gap-1", "py-1", "focus-visible:outline-none"]
    }
  },
  defaultVariants: {
    variant: "standard"
  }
}), qH = Pe(
  ["font-sans", "text-sm", "leading-normal", "flex", "items-center", "gap-1", "font-normal", "mt-2"],
  {
    variants: {
      error: {
        false: ["text-gray-700"],
        true: ["text-error-500"]
      }
    }
  }
), sm = o.forwardRef(
  ({
    variant: e = "standard",
    size: t = "medium",
    error: n = !1,
    disabled: r = !1,
    helperText: a,
    readOnly: i,
    items: l,
    quickAccessItems: s,
    className: c,
    onChange: d,
    ...f
  }, u) => {
    const h = Oh[f.country];
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(Ql, { open: i ? !1 : void 0, disabled: r, onValueChange: d, ...f, children: [
        /* @__PURE__ */ v.jsxs(t1, { ref: u, className: XH({ variant: e, error: n, disabled: r, size: t, className: c }), children: [
          f.country ? /* @__PURE__ */ v.jsx(h, { className: "h-4 w-8" }) : /* @__PURE__ */ v.jsx(O6, { className: "h-6 w-8" }),
          /* @__PURE__ */ v.jsx(
            am,
            {
              className: K("fill-text-secondary", {
                "fill-text-disabled": r
              }),
              children: /* @__PURE__ */ v.jsx(A6, {})
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(om, { children: /* @__PURE__ */ v.jsx(
          n1,
          {
            className: "z-20 h-64 w-full cursor-pointer overflow-auto rounded-md bg-white py-2 shadow-md",
            position: e === "outlined" ? void 0 : "popper",
            side: e === "outlined" ? void 0 : "bottom",
            children: /* @__PURE__ */ v.jsx(im, { children: /* @__PURE__ */ v.jsxs(KH, { children: [
              s && s.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                s.map((p, y) => /* @__PURE__ */ v.jsx(
                  ka,
                  {
                    className: `${pc({ variant: e, className: c })} data-[highlighted]:bg-lightBlue-500/5
                data-[state=checked]:bg-lightBlue-500/10
                data-[state=checked]:shadow-[inset_4px_0_0_0]
                data-[state=checked]:shadow-lightBlue-500
                data-[highlighted]:outline-none
                ${y === s.length - 1 && "border-none"}`,
                    value: p.value,
                    children: /* @__PURE__ */ v.jsx(Yi, { children: p.label })
                  },
                  p.key
                )),
                /* @__PURE__ */ v.jsx("div", { className: "flex w-full cursor-default items-center px-8 py-2", children: /* @__PURE__ */ v.jsx("div", { className: "h-0.5 w-full bg-deepGray-500/[0.12]" }) })
              ] }),
              l.map((p) => /* @__PURE__ */ v.jsx(
                ka,
                {
                  className: `${pc({ variant: e, className: c })} data-[highlighted]:bg-lightBlue-500/5
                data-[state=checked]:bg-lightBlue-500/10
                data-[state=checked]:shadow-[inset_4px_0_0_0]
                data-[state=checked]:shadow-lightBlue-500
                data-[highlighted]:outline-none`,
                  value: p.value,
                  children: /* @__PURE__ */ v.jsx(Yi, { children: p.label })
                },
                p.key
              ))
            ] }) })
          }
        ) })
      ] }),
      a && /* @__PURE__ */ v.jsx("p", { className: qH({ error: n }), children: a })
    ] });
  }
);
sm.displayName = "CountryDropdown";
const ZH = 'before:content-[" "]', JH = 'after:content-[" "]', QH = Pe(
  [
    "group",
    "peer",
    "h-full",
    "w-full",
    "rounded-md",
    "border",
    "border-t-transparent",
    "bg-transparent",
    "pl-20",
    "font-sans",
    "font-normal",
    "outline",
    "outline-0",
    "transition-all",
    "text-[0.875rem]",
    "py-2.5",
    "placeholder-shown:border",
    "focus:border-2",
    "focus:border-t-transparent",
    "focus:outline-0",
    "disabled:border-deepGray-500",
    "disabled:border-t-transparent",
    "placeholder-shown:disabled:border-t-deepGray-500",
    "placeholder-shown:disabled:border-t",
    "disabled:text-deepGray-400",
    "disabled:bg-deepGray-50"
  ],
  {
    variants: {
      lightBorder: {
        false: [],
        true: [
          "disabled:border-deepGray-100",
          "disabled:border-t-transparent",
          "placeholder-shown:disabled:border-t-deepGray-100",
          "placeholder-shown:disabled:border-t",
          "disabled:hover:border-deepGray-100",
          "disabled:hover:border-t-transparent",
          "placeholder-shown:disabled:hover:border-t-deepGray-100",
          "placeholder-shown:disabled:hover:border-t"
        ]
      },
      hasStartAdornment: {
        false: [],
        true: ["pl-16"]
      },
      hasEndAdornment: {
        false: [],
        true: ["pr-10"]
      },
      size: {
        normal: [],
        large: ["text-[1.125rem]", "py-4"]
      },
      state: {
        default: [
          "text-deepGray-700",
          "border-deepGray-500",
          "border-t-transparent",
          "focus:border-success-700",
          "focus:border-t-transparent",
          "placeholder-shown:border-deepGray-500",
          "placeholder-shown:border-t-deepGray-500"
        ],
        error: [
          "text-error-500",
          "border-error-500",
          "border-t-transparent",
          "focus:border-error-500",
          "focus:border-t-transparent",
          "placeholder-shown:border-error-500",
          "placeholder-shown:border-t-error-500"
        ],
        success: [
          "text-success-700",
          "border-success-700",
          "border-t-transparent",
          "focus:border-success-700",
          "focus:border-t-transparent",
          "placeholder-shown:border-success-700",
          "placeholder-shown:border-t-success-700"
        ]
      }
    },
    defaultVariants: {
      state: "default"
    },
    compoundVariants: [
      {
        state: "default",
        lightBorder: !0,
        class: "border-deepGray-100 border-t-transparent placeholder-shown:border-deepGray-100 hover:border-text-primary hover:border-t-transparent placeholder-shown:hover:border-text-primary focus:hover:border-success-700 focus:hover:border-t-transparent"
      }
    ]
  }
), eR = Pe(
  [
    ZH,
    JH,
    "pointer-events-none",
    "absolute",
    "left-0",
    "-top-1.5",
    "flex",
    "h-full",
    "w-full",
    "select-none",
    "text-[0.875rem]",
    "font-normal",
    "leading-tight",
    "transition-all",
    "box-border",
    "before:pointer-events-none",
    "before:mt-[6.5px]",
    "before:mr-1",
    "before:box-border",
    "before:block",
    "before:h-1.5",
    "before:w-2.5",
    "before:rounded-tl-md",
    "before:border-t",
    "before:border-l",
    "before:transition-all",
    "after:pointer-events-none",
    "after:mt-[6.5px]",
    "after:ml-1",
    "after:box-border",
    "after:block",
    "after:grow",
    "after:rounded-tr-md",
    "after:border-t",
    "after:border-r",
    "after:transition-all",
    "peer-focus:leading-tight",
    "peer-placeholder-shown:leading-[3.75]",
    "peer-placeholder-shown:before:border-transparent",
    "peer-placeholder-shown:after:border-transparent",
    "peer-focus:before:border-t-2",
    "peer-focus:before:border-l-2",
    "peer-focus:after:border-t-2",
    "peer-focus:after:border-r-2",
    "peer-disabled:text-deepGray-400",
    "peer-disabled:before:border-t-deepGray-400",
    "peer-disabled:after:border-t-deepGray-400",
    "peer-disabled:peer-placeholder-shown:before:border-t-0",
    "peer-disabled:peer-placeholder-shown:after:border-t-0"
  ],
  {
    variants: {
      lightBorder: {
        false: [],
        true: [
          "peer-disabled:before:border-t-deepGray-100",
          "peer-disabled:before:border-l-0",
          "peer-disabled:after:border-t-deepGray-100",
          "peer-disabled:after:border-r-0",
          "peer-disabled:peer-hover:before:border-t-deepGray-100",
          "peer-disabled:peer-hover:after:border-t-deepGray-100",
          "peer-placeholder-shown:peer-disabled:peer-hover:before:border-t-0",
          "peer-placeholder-shown:peer-disabled:peer-hover:after:border-t-0"
        ]
      },
      size: {
        normal: [],
        large: [
          "text-[0.875rem]",
          "peer-focus:leading-[0.75]",
          "peer-placeholder-shown:text-[1.125rem]",
          "leading-[0.75]",
          "peer-placeholder-shown:leading-[3.75]"
        ]
      },
      hasStartAdornment: {
        false: [],
        true: ["peer-placeholder-shown:pl-12", "peer-focus:peer-placeholder-shown:pl-0"]
      },
      state: {
        default: [
          "text-deepGray-400",
          "peer-disabled:peer-placeholder-shown:text-deepGray-500",
          "peer-placeholder-shown:text-deepGray-500",
          "after:border-deepGray-500",
          "peer-focus:text-success-700",
          "peer-focus:before:border-success-700",
          "peer-focus:after:border-success-700",
          "before:border-deepGray-500"
        ],
        error: [
          "text-error-500",
          "after:border-error-500",
          "peer-placeholder-shown:text-error-500",
          "peer-focus:text-error-500",
          "peer-focus:before:border-error-500",
          "peer-focus:after:border-error-500",
          "before:border-error-500"
        ],
        success: [
          "text-success-700",
          "after:border-error-500",
          "peer-placeholder-shown:text-success-700",
          "peer-focus:text-success-700",
          "peer-focus:before:border-success-700",
          "peer-focus:after:border-success-700",
          "before:border-success-700"
        ]
      }
    },
    defaultVariants: {
      state: "default",
      size: "normal"
    },
    compoundVariants: [
      {
        state: "default",
        lightBorder: !0,
        class: "before:border-deepGray-100 after:border-deepGray-100 peer-hover:before:border-text-primary peer-hover:after:border-text-primary peer-placeholder-shown:peer-hover:before:border-transparent peer-placeholder-shown:peer-hover:after:border-transparent peer-placeholder-shown:peer-focus:peer-hover:before:border-success-700 peer-placeholder-shown:peer-focus:peer-hover:after:border-success-700"
      }
    ]
  }
), tR = Pe(["font-sans", "text-sm", "leading-normal", "flex", "items-center", "gap-1", "font-normal", "mt-2"], {
  variants: {
    error: {
      false: ["text-gray-700"],
      true: ["text-error-500"]
    }
  }
}), nR = me(
  ({
    label: e,
    error: t = !1,
    state: n = "default",
    className: r,
    full: a,
    helperText: i,
    size: l = "normal",
    lightBorder: s,
    classNames: c,
    defaultCountry: d = "",
    quickAccessCountries: f = [],
    required: u,
    ...h
  }, p) => {
    const y = HD(String(h.value)), [m, b] = Ae(d), [$, w] = Ae("");
    Ce(() => {
      if (y && y.country) {
        const z = (y == null ? void 0 : y.country) ?? "";
        b(z), w(`+${Qo(z)} ${z}`);
      }
    }, [y]);
    const E = (z) => z.map((N) => {
      const A = Oh[N];
      return {
        key: `qa:${Ii[N]}`,
        label: /* @__PURE__ */ v.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ v.jsx(A, { className: "mr-1 h-4 w-8 bg-gray-100" }),
          Ii[N],
          " +",
          Qo(N)
        ] }),
        value: `+${Qo(N)} ${N}`
      };
    }), P = E(f), x = E(RD().filter((z) => !f.includes(z))), F = (z) => {
      h.onChange && h.onChange(z.target.value);
    };
    return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("div", { className: K("flex rounded-md shadow-sm", a && "w-full"), children: /* @__PURE__ */ v.jsxs("div", { className: K("relative", a && "w-full"), children: [
        /* @__PURE__ */ v.jsx("div", { className: "absolute inset-y-0 left-0 flex items-center pl-0", children: /* @__PURE__ */ v.jsx(
          sm,
          {
            value: $,
            country: m,
            disabled: h.disabled,
            size: "small",
            items: x,
            quickAccessItems: P,
            onChange: (z) => {
              const [N, A] = z.split(" ");
              h.onChange && h.onChange(N), w(z), b(A);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(
          "input",
          {
            ref: p,
            "aria-invalid": !!t,
            className: QH({
              state: t ? "error" : n,
              size: l,
              lightBorder: s,
              hasStartAdornment: !0,
              className: r
            }),
            placeholder: " ",
            ...h,
            onChange: F
          }
        ),
        /* @__PURE__ */ v.jsx(
          "label",
          {
            htmlFor: h.id,
            className: K(
              eR({
                state: t ? "error" : n,
                size: l,
                lightBorder: s,
                hasStartAdornment: !0
              }),
              c == null ? void 0 : c.label
            ),
            children: /* @__PURE__ */ v.jsxs("div", { children: [
              e,
              u && /* @__PURE__ */ v.jsx("span", { className: "text-red-500", children: "*" })
            ] })
          }
        )
      ] }) }),
      i && /* @__PURE__ */ v.jsx("p", { className: tR({ error: n === "error" }), children: i })
    ] });
  }
);
nR.displayName = "PhoneNumberInput";
const gc = "transition-all duration-300 ease-in-out", DL = ({
  isOpen: e,
  onClose: t,
  title: n,
  children: r,
  dialogClassName: a,
  backdropClassName: i,
  titleClassName: l,
  disableBackdrop: s,
  actionButtons: c,
  portalContainer: d,
  portalContainerRef: f,
  hideCloseButton: u = !1,
  position: h = "right"
}) => {
  const p = ve(null), y = ve(null), m = $6(), b = he(
    (x) => {
      p.current = x, f && (f.current = x);
    },
    [f]
  ), $ = Ze(() => typeof document > "u" ? null : d || document.body, [d]), w = he((x) => {
    const F = [
      "a[href]",
      "button:not([disabled])",
      "textarea:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ], z = x.querySelectorAll(F.join(","));
    return Array.from(z).filter(
      (A) => !A.hasAttribute("disabled") && !A.getAttribute("aria-hidden") && (A.offsetWidth > 0 || A.offsetHeight > 0 || A === document.activeElement)
    );
  }, []), E = he(() => {
    const x = p.current;
    if (!x) return;
    const z = w(x)[0];
    if (z) {
      z.focus();
      return;
    }
    x.focus();
  }, [w]);
  Ce(() => {
    const x = document.body, F = x.style.overflow, z = x.style.paddingRight, N = x.style.paddingLeft;
    if (e) {
      const A = window.innerWidth - document.documentElement.clientWidth;
      if (A > 0)
        if (h === "right") {
          const _ = parseFloat(getComputedStyle(x).paddingRight) || 0;
          x.style.paddingRight = `${_ + A}px`;
        } else {
          const _ = parseFloat(getComputedStyle(x).paddingLeft) || 0;
          x.style.paddingLeft = `${_ + A}px`;
        }
      x.style.overflow = "hidden";
    } else
      x.style.overflow = F || "", x.style.paddingRight = z || "", x.style.paddingLeft = N || "";
    return () => {
      x.style.overflow = F || "", x.style.paddingRight = z || "", x.style.paddingLeft = N || "";
    };
  }, [e, h]), Ce(() => {
    if (e) {
      y.current = document.activeElement || null;
      const F = window.setTimeout(E, 0);
      return () => window.clearTimeout(F);
    }
    const x = y.current;
    x && typeof x.focus == "function" && x.focus();
  }, [e, E]), Ce(() => {
    if (!e) return;
    const x = (F) => {
      const z = p.current;
      if (!z) return;
      if (F.key === "Escape") {
        F.preventDefault(), t();
        return;
      }
      if (F.key !== "Tab") return;
      const N = w(z);
      if (N.length === 0) {
        F.preventDefault(), z.focus();
        return;
      }
      const A = N[0], _ = N[N.length - 1], B = document.activeElement, j = !!B && z.contains(B);
      if (F.shiftKey) {
        (!j || B === A) && (F.preventDefault(), _.focus());
        return;
      }
      (!j || B === _) && (F.preventDefault(), A.focus());
    };
    return document.addEventListener("keydown", x), () => document.removeEventListener("keydown", x);
  }, [e, w, t]);
  const P = /* @__PURE__ */ v.jsxs(
    "div",
    {
      "data-testid": "drawer-container",
      className: K({ "pointer-events-none": !e, "pointer-events-auto": e }),
      children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            "data-testid": "drawer-backdrop",
            className: K(
              "fixed inset-0 z-[8] bg-gray-700/50",
              {
                "opacity-100 backdrop-blur-sm": e,
                "opacity-0 backdrop-blur-none": !e
              },
              {
                // If the backdrop is disabled, we don't want to show it visually, but we keep it so we can "click out" and close the drawer.
                "bg-transparent backdrop-blur-none": s
              },
              gc,
              i
            ),
            "aria-hidden": "true",
            onClick: t
          }
        ),
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            ref: b,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": m,
            "aria-hidden": !e,
            tabIndex: -1,
            inert: e ? void 0 : "",
            className: K(
              "fixed top-0 z-[9] flex h-full w-full max-w-[600px] flex-col bg-white outline-none",
              {
                "right-0": h === "right",
                "left-0": h === "left"
              },
              {
                "translate-x-0 shadow-2xl": e,
                "translate-x-full shadow-none": !e && h === "right",
                "-translate-x-full shadow-none": !e && h === "left"
              },
              gc,
              a
            ),
            children: [
              /* @__PURE__ */ v.jsxs("div", { className: K("flex items-center justify-between p-4", l), children: [
                n && (typeof n == "string" ? /* @__PURE__ */ v.jsx("p", { id: m, className: "text-lg font-bold", children: n }) : /* @__PURE__ */ v.jsx("div", { id: m, children: n })),
                !u && /* @__PURE__ */ v.jsx(
                  vd,
                  {
                    onClick: t,
                    icon: T6,
                    type: "button",
                    variant: "ancillary",
                    name: "close",
                    className: "ml-auto p-1"
                  }
                )
              ] }),
              /* @__PURE__ */ v.jsx("div", { className: "h-full overflow-y-auto", children: r }),
              c && /* @__PURE__ */ v.jsx("div", { className: "mt-auto flex flex-col items-center justify-end gap-2 p-6 md:flex-row", children: c.map((x, F) => /* @__PURE__ */ v.jsx(
                a8,
                {
                  variant: "secondary",
                  size: "md",
                  ...x,
                  className: K(x.className, "w-full md:w-auto")
                },
                typeof x.children == "string" ? x.children : F
              )) })
            ]
          }
        )
      ]
    }
  );
  return $ ? x6(P, $) : P;
};
function He() {
  return He = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, He.apply(null, arguments);
}
function We(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented) return t == null ? void 0 : t(a);
  };
}
function rR(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function cm(...e) {
  return (t) => e.forEach(
    (n) => rR(n, t)
  );
}
function Ue(...e) {
  return he(cm(...e), e);
}
function Vr(e, t = []) {
  let n = [];
  function r(i, l) {
    const s = /* @__PURE__ */ jt(l), c = n.length;
    n = [
      ...n,
      l
    ];
    function d(u) {
      const { scope: h, children: p, ...y } = u, m = (h == null ? void 0 : h[e][c]) || s, b = Ze(
        () => y,
        Object.values(y)
      );
      return /* @__PURE__ */ Y(m.Provider, {
        value: b
      }, p);
    }
    function f(u, h) {
      const p = (h == null ? void 0 : h[e][c]) || s, y = gt(p);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [
      d,
      f
    ];
  }
  const a = () => {
    const i = n.map((l) => /* @__PURE__ */ jt(l));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return Ze(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    aR(a, ...t)
  ];
}
function aR(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const u = c(i)[`__scope${d}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return Ze(
        () => ({
          [`__scope${t.scopeName}`]: l
        }),
        [
          l
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function ft() {
  return ft = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ft.apply(null, arguments);
}
const zr = /* @__PURE__ */ me((e, t) => {
  const { children: n, ...r } = e, a = Tn.toArray(n), i = a.find(oR);
  if (i) {
    const l = i.props.children, s = a.map((c) => c === i ? Tn.count(l) > 1 ? Tn.only(null) : /* @__PURE__ */ ya(l) ? l.props.children : null : c);
    return /* @__PURE__ */ Y(Ui, ft({}, r, {
      ref: t
    }), /* @__PURE__ */ ya(l) ? /* @__PURE__ */ Qi(l, void 0, s) : null);
  }
  return /* @__PURE__ */ Y(Ui, ft({}, r, {
    ref: t
  }), n);
});
zr.displayName = "Slot";
const Ui = /* @__PURE__ */ me((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ ya(n) ? /* @__PURE__ */ Qi(n, {
    ...iR(r, n.props),
    ref: t ? cm(t, n.ref) : n.ref
  }) : Tn.count(n) > 1 ? Tn.only(null) : null;
});
Ui.displayName = "SlotClone";
const dm = ({ children: e }) => /* @__PURE__ */ Y(E6, null, e);
function oR(e) {
  return /* @__PURE__ */ ya(e) && e.type === dm;
}
function iR(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const lR = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], at = lR.reduce((e, t) => {
  const n = /* @__PURE__ */ me((r, a) => {
    const { asChild: i, ...l } = r, s = i ? zr : t;
    return Ce(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Y(s, ft({}, l, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function sR(e, t) {
  e && Tc(
    () => e.dispatchEvent(t)
  );
}
function on(e) {
  const t = ve(e);
  return Ce(() => {
    t.current = e;
  }), Ze(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function cR(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = on(e);
  Ce(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Ki = "dismissableLayer.update", dR = "dismissableLayer.pointerDownOutside", uR = "dismissableLayer.focusOutside";
let yc;
const fR = /* @__PURE__ */ jt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), um = /* @__PURE__ */ me((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: l, onInteractOutside: s, onDismiss: c, ...d } = e, f = gt(fR), [u, h] = Ae(null), p = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, y] = Ae({}), m = Ue(
    t,
    (N) => h(N)
  ), b = Array.from(f.layers), [$] = [
    ...f.layersWithOutsidePointerEventsDisabled
  ].slice(-1), w = b.indexOf($), E = u ? b.indexOf(u) : -1, P = f.layersWithOutsidePointerEventsDisabled.size > 0, x = E >= w, F = hR((N) => {
    const A = N.target, _ = [
      ...f.branches
    ].some(
      (B) => B.contains(A)
    );
    !x || _ || (i == null || i(N), s == null || s(N), N.defaultPrevented || c == null || c());
  }, p), z = mR((N) => {
    const A = N.target;
    [
      ...f.branches
    ].some(
      (B) => B.contains(A)
    ) || (l == null || l(N), s == null || s(N), N.defaultPrevented || c == null || c());
  }, p);
  return cR((N) => {
    E === f.layers.size - 1 && (a == null || a(N), !N.defaultPrevented && c && (N.preventDefault(), c()));
  }, p), Ce(() => {
    if (u)
      return r && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (yc = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(u)), f.layers.add(u), bc(), () => {
        r && f.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = yc);
      };
  }, [
    u,
    p,
    r,
    f
  ]), Ce(() => () => {
    u && (f.layers.delete(u), f.layersWithOutsidePointerEventsDisabled.delete(u), bc());
  }, [
    u,
    f
  ]), Ce(() => {
    const N = () => y({});
    return document.addEventListener(Ki, N), () => document.removeEventListener(Ki, N);
  }, []), /* @__PURE__ */ Y(at.div, ft({}, d, {
    ref: m,
    style: {
      pointerEvents: P ? x ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: We(e.onFocusCapture, z.onFocusCapture),
    onBlurCapture: We(e.onBlurCapture, z.onBlurCapture),
    onPointerDownCapture: We(e.onPointerDownCapture, F.onPointerDownCapture)
  }));
});
function hR(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = on(e), r = ve(!1), a = ve(() => {
  });
  return Ce(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let d = function() {
          fm(dR, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = d, t.addEventListener("click", a.current, {
          once: !0
        })) : d();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function mR(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = on(e), r = ve(!1);
  return Ce(() => {
    const a = (i) => {
      i.target && !r.current && fm(uR, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function bc() {
  const e = new CustomEvent(Ki);
  document.dispatchEvent(e);
}
function fm(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), r ? sR(a, i) : a.dispatchEvent(i);
}
let ei = 0;
function vR() {
  Ce(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : wc()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : wc()), ei++, () => {
      ei === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), ei--;
    };
  }, []);
}
function wc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const ti = "focusScope.autoFocusOnMount", ni = "focusScope.autoFocusOnUnmount", $c = {
  bubbles: !1,
  cancelable: !0
}, pR = /* @__PURE__ */ me((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...l } = e, [s, c] = Ae(null), d = on(a), f = on(i), u = ve(null), h = Ue(
    t,
    (m) => c(m)
  ), p = ve({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Ce(() => {
    if (r) {
      let m = function(E) {
        if (p.paused || !s) return;
        const P = E.target;
        s.contains(P) ? u.current = P : en(u.current, {
          select: !0
        });
      }, b = function(E) {
        if (p.paused || !s) return;
        const P = E.relatedTarget;
        P !== null && (s.contains(P) || en(u.current, {
          select: !0
        }));
      }, $ = function(E) {
        if (document.activeElement === document.body)
          for (const x of E) x.removedNodes.length > 0 && en(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const w = new MutationObserver($);
      return s && w.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), w.disconnect();
      };
    }
  }, [
    r,
    s,
    p.paused
  ]), Ce(() => {
    if (s) {
      xc.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const $ = new CustomEvent(ti, $c);
        s.addEventListener(ti, d), s.dispatchEvent($), $.defaultPrevented || (gR(ER(hm(s)), {
          select: !0
        }), document.activeElement === m && en(s));
      }
      return () => {
        s.removeEventListener(ti, d), setTimeout(() => {
          const $ = new CustomEvent(ni, $c);
          s.addEventListener(ni, f), s.dispatchEvent($), $.defaultPrevented || en(m ?? document.body, {
            select: !0
          }), s.removeEventListener(ni, f), xc.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    d,
    f,
    p
  ]);
  const y = he((m) => {
    if (!n && !r || p.paused) return;
    const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, $ = document.activeElement;
    if (b && $) {
      const w = m.currentTarget, [E, P] = yR(w);
      E && P ? !m.shiftKey && $ === P ? (m.preventDefault(), n && en(E, {
        select: !0
      })) : m.shiftKey && $ === E && (m.preventDefault(), n && en(P, {
        select: !0
      })) : $ === w && m.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ Y(at.div, ft({
    tabIndex: -1
  }, l, {
    ref: h,
    onKeyDown: y
  }));
});
function gR(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (en(r, {
      select: t
    }), document.activeElement !== n) return;
}
function yR(e) {
  const t = hm(e), n = Ec(t, e), r = Ec(t.reverse(), e);
  return [
    n,
    r
  ];
}
function hm(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Ec(e, t) {
  for (const n of e)
    if (!bR(n, {
      upTo: t
    })) return n;
}
function bR(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function wR(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function en(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && wR(e) && t && e.select();
  }
}
const xc = $R();
function $R() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Mc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Mc(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Mc(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function ER(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const jn = globalThis != null && globalThis.document ? _n : () => {
}, xR = g.useId || (() => {
});
let MR = 0;
function mm(e) {
  const [t, n] = g.useState(xR());
  return jn(() => {
    n(
      (r) => r ?? String(MR++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const CR = /* @__PURE__ */ me((e, t) => {
  const { children: n, width: r = 10, height: a = 5, ...i } = e;
  return /* @__PURE__ */ Y(at.svg, ft({}, i, {
    ref: t,
    width: r,
    height: a,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ Y("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), PR = CR;
function vm(e) {
  const [t, n] = Ae(void 0);
  return jn(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let l, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          l = d.inlineSize, s = d.blockSize;
        } else
          l = e.offsetWidth, s = e.offsetHeight;
        n({
          width: l,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const pm = "Popper", [gm, fo] = Vr(pm), [SR, ym] = gm(pm), FR = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = Ae(null);
  return /* @__PURE__ */ Y(SR, {
    scope: t,
    anchor: r,
    onAnchorChange: a
  }, n);
}, zR = "PopperAnchor", NR = /* @__PURE__ */ me((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...a } = e, i = ym(zR, n), l = ve(null), s = Ue(t, l);
  return Ce(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || l.current);
  }), r ? null : /* @__PURE__ */ Y(at.div, ft({}, a, {
    ref: s
  }));
}), bm = "PopperContent", [DR, OR] = gm(bm), AR = /* @__PURE__ */ me((e, t) => {
  var n, r, a, i, l, s, c, d;
  const { __scopePopper: f, side: u = "bottom", sideOffset: h = 0, align: p = "center", alignOffset: y = 0, arrowPadding: m = 0, avoidCollisions: b = !0, collisionBoundary: $ = [], collisionPadding: w = 0, sticky: E = "partial", hideWhenDetached: P = !1, updatePositionStrategy: x = "optimized", onPlaced: F, ...z } = e, N = ym(bm, f), [A, _] = Ae(null), B = Ue(
    t,
    (Ie) => _(Ie)
  ), [j, ee] = Ae(null), R = vm(j), X = (n = R == null ? void 0 : R.width) !== null && n !== void 0 ? n : 0, V = (r = R == null ? void 0 : R.height) !== null && r !== void 0 ? r : 0, G = u + (p !== "center" ? "-" + p : ""), ne = typeof w == "number" ? w : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...w
  }, k = Array.isArray($) ? $ : [
    $
  ], D = k.length > 0, O = {
    padding: ne,
    boundary: k.filter(RR),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: D
  }, { refs: J, floatingStyles: oe, placement: te, isPositioned: se, middlewareData: Q } = i2({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: G,
    whileElementsMounted: (...Ie) => a2(...Ie, {
      animationFrame: x === "always"
    }),
    elements: {
      reference: N.anchor
    },
    middleware: [
      l2({
        mainAxis: h + V,
        alignmentAxis: y
      }),
      b && s2({
        mainAxis: !0,
        crossAxis: !1,
        limiter: E === "partial" ? c2() : void 0,
        ...O
      }),
      b && d2({
        ...O
      }),
      u2({
        ...O,
        apply: ({ elements: Ie, rects: Ke, availableWidth: ht, availableHeight: Kt }) => {
          const { width: ot, height: Zn } = Ke.reference, Xt = Ie.floating.style;
          Xt.setProperty("--radix-popper-available-width", `${ht}px`), Xt.setProperty("--radix-popper-available-height", `${Kt}px`), Xt.setProperty("--radix-popper-anchor-width", `${ot}px`), Xt.setProperty("--radix-popper-anchor-height", `${Zn}px`);
        }
      }),
      j && h2({
        element: j,
        padding: m
      }),
      _R({
        arrowWidth: X,
        arrowHeight: V
      }),
      P && f2({
        strategy: "referenceHidden",
        ...O
      })
    ]
  }), [H, U] = wm(te), q = on(F);
  jn(() => {
    se && (q == null || q());
  }, [
    se,
    q
  ]);
  const W = (a = Q.arrow) === null || a === void 0 ? void 0 : a.x, de = (i = Q.arrow) === null || i === void 0 ? void 0 : i.y, T = ((l = Q.arrow) === null || l === void 0 ? void 0 : l.centerOffset) !== 0, [Se, Le] = Ae();
  return jn(() => {
    A && Le(window.getComputedStyle(A).zIndex);
  }, [
    A
  ]), /* @__PURE__ */ Y("div", {
    ref: J.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...oe,
      transform: se ? oe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Se,
      "--radix-popper-transform-origin": [
        (s = Q.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = Q.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ Y(DR, {
    scope: f,
    placedSide: H,
    onArrowChange: ee,
    arrowX: W,
    arrowY: de,
    shouldHideArrow: T
  }, /* @__PURE__ */ Y(at.div, ft({
    "data-side": H,
    "data-align": U
  }, z, {
    ref: B,
    style: {
      ...z.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: se ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (d = Q.hide) !== null && d !== void 0 && d.referenceHidden ? 0 : void 0
    }
  }))));
}), TR = "PopperArrow", kR = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, HR = /* @__PURE__ */ me(function(t, n) {
  const { __scopePopper: r, ...a } = t, i = OR(TR, r), l = kR[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ Y("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [l]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ Y(PR, ft({}, a, {
      ref: n,
      style: {
        ...a.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function RR(e) {
  return e !== null;
}
const _R = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, a, i, l;
    const { placement: s, rects: c, middlewareData: d } = t, u = ((n = d.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, h = u ? 0 : e.arrowWidth, p = u ? 0 : e.arrowHeight, [y, m] = wm(s), b = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[m], $ = ((r = (a = d.arrow) === null || a === void 0 ? void 0 : a.x) !== null && r !== void 0 ? r : 0) + h / 2, w = ((i = (l = d.arrow) === null || l === void 0 ? void 0 : l.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let E = "", P = "";
    return y === "bottom" ? (E = u ? b : `${$}px`, P = `${-p}px`) : y === "top" ? (E = u ? b : `${$}px`, P = `${c.floating.height + p}px`) : y === "right" ? (E = `${-p}px`, P = u ? b : `${w}px`) : y === "left" && (E = `${c.floating.width + p}px`, P = u ? b : `${w}px`), {
      data: {
        x: E,
        y: P
      }
    };
  }
});
function wm(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const $m = FR, Em = NR, xm = AR, Mm = HR, Cm = /* @__PURE__ */ me((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...a } = e;
  return r ? /* @__PURE__ */ Ac.createPortal(/* @__PURE__ */ Y(at.div, ft({}, a, {
    ref: t
  })), r) : null;
});
function IR(e, t) {
  return Oc((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const Gr = (e) => {
  const { present: t, children: n } = e, r = LR(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), i = Ue(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Qi(a, {
    ref: i
  }) : null;
};
Gr.displayName = "Presence";
function LR(e) {
  const [t, n] = Ae(), r = ve({}), a = ve(e), i = ve("none"), l = e ? "mounted" : "unmounted", [s, c] = IR(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ce(() => {
    const d = fa(r.current);
    i.current = s === "mounted" ? d : "none";
  }, [
    s
  ]), jn(() => {
    const d = r.current, f = a.current;
    if (f !== e) {
      const h = i.current, p = fa(d);
      e ? c("MOUNT") : p === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(f && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), jn(() => {
    if (t) {
      const d = (u) => {
        const p = fa(r.current).includes(u.animationName);
        u.target === t && p && Tc(
          () => c("ANIMATION_END")
        );
      }, f = (u) => {
        u.target === t && (i.current = fa(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: he((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function fa(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function r1({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = jR({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : r, s = on(n), c = he((d) => {
    if (i) {
      const u = typeof d == "function" ? d(e) : d;
      u !== e && s(u);
    } else a(d);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    l,
    c
  ];
}
function jR({ defaultProp: e, onChange: t }) {
  const n = Ae(e), [r] = n, a = ve(r), i = on(t);
  return Ce(() => {
    a.current !== r && (i(r), a.current = r);
  }, [
    r,
    a,
    i
  ]), n;
}
var Pm = R2(), ri = function() {
}, ho = g.forwardRef(function(e, t) {
  var n = g.useRef(null), r = g.useState({
    onScrollCapture: ri,
    onWheelCapture: ri,
    onTouchMoveCapture: ri
  }), a = r[0], i = r[1], l = e.forwardProps, s = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, u = e.shards, h = e.sideCar, p = e.noIsolation, y = e.inert, m = e.allowPinchZoom, b = e.as, $ = b === void 0 ? "div" : b, w = Fl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), E = h, P = H2([n, t]), x = qe(qe({}, w), a);
  return g.createElement(
    g.Fragment,
    null,
    f && g.createElement(E, { sideCar: Pm, removeScrollBar: d, shards: u, noIsolation: p, inert: y, setCallbacks: i, allowPinchZoom: !!m, lockRef: n }),
    l ? g.cloneElement(g.Children.only(s), qe(qe({}, x), { ref: P })) : g.createElement($, qe({}, x, { className: c, ref: P }), s)
  );
});
ho.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ho.classNames = {
  fullWidth: yr,
  zeroRight: gr
};
var Xi = !1;
if (typeof window < "u")
  try {
    var ha = Object.defineProperty({}, "passive", {
      get: function() {
        return Xi = !0, !0;
      }
    });
    window.addEventListener("test", ha, ha), window.removeEventListener("test", ha, ha);
  } catch {
    Xi = !1;
  }
var Nn = Xi ? { passive: !1 } : !1, BR = function(e) {
  return e.tagName === "TEXTAREA";
}, Sm = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !BR(e) && n[t] === "visible")
  );
}, WR = function(e) {
  return Sm(e, "overflowY");
}, VR = function(e) {
  return Sm(e, "overflowX");
}, Cc = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Fm(e, n);
    if (r) {
      var a = zm(e, n), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, GR = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, YR = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Fm = function(e, t) {
  return e === "v" ? WR(t) : VR(t);
}, zm = function(e, t) {
  return e === "v" ? GR(t) : YR(t);
}, UR = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, KR = function(e, t, n, r, a) {
  var i = UR(e, window.getComputedStyle(t).direction), l = i * r, s = n.target, c = t.contains(s), d = !1, f = l > 0, u = 0, h = 0;
  do {
    var p = zm(e, s), y = p[0], m = p[1], b = p[2], $ = m - b - i * y;
    (y || $) && Fm(e, s) && (u += $, h += y), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && u === 0 || !f && h === 0) && (d = !0), d;
}, ma = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Pc = function(e) {
  return [e.deltaX, e.deltaY];
}, Sc = function(e) {
  return e && "current" in e ? e.current : e;
}, XR = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, qR = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ZR = 0, Dn = [];
function JR(e) {
  var t = g.useRef([]), n = g.useRef([0, 0]), r = g.useRef(), a = g.useState(ZR++)[0], i = g.useState(function() {
    return zl();
  })[0], l = g.useRef(e);
  g.useEffect(function() {
    l.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var m = k2([e.lockRef.current], (e.shards || []).map(Sc), !0).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2)
      return !l.current.allowPinchZoom;
    var $ = ma(m), w = n.current, E = "deltaX" in m ? m.deltaX : w[0] - $[0], P = "deltaY" in m ? m.deltaY : w[1] - $[1], x, F = m.target, z = Math.abs(E) > Math.abs(P) ? "h" : "v";
    if ("touches" in m && z === "h" && F.type === "range")
      return !1;
    var N = Cc(z, F);
    if (!N)
      return !0;
    if (N ? x = z : (x = z === "v" ? "h" : "v", N = Cc(z, F)), !N)
      return !1;
    if (!r.current && "changedTouches" in m && (E || P) && (r.current = x), !x)
      return !0;
    var A = r.current || x;
    return KR(A, b, m, A === "h" ? E : P);
  }, []), c = g.useCallback(function(m) {
    var b = m;
    if (!(!Dn.length || Dn[Dn.length - 1] !== i)) {
      var $ = "deltaY" in b ? Pc(b) : ma(b), w = t.current.filter(function(x) {
        return x.name === b.type && x.target === b.target && XR(x.delta, $);
      })[0];
      if (w && w.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!w) {
        var E = (l.current.shards || []).map(Sc).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), P = E.length > 0 ? s(b, E[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), d = g.useCallback(function(m, b, $, w) {
    var E = { name: m, delta: b, target: $, should: w };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== E;
      });
    }, 1);
  }, []), f = g.useCallback(function(m) {
    n.current = ma(m), r.current = void 0;
  }, []), u = g.useCallback(function(m) {
    d(m.type, Pc(m), m.target, s(m, e.lockRef.current));
  }, []), h = g.useCallback(function(m) {
    d(m.type, ma(m), m.target, s(m, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Dn.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, Nn), document.addEventListener("touchmove", c, Nn), document.addEventListener("touchstart", f, Nn), function() {
      Dn = Dn.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", c, Nn), document.removeEventListener("touchmove", c, Nn), document.removeEventListener("touchstart", f, Nn);
    };
  }, []);
  var p = e.removeScrollBar, y = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    y ? g.createElement(i, { styles: qR(a) }) : null,
    p ? g.createElement(j2, { gapMode: "margin" }) : null
  );
}
const QR = I2(Pm, JR);
var Nm = g.forwardRef(function(e, t) {
  return g.createElement(ho, qe({}, e, { ref: t, sideCar: QR }));
});
Nm.classNames = ho.classNames;
const Dm = "Popover", [Om] = Vr(Dm, [
  fo
]), mo = fo(), [e_, $n] = Om(Dm), t_ = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: a, onOpenChange: i, modal: l = !1 } = e, s = mo(t), c = ve(null), [d, f] = Ae(!1), [u = !1, h] = r1({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ Y($m, s, /* @__PURE__ */ Y(e_, {
    scope: t,
    contentId: mm(),
    triggerRef: c,
    open: u,
    onOpenChange: h,
    onOpenToggle: he(
      () => h(
        (p) => !p
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: d,
    onCustomAnchorAdd: he(
      () => f(!0),
      []
    ),
    onCustomAnchorRemove: he(
      () => f(!1),
      []
    ),
    modal: l
  }, n));
}, n_ = "PopoverTrigger", r_ = /* @__PURE__ */ me((e, t) => {
  const { __scopePopover: n, ...r } = e, a = $n(n_, n), i = mo(n), l = Ue(t, a.triggerRef), s = /* @__PURE__ */ Y(at.button, He({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": km(a.open)
  }, r, {
    ref: l,
    onClick: We(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ Y(Em, He({
    asChild: !0
  }, i), s);
}), Am = "PopoverPortal", [a_, o_] = Om(Am, {
  forceMount: void 0
}), i_ = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: a } = e, i = $n(Am, t);
  return /* @__PURE__ */ Y(a_, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Y(Gr, {
    present: n || i.open
  }, /* @__PURE__ */ Y(Cm, {
    asChild: !0,
    container: a
  }, r)));
}, Nr = "PopoverContent", l_ = /* @__PURE__ */ me((e, t) => {
  const n = o_(Nr, e.__scopePopover), { forceMount: r = n.forceMount, ...a } = e, i = $n(Nr, e.__scopePopover);
  return /* @__PURE__ */ Y(Gr, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Y(s_, He({}, a, {
    ref: t
  })) : /* @__PURE__ */ Y(c_, He({}, a, {
    ref: t
  })));
}), s_ = /* @__PURE__ */ me((e, t) => {
  const n = $n(Nr, e.__scopePopover), r = ve(null), a = Ue(t, r), i = ve(!1);
  return Ce(() => {
    const l = r.current;
    if (l) return Za(l);
  }, []), /* @__PURE__ */ Y(Nm, {
    as: zr,
    allowPinchZoom: !0
  }, /* @__PURE__ */ Y(Tm, He({}, e, {
    ref: a,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: We(e.onCloseAutoFocus, (l) => {
      var s;
      l.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: We(e.onPointerDownOutside, (l) => {
      const s = l.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, d = s.button === 2 || c;
      i.current = d;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: We(
      e.onFocusOutside,
      (l) => l.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), c_ = /* @__PURE__ */ me((e, t) => {
  const n = $n(Nr, e.__scopePopover), r = ve(!1), a = ve(!1);
  return /* @__PURE__ */ Y(Tm, He({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var l;
      if ((l = e.onCloseAutoFocus) === null || l === void 0 || l.call(e, i), !i.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      r.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var l, s;
      (l = e.onInteractOutside) === null || l === void 0 || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), Tm = /* @__PURE__ */ me((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: l, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: d, onInteractOutside: f, ...u } = e, h = $n(Nr, n), p = mo(n);
  return vR(), /* @__PURE__ */ Y(pR, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Y(um, {
    asChild: !0,
    disableOutsidePointerEvents: l,
    onInteractOutside: f,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: d,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ Y(xm, He({
    "data-state": km(h.open),
    role: "dialog",
    id: h.contentId
  }, p, u, {
    ref: t,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), d_ = "PopoverClose", u_ = /* @__PURE__ */ me((e, t) => {
  const { __scopePopover: n, ...r } = e, a = $n(d_, n);
  return /* @__PURE__ */ Y(at.button, He({
    type: "button"
  }, r, {
    ref: t,
    onClick: We(
      e.onClick,
      () => a.onOpenChange(!1)
    )
  }));
}), f_ = /* @__PURE__ */ me((e, t) => {
  const { __scopePopover: n, ...r } = e, a = mo(n);
  return /* @__PURE__ */ Y(Mm, He({}, a, r, {
    ref: t
  }));
});
function km(e) {
  return e ? "open" : "closed";
}
const h_ = t_, m_ = r_, v_ = i_, Hm = l_, p_ = u_, g_ = f_, Rm = me(
  ({
    className: e,
    align: t = "center",
    sideOffset: n = 4,
    children: r,
    arrow: a,
    classNames: i,
    variant: l = "dark",
    portal: s = !0,
    ...c
  }, d) => {
    const f = /* @__PURE__ */ v.jsxs(
      Hm,
      {
        ref: d,
        align: t,
        sideOffset: n,
        className: K(
          [
            "relative z-[101] rounded-md bg-white p-2 text-sm text-text-primary shadow-md will-change-[transform,opacity]"
          ],
          { "bg-deepGray-500 text-white": l === "dark" },
          e
        ),
        ...c,
        children: [
          r,
          a && /* @__PURE__ */ v.jsx(
            g_,
            {
              "data-testid": "arrow",
              className: K("fill-white", { "fill-deepGray-500": l === "dark" }, i == null ? void 0 : i.arrow)
            }
          )
        ]
      }
    );
    return s ? /* @__PURE__ */ v.jsx(v_, { children: f }) : f;
  }
);
Rm.displayName = Hm.displayName;
function a1(e) {
  return /* @__PURE__ */ v.jsx(h_, { ...e });
}
a1.Trigger = m_;
a1.Content = Rm;
a1.Close = p_;
const OL = YH, AL = UH, _m = Pe(
  [
    "flex",
    "w-full",
    "items-center",
    "justify-between",
    "text-left",
    "rounded",
    "bg-white",
    "border",
    "border-stroke",
    "px-4",
    "py-3",
    "hover:border-lightBlue-500",
    "focus:outline-none",
    "focus-visible:border-lightBlue-500",
    "focus-visible:ring-2",
    "focus-visible:ring-lightBlue-500",
    "disabled:bg-gray-200",
    "disabled:border-stroke",
    "disabled:opacity-38",
    "disabled:hover:border-stroke",
    "data-[state=open]:border-lightBlue-500",
    "data-[state=open]:ring-2",
    "data-[state=open]:ring-lightBlue-500",
    "data-[placeholder]:text-text-secondary",
    "[&>span]:truncate"
  ],
  {
    variants: {
      hasError: {
        true: [
          "border-error-600",
          "hover:border-error-600",
          "focus-visible:border-error-400",
          "focus-visible:ring-error-400",
          "data-[state=open]:border-error-400",
          "data-[state=open]:ring-error-400"
        ]
      },
      hasSuccess: {
        true: [
          "border-primary-500",
          "hover:border-primary-500",
          "focus-visible:border-primary-400",
          "focus-visible:ring-primary-400",
          "data-[state=open]:border-primary-400",
          "data-[state=open]:ring-primary-400"
        ]
      },
      isRound: {
        true: ["rounded-full"]
      },
      size: {
        sm: ["px-3", "py-2", "text-sm"]
      }
    }
  }
), Im = g.forwardRef(({ className: e, children: t, hasError: n, hasSuccess: r, isRound: a = !1, size: i, ...l }, s) => /* @__PURE__ */ v.jsxs(
  t1,
  {
    ref: s,
    className: K(_m({ hasError: n, hasSuccess: r, isRound: a, size: i }), e),
    ...l,
    children: [
      t,
      /* @__PURE__ */ v.jsx(am, { asChild: !0, children: /* @__PURE__ */ v.jsx(kc, { className: K("ml-4 h-4 w-4 shrink-0 fill-text-primary", { "ml-3": i === "sm" }) }) })
    ]
  }
));
Im.displayName = t1.displayName;
const y_ = g.forwardRef(({ className: e, children: t, icon: n, iconFill: r, isRound: a = !0, label: i, size: l, ...s }, c) => {
  const d = n;
  return /* @__PURE__ */ v.jsx(Im, { ref: c, className: K(_m({ isRound: a, size: l }), e), ...s, children: /* @__PURE__ */ v.jsxs("span", { className: "flex items-center gap-1", children: [
    d && /* @__PURE__ */ v.jsx("span", { children: /* @__PURE__ */ v.jsx(d, { className: K("h-6 w-6", { "h-5 w-5": l === "sm" }, r) }) }),
    /* @__PURE__ */ v.jsxs("span", { className: "text-text-secondary", children: [
      i,
      ":"
    ] }),
    /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: t })
  ] }) });
});
y_.displayName = "SelectFilterTrigger";
const b_ = g.forwardRef(({ children: e, className: t, position: n = "popper", ...r }, a) => /* @__PURE__ */ v.jsx(om, { children: /* @__PURE__ */ v.jsx(
  n1,
  {
    ref: a,
    className: K(
      "relative z-50 max-h-64 overflow-hidden rounded border border-stroke bg-white shadow",
      n === "popper" && "data-[side=bottom]:translate-y-2 data-[side=left]:-translate-x-2 data-[side=right]:translate-x-2 data-[side=top]:-translate-y-2"
    ),
    position: n,
    ...r,
    children: /* @__PURE__ */ v.jsx(
      im,
      {
        className: K(
          "py-1",
          n === "popper" && "h-[var(--radix-select-trigger-height)] min-w-[var(--radix-select-trigger-width)] max-w-[var(--radix-select-trigger-width)]",
          t
        ),
        children: e
      }
    )
  }
) }));
b_.displayName = n1.displayName;
const w_ = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ v.jsx(
  ka,
  {
    ref: r,
    className: K(
      "my-1 flex w-full cursor-pointer select-none items-center px-4 py-2 outline-none data-[disabled]:pointer-events-none data-[highlighted]:bg-lightBlue-500/5 data-[state=checked]:bg-lightBlue-500/10 data-[disabled]:opacity-38 data-[state=checked]:shadow-[inset_4px_0_0_0] data-[state=checked]:shadow-lightBlue-500 data-[highlighted]:outline-none [&>span]:truncate",
      e
    ),
    ...n,
    children: /* @__PURE__ */ v.jsx(Yi, { children: t })
  }
));
w_.displayName = ka.displayName;
const $_ = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ v.jsx(lm, { ref: n, className: K("my-1 h-px bg-gray-200", e), ...t }));
$_.displayName = lm.displayName;
const Ha = Pe(["h-5", "w-5", "fill-text-secondary"], {
  variants: {
    disabled: { true: ["opacity-38"] },
    hasError: { true: ["fill-error-800"] },
    hasSuccess: { true: ["fill-success-800"] },
    isStartIcon: { true: [] },
    size: {
      sm: ["h-4", "w-4"]
    }
  },
  compoundVariants: [
    {
      hasError: !0,
      disabled: !0,
      class: ["fill-text-secondary"]
    },
    {
      hasSuccess: !0,
      disabled: !0,
      class: ["fill-text-secondary"]
    },
    {
      hasError: !0,
      isStartIcon: !0,
      class: ["fill-text-secondary"]
    },
    {
      hasSuccess: !0,
      isStartIcon: !0,
      class: ["fill-text-secondary"]
    }
  ]
}), E_ = Pe(
  [
    "rounded",
    "border",
    "border-stroke",
    "pt-3",
    "pr-4",
    "pb-3",
    "pl-4",
    "w-full",
    "hover:border-lightBlue-500",
    "focus-visible:outline-none",
    "focus-visible:border-lightBlue-500",
    "focus-visible:ring-2",
    "focus-visible:ring-lightBlue-500",
    "disabled:bg-gray-200",
    "disabled:border-stroke",
    "disabled:hover:border-stroke",
    "disabled:opacity-38",
    "placeholder:text-text-secondary"
  ],
  {
    variants: {
      hasEndSlot: { true: ["pr-11"] },
      hasStartSlot: { true: ["pl-11"] },
      hasError: {
        true: [
          "border-error-600",
          "hover:border-error-600",
          "focus-visible:border-error-400",
          "focus-visible:ring-error-400"
        ]
      },
      hasSuccess: {
        true: [
          "border-success-500",
          "hover:border-success-500",
          "focus-visible:border-success-400",
          "focus-visible:ring-success-400"
        ]
      },
      size: {
        sm: ["pt-2", "pr-3", "pb-2", "pl-3"]
      }
    },
    compoundVariants: [
      {
        hasEndSlot: !0,
        size: "sm",
        class: ["pr-8"]
      },
      {
        hasStartSlot: !0,
        size: "sm",
        class: ["pl-8"]
      },
      {
        hasEndSlot: !0,
        hasStartSlot: !0,
        class: ["pr-11", "pl-11"]
      },
      {
        hasEndSlot: !0,
        hasStartSlot: !0,
        size: "sm",
        class: ["pr-8", "pl-8"]
      }
    ]
  }
), o1 = me(
  ({ className: e, endSlot: t, startSlot: n, hasError: r = !1, hasSuccess: a = !1, size: i, ...l }, s) => {
    const c = !!t, d = !!n;
    return /* @__PURE__ */ v.jsxs("div", { className: K("relative w-fit", e), children: [
      n && /* @__PURE__ */ v.jsx("div", { className: K("absolute inset-y-0 left-0 flex items-center pl-4", { "pl-3": i === "sm" }), children: n.component }),
      /* @__PURE__ */ v.jsx(
        "input",
        {
          ref: s,
          "aria-invalid": !!r,
          className: K(E_({ hasEndSlot: c, hasError: r, hasSuccess: a, hasStartSlot: d, size: i })),
          type: "text",
          ...l
        }
      ),
      t && /* @__PURE__ */ v.jsx(
        "div",
        {
          className: K("absolute inset-y-0 right-0 flex items-center pr-4", {
            "pr-3": i === "sm" || t.type === "button",
            "pr-2": i === "sm" && t.type === "button"
          }),
          children: t.component
        }
      )
    ] });
  }
);
o1.displayName = "BaseInput";
const x_ = me(
  ({
    className: e,
    hasError: t = !1,
    hasSuccess: n = !1,
    onChange: r,
    onClear: a,
    size: i,
    value: l,
    withSearchIcon: s = !1,
    ...c
  }, d) => {
    const f = {
      disabled: c.disabled,
      size: i
    }, [u, h] = Ae(l ?? ""), p = (m) => {
      h(m.target.value), r == null || r(m);
    }, y = () => {
      h(""), a == null || a();
    };
    return /* @__PURE__ */ v.jsx(
      o1,
      {
        ref: d,
        className: e,
        endSlot: {
          component: /* @__PURE__ */ v.jsx(
            "button",
            {
              className: K("invisible rounded-full p-0.5 hover:bg-secondary-100", {
                visible: u.toString().length > 0
              }),
              onClick: y,
              type: "button",
              children: /* @__PURE__ */ v.jsx(Bn, { className: Ha({ ...f, isStartIcon: !1 }) })
            }
          ),
          type: "button"
        },
        hasError: t,
        hasSuccess: n,
        onChange: p,
        size: i,
        startSlot: s ? {
          component: /* @__PURE__ */ v.jsx(k6, { className: Ha({ ...f, isStartIcon: !0 }) }),
          type: "icon"
        } : void 0,
        value: u,
        ...c
      }
    );
  }
);
x_.displayName = "SearchInput";
function Lm(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
const M_ = /* @__PURE__ */ jt(void 0);
function C_(e) {
  const t = gt(M_);
  return e || t || "ltr";
}
function P_(e) {
  const t = ve({
    value: e,
    previous: e
  });
  return Ze(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function S_(e) {
  const t = e + "CollectionProvider", [n, r] = Vr(t), [a, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), l = (p) => {
    const { scope: y, children: m } = p, b = o.useRef(null), $ = o.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ o.createElement(a, {
      scope: y,
      itemMap: $,
      collectionRef: b
    }, m);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ o.forwardRef((p, y) => {
    const { scope: m, children: b } = p, $ = i(s, m), w = Ue(y, $.collectionRef);
    return /* @__PURE__ */ o.createElement(zr, {
      ref: w
    }, b);
  }), d = e + "CollectionItemSlot", f = "data-radix-collection-item", u = /* @__PURE__ */ o.forwardRef((p, y) => {
    const { scope: m, children: b, ...$ } = p, w = o.useRef(null), E = Ue(y, w), P = i(d, m);
    return o.useEffect(() => (P.itemMap.set(w, {
      ref: w,
      ...$
    }), () => void P.itemMap.delete(w))), /* @__PURE__ */ o.createElement(zr, {
      [f]: "",
      ref: E
    }, b);
  });
  function h(p) {
    const y = i(e + "CollectionConsumer", p);
    return o.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const $ = Array.from(b.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, x) => $.indexOf(P.ref.current) - $.indexOf(x.ref.current)
      );
    }, [
      y.collectionRef,
      y.itemMap
    ]);
  }
  return [
    {
      Provider: l,
      Slot: c,
      ItemSlot: u
    },
    h,
    r
  ];
}
const jm = [
  "PageUp",
  "PageDown"
], Bm = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], Wm = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, Yr = "Slider", [qi, F_, z_] = S_(Yr), [Vm, N_] = Vr(Yr, [
  z_
]), [D_, vo] = Vm(Yr), Gm = /* @__PURE__ */ me((e, t) => {
  const { name: n, min: r = 0, max: a = 100, step: i = 1, orientation: l = "horizontal", disabled: s = !1, minStepsBetweenThumbs: c = 0, defaultValue: d = [
    r
  ], value: f, onValueChange: u = () => {
  }, onValueCommit: h = () => {
  }, inverted: p = !1, ...y } = e, [m, b] = Ae(null), $ = Ue(
    t,
    (R) => b(R)
  ), w = ve(/* @__PURE__ */ new Set()), E = ve(0), P = l === "horizontal", x = m ? !!m.closest("form") : !0, F = P ? O_ : A_, [z = [], N] = r1({
    prop: f,
    defaultProp: d,
    onChange: (R) => {
      var X;
      (X = [
        ...w.current
      ][E.current]) === null || X === void 0 || X.focus(), u(R);
    }
  }), A = ve(z);
  function _(R) {
    const X = I_(z, R);
    ee(R, X);
  }
  function B(R) {
    ee(R, E.current);
  }
  function j() {
    const R = A.current[E.current];
    z[E.current] !== R && h(z);
  }
  function ee(R, X, { commit: V } = {
    commit: !1
  }) {
    const G = W_(i), ne = V_(Math.round((R - r) / i) * i + r, G), k = Lm(ne, [
      r,
      a
    ]);
    N((D = []) => {
      const O = R_(D, k, X);
      if (B_(O, c * i)) {
        E.current = O.indexOf(k);
        const J = String(O) !== String(D);
        return J && V && h(O), J ? O : D;
      } else return D;
    });
  }
  return /* @__PURE__ */ Y(D_, {
    scope: e.__scopeSlider,
    disabled: s,
    min: r,
    max: a,
    valueIndexToChangeRef: E,
    thumbs: w.current,
    values: z,
    orientation: l
  }, /* @__PURE__ */ Y(qi.Provider, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ Y(qi.Slot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ Y(F, He({
    "aria-disabled": s,
    "data-disabled": s ? "" : void 0
  }, y, {
    ref: $,
    onPointerDown: We(y.onPointerDown, () => {
      s || (A.current = z);
    }),
    min: r,
    max: a,
    inverted: p,
    onSlideStart: s ? void 0 : _,
    onSlideMove: s ? void 0 : B,
    onSlideEnd: s ? void 0 : j,
    onHomeKeyDown: () => !s && ee(r, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !s && ee(a, z.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: R, direction: X }) => {
      if (!s) {
        const ne = jm.includes(R.key) || R.shiftKey && Bm.includes(R.key) ? 10 : 1, k = E.current, D = z[k], O = i * ne * X;
        ee(D + O, k, {
          commit: !0
        });
      }
    }
  })))), x && z.map(
    (R, X) => /* @__PURE__ */ Y(H_, {
      key: X,
      name: n ? n + (z.length > 1 ? "[]" : "") : void 0,
      value: R
    })
  ));
}), [Ym, Um] = Vm(Yr, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), O_ = /* @__PURE__ */ me((e, t) => {
  const { min: n, max: r, dir: a, inverted: i, onSlideStart: l, onSlideMove: s, onSlideEnd: c, onStepKeyDown: d, ...f } = e, [u, h] = Ae(null), p = Ue(
    t,
    (E) => h(E)
  ), y = ve(), m = C_(a), b = m === "ltr", $ = b && !i || !b && i;
  function w(E) {
    const P = y.current || u.getBoundingClientRect(), x = [
      0,
      P.width
    ], z = i1(x, $ ? [
      n,
      r
    ] : [
      r,
      n
    ]);
    return y.current = P, z(E - P.left);
  }
  return /* @__PURE__ */ Y(Ym, {
    scope: e.__scopeSlider,
    startEdge: $ ? "left" : "right",
    endEdge: $ ? "right" : "left",
    direction: $ ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ Y(Km, He({
    dir: m,
    "data-orientation": "horizontal"
  }, f, {
    ref: p,
    style: {
      ...f.style,
      "--radix-slider-thumb-transform": "translateX(-50%)"
    },
    onSlideStart: (E) => {
      const P = w(E.clientX);
      l == null || l(P);
    },
    onSlideMove: (E) => {
      const P = w(E.clientX);
      s == null || s(P);
    },
    onSlideEnd: () => {
      y.current = void 0, c == null || c();
    },
    onStepKeyDown: (E) => {
      const x = Wm[$ ? "from-left" : "from-right"].includes(E.key);
      d == null || d({
        event: E,
        direction: x ? -1 : 1
      });
    }
  })));
}), A_ = /* @__PURE__ */ me((e, t) => {
  const { min: n, max: r, inverted: a, onSlideStart: i, onSlideMove: l, onSlideEnd: s, onStepKeyDown: c, ...d } = e, f = ve(null), u = Ue(t, f), h = ve(), p = !a;
  function y(m) {
    const b = h.current || f.current.getBoundingClientRect(), $ = [
      0,
      b.height
    ], E = i1($, p ? [
      r,
      n
    ] : [
      n,
      r
    ]);
    return h.current = b, E(m - b.top);
  }
  return /* @__PURE__ */ Y(Ym, {
    scope: e.__scopeSlider,
    startEdge: p ? "bottom" : "top",
    endEdge: p ? "top" : "bottom",
    size: "height",
    direction: p ? 1 : -1
  }, /* @__PURE__ */ Y(Km, He({
    "data-orientation": "vertical"
  }, d, {
    ref: u,
    style: {
      ...d.style,
      "--radix-slider-thumb-transform": "translateY(50%)"
    },
    onSlideStart: (m) => {
      const b = y(m.clientY);
      i == null || i(b);
    },
    onSlideMove: (m) => {
      const b = y(m.clientY);
      l == null || l(b);
    },
    onSlideEnd: () => {
      h.current = void 0, s == null || s();
    },
    onStepKeyDown: (m) => {
      const $ = Wm[p ? "from-bottom" : "from-top"].includes(m.key);
      c == null || c({
        event: m,
        direction: $ ? -1 : 1
      });
    }
  })));
}), Km = /* @__PURE__ */ me((e, t) => {
  const { __scopeSlider: n, onSlideStart: r, onSlideMove: a, onSlideEnd: i, onHomeKeyDown: l, onEndKeyDown: s, onStepKeyDown: c, ...d } = e, f = vo(Yr, n);
  return /* @__PURE__ */ Y(at.span, He({}, d, {
    ref: t,
    onKeyDown: We(e.onKeyDown, (u) => {
      u.key === "Home" ? (l(u), u.preventDefault()) : u.key === "End" ? (s(u), u.preventDefault()) : jm.concat(Bm).includes(u.key) && (c(u), u.preventDefault());
    }),
    onPointerDown: We(e.onPointerDown, (u) => {
      const h = u.target;
      h.setPointerCapture(u.pointerId), u.preventDefault(), f.thumbs.has(h) ? h.focus() : r(u);
    }),
    onPointerMove: We(e.onPointerMove, (u) => {
      u.target.hasPointerCapture(u.pointerId) && a(u);
    }),
    onPointerUp: We(e.onPointerUp, (u) => {
      const h = u.target;
      h.hasPointerCapture(u.pointerId) && (h.releasePointerCapture(u.pointerId), i(u));
    })
  }));
}), T_ = "SliderTrack", Xm = /* @__PURE__ */ me((e, t) => {
  const { __scopeSlider: n, ...r } = e, a = vo(T_, n);
  return /* @__PURE__ */ Y(at.span, He({
    "data-disabled": a.disabled ? "" : void 0,
    "data-orientation": a.orientation
  }, r, {
    ref: t
  }));
}), Fc = "SliderRange", qm = /* @__PURE__ */ me((e, t) => {
  const { __scopeSlider: n, ...r } = e, a = vo(Fc, n), i = Um(Fc, n), l = ve(null), s = Ue(t, l), c = a.values.length, d = a.values.map(
    (h) => Jm(h, a.min, a.max)
  ), f = c > 1 ? Math.min(...d) : 0, u = 100 - Math.max(...d);
  return /* @__PURE__ */ Y(at.span, He({
    "data-orientation": a.orientation,
    "data-disabled": a.disabled ? "" : void 0
  }, r, {
    ref: s,
    style: {
      ...e.style,
      [i.startEdge]: f + "%",
      [i.endEdge]: u + "%"
    }
  }));
}), zc = "SliderThumb", Zm = /* @__PURE__ */ me((e, t) => {
  const n = F_(e.__scopeSlider), [r, a] = Ae(null), i = Ue(
    t,
    (s) => a(s)
  ), l = Ze(
    () => r ? n().findIndex(
      (s) => s.ref.current === r
    ) : -1,
    [
      n,
      r
    ]
  );
  return /* @__PURE__ */ Y(k_, He({}, e, {
    ref: i,
    index: l
  }));
}), k_ = /* @__PURE__ */ me((e, t) => {
  const { __scopeSlider: n, index: r, ...a } = e, i = vo(zc, n), l = Um(zc, n), [s, c] = Ae(null), d = Ue(
    t,
    (b) => c(b)
  ), f = vm(s), u = i.values[r], h = u === void 0 ? 0 : Jm(u, i.min, i.max), p = __(r, i.values.length), y = f == null ? void 0 : f[l.size], m = y ? L_(y, h, l.direction) : 0;
  return Ce(() => {
    if (s)
      return i.thumbs.add(s), () => {
        i.thumbs.delete(s);
      };
  }, [
    s,
    i.thumbs
  ]), /* @__PURE__ */ Y("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [l.startEdge]: `calc(${h}% + ${m}px)`
    }
  }, /* @__PURE__ */ Y(qi.ItemSlot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ Y(at.span, He({
    role: "slider",
    "aria-label": e["aria-label"] || p,
    "aria-valuemin": i.min,
    "aria-valuenow": u,
    "aria-valuemax": i.max,
    "aria-orientation": i.orientation,
    "data-orientation": i.orientation,
    "data-disabled": i.disabled ? "" : void 0,
    tabIndex: i.disabled ? void 0 : 0
  }, a, {
    ref: d,
    style: u === void 0 ? {
      display: "none"
    } : e.style,
    onFocus: We(e.onFocus, () => {
      i.valueIndexToChangeRef.current = r;
    })
  }))));
}), H_ = (e) => {
  const { value: t, ...n } = e, r = ve(null), a = P_(t);
  return Ce(() => {
    const i = r.current, l = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(l, "value").set;
    if (a !== t && c) {
      const d = new Event("input", {
        bubbles: !0
      });
      c.call(i, t), i.dispatchEvent(d);
    }
  }, [
    a,
    t
  ]), /* @__PURE__ */ Y("input", He({
    style: {
      display: "none"
    }
  }, n, {
    ref: r,
    defaultValue: t
  }));
};
function R_(e = [], t, n) {
  const r = [
    ...e
  ];
  return r[n] = t, r.sort(
    (a, i) => a - i
  );
}
function Jm(e, t, n) {
  const i = 100 / (n - t) * (e - t);
  return Lm(i, [
    0,
    100
  ]);
}
function __(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? [
    "Minimum",
    "Maximum"
  ][e] : void 0;
}
function I_(e, t) {
  if (e.length === 1) return 0;
  const n = e.map(
    (a) => Math.abs(a - t)
  ), r = Math.min(...n);
  return n.indexOf(r);
}
function L_(e, t, n) {
  const r = e / 2, i = i1([
    0,
    50
  ], [
    0,
    r
  ]);
  return (r - i(t) * n) * n;
}
function j_(e) {
  return e.slice(0, -1).map(
    (t, n) => e[n + 1] - t
  );
}
function B_(e, t) {
  if (t > 0) {
    const n = j_(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function i1(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function W_(e) {
  return (String(e).split(".")[1] || "").length;
}
function V_(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
const G_ = Gm, Y_ = Xm, U_ = qm, K_ = Zm, TL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Range: U_,
  Root: G_,
  Slider: Gm,
  SliderRange: qm,
  SliderThumb: Zm,
  SliderTrack: Xm,
  Thumb: K_,
  Track: Y_,
  createSliderScope: N_
}, Symbol.toStringTag, { value: "Module" })), Qm = jt({ queue: [] }), e6 = jt(null);
function X_(e, t) {
  return t.type === "enqueue" ? t.message.closeable ?? !0 ? { ...e, queue: [t.message, ...e.queue.filter((r) => !r.closeable)] } : { ...e, queue: [...e.queue, t.message] } : { ...e, queue: e.queue.filter((n) => n.id !== t.id) };
}
function kL({ children: e }) {
  const [t, n] = Oc(X_, { queue: [] });
  return /* @__PURE__ */ v.jsx(Qm.Provider, { value: t, children: /* @__PURE__ */ v.jsx(e6.Provider, { value: n, children: e }) });
}
const q_ = () => gt(Qm), Z_ = () => gt(e6), l1 = ({ className: e, fill: t }) => /* @__PURE__ */ v.jsxs(
  "svg",
  {
    "aria-hidden": "true",
    className: K("animate-spin p-1 text-transparent", e),
    fill: "none",
    viewBox: "0 0 100 101",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
          fill: t ?? "currentFill"
        }
      )
    ]
  }
), J_ = Pe(["fixed", "space-y-2", "z-50"], {
  variants: {
    vertical: {
      top: ["top-10"],
      bottom: ["bottom-10"]
    },
    horizontal: {
      left: ["left-10"],
      center: ["right-1/2", "translate-x-1/2"],
      right: ["right-10"]
    }
  }
}), Q_ = Pe(
  [
    "bg-deepGray-500",
    "flex",
    "items-center",
    "justify-between",
    "px-4",
    "py-2",
    "rounded-md",
    "shadow-lg",
    "text-white",
    "w-fit"
  ],
  {
    variants: {
      vertical: {
        top: [],
        bottom: []
      },
      horizontal: {
        left: [],
        center: [],
        right: []
      },
      action: {
        true: "py-2",
        false: "py-3"
      }
    },
    compoundVariants: [
      {
        vertical: "top",
        horizontal: "left",
        className: ["animate-top-left"]
      },
      {
        vertical: "top",
        horizontal: "right",
        className: ["animate-top-right"]
      },
      {
        vertical: "bottom",
        horizontal: "left",
        className: ["animate-bottom-left"]
      },
      {
        vertical: "bottom",
        horizontal: "right",
        className: ["animate-bottom-right"]
      },
      {
        vertical: "top",
        horizontal: "center",
        className: ["animate-top-center"]
      },
      {
        vertical: "bottom",
        horizontal: "center",
        className: ["animate-bottom-center"]
      }
    ]
  }
);
function HL({ vertical: e = "bottom", horizontal: t = "left" }) {
  const { queue: n } = q_(), r = new Vn();
  return /* @__PURE__ */ v.jsx("div", { className: J_({ vertical: e, horizontal: t }), children: n.map((a) => /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: Q_({
        vertical: e,
        horizontal: t,
        action: !!a.action
      }),
      children: [
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: K("text-sm", {
              "mr-8": a.action ?? a.closeable,
              "flex items-center gap-3": a.loading
            }),
            children: [
              a.loading && /* @__PURE__ */ v.jsx(l1, { className: "h-5 w-5 p-0", fill: "white" }),
              /* @__PURE__ */ v.jsx("span", { children: a.content })
            ]
          }
        ),
        /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
          a.action && /* @__PURE__ */ v.jsx(
            "button",
            {
              className: K("rounded-full px-2 py-1 font-bold text-lightBlue-400 hover:bg-white/10", {
                "mr-2": a.closeable
              }),
              onClick: a.action.onClick,
              onMouseDown: (i) => {
                r.apply(i, { color: ye.white, opacity: 0.1 });
              },
              type: "button",
              children: a.action.text
            }
          ),
          a.closeable && /* @__PURE__ */ v.jsx(
            "button",
            {
              "aria-label": "Close",
              className: "rounded-full p-1 text-xl hover:bg-white/10",
              onClick: a.onClose,
              type: "button",
              children: /* @__PURE__ */ v.jsx(Bn, { fill: ye.lightBlue[400] })
            }
          )
        ] })
      ]
    },
    a.id
  )) });
}
function RL() {
  const e = Z_();
  function t({ message: n, action: r, closeable: a = !0, delay: i = 8e3, loading: l = !1 }) {
    const s = q7(), c = a ? setTimeout(() => {
      e == null || e({ type: "dequeue", id: s });
    }, i) : null;
    e == null || e({
      type: "enqueue",
      message: {
        id: s,
        action: r,
        closeable: a,
        content: n,
        loading: l,
        onClose: () => {
          e == null || e({ type: "dequeue", id: s }), c && clearTimeout(c);
        },
        open: !0
      }
    });
  }
  return t;
}
function eI(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function Nc(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function t6(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((a) => {
      const i = Nc(a, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let a = 0; a < r.length; a++) {
          const i = r[a];
          typeof i == "function" ? i() : Nc(e[a], null);
        }
      };
  };
}
function tI(...e) {
  return g.useCallback(t6(...e), e);
}
var n6 = g.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = g.Children.toArray(n), i = a.find(rI);
  if (i) {
    const l = i.props.children, s = a.map((c) => c === i ? g.Children.count(l) > 1 ? g.Children.only(null) : g.isValidElement(l) ? l.props.children : null : c);
    return /* @__PURE__ */ v.jsx(Zi, { ...r, ref: t, children: g.isValidElement(l) ? g.cloneElement(l, void 0, s) : null });
  }
  return /* @__PURE__ */ v.jsx(Zi, { ...r, ref: t, children: n });
});
n6.displayName = "Slot";
var Zi = g.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (g.isValidElement(n)) {
    const a = oI(n);
    return g.cloneElement(n, {
      ...aI(r, n.props),
      // @ts-ignore
      ref: t ? t6(t, a) : a
    });
  }
  return g.Children.count(n) > 1 ? g.Children.only(null) : null;
});
Zi.displayName = "SlotClone";
var nI = ({ children: e }) => /* @__PURE__ */ v.jsx(v.Fragment, { children: e });
function rI(e) {
  return g.isValidElement(e) && e.type === nI;
}
function aI(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function oI(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var iI = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], r6 = iI.reduce((e, t) => {
  const n = g.forwardRef((r, a) => {
    const { asChild: i, ...l } = r, s = i ? n6 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v.jsx(s, { ...l, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), s1 = "Switch", [lI] = Rr(s1), [sI, cI] = lI(s1), a6 = g.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: a,
      defaultChecked: i,
      required: l,
      disabled: s,
      value: c = "on",
      onCheckedChange: d,
      form: f,
      ...u
    } = e, [h, p] = g.useState(null), y = tI(t, (E) => p(E)), m = g.useRef(!1), b = h ? f || !!h.closest("form") : !0, [$ = !1, w] = At({
      prop: a,
      defaultProp: i,
      onChange: d
    });
    return /* @__PURE__ */ v.jsxs(sI, { scope: n, checked: $, disabled: s, children: [
      /* @__PURE__ */ v.jsx(
        r6.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": $,
          "aria-required": l,
          "data-state": l6($),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...u,
          ref: y,
          onClick: eI(e.onClick, (E) => {
            w((P) => !P), b && (m.current = E.isPropagationStopped(), m.current || E.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v.jsx(
        dI,
        {
          control: h,
          bubbles: !m.current,
          name: r,
          value: c,
          checked: $,
          required: l,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
a6.displayName = s1;
var o6 = "SwitchThumb", i6 = g.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, a = cI(o6, n);
    return /* @__PURE__ */ v.jsx(
      r6.span,
      {
        "data-state": l6(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
i6.displayName = o6;
var dI = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...a } = e, i = g.useRef(null), l = Ah(n), s = v2(t);
  return g.useEffect(() => {
    const c = i.current, d = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (l !== n && u) {
      const h = new Event("click", { bubbles: r });
      u.call(c, n), c.dispatchEvent(h);
    }
  }, [l, n, r]), /* @__PURE__ */ v.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...a,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function l6(e) {
  return e ? "checked" : "unchecked";
}
var c1 = a6, s6 = i6;
const uI = Pe(
  [
    "cursor-pointer",
    "rounded-full",
    "outline-none",
    "flex",
    "items-center",
    "justify-center",
    "bg-deepGray-500/38",
    "[&_span]:data-[state=unchecked]:hover:ring-black/10",
    "[&_span]:data-[state=unchecked]:focus-visible:ring-black/20",
    "disabled:opacity-38",
    "disabled:cursor-default",
    "[&_span]:disabled:hover:ring-0"
  ],
  {
    variants: {
      size: {
        sm: ["h-2.5", "w-7", "[&_span]:hover:ring-4", "[&_span]:focus-visible:ring-4"],
        md: ["h-[14px]", "w-9", "[&_span]:hover:ring-8", "[&_span]:focus-visible:ring-8"]
      },
      variant: {
        secondary: [
          "data-[state=checked]:bg-secondary-500/50",
          "[&_span]:data-[state=checked]:hover:ring-secondary-500/10",
          "[&_span]:data-[state=checked]:focus-visible:ring-secondary-500/20"
        ],
        info: [
          "data-[state=checked]:bg-info-500/50",
          "[&_span]:data-[state=checked]:hover:ring-info-500/10",
          "[&_span]:data-[state=checked]:focus-visible:ring-info-500/20"
        ],
        primary: [
          "data-[state=checked]:bg-primary-500/50",
          "[&_span]:data-[state=checked]:hover:ring-primary-500/10",
          "[&_span]:data-[state=checked]:focus-visible:ring-primary-500/20"
        ]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), fI = Pe(
  [
    "block",
    "-translate-x-2",
    "rounded-full",
    "transition-transform",
    "duration-100",
    "will-change-transform",
    "shadow-sm",
    "shadow-black/40",
    "bg-gray-50",
    "[&_svg]:data-[state=checked]:fill-white",
    "[&_svg]:data-[state=unchecked]:fill-black/80"
  ],
  {
    variants: {
      size: {
        sm: ["h-4", "w-4", "data-[state=checked]:translate-x-[8px]"],
        md: ["h-5", "w-5", "data-[state=checked]:translate-x-[8px]"]
      },
      variant: {
        secondary: ["data-[state=checked]:bg-secondary-500"],
        info: ["data-[state=checked]:bg-info-500"],
        primary: ["data-[state=checked]:bg-primary-500"]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), hI = g.forwardRef(({ accessibilityLabel: e, className: t, loading: n, size: r = "md", variant: a = "primary", ...i }, l) => /* @__PURE__ */ v.jsxs(
  c1,
  {
    ref: l,
    className: K(uI({ size: r, variant: a }), t),
    disabled: n || i.disabled,
    ...i,
    children: [
      /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: e }),
      /* @__PURE__ */ v.jsx(s6, { className: K(fI({ size: r, variant: a })), children: n && /* @__PURE__ */ v.jsx(l1, { className: K("h-5 w-5", { "h-4 w-4": r === "sm" }) }) })
    ]
  }
));
hI.displayName = c1.displayName;
const mI = 'before:content-[" "]', vI = 'after:content-[" "]', pI = Pe(
  [
    "group",
    "peer",
    "h-full",
    "w-full",
    "rounded-md",
    "border",
    "bg-transparent",
    "px-3",
    "font-sans",
    "font-normal",
    "outline",
    "outline-0",
    "transition-all",
    "text-[0.875rem]",
    "py-2.5",
    "placeholder-shown:border",
    "focus:border-2",
    "focus:outline-0",
    "disabled:border-deepGray-500",
    "disabled:border-t-transparent",
    "placeholder-shown:disabled:border-t-deepGray-500",
    "placeholder-shown:disabled:border-t",
    "disabled:text-gray-800",
    "disabled:bg-deepGray-100"
  ],
  {
    variants: {
      lightBorder: {
        false: [],
        true: [
          "disabled:border-deepGray-200",
          "disabled:border-t-transparent",
          "placeholder-shown:disabled:border-t-deepGray-200",
          "placeholder-shown:disabled:border-t",
          "disabled:hover:border-deepGray-200",
          "disabled:hover:border-t-transparent",
          "placeholder-shown:disabled:hover:border-t-deepGray-200",
          "placeholder-shown:disabled:hover:border-t"
        ]
      },
      hasStartAdornment: {
        false: [],
        true: ["pl-10"]
      },
      hasEndAdornment: {
        false: [],
        true: ["pr-10"]
      },
      size: {
        normal: [],
        large: ["text-[1.125rem]", "py-4"]
      },
      state: {
        default: [
          "text-deepGray-700",
          "border-deepGray-500",
          "focus:border-success-700",
          "placeholder-shown:border-deepGray-500",
          "placeholder-shown:border-t-deepGray-500"
        ],
        error: [
          "text-error-500",
          "border-error-500",
          "focus:border-error-500",
          "placeholder-shown:border-error-500",
          "placeholder-shown:border-t-error-500"
        ],
        success: [
          "text-success-700",
          "border-success-700",
          "focus:border-success-700",
          "placeholder-shown:border-success-700",
          "placeholder-shown:border-t-success-700"
        ]
      },
      withLabel: {
        false: [],
        true: ["border-t-transparent", "focus:border-t-transparent"]
      }
    },
    defaultVariants: {
      state: "default"
    },
    compoundVariants: [
      {
        state: "default",
        lightBorder: !0,
        withLabel: !0,
        class: "border-deepGray-200 border-t-transparent placeholder-shown:border-deepGray-200 hover:border-text-primary hover:border-t-transparent placeholder-shown:hover:border-text-primary focus:hover:border-success-700 focus:hover:border-t-transparent"
      },
      {
        state: "default",
        lightBorder: !0,
        withLabel: !1,
        class: "border-deepGray-200 placeholder-shown:border-deepGray-200 hover:border-text-primary placeholder-shown:hover:border-text-primary focus:hover:border-success-700"
      }
    ]
  }
), gI = Pe(
  [
    mI,
    vI,
    "pointer-events-none",
    "absolute",
    "left-0",
    "-top-1.5",
    "flex",
    "h-full",
    "w-full",
    "select-none",
    "text-[0.875rem]",
    "font-normal",
    "leading-tight",
    "transition-all",
    "box-border",
    "before:pointer-events-none",
    "before:mt-[6.5px]",
    "before:mr-1",
    "before:box-border",
    "before:block",
    "before:h-1.5",
    "before:w-2.5",
    "before:rounded-tl-md",
    "before:border-t",
    "before:border-l",
    "before:transition-all",
    "after:pointer-events-none",
    "after:mt-[6.5px]",
    "after:ml-1",
    "after:box-border",
    "after:block",
    "after:grow",
    "after:rounded-tr-md",
    "after:border-t",
    "after:border-r",
    "after:transition-all",
    "peer-focus:leading-tight",
    "peer-placeholder-shown:leading-[3.75]",
    "peer-placeholder-shown:before:border-transparent",
    "peer-placeholder-shown:after:border-transparent",
    "peer-focus:before:border-t-2",
    "peer-focus:before:border-l-2",
    "peer-focus:after:border-t-2",
    "peer-focus:after:border-r-2",
    "peer-disabled:text-deepGray-400",
    "peer-disabled:before:border-t-deepGray-400",
    "peer-disabled:after:border-t-deepGray-400",
    "peer-disabled:peer-placeholder-shown:before:border-t-0",
    "peer-disabled:peer-placeholder-shown:after:border-t-0"
  ],
  {
    variants: {
      lightBorder: {
        false: [],
        true: [
          "peer-disabled:before:border-t-deepGray-200",
          "peer-disabled:before:border-l-0",
          "peer-disabled:after:border-t-deepGray-200",
          "peer-disabled:after:border-r-0",
          "peer-disabled:peer-hover:before:border-t-deepGray-200",
          "peer-disabled:peer-hover:after:border-t-deepGray-200",
          "peer-placeholder-shown:peer-disabled:peer-hover:before:border-t-0",
          "peer-placeholder-shown:peer-disabled:peer-hover:after:border-t-0"
        ]
      },
      size: {
        normal: [],
        large: [
          "text-[0.875rem]",
          "peer-focus:leading-[0.75]",
          "peer-placeholder-shown:text-[1.125rem]",
          "leading-[0.75]",
          "peer-placeholder-shown:leading-[3.75]"
        ]
      },
      hasStartAdornment: {
        false: [],
        true: ["peer-placeholder-shown:pl-6", "peer-focus:peer-placeholder-shown:pl-0"]
      },
      state: {
        default: [
          "text-deepGray-400",
          "peer-disabled:peer-placeholder-shown:text-deepGray-500",
          "peer-placeholder-shown:text-deepGray-500",
          "after:border-deepGray-500",
          "peer-focus:text-success-700",
          "peer-focus:before:border-success-700",
          "peer-focus:after:border-success-700",
          "before:border-deepGray-500"
        ],
        error: [
          "text-error-500",
          "after:border-error-500",
          "peer-placeholder-shown:text-error-500",
          "peer-focus:text-error-500",
          "peer-focus:before:border-error-500",
          "peer-focus:after:border-error-500",
          "before:border-error-500"
        ],
        success: [
          "text-success-700",
          "after:border-error-500",
          "peer-placeholder-shown:text-success-700",
          "peer-focus:text-success-700",
          "peer-focus:before:border-success-700",
          "peer-focus:after:border-success-700",
          "before:border-success-700"
        ]
      }
    },
    defaultVariants: {
      state: "default",
      size: "normal"
    },
    compoundVariants: [
      {
        state: "default",
        lightBorder: !0,
        class: "before:border-deepGray-200 after:border-deepGray-200 peer-hover:before:border-text-primary peer-hover:after:border-text-primary peer-placeholder-shown:peer-hover:before:border-transparent peer-placeholder-shown:peer-hover:after:border-transparent peer-placeholder-shown:peer-focus:peer-hover:before:border-success-700 peer-placeholder-shown:peer-focus:peer-hover:after:border-success-700"
      }
    ]
  }
), yI = Pe(["font-sans", "text-sm", "leading-normal", "flex", "items-center", "gap-1", "font-normal", "mt-2"], {
  variants: {
    error: {
      false: ["text-gray-700"],
      true: ["text-error-500"]
    }
  }
}), _L = me(function({
  label: t,
  error: n = !1,
  state: r = "default",
  className: a,
  full: i,
  helperText: l,
  size: s = "normal",
  startAdornment: c,
  endAdornment: d,
  lightBorder: f,
  classNames: u,
  required: h,
  ...p
}, y) {
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { className: K("flex rounded-md shadow-sm", i && "w-full"), children: /* @__PURE__ */ v.jsxs("div", { className: K("relative", i && "w-full"), children: [
      c && /* @__PURE__ */ v.jsx("div", { className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3", children: c }),
      /* @__PURE__ */ v.jsx(
        "input",
        {
          ref: y,
          "aria-invalid": !!n,
          className: pI({
            state: n ? "error" : r,
            size: s,
            lightBorder: f,
            hasStartAdornment: !!c,
            hasEndAdornment: !!d,
            withLabel: !!t,
            className: a
          }),
          placeholder: " ",
          ...p
        }
      ),
      t && /* @__PURE__ */ v.jsx(
        "label",
        {
          htmlFor: p.id,
          className: K(
            gI({
              state: n ? "error" : r,
              size: s,
              lightBorder: f,
              hasStartAdornment: !!c
            }),
            u == null ? void 0 : u.label
          ),
          children: /* @__PURE__ */ v.jsxs("div", { children: [
            t,
            h && /* @__PURE__ */ v.jsx("span", { className: "text-red-500", children: "*" })
          ] })
        }
      ),
      d && /* @__PURE__ */ v.jsx("div", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3", children: d })
    ] }) }),
    l && /* @__PURE__ */ v.jsx("p", { className: yI({ error: r === "error" }), children: l })
  ] });
}), bI = me(
  ({ className: e, endIcon: t, hasError: n = !1, hasSuccess: r = !1, startIcon: a, size: i, ...l }, s) => {
    const c = {
      disabled: l.disabled,
      hasError: n,
      hasSuccess: r,
      size: i
    }, d = t, f = a;
    return /* @__PURE__ */ v.jsx(
      o1,
      {
        ref: s,
        className: e,
        endSlot: d ? {
          component: /* @__PURE__ */ v.jsx(d, { className: Ha({ ...c, isStartIcon: !1 }) }),
          type: "icon"
        } : void 0,
        hasError: n,
        hasSuccess: r,
        size: i,
        startSlot: f ? {
          component: /* @__PURE__ */ v.jsx(f, { className: Ha({ ...c, isStartIcon: !0 }) }),
          type: "icon"
        } : void 0,
        ...l
      }
    );
  }
);
bI.displayName = "TextInput";
const wI = Pe(
  [
    "cursor-pointer",
    "rounded-full",
    "outline-none",
    "disabled:opacity-38",
    "disabled:cursor-default",
    "[&_span]:data-[state=checked]:hover:ring-4",
    "[&_span]:data-[state=checked]:hover:ring-primary-800/40",
    "[&_span]:data-[state=unchecked]:hover:ring-4",
    "[&_span]:data-[state=unchecked]:hover:ring-red-800/40",
    "[&_span]:data-[state=checked]:focus-visible:ring-4",
    "[&_span]:data-[state=checked]:focus-visible:ring-primary-800/40",
    "[&_span]:data-[state=checked]:disabled:hover:ring-0",
    "[&_span]:data-[state=unchecked]:focus-visible:ring-4",
    "[&_span]:data-[state=unchecked]:focus-visible:ring-red-800/40",
    "[&_span]:data-[state=unchecked]:disabled:hover:ring-0"
  ],
  {
    variants: {
      size: {
        sm: ["h-5", "w-10"],
        md: ["h-7", "w-12"],
        lg: ["h-8", "w-14"]
      },
      variant: {
        primary: ["bg-red-500", "data-[state=checked]:bg-primary-500"],
        secondary: ["bg-gray-800", "data-[state=checked]:bg-gray-800"],
        tertiary: ["bg-gray-200", "data-[state=checked]:bg-gray-200"]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), $I = Pe(
  [
    "block",
    "translate-x-0.5",
    "rounded-full",
    "transition-transform",
    "duration-100",
    "will-change-transform",
    "flex",
    "items-center",
    "justify-center"
  ],
  {
    variants: {
      size: {
        sm: ["h-4", "w-4", "data-[state=checked]:translate-x-[22px]"],
        md: ["h-6", "w-6", "data-[state=checked]:translate-x-[22px]"],
        lg: ["h-7", "w-7", "data-[state=checked]:translate-x-[26px]"]
      },
      variant: {
        primary: ["border", "border-red-800", "bg-white", "data-[state=checked]:border-primary-800"],
        secondary: ["bg-white", "data-[state=checked]:border-primary-800"],
        tertiary: [
          "border",
          "border-red-800",
          "bg-red-500",
          "data-[state=checked]:bg-primary-500",
          "data-[state=checked]:border-primary-800"
        ]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), fr = Pe([], {
  variants: {
    checked: {
      true: ["fill-primary-500"],
      false: ["fill-red-500"]
    },
    locked: {
      true: [],
      false: []
    },
    size: {
      sm: ["h-4", "w-4"],
      md: ["h-5", "w-5"],
      lg: ["h-6", "w-6"]
    },
    variant: {
      primary: [],
      secondary: [],
      tertiary: ["fill-white"]
    },
    scheduled: {
      true: [],
      false: []
    }
  },
  compoundVariants: [
    {
      size: "sm",
      locked: !0,
      class: ["h-3", "w-3"]
    },
    {
      size: "md",
      locked: !0,
      class: ["h-4", "w-4"]
    },
    {
      size: "lg",
      locked: !0,
      class: ["h-5", "w-5"]
    },
    {
      size: "sm",
      scheduled: !0,
      class: ["h-3", "w-3"]
    }
  ],
  defaultVariants: {
    size: "md",
    variant: "primary"
  }
}), EI = g.forwardRef(
  ({
    accessibilityLabel: e,
    className: t,
    loading: n = !1,
    locked: r = !1,
    scheduled: a = !1,
    size: i = "md",
    variant: l = "primary",
    ...s
  }, c) => /* @__PURE__ */ v.jsxs(
    c1,
    {
      ref: c,
      className: K(wI({ size: i, variant: l }), t),
      disabled: s.disabled || r || n || a,
      ...s,
      children: [
        /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: e }),
        /* @__PURE__ */ v.jsx(s6, { className: K($I({ size: i, variant: l })), children: a ? /* @__PURE__ */ v.jsx(H6, { className: fr({ checked: s.checked, scheduled: a, size: i, variant: l }) }) : r ? /* @__PURE__ */ v.jsx(R6, { className: fr({ checked: s.checked, locked: r, size: i, variant: l }) }) : n ? /* @__PURE__ */ v.jsx(l1, { className: K(fr({ checked: s.checked, size: i, variant: l }), "p-0.5") }) : s.checked ? /* @__PURE__ */ v.jsx(_6, { className: fr({ checked: s.checked, size: i, variant: l }) }) : /* @__PURE__ */ v.jsx(Bn, { className: fr({ checked: s.checked, size: i, variant: l }) }) })
      ]
    }
  )
);
EI.displayName = "Toggle";
const xI = /* @__PURE__ */ me((e, t) => /* @__PURE__ */ Y(at.span, ft({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), MI = xI, [po] = Vr("Tooltip", [
  fo
]), go = fo(), CI = "TooltipProvider", PI = 700, Ji = "tooltip.open", [SI, d1] = po(CI), FI = (e) => {
  const { __scopeTooltip: t, delayDuration: n = PI, skipDelayDuration: r = 300, disableHoverableContent: a = !1, children: i } = e, [l, s] = Ae(!0), c = ve(!1), d = ve(0);
  return Ce(() => {
    const f = d.current;
    return () => window.clearTimeout(f);
  }, []), /* @__PURE__ */ Y(SI, {
    scope: t,
    isOpenDelayed: l,
    delayDuration: n,
    onOpen: he(() => {
      window.clearTimeout(d.current), s(!1);
    }, []),
    onClose: he(() => {
      window.clearTimeout(d.current), d.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: he((f) => {
      c.current = f;
    }, []),
    disableHoverableContent: a
  }, i);
}, u1 = "Tooltip", [zI, Ur] = po(u1), NI = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: a = !1, onOpenChange: i, disableHoverableContent: l, delayDuration: s } = e, c = d1(u1, e.__scopeTooltip), d = go(t), [f, u] = Ae(null), h = mm(), p = ve(0), y = l ?? c.disableHoverableContent, m = s ?? c.delayDuration, b = ve(!1), [$ = !1, w] = r1({
    prop: r,
    defaultProp: a,
    onChange: (z) => {
      z ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Ji))) : c.onClose(), i == null || i(z);
    }
  }), E = Ze(() => $ ? b.current ? "delayed-open" : "instant-open" : "closed", [
    $
  ]), P = he(() => {
    window.clearTimeout(p.current), b.current = !1, w(!0);
  }, [
    w
  ]), x = he(() => {
    window.clearTimeout(p.current), w(!1);
  }, [
    w
  ]), F = he(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      b.current = !0, w(!0);
    }, m);
  }, [
    m,
    w
  ]);
  return Ce(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ Y($m, d, /* @__PURE__ */ Y(zI, {
    scope: t,
    contentId: h,
    open: $,
    stateAttribute: E,
    trigger: f,
    onTriggerChange: u,
    onTriggerEnter: he(() => {
      c.isOpenDelayed ? F() : P();
    }, [
      c.isOpenDelayed,
      F,
      P
    ]),
    onTriggerLeave: he(() => {
      y ? x() : window.clearTimeout(p.current);
    }, [
      x,
      y
    ]),
    onOpen: P,
    onClose: x,
    disableHoverableContent: y
  }, n));
}, Dc = "TooltipTrigger", DI = /* @__PURE__ */ me((e, t) => {
  const { __scopeTooltip: n, ...r } = e, a = Ur(Dc, n), i = d1(Dc, n), l = go(n), s = ve(null), c = Ue(t, s, a.onTriggerChange), d = ve(!1), f = ve(!1), u = he(
    () => d.current = !1,
    []
  );
  return Ce(() => () => document.removeEventListener("pointerup", u), [
    u
  ]), /* @__PURE__ */ Y(Em, He({
    asChild: !0
  }, l), /* @__PURE__ */ Y(at.button, He({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": a.open ? a.contentId : void 0,
    "data-state": a.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: We(e.onPointerMove, (h) => {
      h.pointerType !== "touch" && !f.current && !i.isPointerInTransitRef.current && (a.onTriggerEnter(), f.current = !0);
    }),
    onPointerLeave: We(e.onPointerLeave, () => {
      a.onTriggerLeave(), f.current = !1;
    }),
    onPointerDown: We(e.onPointerDown, () => {
      d.current = !0, document.addEventListener("pointerup", u, {
        once: !0
      });
    }),
    onFocus: We(e.onFocus, () => {
      d.current || a.onOpen();
    }),
    onBlur: We(e.onBlur, a.onClose),
    onClick: We(e.onClick, a.onClose)
  })));
}), c6 = "TooltipPortal", [OI, AI] = po(c6, {
  forceMount: void 0
}), TI = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: a } = e, i = Ur(c6, t);
  return /* @__PURE__ */ Y(OI, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Y(Gr, {
    present: n || i.open
  }, /* @__PURE__ */ Y(Cm, {
    asChild: !0,
    container: a
  }, r)));
}, Dr = "TooltipContent", kI = /* @__PURE__ */ me((e, t) => {
  const n = AI(Dr, e.__scopeTooltip), { forceMount: r = n.forceMount, side: a = "top", ...i } = e, l = Ur(Dr, e.__scopeTooltip);
  return /* @__PURE__ */ Y(Gr, {
    present: r || l.open
  }, l.disableHoverableContent ? /* @__PURE__ */ Y(d6, He({
    side: a
  }, i, {
    ref: t
  })) : /* @__PURE__ */ Y(HI, He({
    side: a
  }, i, {
    ref: t
  })));
}), HI = /* @__PURE__ */ me((e, t) => {
  const n = Ur(Dr, e.__scopeTooltip), r = d1(Dr, e.__scopeTooltip), a = ve(null), i = Ue(t, a), [l, s] = Ae(null), { trigger: c, onClose: d } = n, f = a.current, { onPointerInTransitChange: u } = r, h = he(() => {
    s(null), u(!1);
  }, [
    u
  ]), p = he((y, m) => {
    const b = y.currentTarget, $ = {
      x: y.clientX,
      y: y.clientY
    }, w = jI($, b.getBoundingClientRect()), E = BI($, w), P = WI(m.getBoundingClientRect()), x = GI([
      ...E,
      ...P
    ]);
    s(x), u(!0);
  }, [
    u
  ]);
  return Ce(() => () => h(), [
    h
  ]), Ce(() => {
    if (c && f) {
      const y = (b) => p(b, f), m = (b) => p(b, c);
      return c.addEventListener("pointerleave", y), f.addEventListener("pointerleave", m), () => {
        c.removeEventListener("pointerleave", y), f.removeEventListener("pointerleave", m);
      };
    }
  }, [
    c,
    f,
    p,
    h
  ]), Ce(() => {
    if (l) {
      const y = (m) => {
        const b = m.target, $ = {
          x: m.clientX,
          y: m.clientY
        }, w = (c == null ? void 0 : c.contains(b)) || (f == null ? void 0 : f.contains(b)), E = !VI($, l);
        w ? h() : E && (h(), d());
      };
      return document.addEventListener("pointermove", y), () => document.removeEventListener("pointermove", y);
    }
  }, [
    c,
    f,
    l,
    d,
    h
  ]), /* @__PURE__ */ Y(d6, He({}, e, {
    ref: i
  }));
}), [RI, _I] = po(u1, {
  isInside: !1
}), d6 = /* @__PURE__ */ me((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": a, onEscapeKeyDown: i, onPointerDownOutside: l, ...s } = e, c = Ur(Dr, n), d = go(n), { onClose: f } = c;
  return Ce(() => (document.addEventListener(Ji, f), () => document.removeEventListener(Ji, f)), [
    f
  ]), Ce(() => {
    if (c.trigger) {
      const u = (h) => {
        const p = h.target;
        p != null && p.contains(c.trigger) && f();
      };
      return window.addEventListener("scroll", u, {
        capture: !0
      }), () => window.removeEventListener("scroll", u, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    f
  ]), /* @__PURE__ */ Y(um, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: l,
    onFocusOutside: (u) => u.preventDefault(),
    onDismiss: f
  }, /* @__PURE__ */ Y(xm, He({
    "data-state": c.stateAttribute
  }, d, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ Y(dm, null, r), /* @__PURE__ */ Y(RI, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ Y(MI, {
    id: c.contentId,
    role: "tooltip"
  }, a || r))));
}), II = "TooltipArrow", LI = /* @__PURE__ */ me((e, t) => {
  const { __scopeTooltip: n, ...r } = e, a = go(n);
  return _I(II, n).isInside ? null : /* @__PURE__ */ Y(Mm, He({}, a, r, {
    ref: t
  }));
});
function jI(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), a = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, a, i)) {
    case i:
      return "left";
    case a:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function BI(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function WI(e) {
  const { top: t, right: n, bottom: r, left: a } = e;
  return [
    {
      x: a,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: a,
      y: r
    }
  ];
}
function VI(e, t) {
  const { x: n, y: r } = e;
  let a = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const s = t[i].x, c = t[i].y, d = t[l].x, f = t[l].y;
    c > r != f > r && n < (d - s) * (r - c) / (f - c) + s && (a = !a);
  }
  return a;
}
function GI(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), YI(t);
}
function YI(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], l = t[t.length - 2];
      if ((i.x - l.x) * (a.y - l.y) >= (i.y - l.y) * (a.x - l.x)) t.pop();
      else break;
    }
    t.push(a);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const a = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], l = n[n.length - 2];
      if ((i.x - l.x) * (a.y - l.y) >= (i.y - l.y) * (a.x - l.x)) n.pop();
      else break;
    }
    n.push(a);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const UI = FI, KI = NI, XI = DI, qI = TI, u6 = kI, ZI = LI, f6 = me(
  ({ className: e, classNames: t, arrow: n, sideOffset: r = 4, children: a, variant: i = "light", ...l }, s) => /* @__PURE__ */ v.jsxs(
    u6,
    {
      ref: s,
      sideOffset: r,
      className: K(
        ["z-50 overflow-hidden rounded-md bg-white p-2 text-sm text-text-primary shadow-md"],
        { "bg-deepGray-500 text-white": i === "dark" },
        e
      ),
      ...l,
      children: [
        a,
        n && /* @__PURE__ */ v.jsx(
          ZI,
          {
            width: 11,
            height: 5,
            className: K("fill-white", { "fill-deepGray-500": i === "dark" }, t == null ? void 0 : t.arrow)
          }
        )
      ]
    }
  )
);
f6.displayName = u6.displayName;
function yo(e) {
  return /* @__PURE__ */ v.jsx(KI, { ...e });
}
yo.Content = f6;
yo.Trigger = XI;
yo.Provider = UI;
yo.Portal = qI;
export {
  oL as Accordion,
  n8 as AccordionContent,
  e8 as AccordionHeader,
  Q7 as AccordionItem,
  t8 as AccordionTrigger,
  iL as Alert,
  a8 as Button,
  lL as ButtonLink,
  sL as Calendar,
  cL as Checkbox,
  dL as Chip,
  DL as Drawer,
  vL as DropdownMenu,
  EP as DropdownMenuContent,
  uL as DropdownMenuGroup,
  xP as DropdownMenuItem,
  MP as DropdownMenuLabel,
  fL as DropdownMenuPortal,
  hL as DropdownMenuRadioGroup,
  CP as DropdownMenuSeparator,
  mL as DropdownMenuSub,
  SP as DropdownMenuSubContent,
  PP as DropdownMenuSubTrigger,
  $P as DropdownMenuTrigger,
  pL as HelperText,
  vd as IconButton,
  gL as IconButtonLink,
  DP as Label,
  yL as Logo,
  PL as Modal,
  CL as ModalActions,
  xL as ModalContent,
  SL as ModalFullScreen,
  ML as ModalScreenReaderTitle,
  wL as ModalTitle,
  EL as ModalTitleInfo,
  $L as ModalTitleInverse,
  FL as Paper,
  nR as PhoneNumberInput,
  a1 as Popover,
  x_ as SearchInput,
  OL as Select,
  b_ as SelectContent,
  y_ as SelectFilterTrigger,
  w_ as SelectItem,
  $_ as SelectSeparator,
  Im as SelectTrigger,
  AL as SelectValue,
  TL as Slider,
  HL as Snackbar,
  kL as SnackbarProvider,
  l1 as Spinner,
  hI as Switch,
  _L as TextField,
  bI as TextInput,
  EI as Toggle,
  yo as Tooltip,
  pd as buttonCva,
  K as cn,
  aL as createSlots,
  Pe as cva,
  q7 as generateUniqueId,
  md as iconButtonCva,
  wa as iconFillMap,
  NL as isPossiblePhoneNumber,
  zL as isValidPhoneNumber,
  RL as useSnackbar,
  q_ as useSnackbarContext,
  Z_ as useSnackbarDispatchContext
};
